(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree4b0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree4b0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("biv32", function(module, exports) {

$parcel$export(module.exports, "_config", function () { return _config; });
$parcel$export(module.exports, "_isString", function () { return _isString; });
$parcel$export(module.exports, "_isUndefined", function () { return _isUndefined; });
$parcel$export(module.exports, "_numExp", function () { return _numExp; });
$parcel$export(module.exports, "_numWithUnitExp", function () { return _numWithUnitExp; });
$parcel$export(module.exports, "_relExp", function () { return _relExp; });
$parcel$export(module.exports, "gsap", function () { return gsap; });
$parcel$export(module.exports, "_missingPlugin", function () { return _missingPlugin; });
$parcel$export(module.exports, "_plugins", function () { return _plugins; });
$parcel$export(module.exports, "GSCache", function () { return GSCache; });
$parcel$export(module.exports, "_getCache", function () { return _getCache; });
$parcel$export(module.exports, "_getProperty", function () { return _getProperty; });
$parcel$export(module.exports, "_forEachName", function () { return _forEachName; });
$parcel$export(module.exports, "_round", function () { return _round; });
$parcel$export(module.exports, "_parseRelative", function () { return _parseRelative; });
$parcel$export(module.exports, "_ticker", function () { return _ticker; });
$parcel$export(module.exports, "getUnit", function () { return getUnit; });
$parcel$export(module.exports, "_replaceRandom", function () { return _replaceRandom; });
$parcel$export(module.exports, "_getSetter", function () { return _getSetter; });
$parcel$export(module.exports, "PropTween", function () { return PropTween; });
$parcel$export(module.exports, "_colorExp", function () { return _colorExp; });
$parcel$export(module.exports, "_colorStringFilter", function () { return _colorStringFilter; });
$parcel$export(module.exports, "_renderComplexString", function () { return _renderComplexString; });
$parcel$export(module.exports, "_checkPlugin", function () { return _checkPlugin; });
$parcel$export(module.exports, "_sortPropTweensByPriority", function () { return _sortPropTweensByPriority; });
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? _interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.5";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});


var $biv32 = parcelRequire("biv32");
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $biv32 = parcelRequire("biv32");
var $2bd88b8e97470578$var$_win, $2bd88b8e97470578$var$_doc, $2bd88b8e97470578$var$_docElement, $2bd88b8e97470578$var$_pluginInitted, $2bd88b8e97470578$var$_tempDiv, $2bd88b8e97470578$var$_tempDivStyler, $2bd88b8e97470578$var$_recentSetterPlugin, $2bd88b8e97470578$var$_reverting, $2bd88b8e97470578$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $2bd88b8e97470578$var$_transformProps = {}, $2bd88b8e97470578$var$_RAD2DEG = 180 / Math.PI, $2bd88b8e97470578$var$_DEG2RAD = Math.PI / 180, $2bd88b8e97470578$var$_atan2 = Math.atan2, $2bd88b8e97470578$var$_bigNum = 1e8, $2bd88b8e97470578$var$_capsExp = /([A-Z])/g, $2bd88b8e97470578$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $2bd88b8e97470578$var$_complexExp = /[\s,\(]\S/, $2bd88b8e97470578$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $2bd88b8e97470578$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $2bd88b8e97470578$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $2bd88b8e97470578$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$2bd88b8e97470578$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $2bd88b8e97470578$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $2bd88b8e97470578$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $2bd88b8e97470578$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $2bd88b8e97470578$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $2bd88b8e97470578$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $2bd88b8e97470578$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $2bd88b8e97470578$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $2bd88b8e97470578$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $2bd88b8e97470578$var$_transformProp = "transform", $2bd88b8e97470578$var$_transformOriginProp = $2bd88b8e97470578$var$_transformProp + "Origin", $2bd88b8e97470578$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $2bd88b8e97470578$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $2bd88b8e97470578$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $2bd88b8e97470578$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $2bd88b8e97470578$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $2bd88b8e97470578$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $2bd88b8e97470578$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($2bd88b8e97470578$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($2bd88b8e97470578$var$_transformOriginProp, isNotCSS, "");
        }
        property = $2bd88b8e97470578$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $2bd88b8e97470578$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $2bd88b8e97470578$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($2bd88b8e97470578$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $2bd88b8e97470578$var$_reverting();
        if ((!i || !i.isStart) && !style[$2bd88b8e97470578$var$_transformProp]) {
            $2bd88b8e97470578$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$2bd88b8e97470578$var$_transformOriginProp]) {
                style[$2bd88b8e97470578$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $2bd88b8e97470578$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $2bd88b8e97470578$var$_revertStyle,
        save: $2bd88b8e97470578$var$_saveStyle
    };
    target._gsap || (0, $biv32.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $2bd88b8e97470578$var$_supports3D, $2bd88b8e97470578$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $2bd88b8e97470578$var$_doc.createElementNS ? $2bd88b8e97470578$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $2bd88b8e97470578$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $2bd88b8e97470578$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $2bd88b8e97470578$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($2bd88b8e97470578$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $2bd88b8e97470578$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $2bd88b8e97470578$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $2bd88b8e97470578$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $2bd88b8e97470578$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($2bd88b8e97470578$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $2bd88b8e97470578$var$_prefixes[i] : "") + property;
}, $2bd88b8e97470578$var$_initCore = function _initCore() {
    if ($2bd88b8e97470578$var$_windowExists() && window.document) {
        $2bd88b8e97470578$var$_win = window;
        $2bd88b8e97470578$var$_doc = $2bd88b8e97470578$var$_win.document;
        $2bd88b8e97470578$var$_docElement = $2bd88b8e97470578$var$_doc.documentElement;
        $2bd88b8e97470578$var$_tempDiv = $2bd88b8e97470578$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $2bd88b8e97470578$var$_tempDivStyler = $2bd88b8e97470578$export$a232bb0480ae674a("div");
        $2bd88b8e97470578$var$_transformProp = $2bd88b8e97470578$export$8cbef5dd49a09c8b($2bd88b8e97470578$var$_transformProp);
        $2bd88b8e97470578$var$_transformOriginProp = $2bd88b8e97470578$var$_transformProp + "Origin";
        $2bd88b8e97470578$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $2bd88b8e97470578$var$_supports3D = !!$2bd88b8e97470578$export$8cbef5dd49a09c8b("perspective");
        $2bd88b8e97470578$var$_reverting = (0, $biv32.gsap).core.reverting;
        $2bd88b8e97470578$var$_pluginInitted = 1;
    }
}, $2bd88b8e97470578$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $2bd88b8e97470578$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $2bd88b8e97470578$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $2bd88b8e97470578$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $2bd88b8e97470578$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $2bd88b8e97470578$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $2bd88b8e97470578$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $2bd88b8e97470578$var$_getBBoxHack || (bounds = $2bd88b8e97470578$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$2bd88b8e97470578$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$2bd88b8e97470578$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $2bd88b8e97470578$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $2bd88b8e97470578$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$2bd88b8e97470578$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $2bd88b8e97470578$var$_transformProps && property !== $2bd88b8e97470578$var$_transformOriginProp) property = $2bd88b8e97470578$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($2bd88b8e97470578$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $2bd88b8e97470578$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $biv32.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $2bd88b8e97470578$var$_renderNonTweeningValueOnlyAtEnd : $2bd88b8e97470578$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $2bd88b8e97470578$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $2bd88b8e97470578$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$2bd88b8e97470578$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $2bd88b8e97470578$var$_tempDiv.style, horizontal = $2bd88b8e97470578$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $2bd88b8e97470578$var$_nonConvertibleUnits[unit] || $2bd88b8e97470578$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $2bd88b8e97470578$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($2bd88b8e97470578$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $biv32._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $2bd88b8e97470578$var$_doc || !parent.appendChild) parent = $2bd88b8e97470578$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $biv32._ticker).time && !cache.uncache) return (0, $biv32._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $2bd88b8e97470578$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$2bd88b8e97470578$var$_nonStandardLayouts[$2bd88b8e97470578$var$_getComputedProperty(parent, "display")] && (style.position = $2bd88b8e97470578$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($2bd88b8e97470578$var$_tempDiv);
            px = $2bd88b8e97470578$var$_tempDiv[measureProperty];
            parent.removeChild($2bd88b8e97470578$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $biv32._getCache)(parent);
            cache.time = (0, $biv32._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $biv32._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $2bd88b8e97470578$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $2bd88b8e97470578$var$_pluginInitted || $2bd88b8e97470578$var$_initCore();
    if (property in $2bd88b8e97470578$var$_propertyAliases && property !== "transform") {
        property = $2bd88b8e97470578$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($2bd88b8e97470578$var$_transformProps[property] && property !== "transform") {
        value = $2bd88b8e97470578$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $2bd88b8e97470578$var$_firstTwoOnly($2bd88b8e97470578$var$_getComputedProperty(target, $2bd88b8e97470578$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $2bd88b8e97470578$var$_specialProps[property] && $2bd88b8e97470578$var$_specialProps[property](target, property, unit) || $2bd88b8e97470578$var$_getComputedProperty(target, property) || (0, $biv32._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $2bd88b8e97470578$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $2bd88b8e97470578$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $2bd88b8e97470578$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $2bd88b8e97470578$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $2bd88b8e97470578$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $biv32.PropTween)(this._pt, target.style, prop, 0, 1, (0, $biv32._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $2bd88b8e97470578$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $2bd88b8e97470578$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $biv32._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $biv32._numWithUnitExp)) || [];
    endValues = end.match((0, $biv32._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $biv32._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $biv32._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $biv32._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $biv32._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $2bd88b8e97470578$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $2bd88b8e97470578$var$_renderNonTweeningValueOnlyAtEnd : $2bd88b8e97470578$var$_renderNonTweeningValue;
    (0, $biv32._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $2bd88b8e97470578$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $2bd88b8e97470578$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $2bd88b8e97470578$var$_keywordToPercent[x] || x;
    split[1] = $2bd88b8e97470578$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $2bd88b8e97470578$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($2bd88b8e97470578$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $2bd88b8e97470578$var$_transformOriginProp : $2bd88b8e97470578$var$_transformProp;
                }
                $2bd88b8e97470578$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $2bd88b8e97470578$var$_removeProperty(target, $2bd88b8e97470578$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $2bd88b8e97470578$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $2bd88b8e97470578$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$2bd88b8e97470578$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $biv32.PropTween)(plugin._pt, target, property, 0, 0, $2bd88b8e97470578$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $2bd88b8e97470578$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $2bd88b8e97470578$var$_rotationalProperties = {}, $2bd88b8e97470578$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $2bd88b8e97470578$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $2bd88b8e97470578$var$_getComputedProperty(target, $2bd88b8e97470578$var$_transformProp);
    return $2bd88b8e97470578$var$_isNullTransform(matrixString) ? $2bd88b8e97470578$var$_identity2DMatrix : matrixString.substr(7).match((0, $biv32._numExp)).map((0, $biv32._round));
}, $2bd88b8e97470578$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $biv32._getCache)(target), style = target.style, matrix = $2bd88b8e97470578$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $2bd88b8e97470578$var$_identity2DMatrix : matrix;
    } else if (matrix === $2bd88b8e97470578$var$_identity2DMatrix && !target.offsetParent && target !== $2bd88b8e97470578$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $2bd88b8e97470578$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $2bd88b8e97470578$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $2bd88b8e97470578$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $2bd88b8e97470578$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $2bd88b8e97470578$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $2bd88b8e97470578$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $2bd88b8e97470578$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $2bd88b8e97470578$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$2bd88b8e97470578$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $2bd88b8e97470578$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $2bd88b8e97470578$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $2bd88b8e97470578$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $2bd88b8e97470578$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $2bd88b8e97470578$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $biv32.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $2bd88b8e97470578$var$_getComputedProperty(target, $2bd88b8e97470578$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $2bd88b8e97470578$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$2bd88b8e97470578$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$2bd88b8e97470578$var$_transformProp] !== "none" ? cs[$2bd88b8e97470578$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $2bd88b8e97470578$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $2bd88b8e97470578$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $2bd88b8e97470578$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $2bd88b8e97470578$var$_atan2(b, a) * $2bd88b8e97470578$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $2bd88b8e97470578$var$_atan2(c, d) * $2bd88b8e97470578$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $2bd88b8e97470578$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $2bd88b8e97470578$var$_atan2(a32, a33);
            rotationX = angle * $2bd88b8e97470578$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $2bd88b8e97470578$var$_atan2(-c, a33);
            rotationY = angle * $2bd88b8e97470578$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $2bd88b8e97470578$var$_atan2(b, a);
            rotation = angle * $2bd88b8e97470578$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $biv32._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $biv32._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $2bd88b8e97470578$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $2bd88b8e97470578$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$2bd88b8e97470578$var$_isNullTransform($2bd88b8e97470578$var$_getComputedProperty(target, $2bd88b8e97470578$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $biv32._round)(scaleX);
    cache.scaleY = (0, $biv32._round)(scaleY);
    cache.rotation = (0, $biv32._round)(rotation) + deg;
    cache.rotationX = (0, $biv32._round)(rotationX) + deg;
    cache.rotationY = (0, $biv32._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$2bd88b8e97470578$var$_transformOriginProp] = $2bd88b8e97470578$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $biv32._config).force3D;
    cache.renderTransform = cache.svg ? $2bd88b8e97470578$var$_renderSVGTransforms : $2bd88b8e97470578$var$_supports3D ? $2bd88b8e97470578$var$_renderCSSTransforms : $2bd88b8e97470578$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $2bd88b8e97470578$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$2bd88b8e97470578$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $biv32.getUnit)(start);
    return (0, $biv32._round)(parseFloat(start) + parseFloat($2bd88b8e97470578$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $2bd88b8e97470578$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $2bd88b8e97470578$var$_renderCSSTransforms(ratio, cache);
}, $2bd88b8e97470578$var$_zeroDeg = "0deg", $2bd88b8e97470578$var$_zeroPx = "0px", $2bd88b8e97470578$var$_endParenthesis = ") ", $2bd88b8e97470578$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $2bd88b8e97470578$var$_zeroDeg || rotationY !== $2bd88b8e97470578$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $2bd88b8e97470578$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $2bd88b8e97470578$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $2bd88b8e97470578$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $2bd88b8e97470578$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $2bd88b8e97470578$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $2bd88b8e97470578$var$_zeroPx) transforms += "perspective(" + transformPerspective + $2bd88b8e97470578$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $2bd88b8e97470578$var$_zeroPx || y !== $2bd88b8e97470578$var$_zeroPx || z !== $2bd88b8e97470578$var$_zeroPx) transforms += z !== $2bd88b8e97470578$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $2bd88b8e97470578$var$_endParenthesis;
    if (rotation !== $2bd88b8e97470578$var$_zeroDeg) transforms += "rotate(" + rotation + $2bd88b8e97470578$var$_endParenthesis;
    if (rotationY !== $2bd88b8e97470578$var$_zeroDeg) transforms += "rotateY(" + rotationY + $2bd88b8e97470578$var$_endParenthesis;
    if (rotationX !== $2bd88b8e97470578$var$_zeroDeg) transforms += "rotateX(" + rotationX + $2bd88b8e97470578$var$_endParenthesis;
    if (skewX !== $2bd88b8e97470578$var$_zeroDeg || skewY !== $2bd88b8e97470578$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $2bd88b8e97470578$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $2bd88b8e97470578$var$_endParenthesis;
    target.style[$2bd88b8e97470578$var$_transformProp] = transforms || "translate(0, 0)";
}, $2bd88b8e97470578$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $2bd88b8e97470578$var$_DEG2RAD;
        skewX *= $2bd88b8e97470578$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $2bd88b8e97470578$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $biv32._round)(a11);
        a21 = (0, $biv32._round)(a21);
        a12 = (0, $biv32._round)(a12);
        a22 = (0, $biv32._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $2bd88b8e97470578$var$_convertToUnit(target, "x", x, "px");
        ty = $2bd88b8e97470578$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $biv32._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $biv32._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $biv32._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $biv32._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$2bd88b8e97470578$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $2bd88b8e97470578$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $biv32._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $2bd88b8e97470578$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $2bd88b8e97470578$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $2bd88b8e97470578$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $biv32.PropTween)(plugin._pt, target, property, startNum, change, $2bd88b8e97470578$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $2bd88b8e97470578$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $2bd88b8e97470578$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $2bd88b8e97470578$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$2bd88b8e97470578$var$_transformProp] = transforms;
        endCache = $2bd88b8e97470578$var$_parseTransform(target, 1);
        $2bd88b8e97470578$var$_removeProperty(target, $2bd88b8e97470578$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$2bd88b8e97470578$var$_transformProp];
        style[$2bd88b8e97470578$var$_transformProp] = transforms;
        endCache = $2bd88b8e97470578$var$_parseTransform(target, 1);
        style[$2bd88b8e97470578$var$_transformProp] = startValue;
    }
    for(p in $2bd88b8e97470578$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $biv32.getUnit)(startValue);
            endUnit = (0, $biv32.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $2bd88b8e97470578$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $biv32.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $2bd88b8e97470578$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $2bd88b8e97470578$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $biv32._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $2bd88b8e97470578$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $2bd88b8e97470578$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $2bd88b8e97470578$export$855822f522f18eef = {
    name: "css",
    register: $2bd88b8e97470578$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $2bd88b8e97470578$var$_pluginInitted || $2bd88b8e97470578$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $2bd88b8e97470578$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $biv32._plugins)[p] && (0, $biv32._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $2bd88b8e97470578$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $biv32._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $biv32._colorExp).lastIndex = 0;
                if (!(0, $biv32._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $biv32.getUnit)(startValue);
                    endUnit = (0, $biv32.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $2bd88b8e97470578$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $biv32._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $biv32._replaceRandom)(startValue));
                    (0, $biv32.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $biv32._config).units[p] || (0, $biv32.getUnit)($2bd88b8e97470578$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $2bd88b8e97470578$var$_get(target, p)); // can't work with relative values
                } else startValue = $2bd88b8e97470578$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $2bd88b8e97470578$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $2bd88b8e97470578$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $2bd88b8e97470578$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $2bd88b8e97470578$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $2bd88b8e97470578$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $2bd88b8e97470578$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $biv32.PropTween)(this._pt, style, $2bd88b8e97470578$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $biv32.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $biv32._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $2bd88b8e97470578$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($2bd88b8e97470578$var$_transformOriginProp, 0, style[$2bd88b8e97470578$var$_transformOriginProp]);
                        endValue = $2bd88b8e97470578$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $2bd88b8e97470578$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $2bd88b8e97470578$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $2bd88b8e97470578$var$_addNonTweeningPT(this, style, p, $2bd88b8e97470578$var$_firstTwoOnly(startValue), $2bd88b8e97470578$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $2bd88b8e97470578$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $2bd88b8e97470578$var$_rotationalProperties) {
                        $2bd88b8e97470578$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $biv32._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $2bd88b8e97470578$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $2bd88b8e97470578$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $2bd88b8e97470578$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$2bd88b8e97470578$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $biv32.getUnit)(endValue) || (p in (0, $biv32._config).units ? (0, $biv32._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $2bd88b8e97470578$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $biv32.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $biv32._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $2bd88b8e97470578$var$_renderRoundedCSSProp : $2bd88b8e97470578$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $2bd88b8e97470578$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $biv32._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $2bd88b8e97470578$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $biv32._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$2bd88b8e97470578$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $2bd88b8e97470578$var$_get,
    aliases: $2bd88b8e97470578$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $2bd88b8e97470578$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $2bd88b8e97470578$var$_transformProps && property !== $2bd88b8e97470578$var$_transformOriginProp && (target._gsap.x || $2bd88b8e97470578$var$_get(target, "x")) ? plugin && $2bd88b8e97470578$var$_recentSetterPlugin === plugin ? property === "scale" ? $2bd88b8e97470578$var$_setterScale : $2bd88b8e97470578$var$_setterTransform : ($2bd88b8e97470578$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $2bd88b8e97470578$var$_setterScaleWithRender : $2bd88b8e97470578$var$_setterTransformWithRender) : target.style && !(0, $biv32._isUndefined)(target.style[property]) ? $2bd88b8e97470578$var$_setterCSSStyle : ~property.indexOf("-") ? $2bd88b8e97470578$var$_setterCSSProp : (0, $biv32._getSetter)(target, property);
    },
    core: {
        _removeProperty: $2bd88b8e97470578$var$_removeProperty,
        _getMatrix: $2bd88b8e97470578$var$_getMatrix
    }
};
(0, $biv32.gsap).utils.checkPrefix = $2bd88b8e97470578$export$8cbef5dd49a09c8b;
(0, $biv32.gsap).core.getStyleSaver = $2bd88b8e97470578$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $biv32._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $2bd88b8e97470578$var$_transformProps[name] = 1;
    });
    (0, $biv32._forEachName)(rotation, function(name) {
        (0, $biv32._config).units[name] = "deg";
        $2bd88b8e97470578$var$_rotationalProperties[name] = 1;
    });
    $2bd88b8e97470578$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $biv32._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $2bd88b8e97470578$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $biv32._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $biv32._config).units[name] = "px";
});
(0, $biv32.gsap).registerPlugin($2bd88b8e97470578$export$855822f522f18eef);


var $4dab17958b7cdb31$export$99ee26438460406a = (0, $biv32.gsap).registerPlugin((0, $2bd88b8e97470578$export$855822f522f18eef)) || (0, $biv32.gsap), // to protect from tree shaking
$4dab17958b7cdb31$export$7b23975ad686bf91 = $4dab17958b7cdb31$export$99ee26438460406a.core.Tween;


function $4ce6618e88acaea1$var$Accordion() {
    const accordion = Array.from(document.querySelectorAll(".c-accordion"));
    accordion.forEach($4ce6618e88acaea1$var$setupAccordion);
}
function $4ce6618e88acaea1$var$setupAccordion(accordion) {
    const controls = accordion.querySelectorAll(".c-accordion__trigger");
    const children = accordion.children;
    controls.forEach((control)=>{
        control.addEventListener("click", $4ce6618e88acaea1$var$controlClick(children));
    });
}
function $4ce6618e88acaea1$var$controlClick(children) {
    return (event)=>{
        let detail = {
            open: event.currentTarget.getAttribute("aria-expanded"),
            food: event.currentTarget.dataset.food
        };
        window.dispatchEvent(new CustomEvent("accordianClick", {
            detail: detail
        }));
        const parent = event.currentTarget.parentNode;
        const content = parent.querySelector(".c-accordion__content");
        if (!content) return;
        const CLASSNAME = "c-accordion--open";
        const wasOpen = parent.classList.contains(CLASSNAME);
        children.forEach((child)=>{
            child.classList.remove(CLASSNAME);
        });
        parent.classList.toggle(CLASSNAME, !wasOpen);
        if (!wasOpen) {
            content.setAttribute("tabIndex", -1);
            content.focus();
            event.currentTarget.setAttribute("aria-expanded", true);
        } else {
            content.removeAttribute("tabIndex");
            event.currentTarget.setAttribute("aria-expanded", false);
        }
    };
}
var $4ce6618e88acaea1$export$2e2bcd8739ae039 = $4ce6618e88acaea1$var$Accordion;


function $f2234d90ae84d9bf$export$de363e709c412c8a(fn, wait) {
    var time = Date.now();
    return function() {
        if (time + wait - Date.now() < 0) {
            fn();
            time = Date.now();
        }
    };
}
function $f2234d90ae84d9bf$export$61fc7d43ac8f84b0(fn, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) fn.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) fn.apply(context, args);
    };
}
const $f2234d90ae84d9bf$export$3a89f8d6f6bf6c9f = (x, y, a)=>x * (1 - a) + y * a;
const $f2234d90ae84d9bf$export$7d15b64cf5a3a4c4 = (a, min = 0, max = 1)=>Math.min(max, Math.max(min, a));
const $f2234d90ae84d9bf$export$b568019c0551f0a4 = (x, y, a)=>$f2234d90ae84d9bf$export$7d15b64cf5a3a4c4((a - x) / (y - x));
const $f2234d90ae84d9bf$export$d02631cccf789723 = (x1, y1, x2, y2, a)=>$f2234d90ae84d9bf$export$3a89f8d6f6bf6c9f(x2, y2, $f2234d90ae84d9bf$export$b568019c0551f0a4(x1, y1, a));


function $3122b6012636c8e9$var$Slider() {
    const sliders = Array.from(document.querySelectorAll(".c-lessons__slides"));
    sliders.forEach($3122b6012636c8e9$var$setupSlider);
}
const $3122b6012636c8e9$var$LESSON_WIDTH = 263;
const $3122b6012636c8e9$var$LESSON_GAP = 36;
function $3122b6012636c8e9$var$onScroll(slider, controls, counter) {
    let isMaximumScrollCache = false;
    let isMinimumScrollCache = true;
    const children = slider.children.length;
    const childPositions = Array.from(slider.children).map((child)=>child.offsetLeft);
    return ()=>{
        const maxScrollWidth = slider.scrollWidth - slider.clientWidth;
        const [nearestIndex, position] = childPositions.reduce((prev, pos, index)=>{
            const distance = Math.abs(pos - slider.scrollLeft);
            return distance <= prev[1] ? [
                index,
                distance
            ] : prev;
        }, [
            0,
            9999
        ]);
        counter.innerText = `${Math.min(nearestIndex + 1, children)} | ${children}`;
        const isMaximumScroll = slider.scrollLeft === maxScrollWidth;
        if (isMaximumScroll && !isMaximumScrollCache) {
            controls[1].classList.add("fade-out");
            isMaximumScrollCache = true;
        } else if (!isMaximumScroll && isMaximumScrollCache) {
            controls[1].classList.remove("fade-out");
            isMaximumScrollCache = false;
        }
        const isMinimumScroll = slider.scrollLeft === 0;
        if (isMinimumScroll && !isMinimumScrollCache) {
            controls[0].classList.add("fade-out");
            isMinimumScrollCache = true;
        } else if (!isMinimumScroll && isMinimumScrollCache) {
            controls[0].classList.remove("fade-out");
            isMinimumScrollCache = false;
        }
    };
}
function $3122b6012636c8e9$var$setupSlider(el) {
    const slider = el.querySelector(".c-lessons__slider ol");
    const controls = el.querySelectorAll(".c-lessons__controls button");
    const counter = el.querySelector(".c-lessons__count");
    Array.from(controls).forEach((control)=>{
        control.addEventListener("click", function() {
            const isForwards = control.dataset.direction === "+";
            slider.scrollBy({
                top: 0,
                left: ($3122b6012636c8e9$var$LESSON_WIDTH + $3122b6012636c8e9$var$LESSON_GAP * 2) * (isForwards ? 1 : -1),
                behavior: "smooth"
            });
        });
    });
    const scrollEvent = $3122b6012636c8e9$var$onScroll(slider, controls, counter);
    scrollEvent();
    slider.addEventListener("scroll", (0, $f2234d90ae84d9bf$export$de363e709c412c8a)(scrollEvent, 200));
    slider.addEventListener("scroll", (0, $f2234d90ae84d9bf$export$61fc7d43ac8f84b0)(scrollEvent, 200));
}
var $3122b6012636c8e9$export$2e2bcd8739ae039 = $3122b6012636c8e9$var$Slider;


let $3c6137e97da716c6$var$observer = window.ResizeObserver ? new ResizeObserver($3c6137e97da716c6$var$onResize) : null;
function $3c6137e97da716c6$var$InlineInput() {
    const inlineInput = Array.from(document.querySelectorAll(".c-input-inline-button"));
    inlineInput.forEach((el)=>{
        $3c6137e97da716c6$var$observer && $3c6137e97da716c6$var$observer.observe(el);
    });
}
function $3c6137e97da716c6$var$onResize(entries) {
    entries.forEach(({ target: target, contentRect: contentRect })=>{
        target.classList.toggle("c-input-inline-button--wide", contentRect.width > 450);
    });
}
var $3c6137e97da716c6$export$2e2bcd8739ae039 = $3c6137e97da716c6$var$InlineInput;


function $255ff5105c45b82c$var$Newsletter() {
    const newsletter = Array.from(document.querySelectorAll(".js-newsletter"));
    newsletter.forEach($255ff5105c45b82c$var$SetupNewsletterForm);
    const newsletterLinks = Array.from(document.querySelectorAll('[href="#newsletter-modal"]'));
    newsletterLinks.forEach($255ff5105c45b82c$var$SetupNewsletterLinks);
}
const $255ff5105c45b82c$var$OPEN_CLASS = "newsletter-open";
function $255ff5105c45b82c$var$SetupNewsletterForm(el) {
    el.addEventListener("submit", (e)=>{
        e.preventDefault();
        $255ff5105c45b82c$var$openModal(e.target.email.value);
    });
}
function $255ff5105c45b82c$var$SetupNewsletterLinks(el) {
    el.addEventListener("click", (e)=>{
        e.preventDefault();
        if (e.target.closest(".c-modal")) e.target.closest(".c-modal").querySelector(".c-modal__close")?.click();
        $255ff5105c45b82c$var$openModal();
    });
}
function $255ff5105c45b82c$var$openModal(email = "") {
    const modal = document.getElementById("newsletter-modal");
    if (!modal) return;
    const emailField = modal.querySelector('[type="email"]');
    if (!emailField) return;
    const firstField = modal.querySelector("input,select,textarea");
    if (!firstField) return;
    emailField.value = email;
    document.body.classList.add($255ff5105c45b82c$var$OPEN_CLASS);
    setTimeout(()=>{
        firstField.focus();
    }, 0);
    const close = modal.querySelector(".c-newsletter-modal__close");
    if (close) close.addEventListener("click", (e)=>{
        e.preventDefault();
        $255ff5105c45b82c$var$closeModal();
    });
    const fullClose = modal.querySelector(".c-newsletter-modal__full-close");
    if (fullClose) fullClose.addEventListener("click", (e)=>{
        e.preventDefault();
        $255ff5105c45b82c$var$closeModal();
    });
    window.addEventListener("keydown", $255ff5105c45b82c$var$modalKeydown);
}
function $255ff5105c45b82c$var$modalKeydown(e) {
    if (e.code === "Escape") $255ff5105c45b82c$var$closeModal();
}
function $255ff5105c45b82c$var$closeModal() {
    document.body.classList.remove($255ff5105c45b82c$var$OPEN_CLASS);
    window.removeEventListener("keydown", $255ff5105c45b82c$var$modalKeydown);
}
var $255ff5105c45b82c$export$2e2bcd8739ae039 = $255ff5105c45b82c$var$Newsletter;



let $6581ed4055677626$var$isSticky = false;
let $6581ed4055677626$var$header;
function $6581ed4055677626$var$StickyHeader() {
    $6581ed4055677626$var$header = document.querySelector(".c-header");
    if (!$6581ed4055677626$var$header) return;
    const siblingTrigger = $6581ed4055677626$var$header.querySelector("#siblings-trigger");
    const siblings = $6581ed4055677626$var$header.querySelector("#siblings");
    const logo = $6581ed4055677626$var$header.querySelector(".c-header__logo-wrapper");
    if (siblingTrigger && siblings) $6581ed4055677626$var$Siblings(siblingTrigger, siblings, logo);
    const siblingTriggerMobile = $6581ed4055677626$var$header.querySelector("#siblings-trigger-mobile");
    const siblingsMobile = $6581ed4055677626$var$header.querySelector("#siblings-mobile");
    if (siblingTriggerMobile && siblingsMobile) $6581ed4055677626$var$Siblings(siblingTriggerMobile, siblingsMobile);
    $6581ed4055677626$var$OnScroll();
    window.addEventListener("scroll", (0, $f2234d90ae84d9bf$export$de363e709c412c8a)($6581ed4055677626$var$OnScroll, 100));
    window.addEventListener("scroll", (0, $f2234d90ae84d9bf$export$61fc7d43ac8f84b0)($6581ed4055677626$var$OnScroll, 100));
}
function $6581ed4055677626$var$OnScroll() {
    const matches = $6581ed4055677626$var$header.getBoundingClientRect().top === 0;
    if (!$6581ed4055677626$var$isSticky && matches) {
        $6581ed4055677626$var$isSticky = true;
        document.body.classList.add("is-sticky");
    } else if ($6581ed4055677626$var$isSticky && !matches) {
        $6581ed4055677626$var$isSticky = false;
        document.body.classList.remove("is-sticky");
    }
}
function $6581ed4055677626$var$Siblings(trigger, content, logo) {
    trigger.addEventListener("click", ()=>{
        const expanded = trigger.getAttribute("aria-expanded") === "true";
        trigger.setAttribute("aria-expanded", !expanded);
        content.hidden = expanded;
        if (logo) logo.classList.toggle("c-header__logo-wrapper--open", !expanded);
    });
}
var $6581ed4055677626$export$2e2bcd8739ae039 = $6581ed4055677626$var$StickyHeader;


function $f2327c73126bdde1$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $f2327c73126bdde1$var$hasPassiveEvents = false;
if (typeof window !== "undefined") {
    var $f2327c73126bdde1$var$passiveTestOptions = {
        get passive () {
            $f2327c73126bdde1$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener("testPassive", null, $f2327c73126bdde1$var$passiveTestOptions);
    window.removeEventListener("testPassive", null, $f2327c73126bdde1$var$passiveTestOptions);
}
var $f2327c73126bdde1$var$isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var $f2327c73126bdde1$var$locks = [];
var $f2327c73126bdde1$var$documentListenerAdded = false;
var $f2327c73126bdde1$var$initialClientY = -1;
var $f2327c73126bdde1$var$previousBodyOverflowSetting = void 0;
var $f2327c73126bdde1$var$previousBodyPosition = void 0;
var $f2327c73126bdde1$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $f2327c73126bdde1$var$allowTouchMove = function allowTouchMove(el) {
    return $f2327c73126bdde1$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $f2327c73126bdde1$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($f2327c73126bdde1$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $f2327c73126bdde1$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($f2327c73126bdde1$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
            $f2327c73126bdde1$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + "px";
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($f2327c73126bdde1$var$previousBodyOverflowSetting === undefined) {
        $f2327c73126bdde1$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = "hidden";
    }
};
var $f2327c73126bdde1$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($f2327c73126bdde1$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $f2327c73126bdde1$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $f2327c73126bdde1$var$previousBodyPaddingRight = undefined;
    }
    if ($f2327c73126bdde1$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $f2327c73126bdde1$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $f2327c73126bdde1$var$previousBodyOverflowSetting = undefined;
    }
};
var $f2327c73126bdde1$var$setPositionFixed = function setPositionFixed() {
    return window.requestAnimationFrame(function() {
        // If previousBodyPosition is already set, don't set it again.
        if ($f2327c73126bdde1$var$previousBodyPosition === undefined) {
            $f2327c73126bdde1$var$previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left
            };
            // Update the dom inside an animation frame 
            var _window = window, scrollY = _window.scrollY, scrollX = _window.scrollX, innerHeight = _window.innerHeight;
            document.body.style.position = "fixed";
            document.body.style.top = -scrollY;
            document.body.style.left = -scrollX;
            setTimeout(function() {
                return window.requestAnimationFrame(function() {
                    // Attempt to check if the bottom bar appeared due to the position change
                    var bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollY >= innerHeight) // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = -(scrollY + bottomBarHeight);
                });
            }, 300);
        }
    });
};
var $f2327c73126bdde1$var$restorePositionSetting = function restorePositionSetting() {
    if ($f2327c73126bdde1$var$previousBodyPosition !== undefined) {
        // Convert the position from "px" to Int
        var y = -parseInt(document.body.style.top, 10);
        var x = -parseInt(document.body.style.left, 10);
        // Restore styles
        document.body.style.position = $f2327c73126bdde1$var$previousBodyPosition.position;
        document.body.style.top = $f2327c73126bdde1$var$previousBodyPosition.top;
        document.body.style.left = $f2327c73126bdde1$var$previousBodyPosition.left;
        // Restore scroll
        window.scrollTo(x, y);
        $f2327c73126bdde1$var$previousBodyPosition = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $f2327c73126bdde1$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $f2327c73126bdde1$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $f2327c73126bdde1$var$initialClientY;
    if ($f2327c73126bdde1$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $f2327c73126bdde1$var$preventDefault(event);
    if ($f2327c73126bdde1$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $f2327c73126bdde1$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $f2327c73126bdde1$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($f2327c73126bdde1$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $f2327c73126bdde1$var$locks = [].concat($f2327c73126bdde1$var$_toConsumableArray($f2327c73126bdde1$var$locks), [
        lock
    ]);
    if ($f2327c73126bdde1$var$isIosDevice) $f2327c73126bdde1$var$setPositionFixed();
    else $f2327c73126bdde1$var$setOverflowHidden(options);
    if ($f2327c73126bdde1$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $f2327c73126bdde1$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $f2327c73126bdde1$var$handleScroll(event, targetElement);
        };
        if (!$f2327c73126bdde1$var$documentListenerAdded) {
            document.addEventListener("touchmove", $f2327c73126bdde1$var$preventDefault, $f2327c73126bdde1$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $f2327c73126bdde1$var$documentListenerAdded = true;
        }
    }
};
var $f2327c73126bdde1$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($f2327c73126bdde1$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $f2327c73126bdde1$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($f2327c73126bdde1$var$documentListenerAdded) {
            document.removeEventListener("touchmove", $f2327c73126bdde1$var$preventDefault, $f2327c73126bdde1$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $f2327c73126bdde1$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $f2327c73126bdde1$var$initialClientY = -1;
    }
    if ($f2327c73126bdde1$var$isIosDevice) $f2327c73126bdde1$var$restorePositionSetting();
    else $f2327c73126bdde1$var$restoreOverflowSetting();
    $f2327c73126bdde1$var$locks = [];
};
var $f2327c73126bdde1$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        return;
    }
    $f2327c73126bdde1$var$locks = $f2327c73126bdde1$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($f2327c73126bdde1$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($f2327c73126bdde1$var$documentListenerAdded && $f2327c73126bdde1$var$locks.length === 0) {
            document.removeEventListener("touchmove", $f2327c73126bdde1$var$preventDefault, $f2327c73126bdde1$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $f2327c73126bdde1$var$documentListenerAdded = false;
        }
    }
    if ($f2327c73126bdde1$var$isIosDevice) $f2327c73126bdde1$var$restorePositionSetting();
    else $f2327c73126bdde1$var$restoreOverflowSetting();
};


let $743652607225910f$var$currentModal;
let $743652607225910f$var$currentTrigger;
let $743652607225910f$var$currentScrollPosition = null;
function $743652607225910f$var$Modal() {
    const modals = Array.from(document.querySelectorAll(".c-modal"));
    modals.forEach($743652607225910f$var$setupModal);
    window.addEventListener("keydown", (e)=>$743652607225910f$var$onKeydown(e, modals));
}
// Function to clear video consent from localStorage (for testing or user preference)
function $743652607225910f$export$943c4546d0be2a1f(videoId = null) {
    if (videoId) // Clear consent for a specific video
    localStorage.removeItem(`video_consent_${videoId}`);
    else {
        // Clear all video consents
        const keys = Object.keys(localStorage);
        keys.forEach((key)=>{
            if (key.startsWith("video_consent_")) localStorage.removeItem(key);
        });
    }
}
// Function to check if the user has already given consent for a specific video
function $743652607225910f$var$hasVideoConsent(videoId) {
    const localStorageKey = videoId ? `video_consent_${videoId}` : "video_consent_general";
    return localStorage.getItem(localStorageKey) === "true";
}
function $743652607225910f$var$setupModal(modal) {
    const id = modal.getAttribute("id");
    const triggers = document.querySelectorAll('[href="#' + id + '"]');
    Array.from(triggers).forEach((trigger)=>$743652607225910f$var$setupModalTrigger(trigger, modal));
    Array.from(modal.querySelectorAll(".c-modal__close,.c-modal__wing,.c-header")).forEach((close)=>$743652607225910f$var$setupCloseTrigger(close, modal, triggers[0]));
}
function $743652607225910f$var$setupCloseTrigger(close, modal, trigger) {
    close.addEventListener("click", (e)=>{
        e.preventDefault();
        $743652607225910f$var$closeModal(modal, trigger);
    });
}
function $743652607225910f$var$onPopState(e) {
    e.preventDefault();
    $743652607225910f$var$closeModal($743652607225910f$var$currentModal, $743652607225910f$var$currentTrigger);
}
function $743652607225910f$var$setupModalTrigger(trigger, modal) {
    trigger.addEventListener("click", (e)=>{
        e.preventDefault();
        modal.classList.add("c-modal--open");
        modal.setAttribute("tabIndex", "-1");
        $743652607225910f$var$currentScrollPosition = window.scrollY;
        (0, $f2327c73126bdde1$export$24fdf68abf432c44)(modal);
        $743652607225910f$var$currentModal = modal;
        $743652607225910f$var$currentTrigger = trigger;
        history.pushState(null, document.title, location.href);
        window.addEventListener("popstate", $743652607225910f$var$onPopState);
        const video = modal.querySelector("iframe");
        if (video) {
            // Find the embed wrapper
            const embedWrapper = modal.querySelector(".c-embed__wrapper");
            // Get the cookie policy URL from the embed element
            const embedElement = modal.querySelector(".c-embed");
            const cookiePolicyUrl = embedElement ? embedElement.getAttribute("data-cookie-policy-url") : "https://vimeo.com/cookie_policy";
            // Get video ID to use as a key for localStorage
            const videoId = video.getAttribute("data-src") ? (video.getAttribute("data-src").match(/\/video\/(\d+)/) || [])[1] : null;
            // Check if user has already given consent for this video
            const hasConsent = $743652607225910f$var$hasVideoConsent(videoId);
            if (video.getAttribute("src").includes("player.vimeo")) {
                const player = new Vimeo.Player(video);
                // Create and add the overlay for Vimeo videos if consent hasn't been given
                if (embedWrapper && !hasConsent) // Create overlay if it doesn't exist
                {
                    if (!embedWrapper.querySelector(".c-embed__overlay")) {
                        const overlay = document.createElement("div");
                        overlay.className = "c-embed__overlay";
                        const message = document.createElement("p");
                        // Create the message with a link for "Vimeo cookie policy"
                        const messageText = document.createTextNode("Showing the video will request and load data from Vimeo (");
                        const policyLink = document.createElement("a");
                        policyLink.href = cookiePolicyUrl || "https://vimeo.com/privacy/cookies";
                        policyLink.textContent = "Vimeo cookie policy";
                        policyLink.target = "_blank";
                        policyLink.className = "u-link u-link--consent";
                        policyLink.rel = "noopener noreferrer";
                        const messageTextEnd = document.createTextNode("), along with necessary cookies required for viewing.");
                        message.appendChild(messageText);
                        message.appendChild(policyLink);
                        message.appendChild(messageTextEnd);
                        const playButton = document.createElement("button");
                        playButton.textContent = "Watch the video";
                        playButton.className = "c-button u-link u-sans u-strong u-link-highlight c-button--shadow c-button--shadow-orange";
                        playButton.addEventListener("click", ()=>{
                            // Store consent in localStorage
                            localStorage.setItem(videoId ? `video_consent_${videoId}` : "video_consent_general", "true");
                            // Remove the overlay
                            overlay.remove();
                            // Play the video
                            player.play();
                        });
                        overlay.appendChild(message);
                        overlay.appendChild(playButton);
                        embedWrapper.appendChild(overlay);
                        // Prevent auto-play
                        video.setAttribute("data-autoplay", "0");
                    }
                } else if (hasConsent) // If consent was already given, play the video automatically
                player.play();
            // Don't auto-play the video if no consent
            //player.play();
            } else video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
        }
        setTimeout(()=>{
            const focusId = trigger.getAttribute("data-focus");
            const focusEl = document.getElementById(focusId);
            if (focusEl) {
                focusEl.setAttribute("tabIndex", "-1");
                focusEl.focus();
            } else modal.focus();
        }, 100);
    });
}
function $743652607225910f$var$onKeydown(e, modals) {
    if (e.key === "Escape") modals.forEach((modal)=>{
        if (modal.classList.contains("c-modal--open")) {
            const trigger = document.querySelector('[href="#' + modal.getAttribute("id") + '"]');
            $743652607225910f$var$closeModal(modal, trigger);
        }
    });
}
function $743652607225910f$var$closeModal(modal, trigger) {
    modal.classList.remove("c-modal--open");
    modal.removeAttribute("tabIndex");
    document.documentElement.classList.add("no-smooth-scroll");
    const video = modal.querySelector("iframe");
    if (video) {
        // Remove any overlay if it exists
        const embedWrapper = modal.querySelector(".c-embed__wrapper");
        if (embedWrapper) {
            const overlay = embedWrapper.querySelector(".c-embed__overlay");
            if (overlay) overlay.remove();
        }
        if (video.getAttribute("src").includes("player.vimeo")) {
            const player = new Vimeo.Player(video);
            player.pause();
        } else video.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', "*");
    }
    window.removeEventListener("popstate", $743652607225910f$var$onPopState);
    trigger && trigger.focus();
    window.location.hash = trigger.id;
    setTimeout(()=>{
        window.scrollTo(0, $743652607225910f$var$currentScrollPosition);
        history.replaceState(null, document.title, window.location.pathname);
        (0, $f2327c73126bdde1$export$e5d0524c3725571e)(modal);
    }, 1);
    setTimeout(()=>{
        document.documentElement.classList.remove("no-smooth-scroll");
    }, 100);
}
var $743652607225910f$export$2e2bcd8739ae039 = $743652607225910f$var$Modal;



let $f479ac1331318768$var$currentColumns = 0;
let $f479ac1331318768$var$count = 0;
let $f479ac1331318768$var$children = [];
let $f479ac1331318768$var$tabTriggers = [];
let $f479ac1331318768$var$tabs = [];
let $f479ac1331318768$var$el;
function $f479ac1331318768$var$Rack() {
    $f479ac1331318768$var$el = document.querySelector(".c-lessons__rack");
    if (!$f479ac1331318768$var$el) return;
    $f479ac1331318768$var$children = Array.from($f479ac1331318768$var$el.children);
    $f479ac1331318768$var$count = $f479ac1331318768$var$children.length;
    const lessons = Array.from($f479ac1331318768$var$el.querySelectorAll(".c-lesson"));
    if (!$f479ac1331318768$var$count) return;
    lessons[0].classList.add("c-lesson--active");
    $f479ac1331318768$var$el.addEventListener("click", $f479ac1331318768$var$onClick);
    $f479ac1331318768$var$onResize();
    window.addEventListener("resize", (0, $f2234d90ae84d9bf$export$de363e709c412c8a)($f479ac1331318768$var$onResize, 500));
    window.addEventListener("resize", (0, $f2234d90ae84d9bf$export$61fc7d43ac8f84b0)($f479ac1331318768$var$onResize, 500));
    $f479ac1331318768$var$tabTriggers = Array.from(document.querySelectorAll(".c-view-tab__controls a"));
    $f479ac1331318768$var$tabTriggers.forEach((el)=>{
        el.addEventListener("click", $f479ac1331318768$var$onTabClick);
    });
    $f479ac1331318768$var$tabs = Array.from(document.querySelectorAll(".c-view-tab"));
}
function $f479ac1331318768$var$onTabClick(e) {
    e.preventDefault();
    const id = e.currentTarget.getAttribute("href").replace("#", "");
    $f479ac1331318768$var$tabs.forEach((tab)=>{
        if (tab.id === id) tab.classList.add("c-view-tab--active");
        else tab.classList.remove("c-view-tab--active");
    });
    $f479ac1331318768$var$tabTriggers.forEach((trigger)=>{
        if (e.currentTarget === trigger) trigger.setAttribute("aria-expanded", true);
        else trigger.removeAttribute("aria-expanded", true);
    });
}
function $f479ac1331318768$var$onClick(e) {
    const { target: target } = e;
    if (target.nodeName !== "BUTTON") return;
    e.preventDefault();
    const active = $f479ac1331318768$var$el.querySelector(".c-lesson--active");
    if (active) active.classList.remove("c-lesson--active");
    target.parentNode.children[0].classList.add("c-lesson--active");
}
function $f479ac1331318768$var$onResize() {
    const { innerWidth: innerWidth } = window;
    let columnCount;
    if (innerWidth < 610) columnCount = 1;
    else if (innerWidth < 920) columnCount = 2;
    else if (innerWidth < 1240) columnCount = 3;
    else columnCount = 4;
    if (columnCount === $f479ac1331318768$var$currentColumns) return;
    $f479ac1331318768$var$currentColumns = columnCount;
    const rows = Math.ceil($f479ac1331318768$var$count / $f479ac1331318768$var$currentColumns);
    let html = "";
    let index = 0;
    for(let rowIndex = 0; rowIndex < rows; rowIndex++){
        let rowHtml = "<div>";
        for(let columnIndex = 0; columnIndex < $f479ac1331318768$var$currentColumns; columnIndex++){
            const child = $f479ac1331318768$var$children[index];
            if (child) rowHtml += child.outerHTML;
            index++;
        }
        rowHtml += "</div>";
        html += rowHtml;
    }
    $f479ac1331318768$var$el.innerHTML = html;
}
var $f479ac1331318768$export$2e2bcd8739ae039 = $f479ac1331318768$var$Rack;



/*!
 * ScrollTrigger 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $5d1c91dc7d8b7a2c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5d1c91dc7d8b7a2c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5d1c91dc7d8b7a2c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5d1c91dc7d8b7a2c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $5d1c91dc7d8b7a2c$var$gsap, $5d1c91dc7d8b7a2c$var$_coreInitted, $5d1c91dc7d8b7a2c$var$_clamp, $5d1c91dc7d8b7a2c$var$_win, $5d1c91dc7d8b7a2c$var$_doc, $5d1c91dc7d8b7a2c$var$_docEl, $5d1c91dc7d8b7a2c$var$_body, $5d1c91dc7d8b7a2c$var$_isTouch, $5d1c91dc7d8b7a2c$var$_pointerType, $5d1c91dc7d8b7a2c$var$ScrollTrigger, $5d1c91dc7d8b7a2c$var$_root, $5d1c91dc7d8b7a2c$var$_normalizer, $5d1c91dc7d8b7a2c$var$_eventTypes, $5d1c91dc7d8b7a2c$var$_context, $5d1c91dc7d8b7a2c$var$_getGSAP = function _getGSAP() {
    return $5d1c91dc7d8b7a2c$var$gsap || typeof window !== "undefined" && ($5d1c91dc7d8b7a2c$var$gsap = window.gsap) && $5d1c91dc7d8b7a2c$var$gsap.registerPlugin && $5d1c91dc7d8b7a2c$var$gsap;
}, $5d1c91dc7d8b7a2c$var$_startup = 1, $5d1c91dc7d8b7a2c$var$_observers = [], $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683 = [], $5d1c91dc7d8b7a2c$export$d8e56d510a804d0a = [], $5d1c91dc7d8b7a2c$var$_getTime = Date.now, $5d1c91dc7d8b7a2c$var$_bridge = function _bridge(name, value) {
    return value;
}, $5d1c91dc7d8b7a2c$var$_integrate = function _integrate() {
    var core = $5d1c91dc7d8b7a2c$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $5d1c91dc7d8b7a2c$export$d8e56d510a804d0a);
    $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683 = scrollers;
    $5d1c91dc7d8b7a2c$export$d8e56d510a804d0a = proxies;
    $5d1c91dc7d8b7a2c$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $5d1c91dc7d8b7a2c$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$5d1c91dc7d8b7a2c$export$d8e56d510a804d0a.indexOf(element) && $5d1c91dc7d8b7a2c$export$d8e56d510a804d0a[$5d1c91dc7d8b7a2c$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $5d1c91dc7d8b7a2c$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$5d1c91dc7d8b7a2c$var$_root.indexOf(el);
}, $5d1c91dc7d8b7a2c$var$_addListener = function _addListener(element, type, func, passive, capture) {
    return element.addEventListener(type, func, {
        passive: passive !== false,
        capture: !!capture
    });
}, $5d1c91dc7d8b7a2c$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $5d1c91dc7d8b7a2c$var$_scrollLeft = "scrollLeft", $5d1c91dc7d8b7a2c$var$_scrollTop = "scrollTop", $5d1c91dc7d8b7a2c$var$_onScroll = function _onScroll() {
    return $5d1c91dc7d8b7a2c$var$_normalizer && $5d1c91dc7d8b7a2c$var$_normalizer.isPressed || $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683.cache++;
}, $5d1c91dc7d8b7a2c$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $5d1c91dc7d8b7a2c$var$_startup && ($5d1c91dc7d8b7a2c$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $5d1c91dc7d8b7a2c$var$_normalizer && $5d1c91dc7d8b7a2c$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($5d1c91dc7d8b7a2c$var$_normalizer && $5d1c91dc7d8b7a2c$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683.cache;
            isNormalizing && $5d1c91dc7d8b7a2c$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $5d1c91dc7d8b7a2c$var$_bridge("ref")) {
            cachingFunc.cacheID = $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1 = {
    s: $5d1c91dc7d8b7a2c$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $5d1c91dc7d8b7a2c$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $5d1c91dc7d8b7a2c$var$_win.scrollTo(value, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d.sc()) : $5d1c91dc7d8b7a2c$var$_win.pageXOffset || $5d1c91dc7d8b7a2c$var$_doc[$5d1c91dc7d8b7a2c$var$_scrollLeft] || $5d1c91dc7d8b7a2c$var$_docEl[$5d1c91dc7d8b7a2c$var$_scrollLeft] || $5d1c91dc7d8b7a2c$var$_body[$5d1c91dc7d8b7a2c$var$_scrollLeft] || 0;
    })
}, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d = {
    s: $5d1c91dc7d8b7a2c$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1,
    sc: $5d1c91dc7d8b7a2c$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $5d1c91dc7d8b7a2c$var$_win.scrollTo($5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1.sc(), value) : $5d1c91dc7d8b7a2c$var$_win.pageYOffset || $5d1c91dc7d8b7a2c$var$_doc[$5d1c91dc7d8b7a2c$var$_scrollTop] || $5d1c91dc7d8b7a2c$var$_docEl[$5d1c91dc7d8b7a2c$var$_scrollTop] || $5d1c91dc7d8b7a2c$var$_body[$5d1c91dc7d8b7a2c$var$_scrollTop] || 0;
    })
}, $5d1c91dc7d8b7a2c$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $5d1c91dc7d8b7a2c$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $5d1c91dc7d8b7a2c$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $5d1c91dc7d8b7a2c$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $5d1c91dc7d8b7a2c$export$4330f3a92e5d2e94(element) && (element = $5d1c91dc7d8b7a2c$var$_doc.scrollingElement || $5d1c91dc7d8b7a2c$var$_docEl);
    var i = $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683.indexOf(element), offset = sc === $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683.push(element) - 1);
    $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683[i + offset] || $5d1c91dc7d8b7a2c$var$_addListener(element, "scroll", $5d1c91dc7d8b7a2c$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683[i + offset], func = prev || ($5d1c91dc7d8b7a2c$export$3cd1cee43d19b683[i + offset] = $5d1c91dc7d8b7a2c$var$_scrollCacheFunc($5d1c91dc7d8b7a2c$export$6078f1ef08b38af9(element, s), true) || ($5d1c91dc7d8b7a2c$export$4330f3a92e5d2e94(element) ? sc : $5d1c91dc7d8b7a2c$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $5d1c91dc7d8b7a2c$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $5d1c91dc7d8b7a2c$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $5d1c91dc7d8b7a2c$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $5d1c91dc7d8b7a2c$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $5d1c91dc7d8b7a2c$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $5d1c91dc7d8b7a2c$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $5d1c91dc7d8b7a2c$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $5d1c91dc7d8b7a2c$var$_setScrollTrigger = function _setScrollTrigger() {
    $5d1c91dc7d8b7a2c$var$ScrollTrigger = $5d1c91dc7d8b7a2c$var$gsap.core.globals().ScrollTrigger;
    $5d1c91dc7d8b7a2c$var$ScrollTrigger && $5d1c91dc7d8b7a2c$var$ScrollTrigger.core && $5d1c91dc7d8b7a2c$var$_integrate();
}, $5d1c91dc7d8b7a2c$var$_initCore = function _initCore(core) {
    $5d1c91dc7d8b7a2c$var$gsap = core || $5d1c91dc7d8b7a2c$var$_getGSAP();
    if (!$5d1c91dc7d8b7a2c$var$_coreInitted && $5d1c91dc7d8b7a2c$var$gsap && typeof document !== "undefined" && document.body) {
        $5d1c91dc7d8b7a2c$var$_win = window;
        $5d1c91dc7d8b7a2c$var$_doc = document;
        $5d1c91dc7d8b7a2c$var$_docEl = $5d1c91dc7d8b7a2c$var$_doc.documentElement;
        $5d1c91dc7d8b7a2c$var$_body = $5d1c91dc7d8b7a2c$var$_doc.body;
        $5d1c91dc7d8b7a2c$var$_root = [
            $5d1c91dc7d8b7a2c$var$_win,
            $5d1c91dc7d8b7a2c$var$_doc,
            $5d1c91dc7d8b7a2c$var$_docEl,
            $5d1c91dc7d8b7a2c$var$_body
        ];
        $5d1c91dc7d8b7a2c$var$_clamp = $5d1c91dc7d8b7a2c$var$gsap.utils.clamp;
        $5d1c91dc7d8b7a2c$var$_context = $5d1c91dc7d8b7a2c$var$gsap.core.context || function() {};
        $5d1c91dc7d8b7a2c$var$_pointerType = "onpointerenter" in $5d1c91dc7d8b7a2c$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $5d1c91dc7d8b7a2c$var$_isTouch = $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b.isTouch = $5d1c91dc7d8b7a2c$var$_win.matchMedia && $5d1c91dc7d8b7a2c$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $5d1c91dc7d8b7a2c$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $5d1c91dc7d8b7a2c$var$_eventTypes = $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $5d1c91dc7d8b7a2c$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $5d1c91dc7d8b7a2c$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $5d1c91dc7d8b7a2c$var$_startup = 0;
        }, 500);
        $5d1c91dc7d8b7a2c$var$_setScrollTrigger();
        $5d1c91dc7d8b7a2c$var$_coreInitted = 1;
    }
    return $5d1c91dc7d8b7a2c$var$_coreInitted;
};
$5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1.op = $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d;
$5d1c91dc7d8b7a2c$export$3cd1cee43d19b683.cache = 0;
var $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $5d1c91dc7d8b7a2c$var$_coreInitted || $5d1c91dc7d8b7a2c$var$_initCore($5d1c91dc7d8b7a2c$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $5d1c91dc7d8b7a2c$var$ScrollTrigger || $5d1c91dc7d8b7a2c$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $5d1c91dc7d8b7a2c$export$937374fea3f88711(target) || $5d1c91dc7d8b7a2c$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $5d1c91dc7d8b7a2c$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($5d1c91dc7d8b7a2c$var$_win.getComputedStyle($5d1c91dc7d8b7a2c$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, passive = vars.passive || !preventDefault, scrollFuncX = $5d1c91dc7d8b7a2c$export$8665aac53dad5647(target, $5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1), scrollFuncY = $5d1c91dc7d8b7a2c$export$8665aac53dad5647(target, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $5d1c91dc7d8b7a2c$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $5d1c91dc7d8b7a2c$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $5d1c91dc7d8b7a2c$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $5d1c91dc7d8b7a2c$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && ~ignore.indexOf(e.target) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $5d1c91dc7d8b7a2c$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $5d1c91dc7d8b7a2c$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDrag(self);
                    dragged = false;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $5d1c91dc7d8b7a2c$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum) {
                onDrag && (dragged = true);
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
                isDragging || onDragStart && onDragStart(self);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $5d1c91dc7d8b7a2c$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $5d1c91dc7d8b7a2c$var$_addListener(isNormalizer ? target : ownerDoc, $5d1c91dc7d8b7a2c$var$_eventTypes[1], _onDrag, passive, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            $5d1c91dc7d8b7a2c$var$_removeListener(isNormalizer ? target : ownerDoc, $5d1c91dc7d8b7a2c$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging, isDragNotClick = wasDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $5d1c91dc7d8b7a2c$var$_getEvent(e);
            if (!isDragNotClick && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset(); //if (preventDefault && allowClicks && self.isPressed) { // check isPressed because in a rare edge case, the inputObserver in ScrollTrigger may stopPropagation() on the press/drag, so the onRelease may get fired without the onPress/onDrag ever getting called, thus it could trigger a click to occur on a link after scroll-dragging it.
                if (preventDefault && allowClicks) $5d1c91dc7d8b7a2c$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($5d1c91dc7d8b7a2c$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $5d1c91dc7d8b7a2c$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && wasDragging && !isNormalizer && onStopDelayedCall.restart(true);
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, isDragNotClick);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $5d1c91dc7d8b7a2c$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $5d1c91dc7d8b7a2c$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            onStop && onStopDelayedCall.restart(true);
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $5d1c91dc7d8b7a2c$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $5d1c91dc7d8b7a2c$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $5d1c91dc7d8b7a2c$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $5d1c91dc7d8b7a2c$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $5d1c91dc7d8b7a2c$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $5d1c91dc7d8b7a2c$var$_addListener(isViewport ? ownerDoc : target, "scroll", $5d1c91dc7d8b7a2c$var$_onScroll);
                type.indexOf("scroll") >= 0 && $5d1c91dc7d8b7a2c$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, passive, capture);
                type.indexOf("wheel") >= 0 && $5d1c91dc7d8b7a2c$var$_addListener(target, "wheel", _onWheel, passive, capture);
                if (type.indexOf("touch") >= 0 && $5d1c91dc7d8b7a2c$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $5d1c91dc7d8b7a2c$var$_addListener(target, $5d1c91dc7d8b7a2c$var$_eventTypes[0], _onPress, passive, capture);
                    $5d1c91dc7d8b7a2c$var$_addListener(ownerDoc, $5d1c91dc7d8b7a2c$var$_eventTypes[2], _onRelease);
                    $5d1c91dc7d8b7a2c$var$_addListener(ownerDoc, $5d1c91dc7d8b7a2c$var$_eventTypes[3], _onRelease);
                    allowClicks && $5d1c91dc7d8b7a2c$var$_addListener(target, "click", clickCapture, true, true);
                    onClick && $5d1c91dc7d8b7a2c$var$_addListener(target, "click", _onClick);
                    onGestureStart && $5d1c91dc7d8b7a2c$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $5d1c91dc7d8b7a2c$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $5d1c91dc7d8b7a2c$var$_addListener(target, $5d1c91dc7d8b7a2c$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $5d1c91dc7d8b7a2c$var$_addListener(target, $5d1c91dc7d8b7a2c$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $5d1c91dc7d8b7a2c$var$_addListener(target, $5d1c91dc7d8b7a2c$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $5d1c91dc7d8b7a2c$var$_observers.filter(function(o) {
                    return o !== self && $5d1c91dc7d8b7a2c$export$4330f3a92e5d2e94(o.target);
                }).length || $5d1c91dc7d8b7a2c$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $5d1c91dc7d8b7a2c$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $5d1c91dc7d8b7a2c$var$_removeListener(isNormalizer ? target : ownerDoc, $5d1c91dc7d8b7a2c$var$_eventTypes[1], _onDrag, true);
                }
                $5d1c91dc7d8b7a2c$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $5d1c91dc7d8b7a2c$var$_removeListener(target, "wheel", _onWheel, capture);
                $5d1c91dc7d8b7a2c$var$_removeListener(target, $5d1c91dc7d8b7a2c$var$_eventTypes[0], _onPress, capture);
                $5d1c91dc7d8b7a2c$var$_removeListener(ownerDoc, $5d1c91dc7d8b7a2c$var$_eventTypes[2], _onRelease);
                $5d1c91dc7d8b7a2c$var$_removeListener(ownerDoc, $5d1c91dc7d8b7a2c$var$_eventTypes[3], _onRelease);
                $5d1c91dc7d8b7a2c$var$_removeListener(target, "click", clickCapture, true);
                $5d1c91dc7d8b7a2c$var$_removeListener(target, "click", _onClick);
                $5d1c91dc7d8b7a2c$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $5d1c91dc7d8b7a2c$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $5d1c91dc7d8b7a2c$var$_removeListener(target, $5d1c91dc7d8b7a2c$var$_pointerType + "enter", _onHover);
                $5d1c91dc7d8b7a2c$var$_removeListener(target, $5d1c91dc7d8b7a2c$var$_pointerType + "leave", _onHoverEnd);
                $5d1c91dc7d8b7a2c$var$_removeListener(target, $5d1c91dc7d8b7a2c$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $5d1c91dc7d8b7a2c$var$_observers.indexOf(self);
            i >= 0 && $5d1c91dc7d8b7a2c$var$_observers.splice(i, 1);
            $5d1c91dc7d8b7a2c$var$_normalizer === self && ($5d1c91dc7d8b7a2c$var$_normalizer = 0);
        };
        $5d1c91dc7d8b7a2c$var$_observers.push(self);
        isNormalizer && $5d1c91dc7d8b7a2c$export$4330f3a92e5d2e94(target) && ($5d1c91dc7d8b7a2c$var$_normalizer = self);
        self.enable(event);
    };
    $5d1c91dc7d8b7a2c$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b.version = "3.12.5";
$5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b(vars);
};
$5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b.register = $5d1c91dc7d8b7a2c$var$_initCore;
$5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b.getAll = function() {
    return $5d1c91dc7d8b7a2c$var$_observers.slice();
};
$5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b.getById = function(id) {
    return $5d1c91dc7d8b7a2c$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$5d1c91dc7d8b7a2c$var$_getGSAP() && $5d1c91dc7d8b7a2c$var$gsap.registerPlugin($5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b);


var $ab59d772409cf5f3$var$gsap, $ab59d772409cf5f3$var$_coreInitted, $ab59d772409cf5f3$var$_win, $ab59d772409cf5f3$var$_doc, $ab59d772409cf5f3$var$_docEl, $ab59d772409cf5f3$var$_body, $ab59d772409cf5f3$var$_root, $ab59d772409cf5f3$var$_resizeDelay, $ab59d772409cf5f3$var$_toArray, $ab59d772409cf5f3$var$_clamp, $ab59d772409cf5f3$var$_time2, $ab59d772409cf5f3$var$_syncInterval, $ab59d772409cf5f3$var$_refreshing, $ab59d772409cf5f3$var$_pointerIsDown, $ab59d772409cf5f3$var$_transformProp, $ab59d772409cf5f3$var$_i, $ab59d772409cf5f3$var$_prevWidth, $ab59d772409cf5f3$var$_prevHeight, $ab59d772409cf5f3$var$_autoRefresh, $ab59d772409cf5f3$var$_sort, $ab59d772409cf5f3$var$_suppressOverwrites, $ab59d772409cf5f3$var$_ignoreResize, $ab59d772409cf5f3$var$_normalizer, $ab59d772409cf5f3$var$_ignoreMobileResize, $ab59d772409cf5f3$var$_baseScreenHeight, $ab59d772409cf5f3$var$_baseScreenWidth, $ab59d772409cf5f3$var$_fixIOSBug, $ab59d772409cf5f3$var$_context, $ab59d772409cf5f3$var$_scrollRestoration, $ab59d772409cf5f3$var$_div100vh, $ab59d772409cf5f3$var$_100vh, $ab59d772409cf5f3$var$_isReverted, $ab59d772409cf5f3$var$_clampingMax, $ab59d772409cf5f3$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$ab59d772409cf5f3$var$_startup = 1, $ab59d772409cf5f3$var$_getTime = Date.now, $ab59d772409cf5f3$var$_time1 = $ab59d772409cf5f3$var$_getTime(), $ab59d772409cf5f3$var$_lastScrollTime = 0, $ab59d772409cf5f3$var$_enabled = 0, $ab59d772409cf5f3$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $ab59d772409cf5f3$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $ab59d772409cf5f3$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$ab59d772409cf5f3$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $ab59d772409cf5f3$var$_rafBugFix = function _rafBugFix() {
    return $ab59d772409cf5f3$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$ab59d772409cf5f3$var$_pointerDownHandler = function _pointerDownHandler() {
    return $ab59d772409cf5f3$var$_pointerIsDown = 1;
}, $ab59d772409cf5f3$var$_pointerUpHandler = function _pointerUpHandler() {
    return $ab59d772409cf5f3$var$_pointerIsDown = 0;
}, $ab59d772409cf5f3$var$_passThrough = function _passThrough(v) {
    return v;
}, $ab59d772409cf5f3$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $ab59d772409cf5f3$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $ab59d772409cf5f3$var$_getGSAP = function _getGSAP() {
    return $ab59d772409cf5f3$var$gsap || $ab59d772409cf5f3$var$_windowExists() && ($ab59d772409cf5f3$var$gsap = window.gsap) && $ab59d772409cf5f3$var$gsap.registerPlugin && $ab59d772409cf5f3$var$gsap;
}, $ab59d772409cf5f3$var$_isViewport = function _isViewport(e) {
    return !!~$ab59d772409cf5f3$var$_root.indexOf(e);
}, $ab59d772409cf5f3$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $ab59d772409cf5f3$var$_100vh : $ab59d772409cf5f3$var$_win["inner" + dimensionProperty]) || $ab59d772409cf5f3$var$_docEl["client" + dimensionProperty] || $ab59d772409cf5f3$var$_body["client" + dimensionProperty];
}, $ab59d772409cf5f3$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $5d1c91dc7d8b7a2c$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($ab59d772409cf5f3$var$_isViewport(element) ? function() {
        $ab59d772409cf5f3$var$_winOffsets.width = $ab59d772409cf5f3$var$_win.innerWidth;
        $ab59d772409cf5f3$var$_winOffsets.height = $ab59d772409cf5f3$var$_100vh;
        return $ab59d772409cf5f3$var$_winOffsets;
    } : function() {
        return $ab59d772409cf5f3$var$_getBounds(element);
    });
}, $ab59d772409cf5f3$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $5d1c91dc7d8b7a2c$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $ab59d772409cf5f3$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $ab59d772409cf5f3$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $5d1c91dc7d8b7a2c$export$d8e56d510a804d0a).indexOf(element) ? $ab59d772409cf5f3$var$_getBoundsFunc(element) : function() {
        return $ab59d772409cf5f3$var$_winOffsets;
    };
}, $ab59d772409cf5f3$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $5d1c91dc7d8b7a2c$export$6078f1ef08b38af9)(element, s)) ? a() - $ab59d772409cf5f3$var$_getBoundsFunc(element)()[d] : $ab59d772409cf5f3$var$_isViewport(element) ? ($ab59d772409cf5f3$var$_docEl[s] || $ab59d772409cf5f3$var$_body[s]) - $ab59d772409cf5f3$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $ab59d772409cf5f3$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $ab59d772409cf5f3$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($ab59d772409cf5f3$var$_autoRefresh[i + 1])) && func($ab59d772409cf5f3$var$_autoRefresh[i], $ab59d772409cf5f3$var$_autoRefresh[i + 1], $ab59d772409cf5f3$var$_autoRefresh[i + 2]);
}, $ab59d772409cf5f3$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $ab59d772409cf5f3$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $ab59d772409cf5f3$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $ab59d772409cf5f3$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $ab59d772409cf5f3$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $ab59d772409cf5f3$var$_callback = function _callback(self, func) {
    if (self.enabled) {
        var result = self._ctx ? self._ctx.add(function() {
            return func(self);
        }) : func(self);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $ab59d772409cf5f3$var$_abs = Math.abs, $ab59d772409cf5f3$var$_left = "left", $ab59d772409cf5f3$var$_top = "top", $ab59d772409cf5f3$var$_right = "right", $ab59d772409cf5f3$var$_bottom = "bottom", $ab59d772409cf5f3$var$_width = "width", $ab59d772409cf5f3$var$_height = "height", $ab59d772409cf5f3$var$_Right = "Right", $ab59d772409cf5f3$var$_Left = "Left", $ab59d772409cf5f3$var$_Top = "Top", $ab59d772409cf5f3$var$_Bottom = "Bottom", $ab59d772409cf5f3$var$_padding = "padding", $ab59d772409cf5f3$var$_margin = "margin", $ab59d772409cf5f3$var$_Width = "Width", $ab59d772409cf5f3$var$_Height = "Height", $ab59d772409cf5f3$var$_px = "px", $ab59d772409cf5f3$var$_getComputedStyle = function _getComputedStyle(element) {
    return $ab59d772409cf5f3$var$_win.getComputedStyle(element);
}, $ab59d772409cf5f3$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $ab59d772409cf5f3$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $ab59d772409cf5f3$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $ab59d772409cf5f3$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $ab59d772409cf5f3$var$_getComputedStyle(element)[$ab59d772409cf5f3$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $ab59d772409cf5f3$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $ab59d772409cf5f3$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $ab59d772409cf5f3$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $ab59d772409cf5f3$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $ab59d772409cf5f3$var$gsap.utils.snap($ab59d772409cf5f3$var$_getLabelRatioArray(animation), value);
    };
}, $ab59d772409cf5f3$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $ab59d772409cf5f3$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $ab59d772409cf5f3$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $ab59d772409cf5f3$var$_snapDirectional($ab59d772409cf5f3$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $ab59d772409cf5f3$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $ab59d772409cf5f3$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $ab59d772409cf5f3$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $ab59d772409cf5f3$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $ab59d772409cf5f3$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $ab59d772409cf5f3$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $ab59d772409cf5f3$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $ab59d772409cf5f3$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($ab59d772409cf5f3$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $ab59d772409cf5f3$var$_keywords ? $ab59d772409cf5f3$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $ab59d772409cf5f3$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $ab59d772409cf5f3$var$_doc.createElement("div"), useFixedPosition = $ab59d772409cf5f3$var$_isViewport(container) || (0, $5d1c91dc7d8b7a2c$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $ab59d772409cf5f3$var$_body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d) ? $ab59d772409cf5f3$var$_right : $ab59d772409cf5f3$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $ab59d772409cf5f3$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $ab59d772409cf5f3$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $ab59d772409cf5f3$var$_Width] = 1;
    vars["border" + oppositeSide + $ab59d772409cf5f3$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $ab59d772409cf5f3$var$gsap.set(marker, vars);
}, $ab59d772409cf5f3$var$_triggers = [], $ab59d772409cf5f3$var$_ids = {}, $ab59d772409cf5f3$var$_rafID, $ab59d772409cf5f3$var$_sync = function _sync() {
    return $ab59d772409cf5f3$var$_getTime() - $ab59d772409cf5f3$var$_lastScrollTime > 34 && ($ab59d772409cf5f3$var$_rafID || ($ab59d772409cf5f3$var$_rafID = requestAnimationFrame($ab59d772409cf5f3$var$_updateAll)));
}, $ab59d772409cf5f3$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$ab59d772409cf5f3$var$_normalizer || !$ab59d772409cf5f3$var$_normalizer.isPressed || $ab59d772409cf5f3$var$_normalizer.startX > $ab59d772409cf5f3$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).cache++;
        if ($ab59d772409cf5f3$var$_normalizer) $ab59d772409cf5f3$var$_rafID || ($ab59d772409cf5f3$var$_rafID = requestAnimationFrame($ab59d772409cf5f3$var$_updateAll));
        else $ab59d772409cf5f3$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $ab59d772409cf5f3$var$_lastScrollTime || $ab59d772409cf5f3$var$_dispatch("scrollStart");
        $ab59d772409cf5f3$var$_lastScrollTime = $ab59d772409cf5f3$var$_getTime();
    }
}, $ab59d772409cf5f3$var$_setBaseDimensions = function _setBaseDimensions() {
    $ab59d772409cf5f3$var$_baseScreenWidth = $ab59d772409cf5f3$var$_win.innerWidth;
    $ab59d772409cf5f3$var$_baseScreenHeight = $ab59d772409cf5f3$var$_win.innerHeight;
}, $ab59d772409cf5f3$var$_onResize = function _onResize() {
    (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).cache++;
    !$ab59d772409cf5f3$var$_refreshing && !$ab59d772409cf5f3$var$_ignoreResize && !$ab59d772409cf5f3$var$_doc.fullscreenElement && !$ab59d772409cf5f3$var$_doc.webkitFullscreenElement && (!$ab59d772409cf5f3$var$_ignoreMobileResize || $ab59d772409cf5f3$var$_baseScreenWidth !== $ab59d772409cf5f3$var$_win.innerWidth || Math.abs($ab59d772409cf5f3$var$_win.innerHeight - $ab59d772409cf5f3$var$_baseScreenHeight) > $ab59d772409cf5f3$var$_win.innerHeight * 0.25) && $ab59d772409cf5f3$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$ab59d772409cf5f3$var$_listeners = {}, $ab59d772409cf5f3$var$_emptyArray = [], $ab59d772409cf5f3$var$_softRefresh = function _softRefresh() {
    return $ab59d772409cf5f3$var$_removeListener($ab59d772409cf5f3$export$875bcbe48555930, "scrollEnd", _softRefresh) || $ab59d772409cf5f3$var$_refreshAll(true);
}, $ab59d772409cf5f3$var$_dispatch = function _dispatch(type) {
    return $ab59d772409cf5f3$var$_listeners[type] && $ab59d772409cf5f3$var$_listeners[type].map(function(f) {
        return f();
    }) || $ab59d772409cf5f3$var$_emptyArray;
}, $ab59d772409cf5f3$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$ab59d772409cf5f3$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $ab59d772409cf5f3$var$_savedStyles.length; i += 5)if (!media || $ab59d772409cf5f3$var$_savedStyles[i + 4] && $ab59d772409cf5f3$var$_savedStyles[i + 4].query === media) {
        $ab59d772409cf5f3$var$_savedStyles[i].style.cssText = $ab59d772409cf5f3$var$_savedStyles[i + 1];
        $ab59d772409cf5f3$var$_savedStyles[i].getBBox && $ab59d772409cf5f3$var$_savedStyles[i].setAttribute("transform", $ab59d772409cf5f3$var$_savedStyles[i + 2] || "");
        $ab59d772409cf5f3$var$_savedStyles[i + 3].uncache = 1;
    }
}, $ab59d772409cf5f3$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($ab59d772409cf5f3$var$_i = 0; $ab59d772409cf5f3$var$_i < $ab59d772409cf5f3$var$_triggers.length; $ab59d772409cf5f3$var$_i++){
        trigger = $ab59d772409cf5f3$var$_triggers[$ab59d772409cf5f3$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    $ab59d772409cf5f3$var$_isReverted = true;
    media && $ab59d772409cf5f3$var$_revertRecorded(media);
    media || $ab59d772409cf5f3$var$_dispatch("revert");
}, $ab59d772409cf5f3$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).cache++;
    (force || !$ab59d772409cf5f3$var$_refreshingAll) && (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).forEach(function(obj) {
        return $ab59d772409cf5f3$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $ab59d772409cf5f3$var$_isString(scrollRestoration) && ($ab59d772409cf5f3$var$_win.history.scrollRestoration = $ab59d772409cf5f3$var$_scrollRestoration = scrollRestoration);
}, $ab59d772409cf5f3$var$_refreshingAll, $ab59d772409cf5f3$var$_refreshID = 0, $ab59d772409cf5f3$var$_queueRefreshID, $ab59d772409cf5f3$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($ab59d772409cf5f3$var$_queueRefreshID !== $ab59d772409cf5f3$var$_refreshID) {
        var id = $ab59d772409cf5f3$var$_queueRefreshID = $ab59d772409cf5f3$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $ab59d772409cf5f3$var$_refreshID && $ab59d772409cf5f3$var$_refreshAll(true);
        });
    }
}, $ab59d772409cf5f3$var$_refresh100vh = function _refresh100vh() {
    $ab59d772409cf5f3$var$_body.appendChild($ab59d772409cf5f3$var$_div100vh);
    $ab59d772409cf5f3$var$_100vh = !$ab59d772409cf5f3$var$_normalizer && $ab59d772409cf5f3$var$_div100vh.offsetHeight || $ab59d772409cf5f3$var$_win.innerHeight;
    $ab59d772409cf5f3$var$_body.removeChild($ab59d772409cf5f3$var$_div100vh);
}, $ab59d772409cf5f3$var$_hideAllMarkers = function _hideAllMarkers(hide) {
    return $ab59d772409cf5f3$var$_toArray(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(el) {
        return el.style.display = hide ? "none" : "block";
    });
}, $ab59d772409cf5f3$var$_refreshAll = function _refreshAll(force, skipRevert) {
    if ($ab59d772409cf5f3$var$_lastScrollTime && !force && !$ab59d772409cf5f3$var$_isReverted) {
        $ab59d772409cf5f3$var$_addListener($ab59d772409cf5f3$export$875bcbe48555930, "scrollEnd", $ab59d772409cf5f3$var$_softRefresh);
        return;
    }
    $ab59d772409cf5f3$var$_refresh100vh();
    $ab59d772409cf5f3$var$_refreshingAll = $ab59d772409cf5f3$export$875bcbe48555930.isRefreshing = true;
    (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).forEach(function(obj) {
        return $ab59d772409cf5f3$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    }); // force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
    var refreshInits = $ab59d772409cf5f3$var$_dispatch("refreshInit");
    $ab59d772409cf5f3$var$_sort && $ab59d772409cf5f3$export$875bcbe48555930.sort();
    skipRevert || $ab59d772409cf5f3$var$_revertAll();
    (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($ab59d772409cf5f3$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $ab59d772409cf5f3$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $ab59d772409cf5f3$var$_isReverted = false;
    $ab59d772409cf5f3$var$_triggers.forEach(function(t) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $ab59d772409cf5f3$var$_clampingMax = 1; // pinSpacing might be propping a page open, thus when we .setPositions() to clamp a ScrollTrigger's end we should leave the pinSpacing alone. That's what this flag is for.
    $ab59d772409cf5f3$var$_hideAllMarkers(true);
    $ab59d772409cf5f3$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $ab59d772409cf5f3$var$_maxScroll(t.scroller, t._dir), endClamp = t.vars.end === "max" || t._endClamp && t.end > max, startClamp = t._startClamp && t.start >= max;
        (endClamp || startClamp) && t.setPositions(startClamp ? max - 1 : t.start, endClamp ? Math.max(startClamp ? max : t.start + 1, max) : t.end, true);
    });
    $ab59d772409cf5f3$var$_hideAllMarkers(false);
    $ab59d772409cf5f3$var$_clampingMax = 0;
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($ab59d772409cf5f3$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $ab59d772409cf5f3$var$_clearScrollMemory($ab59d772409cf5f3$var$_scrollRestoration, 1);
    $ab59d772409cf5f3$var$_resizeDelay.pause();
    $ab59d772409cf5f3$var$_refreshID++;
    $ab59d772409cf5f3$var$_refreshingAll = 2;
    $ab59d772409cf5f3$var$_updateAll(2);
    $ab59d772409cf5f3$var$_triggers.forEach(function(t) {
        return $ab59d772409cf5f3$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $ab59d772409cf5f3$var$_refreshingAll = $ab59d772409cf5f3$export$875bcbe48555930.isRefreshing = false;
    $ab59d772409cf5f3$var$_dispatch("refresh");
}, $ab59d772409cf5f3$var$_lastScroll = 0, $ab59d772409cf5f3$var$_direction = 1, $ab59d772409cf5f3$var$_primary, $ab59d772409cf5f3$var$_updateAll = function _updateAll(force) {
    if (force === 2 || !$ab59d772409cf5f3$var$_refreshingAll && !$ab59d772409cf5f3$var$_isReverted) {
        // _isReverted could be true if, for example, a matchMedia() is in the process of executing. We don't want to update during the time everything is reverted.
        $ab59d772409cf5f3$export$875bcbe48555930.isUpdating = true;
        $ab59d772409cf5f3$var$_primary && $ab59d772409cf5f3$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $ab59d772409cf5f3$var$_triggers.length, time = $ab59d772409cf5f3$var$_getTime(), recordVelocity = time - $ab59d772409cf5f3$var$_time1 >= 50, scroll = l && $ab59d772409cf5f3$var$_triggers[0].scroll();
        $ab59d772409cf5f3$var$_direction = $ab59d772409cf5f3$var$_lastScroll > scroll ? -1 : 1;
        $ab59d772409cf5f3$var$_refreshingAll || ($ab59d772409cf5f3$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($ab59d772409cf5f3$var$_lastScrollTime && !$ab59d772409cf5f3$var$_pointerIsDown && time - $ab59d772409cf5f3$var$_lastScrollTime > 200) {
                $ab59d772409cf5f3$var$_lastScrollTime = 0;
                $ab59d772409cf5f3$var$_dispatch("scrollEnd");
            }
            $ab59d772409cf5f3$var$_time2 = $ab59d772409cf5f3$var$_time1;
            $ab59d772409cf5f3$var$_time1 = time;
        }
        if ($ab59d772409cf5f3$var$_direction < 0) {
            $ab59d772409cf5f3$var$_i = l;
            while($ab59d772409cf5f3$var$_i-- > 0)$ab59d772409cf5f3$var$_triggers[$ab59d772409cf5f3$var$_i] && $ab59d772409cf5f3$var$_triggers[$ab59d772409cf5f3$var$_i].update(0, recordVelocity);
            $ab59d772409cf5f3$var$_direction = 1;
        } else for($ab59d772409cf5f3$var$_i = 0; $ab59d772409cf5f3$var$_i < l; $ab59d772409cf5f3$var$_i++)$ab59d772409cf5f3$var$_triggers[$ab59d772409cf5f3$var$_i] && $ab59d772409cf5f3$var$_triggers[$ab59d772409cf5f3$var$_i].update(0, recordVelocity);
        $ab59d772409cf5f3$export$875bcbe48555930.isUpdating = false;
    }
    $ab59d772409cf5f3$var$_rafID = 0;
}, $ab59d772409cf5f3$var$_propNamesToCopy = [
    $ab59d772409cf5f3$var$_left,
    $ab59d772409cf5f3$var$_top,
    $ab59d772409cf5f3$var$_bottom,
    $ab59d772409cf5f3$var$_right,
    $ab59d772409cf5f3$var$_margin + $ab59d772409cf5f3$var$_Bottom,
    $ab59d772409cf5f3$var$_margin + $ab59d772409cf5f3$var$_Right,
    $ab59d772409cf5f3$var$_margin + $ab59d772409cf5f3$var$_Top,
    $ab59d772409cf5f3$var$_margin + $ab59d772409cf5f3$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $ab59d772409cf5f3$var$_stateProps = $ab59d772409cf5f3$var$_propNamesToCopy.concat([
    $ab59d772409cf5f3$var$_width,
    $ab59d772409cf5f3$var$_height,
    "boxSizing",
    "max" + $ab59d772409cf5f3$var$_Width,
    "max" + $ab59d772409cf5f3$var$_Height,
    "position",
    $ab59d772409cf5f3$var$_margin,
    $ab59d772409cf5f3$var$_padding,
    $ab59d772409cf5f3$var$_padding + $ab59d772409cf5f3$var$_Top,
    $ab59d772409cf5f3$var$_padding + $ab59d772409cf5f3$var$_Right,
    $ab59d772409cf5f3$var$_padding + $ab59d772409cf5f3$var$_Bottom,
    $ab59d772409cf5f3$var$_padding + $ab59d772409cf5f3$var$_Left
]), $ab59d772409cf5f3$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $ab59d772409cf5f3$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $ab59d772409cf5f3$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $ab59d772409cf5f3$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $ab59d772409cf5f3$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $ab59d772409cf5f3$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$ab59d772409cf5f3$var$_bottom] = pinStyle[$ab59d772409cf5f3$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$ab59d772409cf5f3$var$_width] = $ab59d772409cf5f3$var$_getSize(pin, (0, $5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1)) + $ab59d772409cf5f3$var$_px;
        spacerStyle[$ab59d772409cf5f3$var$_height] = $ab59d772409cf5f3$var$_getSize(pin, (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d)) + $ab59d772409cf5f3$var$_px;
        spacerStyle[$ab59d772409cf5f3$var$_padding] = pinStyle[$ab59d772409cf5f3$var$_margin] = pinStyle[$ab59d772409cf5f3$var$_top] = pinStyle[$ab59d772409cf5f3$var$_left] = "0";
        $ab59d772409cf5f3$var$_setState(spacerState);
        pinStyle[$ab59d772409cf5f3$var$_width] = pinStyle["max" + $ab59d772409cf5f3$var$_Width] = cs[$ab59d772409cf5f3$var$_width];
        pinStyle[$ab59d772409cf5f3$var$_height] = pinStyle["max" + $ab59d772409cf5f3$var$_Height] = cs[$ab59d772409cf5f3$var$_height];
        pinStyle[$ab59d772409cf5f3$var$_padding] = cs[$ab59d772409cf5f3$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $ab59d772409cf5f3$var$_capsExp = /([A-Z])/g, $ab59d772409cf5f3$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $ab59d772409cf5f3$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($ab59d772409cf5f3$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $ab59d772409cf5f3$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $ab59d772409cf5f3$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($ab59d772409cf5f3$var$_stateProps[i], style[$ab59d772409cf5f3$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $ab59d772409cf5f3$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $ab59d772409cf5f3$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$ab59d772409cf5f3$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $ab59d772409cf5f3$var$_isFunction(value) && (value = value(self));
    if ($ab59d772409cf5f3$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $ab59d772409cf5f3$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$ab59d772409cf5f3$var$_isNumber(value)) {
        $ab59d772409cf5f3$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $5d1c91dc7d8b7a2c$export$937374fea3f88711)(trigger, self) || $ab59d772409cf5f3$var$_body;
        bounds = $ab59d772409cf5f3$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $ab59d772409cf5f3$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $ab59d772409cf5f3$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $ab59d772409cf5f3$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $ab59d772409cf5f3$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $ab59d772409cf5f3$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $ab59d772409cf5f3$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $ab59d772409cf5f3$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $ab59d772409cf5f3$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($ab59d772409cf5f3$var$_body[p1], $ab59d772409cf5f3$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $ab59d772409cf5f3$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $ab59d772409cf5f3$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $ab59d772409cf5f3$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $ab59d772409cf5f3$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $ab59d772409cf5f3$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $ab59d772409cf5f3$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $ab59d772409cf5f3$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $ab59d772409cf5f3$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$ab59d772409cf5f3$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $ab59d772409cf5f3$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $ab59d772409cf5f3$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = value;
        return value;
    };
}, $ab59d772409cf5f3$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $ab59d772409cf5f3$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$ab59d772409cf5f3$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $5d1c91dc7d8b7a2c$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $ab59d772409cf5f3$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.inherit = false;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).cache++;
            getTween.tween && $ab59d772409cf5f3$var$_updateAll(); // if it was interrupted/killed, like in a context.revert(), don't force an updateAll()
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $ab59d772409cf5f3$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $ab59d772409cf5f3$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $ab59d772409cf5f3$export$875bcbe48555930.isTouch && $ab59d772409cf5f3$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $ab59d772409cf5f3$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $ab59d772409cf5f3$var$_coreInitted || ScrollTrigger.register($ab59d772409cf5f3$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $ab59d772409cf5f3$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$ab59d772409cf5f3$var$_enabled) {
            this.update = this.refresh = this.kill = $ab59d772409cf5f3$var$_passThrough;
            return;
        }
        vars = $ab59d772409cf5f3$var$_setDefaults($ab59d772409cf5f3$var$_isString(vars) || $ab59d772409cf5f3$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $ab59d772409cf5f3$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1) : (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $5d1c91dc7d8b7a2c$export$937374fea3f88711)(vars.scroller || $ab59d772409cf5f3$var$_win), scrollerCache = $ab59d772409cf5f3$var$gsap.core.getCache(scroller), isViewport = $ab59d772409cf5f3$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $5d1c91dc7d8b7a2c$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $ab59d772409cf5f3$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($ab59d772409cf5f3$var$_getComputedStyle(scroller)["border" + direction.p2 + $ab59d772409cf5f3$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $ab59d772409cf5f3$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $ab59d772409cf5f3$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $5d1c91dc7d8b7a2c$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $ab59d772409cf5f3$var$_sort = 1;
            vars.refreshPriority === -9999 && ($ab59d772409cf5f3$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $ab59d772409cf5f3$var$_getTweenCreator(scroller, (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d)),
            left: $ab59d772409cf5f3$var$_getTweenCreator(scroller, (0, $5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $ab59d772409cf5f3$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $ab59d772409cf5f3$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                inherit: false,
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://gsap.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$ab59d772409cf5f3$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $ab59d772409cf5f3$var$_body.style && $ab59d772409cf5f3$var$gsap.set(isViewport ? [
                $ab59d772409cf5f3$var$_body,
                $ab59d772409cf5f3$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).forEach(function(o) {
                return $ab59d772409cf5f3$var$_isFunction(o) && o.target === (isViewport ? $ab59d772409cf5f3$var$_doc.scrollingElement || $ab59d772409cf5f3$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $ab59d772409cf5f3$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $ab59d772409cf5f3$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $ab59d772409cf5f3$var$_getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return $ab59d772409cf5f3$var$_snapDirectional(snap.snapTo)(value, $ab59d772409cf5f3$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $ab59d772409cf5f3$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $ab59d772409cf5f3$var$_isObject(snapDurClamp) ? $ab59d772409cf5f3$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $ab59d772409cf5f3$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $ab59d772409cf5f3$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $ab59d772409cf5f3$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$ab59d772409cf5f3$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($ab59d772409cf5f3$var$_getTime() - $ab59d772409cf5f3$var$_time2) * 1000 || 0, change1 = $ab59d772409cf5f3$var$gsap.utils.clamp(-progress, 1 - progress, $ab59d772409cf5f3$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue, endScroll, _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    endValue = snapFunc(naturalEnd, self);
                    $ab59d772409cf5f3$var$_isNumber(endValue) || (endValue = naturalEnd); // in case the function didn't return a number, fall back to using the naturalEnd
                    endScroll = Math.round(start + endValue * change);
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $ab59d772409cf5f3$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($ab59d772409cf5f3$var$_abs(Math.max($ab59d772409cf5f3$var$_abs(naturalEnd - totalProgress), $ab59d772409cf5f3$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $ab59d772409cf5f3$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                if (animation) // the resolution of the scrollbar is limited, so we should correct the scrubbed animation's playhead at the end to match EXACTLY where it was supposed to snap
                                scrubTween ? scrubTween.resetTo("totalProgress", endValue, animation._tTime / animation._tDur) : animation.progress(endValue);
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && _onComplete(self);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && onStart(self, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($ab59d772409cf5f3$var$_ids[id] = self);
        trigger = self.trigger = (0, $5d1c91dc7d8b7a2c$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $5d1c91dc7d8b7a2c$export$937374fea3f88711)(pin);
        $ab59d772409cf5f3$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $ab59d772409cf5f3$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $ab59d772409cf5f3$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $ab59d772409cf5f3$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $ab59d772409cf5f3$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $5d1c91dc7d8b7a2c$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $ab59d772409cf5f3$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $ab59d772409cf5f3$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $ab59d772409cf5f3$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $ab59d772409cf5f3$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $ab59d772409cf5f3$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $ab59d772409cf5f3$var$gsap.getProperty(pin);
            pinSetter = $ab59d772409cf5f3$var$gsap.quickSetter(pin, direction.a, $ab59d772409cf5f3$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $ab59d772409cf5f3$var$_swapPinIn(pin, spacer, cs);
            pinState = $ab59d772409cf5f3$var$_getState(pin);
        }
        if (markers) {
            markerVars = $ab59d772409cf5f3$var$_isObject(markers) ? $ab59d772409cf5f3$var$_setDefaults(markers, $ab59d772409cf5f3$var$_markerDefaults) : $ab59d772409cf5f3$var$_markerDefaults;
            markerStartTrigger = $ab59d772409cf5f3$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $ab59d772409cf5f3$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $5d1c91dc7d8b7a2c$export$937374fea3f88711)((0, $5d1c91dc7d8b7a2c$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $ab59d772409cf5f3$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $ab59d772409cf5f3$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $ab59d772409cf5f3$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $ab59d772409cf5f3$var$_px));
            if (!useFixedPosition && !((0, $5d1c91dc7d8b7a2c$export$d8e56d510a804d0a).length && (0, $5d1c91dc7d8b7a2c$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $ab59d772409cf5f3$var$_makePositionable(isViewport ? $ab59d772409cf5f3$var$_body : scroller);
                $ab59d772409cf5f3$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $ab59d772409cf5f3$var$gsap.quickSetter(markerStartTrigger, direction.a, $ab59d772409cf5f3$var$_px);
                markerEndSetter = $ab59d772409cf5f3$var$gsap.quickSetter(markerEndTrigger, direction.a, $ab59d772409cf5f3$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $ab59d772409cf5f3$var$_triggers[$ab59d772409cf5f3$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $ab59d772409cf5f3$var$_triggers[$ab59d772409cf5f3$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $ab59d772409cf5f3$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $ab59d772409cf5f3$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $ab59d772409cf5f3$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $ab59d772409cf5f3$var$_swapPinIn(pin, spacer, $ab59d772409cf5f3$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $ab59d772409cf5f3$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($ab59d772409cf5f3$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $ab59d772409cf5f3$var$_lastScrollTime) {
                $ab59d772409cf5f3$var$_addListener(ScrollTrigger, "scrollEnd", $ab59d772409cf5f3$var$_softRefresh);
                return;
            }
            !$ab59d772409cf5f3$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $ab59d772409cf5f3$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            invalidateOnRefresh && animation && animation.revert({
                kill: false
            }).invalidate();
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $ab59d772409cf5f3$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $ab59d772409cf5f3$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $ab59d772409cf5f3$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $5d1c91dc7d8b7a2c$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $ab59d772409cf5f3$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $ab59d772409cf5f3$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $ab59d772409cf5f3$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $ab59d772409cf5f3$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i--){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $ab59d772409cf5f3$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($ab59d772409cf5f3$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $ab59d772409cf5f3$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $ab59d772409cf5f3$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $ab59d772409cf5f3$var$_parseClamp(parsedStart, "start", self);
            start = $ab59d772409cf5f3$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $ab59d772409cf5f3$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($ab59d772409cf5f3$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($ab59d772409cf5f3$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $ab59d772409cf5f3$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $ab59d772409cf5f3$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $ab59d772409cf5f3$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $ab59d772409cf5f3$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $ab59d772409cf5f3$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $ab59d772409cf5f3$var$_triggers[i];
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$ab59d772409cf5f3$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $ab59d772409cf5f3$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $ab59d772409cf5f3$var$gsap.utils.clamp(0, 1, $ab59d772409cf5f3$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $ab59d772409cf5f3$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin && !($ab59d772409cf5f3$var$_clampingMax && self.end >= $ab59d772409cf5f3$var$_maxScroll(scroller, direction))) {
                cs = $ab59d772409cf5f3$var$_getComputedStyle(pin);
                isVertical = direction === (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://gsap.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $ab59d772409cf5f3$var$_doc.scrollingElement || $ab59d772409cf5f3$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $ab59d772409cf5f3$var$_getComputedStyle($ab59d772409cf5f3$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $ab59d772409cf5f3$var$_swapPinIn(pin, spacer, cs);
                pinState = $ab59d772409cf5f3$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $ab59d772409cf5f3$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $5d1c91dc7d8b7a2c$export$8665aac53dad5647)(scroller, isVertical ? (0, $5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1) : (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $ab59d772409cf5f3$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $ab59d772409cf5f3$var$_padding ? $ab59d772409cf5f3$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    if (i) {
                        spacerState.push(direction.d, i + $ab59d772409cf5f3$var$_px); // for box-sizing: border-box (must include padding).
                        spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $ab59d772409cf5f3$var$_px);
                    }
                    $ab59d772409cf5f3$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $ab59d772409cf5f3$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                } else {
                    i = $ab59d772409cf5f3$var$_getSize(pin, direction);
                    i && spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $ab59d772409cf5f3$var$_px);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $ab59d772409cf5f3$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $ab59d772409cf5f3$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$ab59d772409cf5f3$var$_width] = override["max" + $ab59d772409cf5f3$var$_Width] = Math.ceil(bounds.width) + $ab59d772409cf5f3$var$_px;
                    override[$ab59d772409cf5f3$var$_height] = override["max" + $ab59d772409cf5f3$var$_Height] = Math.ceil(bounds.height) + $ab59d772409cf5f3$var$_px;
                    override[$ab59d772409cf5f3$var$_margin] = override[$ab59d772409cf5f3$var$_margin + $ab59d772409cf5f3$var$_Top] = override[$ab59d772409cf5f3$var$_margin + $ab59d772409cf5f3$var$_Right] = override[$ab59d772409cf5f3$var$_margin + $ab59d772409cf5f3$var$_Bottom] = override[$ab59d772409cf5f3$var$_margin + $ab59d772409cf5f3$var$_Left] = "0";
                    override[$ab59d772409cf5f3$var$_padding] = cs[$ab59d772409cf5f3$var$_padding];
                    override[$ab59d772409cf5f3$var$_padding + $ab59d772409cf5f3$var$_Top] = cs[$ab59d772409cf5f3$var$_padding + $ab59d772409cf5f3$var$_Top];
                    override[$ab59d772409cf5f3$var$_padding + $ab59d772409cf5f3$var$_Right] = cs[$ab59d772409cf5f3$var$_padding + $ab59d772409cf5f3$var$_Right];
                    override[$ab59d772409cf5f3$var$_padding + $ab59d772409cf5f3$var$_Bottom] = cs[$ab59d772409cf5f3$var$_padding + $ab59d772409cf5f3$var$_Bottom];
                    override[$ab59d772409cf5f3$var$_padding + $ab59d772409cf5f3$var$_Left] = cs[$ab59d772409cf5f3$var$_padding + $ab59d772409cf5f3$var$_Left];
                    pinActiveState = $ab59d772409cf5f3$var$_copyState(pinOriginalState, override, pinReparent);
                    $ab59d772409cf5f3$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $ab59d772409cf5f3$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $ab59d772409cf5f3$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $ab59d772409cf5f3$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $ab59d772409cf5f3$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$ab59d772409cf5f3$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $ab59d772409cf5f3$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $ab59d772409cf5f3$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation || invalidateOnRefresh) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $ab59d772409cf5f3$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $ab59d772409cf5f3$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $ab59d772409cf5f3$var$gsap.getProperty(markerEndTrigger, direction.p);
                $ab59d772409cf5f3$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $ab59d772409cf5f3$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $ab59d772409cf5f3$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $ab59d772409cf5f3$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$ab59d772409cf5f3$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$ab59d772409cf5f3$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($ab59d772409cf5f3$var$_getTime() - $ab59d772409cf5f3$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $ab59d772409cf5f3$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $ab59d772409cf5f3$var$_endAnimation(animation, animation.reversed()) : isToggle || $ab59d772409cf5f3$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $ab59d772409cf5f3$var$_triggers.indexOf(self), a = self.direction > 0 ? $ab59d772409cf5f3$var$_triggers.slice(0, i).reverse() : $ab59d772409cf5f3$var$_triggers.slice(i + 1);
            return ($ab59d772409cf5f3$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $ab59d772409cf5f3$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            if (anticipatePin && pin && !$ab59d772409cf5f3$var$_refreshing && !$ab59d772409cf5f3$var$_startup && $ab59d772409cf5f3$var$_lastScrollTime) {
                if (!clipped && start < scroll + (scroll - scroll2) / ($ab59d772409cf5f3$var$_getTime() - $ab59d772409cf5f3$var$_time2) * anticipatePin) clipped = 0.0001;
                else if (clipped === 1 && end > scroll + (scroll - scroll2) / ($ab59d772409cf5f3$var$_getTime() - $ab59d772409cf5f3$var$_time2) * anticipatePin) clipped = 0.9999;
            }
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$ab59d772409cf5f3$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($ab59d772409cf5f3$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$ab59d772409cf5f3$var$_refreshing && !$ab59d772409cf5f3$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($ab59d772409cf5f3$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($ab59d772409cf5f3$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $ab59d772409cf5f3$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $ab59d772409cf5f3$var$_getBounds(pin, true), _offset = scroll - start;
                                $ab59d772409cf5f3$var$_reparent(pin, $ab59d772409cf5f3$var$_body, bounds.top + (direction === (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d) ? _offset : 0) + $ab59d772409cf5f3$var$_px, bounds.left + (direction === (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d) ? 0 : _offset) + $ab59d772409cf5f3$var$_px);
                            } else $ab59d772409cf5f3$var$_reparent(pin, spacer);
                        }
                        $ab59d772409cf5f3$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$ab59d772409cf5f3$var$_refreshing && !$ab59d772409cf5f3$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$ab59d772409cf5f3$var$_limitCallbacks)) && $ab59d772409cf5f3$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$ab59d772409cf5f3$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$ab59d772409cf5f3$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $ab59d772409cf5f3$var$_callback(self, onToggle);
                        callbacks[toggleState] && $ab59d772409cf5f3$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $ab59d772409cf5f3$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($ab59d772409cf5f3$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $ab59d772409cf5f3$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $ab59d772409cf5f3$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$ab59d772409cf5f3$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $ab59d772409cf5f3$var$_addListener(scroller, "resize", $ab59d772409cf5f3$var$_onResize);
                isViewport || $ab59d772409cf5f3$var$_addListener(scroller, "scroll", $ab59d772409cf5f3$var$_onScroll);
                onRefreshInit && $ab59d772409cf5f3$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $ab59d772409cf5f3$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $ab59d772409cf5f3$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $ab59d772409cf5f3$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $ab59d772409cf5f3$var$_px;
                $ab59d772409cf5f3$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            if (self.enabled) {
                reset !== false && self.revert(true, true);
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $ab59d772409cf5f3$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $ab59d772409cf5f3$var$_triggers.length;
                    while(i--){
                        if ($ab59d772409cf5f3$var$_triggers[i].scroller === scroller && $ab59d772409cf5f3$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $ab59d772409cf5f3$var$_removeListener(scroller, "resize", $ab59d772409cf5f3$var$_onResize);
                    isViewport || $ab59d772409cf5f3$var$_removeListener(scroller, "scroll", $ab59d772409cf5f3$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $ab59d772409cf5f3$var$_ids[id];
            var i = $ab59d772409cf5f3$var$_triggers.indexOf(self);
            i >= 0 && $ab59d772409cf5f3$var$_triggers.splice(i, 1);
            i === $ab59d772409cf5f3$var$_i && $ab59d772409cf5f3$var$_direction > 0 && $ab59d772409cf5f3$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $ab59d772409cf5f3$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $ab59d772409cf5f3$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $ab59d772409cf5f3$var$_primary === self && ($ab59d772409cf5f3$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $ab59d772409cf5f3$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $ab59d772409cf5f3$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                start || end || self.refresh();
            };
            $ab59d772409cf5f3$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $ab59d772409cf5f3$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$ab59d772409cf5f3$var$_coreInitted) {
            $ab59d772409cf5f3$var$gsap = core || $ab59d772409cf5f3$var$_getGSAP();
            $ab59d772409cf5f3$var$_windowExists() && window.document && ScrollTrigger.enable();
            $ab59d772409cf5f3$var$_coreInitted = $ab59d772409cf5f3$var$_enabled;
        }
        return $ab59d772409cf5f3$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$ab59d772409cf5f3$var$_defaults[p] = config[p];
        return $ab59d772409cf5f3$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $ab59d772409cf5f3$var$_enabled = 0;
        $ab59d772409cf5f3$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $ab59d772409cf5f3$var$_removeListener($ab59d772409cf5f3$var$_win, "wheel", $ab59d772409cf5f3$var$_onScroll);
        $ab59d772409cf5f3$var$_removeListener($ab59d772409cf5f3$var$_doc, "scroll", $ab59d772409cf5f3$var$_onScroll);
        clearInterval($ab59d772409cf5f3$var$_syncInterval);
        $ab59d772409cf5f3$var$_removeListener($ab59d772409cf5f3$var$_doc, "touchcancel", $ab59d772409cf5f3$var$_passThrough);
        $ab59d772409cf5f3$var$_removeListener($ab59d772409cf5f3$var$_body, "touchstart", $ab59d772409cf5f3$var$_passThrough);
        $ab59d772409cf5f3$var$_multiListener($ab59d772409cf5f3$var$_removeListener, $ab59d772409cf5f3$var$_doc, "pointerdown,touchstart,mousedown", $ab59d772409cf5f3$var$_pointerDownHandler);
        $ab59d772409cf5f3$var$_multiListener($ab59d772409cf5f3$var$_removeListener, $ab59d772409cf5f3$var$_doc, "pointerup,touchend,mouseup", $ab59d772409cf5f3$var$_pointerUpHandler);
        $ab59d772409cf5f3$var$_resizeDelay.kill();
        $ab59d772409cf5f3$var$_iterateAutoRefresh($ab59d772409cf5f3$var$_removeListener);
        for(var i = 0; i < (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).length; i += 3){
            $ab59d772409cf5f3$var$_wheelListener($ab59d772409cf5f3$var$_removeListener, (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683)[i], (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683)[i + 1]);
            $ab59d772409cf5f3$var$_wheelListener($ab59d772409cf5f3$var$_removeListener, (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683)[i], (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $ab59d772409cf5f3$var$_win = window;
        $ab59d772409cf5f3$var$_doc = document;
        $ab59d772409cf5f3$var$_docEl = $ab59d772409cf5f3$var$_doc.documentElement;
        $ab59d772409cf5f3$var$_body = $ab59d772409cf5f3$var$_doc.body;
        if ($ab59d772409cf5f3$var$gsap) {
            $ab59d772409cf5f3$var$_toArray = $ab59d772409cf5f3$var$gsap.utils.toArray;
            $ab59d772409cf5f3$var$_clamp = $ab59d772409cf5f3$var$gsap.utils.clamp;
            $ab59d772409cf5f3$var$_context = $ab59d772409cf5f3$var$gsap.core.context || $ab59d772409cf5f3$var$_passThrough;
            $ab59d772409cf5f3$var$_suppressOverwrites = $ab59d772409cf5f3$var$gsap.core.suppressOverwrites || $ab59d772409cf5f3$var$_passThrough;
            $ab59d772409cf5f3$var$_scrollRestoration = $ab59d772409cf5f3$var$_win.history.scrollRestoration || "auto";
            $ab59d772409cf5f3$var$_lastScroll = $ab59d772409cf5f3$var$_win.pageYOffset;
            $ab59d772409cf5f3$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($ab59d772409cf5f3$var$_body) {
                $ab59d772409cf5f3$var$_enabled = 1;
                $ab59d772409cf5f3$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $ab59d772409cf5f3$var$_div100vh.style.height = "100vh";
                $ab59d772409cf5f3$var$_div100vh.style.position = "absolute";
                $ab59d772409cf5f3$var$_refresh100vh();
                $ab59d772409cf5f3$var$_rafBugFix();
                (0, $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b).register($ab59d772409cf5f3$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b).isTouch;
                $ab59d772409cf5f3$var$_fixIOSBug = (0, $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $ab59d772409cf5f3$var$_ignoreMobileResize = (0, $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b).isTouch === 1;
                $ab59d772409cf5f3$var$_addListener($ab59d772409cf5f3$var$_win, "wheel", $ab59d772409cf5f3$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $ab59d772409cf5f3$var$_root = [
                    $ab59d772409cf5f3$var$_win,
                    $ab59d772409cf5f3$var$_doc,
                    $ab59d772409cf5f3$var$_docEl,
                    $ab59d772409cf5f3$var$_body
                ];
                if ($ab59d772409cf5f3$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $ab59d772409cf5f3$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $ab59d772409cf5f3$var$gsap.addEventListener("matchMediaInit", function() {
                        return $ab59d772409cf5f3$var$_revertAll();
                    });
                    $ab59d772409cf5f3$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $ab59d772409cf5f3$var$_revertRecorded();
                    });
                    $ab59d772409cf5f3$var$gsap.addEventListener("matchMedia", function() {
                        $ab59d772409cf5f3$var$_refreshAll(0, 1);
                        $ab59d772409cf5f3$var$_dispatch("matchMedia");
                    });
                    $ab59d772409cf5f3$var$gsap.matchMedia("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $ab59d772409cf5f3$var$_setBaseDimensions();
                        return $ab59d772409cf5f3$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $ab59d772409cf5f3$var$_setBaseDimensions();
                $ab59d772409cf5f3$var$_addListener($ab59d772409cf5f3$var$_doc, "scroll", $ab59d772409cf5f3$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyStyle = $ab59d772409cf5f3$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $ab59d772409cf5f3$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $ab59d772409cf5f3$var$_getBounds($ab59d772409cf5f3$var$_body);
                (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style"); // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $ab59d772409cf5f3$var$_syncInterval = setInterval($ab59d772409cf5f3$var$_sync, 250);
                $ab59d772409cf5f3$var$gsap.delayedCall(0.5, function() {
                    return $ab59d772409cf5f3$var$_startup = 0;
                });
                $ab59d772409cf5f3$var$_addListener($ab59d772409cf5f3$var$_doc, "touchcancel", $ab59d772409cf5f3$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $ab59d772409cf5f3$var$_addListener($ab59d772409cf5f3$var$_body, "touchstart", $ab59d772409cf5f3$var$_passThrough); //works around Safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $ab59d772409cf5f3$var$_multiListener($ab59d772409cf5f3$var$_addListener, $ab59d772409cf5f3$var$_doc, "pointerdown,touchstart,mousedown", $ab59d772409cf5f3$var$_pointerDownHandler);
                $ab59d772409cf5f3$var$_multiListener($ab59d772409cf5f3$var$_addListener, $ab59d772409cf5f3$var$_doc, "pointerup,touchend,mouseup", $ab59d772409cf5f3$var$_pointerUpHandler);
                $ab59d772409cf5f3$var$_transformProp = $ab59d772409cf5f3$var$gsap.utils.checkPrefix("transform");
                $ab59d772409cf5f3$var$_stateProps.push($ab59d772409cf5f3$var$_transformProp);
                $ab59d772409cf5f3$var$_coreInitted = $ab59d772409cf5f3$var$_getTime();
                $ab59d772409cf5f3$var$_resizeDelay = $ab59d772409cf5f3$var$gsap.delayedCall(0.2, $ab59d772409cf5f3$var$_refreshAll).pause();
                $ab59d772409cf5f3$var$_autoRefresh = [
                    $ab59d772409cf5f3$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $ab59d772409cf5f3$var$_win.innerWidth, h = $ab59d772409cf5f3$var$_win.innerHeight;
                        if ($ab59d772409cf5f3$var$_doc.hidden) {
                            $ab59d772409cf5f3$var$_prevWidth = w;
                            $ab59d772409cf5f3$var$_prevHeight = h;
                        } else if ($ab59d772409cf5f3$var$_prevWidth !== w || $ab59d772409cf5f3$var$_prevHeight !== h) $ab59d772409cf5f3$var$_onResize();
                    },
                    $ab59d772409cf5f3$var$_doc,
                    "DOMContentLoaded",
                    $ab59d772409cf5f3$var$_refreshAll,
                    $ab59d772409cf5f3$var$_win,
                    "load",
                    $ab59d772409cf5f3$var$_refreshAll,
                    $ab59d772409cf5f3$var$_win,
                    "resize",
                    $ab59d772409cf5f3$var$_onResize
                ];
                $ab59d772409cf5f3$var$_iterateAutoRefresh($ab59d772409cf5f3$var$_addListener);
                $ab59d772409cf5f3$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).length; i += 3){
                    $ab59d772409cf5f3$var$_wheelListener($ab59d772409cf5f3$var$_removeListener, (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683)[i], (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683)[i + 1]);
                    $ab59d772409cf5f3$var$_wheelListener($ab59d772409cf5f3$var$_removeListener, (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683)[i], (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683)[i + 2]);
                }
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($ab59d772409cf5f3$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($ab59d772409cf5f3$var$_syncInterval) || ($ab59d772409cf5f3$var$_syncInterval = ms) && setInterval($ab59d772409cf5f3$var$_sync, ms);
        "ignoreMobileResize" in vars && ($ab59d772409cf5f3$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $ab59d772409cf5f3$var$_iterateAutoRefresh($ab59d772409cf5f3$var$_removeListener) || $ab59d772409cf5f3$var$_iterateAutoRefresh($ab59d772409cf5f3$var$_addListener, vars.autoRefreshEvents || "none");
            $ab59d772409cf5f3$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $5d1c91dc7d8b7a2c$export$937374fea3f88711)(target), i = (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).indexOf(t), isViewport = $ab59d772409cf5f3$var$_isViewport(t);
        if (~i) (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $5d1c91dc7d8b7a2c$export$d8e56d510a804d0a).unshift($ab59d772409cf5f3$var$_win, vars, $ab59d772409cf5f3$var$_body, vars, $ab59d772409cf5f3$var$_docEl, vars) : (0, $5d1c91dc7d8b7a2c$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $ab59d772409cf5f3$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($ab59d772409cf5f3$var$_isString(element) ? (0, $5d1c91dc7d8b7a2c$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $ab59d772409cf5f3$var$_width : $ab59d772409cf5f3$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $ab59d772409cf5f3$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $ab59d772409cf5f3$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $ab59d772409cf5f3$var$_isString(element) && (element = (0, $5d1c91dc7d8b7a2c$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $ab59d772409cf5f3$var$_width : $ab59d772409cf5f3$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $ab59d772409cf5f3$var$_keywords ? $ab59d772409cf5f3$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $ab59d772409cf5f3$var$_win.innerWidth : (bounds.top + offset) / $ab59d772409cf5f3$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $ab59d772409cf5f3$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $ab59d772409cf5f3$var$_listeners.killAll || [];
            $ab59d772409cf5f3$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$ab59d772409cf5f3$export$875bcbe48555930.version = "3.12.5";
$ab59d772409cf5f3$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $ab59d772409cf5f3$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $ab59d772409cf5f3$var$_savedStyles.indexOf(target);
            i >= 0 && $ab59d772409cf5f3$var$_savedStyles.splice(i, 5);
            $ab59d772409cf5f3$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $ab59d772409cf5f3$var$gsap.core.getCache(target), $ab59d772409cf5f3$var$_context());
        }
    }) : $ab59d772409cf5f3$var$_savedStyles;
};
$ab59d772409cf5f3$export$875bcbe48555930.revert = function(soft, media) {
    return $ab59d772409cf5f3$var$_revertAll(!soft, media);
};
$ab59d772409cf5f3$export$875bcbe48555930.create = function(vars, animation) {
    return new $ab59d772409cf5f3$export$875bcbe48555930(vars, animation);
};
$ab59d772409cf5f3$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $ab59d772409cf5f3$var$_onResize() : ($ab59d772409cf5f3$var$_coreInitted || $ab59d772409cf5f3$export$875bcbe48555930.register()) && $ab59d772409cf5f3$var$_refreshAll(true);
};
$ab59d772409cf5f3$export$875bcbe48555930.update = function(force) {
    return ++(0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).cache && $ab59d772409cf5f3$var$_updateAll(force === true ? 2 : 0);
};
$ab59d772409cf5f3$export$875bcbe48555930.clearScrollMemory = $ab59d772409cf5f3$var$_clearScrollMemory;
$ab59d772409cf5f3$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $ab59d772409cf5f3$var$_maxScroll(element, horizontal ? (0, $5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1) : (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d));
};
$ab59d772409cf5f3$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $5d1c91dc7d8b7a2c$export$8665aac53dad5647)((0, $5d1c91dc7d8b7a2c$export$937374fea3f88711)(element), horizontal ? (0, $5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1) : (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d));
};
$ab59d772409cf5f3$export$875bcbe48555930.getById = function(id) {
    return $ab59d772409cf5f3$var$_ids[id];
};
$ab59d772409cf5f3$export$875bcbe48555930.getAll = function() {
    return $ab59d772409cf5f3$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$ab59d772409cf5f3$export$875bcbe48555930.isScrolling = function() {
    return !!$ab59d772409cf5f3$var$_lastScrollTime;
};
$ab59d772409cf5f3$export$875bcbe48555930.snapDirectional = $ab59d772409cf5f3$var$_snapDirectional;
$ab59d772409cf5f3$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $ab59d772409cf5f3$var$_listeners[type] || ($ab59d772409cf5f3$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$ab59d772409cf5f3$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $ab59d772409cf5f3$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$ab59d772409cf5f3$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $ab59d772409cf5f3$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $ab59d772409cf5f3$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($ab59d772409cf5f3$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $ab59d772409cf5f3$var$_addListener($ab59d772409cf5f3$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $ab59d772409cf5f3$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($ab59d772409cf5f3$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $ab59d772409cf5f3$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $ab59d772409cf5f3$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $ab59d772409cf5f3$var$_docEl && _allowNativePanning($ab59d772409cf5f3$var$_body, direction);
}, $ab59d772409cf5f3$var$_overflow = {
    auto: 1,
    scroll: 1
}, $ab59d772409cf5f3$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $ab59d772409cf5f3$var$gsap.core.getCache(node), time = $ab59d772409cf5f3$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $ab59d772409cf5f3$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($ab59d772409cf5f3$var$_overflow[(cs = $ab59d772409cf5f3$var$_getComputedStyle(node)).overflowY] || $ab59d772409cf5f3$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$ab59d772409cf5f3$var$_isViewport(node) && ($ab59d772409cf5f3$var$_overflow[(cs = $ab59d772409cf5f3$var$_getComputedStyle(node)).overflowY] || $ab59d772409cf5f3$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$ab59d772409cf5f3$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $ab59d772409cf5f3$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $ab59d772409cf5f3$var$_addListener($ab59d772409cf5f3$var$_doc, (0, $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b).eventTypes[0], $ab59d772409cf5f3$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $ab59d772409cf5f3$var$_removeListener($ab59d772409cf5f3$var$_doc, (0, $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b).eventTypes[0], $ab59d772409cf5f3$var$_captureInputs, true);
        }
    });
}, $ab59d772409cf5f3$var$_inputExp = /(input|label|select|textarea)/i, $ab59d772409cf5f3$var$_inputIsFocused, $ab59d772409cf5f3$var$_captureInputs = function _captureInputs(e) {
    var isInput = $ab59d772409cf5f3$var$_inputExp.test(e.target.tagName);
    if (isInput || $ab59d772409cf5f3$var$_inputIsFocused) {
        e._gsapAllow = true;
        $ab59d772409cf5f3$var$_inputIsFocused = isInput;
    }
}, $ab59d772409cf5f3$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $ab59d772409cf5f3$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $5d1c91dc7d8b7a2c$export$937374fea3f88711)(vars.target) || $ab59d772409cf5f3$var$_docEl, smoother = $ab59d772409cf5f3$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $ab59d772409cf5f3$var$_fixIOSBug && (vars.content && (0, $5d1c91dc7d8b7a2c$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $5d1c91dc7d8b7a2c$export$8665aac53dad5647)(target, (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d)), scrollFuncX = (0, $5d1c91dc7d8b7a2c$export$8665aac53dad5647)(target, (0, $5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b).isTouch && $ab59d772409cf5f3$var$_win.visualViewport ? $ab59d772409cf5f3$var$_win.visualViewport.scale * $ab59d772409cf5f3$var$_win.visualViewport.width : $ab59d772409cf5f3$var$_win.outerWidth) / $ab59d772409cf5f3$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $ab59d772409cf5f3$var$_isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $ab59d772409cf5f3$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $ab59d772409cf5f3$var$_passThrough, scrollClampY = $ab59d772409cf5f3$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $ab59d772409cf5f3$var$_maxScroll(target, (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d));
        scrollClampY = $ab59d772409cf5f3$var$_clamp($ab59d772409cf5f3$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $ab59d772409cf5f3$var$_clamp(0, $ab59d772409cf5f3$var$_maxScroll(target, (0, $5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1))));
        lastRefreshID = $ab59d772409cf5f3$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $ab59d772409cf5f3$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $ab59d772409cf5f3$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $ab59d772409cf5f3$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).cache;
                $ab59d772409cf5f3$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $ab59d772409cf5f3$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $ab59d772409cf5f3$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $ab59d772409cf5f3$var$_round(($ab59d772409cf5f3$var$_win.visualViewport && $ab59d772409cf5f3$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $ab59d772409cf5f3$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $ab59d772409cf5f3$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $ab59d772409cf5f3$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $ab59d772409cf5f3$var$_maxScroll(target, (0, $5d1c91dc7d8b7a2c$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $ab59d772409cf5f3$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $ab59d772409cf5f3$var$_maxScroll(target, (0, $5d1c91dc7d8b7a2c$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($ab59d772409cf5f3$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $ab59d772409cf5f3$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($ab59d772409cf5f3$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $ab59d772409cf5f3$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $ab59d772409cf5f3$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $ab59d772409cf5f3$var$_updateAll();
    };
    vars.onEnable = function() {
        $ab59d772409cf5f3$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $ab59d772409cf5f3$export$875bcbe48555930.addEventListener("refresh", onResize);
        $ab59d772409cf5f3$var$_addListener($ab59d772409cf5f3$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $ab59d772409cf5f3$var$_allowNativePanning(target, true);
        $ab59d772409cf5f3$var$_removeListener($ab59d772409cf5f3$var$_win, "resize", onResize);
        $ab59d772409cf5f3$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $ab59d772409cf5f3$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $ab59d772409cf5f3$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $ab59d772409cf5f3$var$_fixIOSBug && $ab59d772409cf5f3$var$gsap.ticker.add($ab59d772409cf5f3$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $ab59d772409cf5f3$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        inherit: false,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $ab59d772409cf5f3$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $ab59d772409cf5f3$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$ab59d772409cf5f3$export$875bcbe48555930.sort = function(func) {
    return $ab59d772409cf5f3$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + a.start - (b.start + (b.vars.refreshPriority || 0) * -1000000);
    });
};
$ab59d772409cf5f3$export$875bcbe48555930.observe = function(vars) {
    return new (0, $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b)(vars);
};
$ab59d772409cf5f3$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $ab59d772409cf5f3$var$_normalizer;
    if (vars === true && $ab59d772409cf5f3$var$_normalizer) return $ab59d772409cf5f3$var$_normalizer.enable();
    if (vars === false) {
        $ab59d772409cf5f3$var$_normalizer && $ab59d772409cf5f3$var$_normalizer.kill();
        $ab59d772409cf5f3$var$_normalizer = vars;
        return;
    }
    var normalizer = vars instanceof (0, $5d1c91dc7d8b7a2c$export$c1cbdee04e18ea8b) ? vars : $ab59d772409cf5f3$var$_getScrollNormalizer(vars);
    $ab59d772409cf5f3$var$_normalizer && $ab59d772409cf5f3$var$_normalizer.target === normalizer.target && $ab59d772409cf5f3$var$_normalizer.kill();
    $ab59d772409cf5f3$var$_isViewport(normalizer.target) && ($ab59d772409cf5f3$var$_normalizer = normalizer);
    return normalizer;
};
$ab59d772409cf5f3$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $5d1c91dc7d8b7a2c$export$5de019f4480f0f8d),
    _inputObserver: $ab59d772409cf5f3$var$_inputObserver,
    _scrollers: (0, $5d1c91dc7d8b7a2c$export$3cd1cee43d19b683),
    _proxies: (0, $5d1c91dc7d8b7a2c$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $ab59d772409cf5f3$var$_lastScrollTime || $ab59d772409cf5f3$var$_dispatch("scrollStart");
            $ab59d772409cf5f3$var$_lastScrollTime = $ab59d772409cf5f3$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $ab59d772409cf5f3$var$_refreshing;
        }
    }
};
$ab59d772409cf5f3$var$_getGSAP() && $ab59d772409cf5f3$var$gsap.registerPlugin($ab59d772409cf5f3$export$875bcbe48555930);


/*!
 * DrawSVGPlugin 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $015e296242376acd$var$gsap, $015e296242376acd$var$_toArray, $015e296242376acd$var$_doc, $015e296242376acd$var$_win, $015e296242376acd$var$_isEdge, $015e296242376acd$var$_coreInitted, $015e296242376acd$var$_warned, $015e296242376acd$var$_getStyleSaver, $015e296242376acd$var$_reverting, $015e296242376acd$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $015e296242376acd$var$_getGSAP = function _getGSAP() {
    return $015e296242376acd$var$gsap || $015e296242376acd$var$_windowExists() && ($015e296242376acd$var$gsap = window.gsap) && $015e296242376acd$var$gsap.registerPlugin && $015e296242376acd$var$gsap;
}, $015e296242376acd$var$_numExp = /[-+=\.]*\d+[\.e\-\+]*\d*[e\-\+]*\d*/gi, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$015e296242376acd$var$_types = {
    rect: [
        "width",
        "height"
    ],
    circle: [
        "r",
        "r"
    ],
    ellipse: [
        "rx",
        "ry"
    ],
    line: [
        "x2",
        "y2"
    ]
}, $015e296242376acd$var$_round = function _round(value) {
    return Math.round(value * 10000) / 10000;
}, $015e296242376acd$var$_parseNum = function _parseNum(value) {
    return parseFloat(value) || 0;
}, $015e296242376acd$var$_parseSingleVal = function _parseSingleVal(value, length) {
    var num = $015e296242376acd$var$_parseNum(value);
    return ~value.indexOf("%") ? num / 100 * length : num;
}, $015e296242376acd$var$_getAttributeAsNumber = function _getAttributeAsNumber(target, attr) {
    return $015e296242376acd$var$_parseNum(target.getAttribute(attr));
}, $015e296242376acd$var$_sqrt = Math.sqrt, $015e296242376acd$var$_getDistance = function _getDistance(x1, y1, x2, y2, scaleX, scaleY) {
    return $015e296242376acd$var$_sqrt(Math.pow(($015e296242376acd$var$_parseNum(x2) - $015e296242376acd$var$_parseNum(x1)) * scaleX, 2) + Math.pow(($015e296242376acd$var$_parseNum(y2) - $015e296242376acd$var$_parseNum(y1)) * scaleY, 2));
}, $015e296242376acd$var$_warn = function _warn(message) {
    return console.warn(message);
}, $015e296242376acd$var$_hasNonScalingStroke = function _hasNonScalingStroke(target) {
    return target.getAttribute("vector-effect") === "non-scaling-stroke";
}, $015e296242376acd$var$_bonusValidated = 1, //<name>DrawSVGPlugin</name>
//accepts values like "100%" or "20% 80%" or "20 50" and parses it into an absolute start and end position on the line/stroke based on its length. Returns an an array with the start and end values, like [0, 243]
$015e296242376acd$var$_parse = function _parse(value, length, defaultStart) {
    var i = value.indexOf(" "), s, e;
    if (i < 0) {
        s = defaultStart !== undefined ? defaultStart + "" : value;
        e = value;
    } else {
        s = value.substr(0, i);
        e = value.substr(i + 1);
    }
    s = $015e296242376acd$var$_parseSingleVal(s, length);
    e = $015e296242376acd$var$_parseSingleVal(e, length);
    return s > e ? [
        e,
        s
    ] : [
        s,
        e
    ];
}, $015e296242376acd$var$_getLength = function _getLength(target) {
    target = $015e296242376acd$var$_toArray(target)[0];
    if (!target) return 0;
    var type = target.tagName.toLowerCase(), style = target.style, scaleX = 1, scaleY = 1, length, bbox, points, prevPoint, i, rx, ry;
    if ($015e296242376acd$var$_hasNonScalingStroke(target)) {
        //non-scaling-stroke basically scales the shape and then strokes it at the screen-level (after transforms), thus we need to adjust the length accordingly.
        scaleY = target.getScreenCTM();
        scaleX = $015e296242376acd$var$_sqrt(scaleY.a * scaleY.a + scaleY.b * scaleY.b);
        scaleY = $015e296242376acd$var$_sqrt(scaleY.d * scaleY.d + scaleY.c * scaleY.c);
    }
    try {
        //IE bug: calling <path>.getTotalLength() locks the repaint area of the stroke to whatever its current dimensions are on that frame/tick. To work around that, we must call getBBox() to force IE to recalculate things.
        bbox = target.getBBox(); //solely for fixing bug in IE - we don't actually use the bbox.
    } catch (e) {
        //firefox has a bug that throws an error if the element isn't visible.
        $015e296242376acd$var$_warn("Some browsers won't measure invisible elements (like display:none or masks inside defs).");
    }
    var _ref = bbox || {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    }, x = _ref.x, y = _ref.y, width = _ref.width, height = _ref.height;
    if ((!bbox || !width && !height) && $015e296242376acd$var$_types[type]) {
        //if the element isn't visible, try to discern width/height using its attributes.
        width = $015e296242376acd$var$_getAttributeAsNumber(target, $015e296242376acd$var$_types[type][0]);
        height = $015e296242376acd$var$_getAttributeAsNumber(target, $015e296242376acd$var$_types[type][1]);
        if (type !== "rect" && type !== "line") {
            //double the radius for circles and ellipses
            width *= 2;
            height *= 2;
        }
        if (type === "line") {
            x = $015e296242376acd$var$_getAttributeAsNumber(target, "x1");
            y = $015e296242376acd$var$_getAttributeAsNumber(target, "y1");
            width = Math.abs(width - x);
            height = Math.abs(height - y);
        }
    }
    if (type === "path") {
        prevPoint = style.strokeDasharray;
        style.strokeDasharray = "none";
        length = target.getTotalLength() || 0;
        $015e296242376acd$var$_round(scaleX) !== $015e296242376acd$var$_round(scaleY) && !$015e296242376acd$var$_warned && ($015e296242376acd$var$_warned = 1) && $015e296242376acd$var$_warn("Warning: <path> length cannot be measured when vector-effect is non-scaling-stroke and the element isn't proportionally scaled.");
        length *= (scaleX + scaleY) / 2;
        style.strokeDasharray = prevPoint;
    } else if (type === "rect") length = width * 2 * scaleX + height * 2 * scaleY;
    else if (type === "line") length = $015e296242376acd$var$_getDistance(x, y, x + width, y + height, scaleX, scaleY);
    else if (type === "polyline" || type === "polygon") {
        points = target.getAttribute("points").match($015e296242376acd$var$_numExp) || [];
        type === "polygon" && points.push(points[0], points[1]);
        length = 0;
        for(i = 2; i < points.length; i += 2)length += $015e296242376acd$var$_getDistance(points[i - 2], points[i - 1], points[i], points[i + 1], scaleX, scaleY) || 0;
    } else if (type === "circle" || type === "ellipse") {
        rx = width / 2 * scaleX;
        ry = height / 2 * scaleY;
        length = Math.PI * (3 * (rx + ry) - $015e296242376acd$var$_sqrt((3 * rx + ry) * (rx + 3 * ry)));
    }
    return length || 0;
}, $015e296242376acd$var$_getPosition = function _getPosition(target, length) {
    target = $015e296242376acd$var$_toArray(target)[0];
    if (!target) return [
        0,
        0
    ];
    length || (length = $015e296242376acd$var$_getLength(target) + 1);
    var cs = $015e296242376acd$var$_win.getComputedStyle(target), dash = cs.strokeDasharray || "", offset = $015e296242376acd$var$_parseNum(cs.strokeDashoffset), i = dash.indexOf(",");
    i < 0 && (i = dash.indexOf(" "));
    dash = i < 0 ? length : $015e296242376acd$var$_parseNum(dash.substr(0, i));
    dash > length && (dash = length);
    return [
        -offset || 0,
        dash - offset || 0
    ];
}, $015e296242376acd$var$_initCore = function _initCore() {
    if ($015e296242376acd$var$_windowExists()) {
        $015e296242376acd$var$_doc = document;
        $015e296242376acd$var$_win = window;
        $015e296242376acd$var$_coreInitted = $015e296242376acd$var$gsap = $015e296242376acd$var$_getGSAP();
        $015e296242376acd$var$_toArray = $015e296242376acd$var$gsap.utils.toArray;
        $015e296242376acd$var$_getStyleSaver = $015e296242376acd$var$gsap.core.getStyleSaver;
        $015e296242376acd$var$_reverting = $015e296242376acd$var$gsap.core.reverting || function() {};
        $015e296242376acd$var$_isEdge = (($015e296242376acd$var$_win.navigator || {}).userAgent || "").indexOf("Edge") !== -1; //Microsoft Edge has a bug that causes it not to redraw the path correctly if the stroke-linecap is anything other than "butt" (like "round") and it doesn't match the stroke-linejoin. A way to trigger it is to change the stroke-miterlimit, so we'll only do that if/when we have to (to maximize performance)
    }
};
var $015e296242376acd$export$4129f9ba90e1264a = {
    version: "3.12.5",
    name: "drawSVG",
    register: function register(core) {
        $015e296242376acd$var$gsap = core;
        $015e296242376acd$var$_initCore();
    },
    init: function init(target, value, tween, index, targets) {
        if (!target.getBBox) return false;
        $015e296242376acd$var$_coreInitted || $015e296242376acd$var$_initCore();
        var length = $015e296242376acd$var$_getLength(target), start, end, cs;
        this.styles = $015e296242376acd$var$_getStyleSaver && $015e296242376acd$var$_getStyleSaver(target, "strokeDashoffset,strokeDasharray,strokeMiterlimit");
        this.tween = tween;
        this._style = target.style;
        this._target = target;
        if (value + "" === "true") value = "0 100%";
        else if (!value) value = "0 0";
        else if ((value + "").indexOf(" ") === -1) value = "0 " + value;
        start = $015e296242376acd$var$_getPosition(target, length);
        end = $015e296242376acd$var$_parse(value, length, start[0]);
        this._length = $015e296242376acd$var$_round(length);
        this._dash = $015e296242376acd$var$_round(start[1] - start[0]); //some browsers render artifacts if dash is 0, so we use a very small number in that case.
        this._offset = $015e296242376acd$var$_round(-start[0]);
        this._dashPT = this.add(this, "_dash", this._dash, $015e296242376acd$var$_round(end[1] - end[0]), 0, 0, 0, 0, 0, 1);
        this._offsetPT = this.add(this, "_offset", this._offset, $015e296242376acd$var$_round(-end[0]), 0, 0, 0, 0, 0, 1);
        if ($015e296242376acd$var$_isEdge) {
            //to work around a bug in Microsoft Edge, animate the stroke-miterlimit by 0.0001 just to trigger the repaint (unnecessary if it's "round" and stroke-linejoin is also "round"). Imperceptible, relatively high-performance, and effective. Another option was to set the "d" <path> attribute to its current value on every tick, but that seems like it'd be much less performant.
            cs = $015e296242376acd$var$_win.getComputedStyle(target);
            if (cs.strokeLinecap !== cs.strokeLinejoin) {
                end = $015e296242376acd$var$_parseNum(cs.strokeMiterlimit);
                this.add(target.style, "strokeMiterlimit", end, end + 0.01);
            }
        }
        this._live = $015e296242376acd$var$_hasNonScalingStroke(target) || ~(value + "").indexOf("live");
        this._nowrap = ~(value + "").indexOf("nowrap");
        this._props.push("drawSVG");
        return $015e296242376acd$var$_bonusValidated;
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$015e296242376acd$var$_reverting()) {
            var pt = data._pt, style = data._style, length, lengthRatio, dash, offset;
            if (pt) {
                //when the element has vector-effect="non-scaling-stroke" and the SVG is resized (like on a window resize), it actually changes the length of the stroke! So we must sense that and make the proper adjustments.
                if (data._live) {
                    length = $015e296242376acd$var$_getLength(data._target);
                    if (length !== data._length) {
                        lengthRatio = length / data._length;
                        data._length = length;
                        if (data._offsetPT) {
                            data._offsetPT.s *= lengthRatio;
                            data._offsetPT.c *= lengthRatio;
                        }
                        if (data._dashPT) {
                            data._dashPT.s *= lengthRatio;
                            data._dashPT.c *= lengthRatio;
                        } else data._dash *= lengthRatio;
                    }
                }
                while(pt){
                    pt.r(ratio, pt.d);
                    pt = pt._next;
                }
                dash = data._dash || ratio && ratio !== 1 && 0.0001 || 0; // only let it be zero if it's at the start or end of the tween.
                length = data._length - dash + 0.1;
                offset = data._offset;
                dash && offset && dash + Math.abs(offset % data._length) > data._length - 0.2 && (offset += offset < 0 ? 0.1 : -0.1) && (length += 0.1);
                style.strokeDashoffset = dash ? offset : offset + 0.001;
                style.strokeDasharray = length < 0.2 ? "none" : dash ? dash + "px," + (data._nowrap ? 999999 : length) + "px" : "0px, 999999px";
            }
        } else data.styles.revert();
    },
    getLength: $015e296242376acd$var$_getLength,
    getPosition: $015e296242376acd$var$_getPosition
};
$015e296242376acd$var$_getGSAP() && $015e296242376acd$var$gsap.registerPlugin($015e296242376acd$export$4129f9ba90e1264a);


/*!
 * CustomEase 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ /*!
 * paths 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $81b4963cef37ffda$var$_svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig, $81b4963cef37ffda$var$_numbersExp = /(?:(-)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig, $81b4963cef37ffda$var$_scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/ig, $81b4963cef37ffda$var$_selectorExp = /(^[#\.][a-z]|[a-y][a-z])/i, $81b4963cef37ffda$var$_DEG2RAD = Math.PI / 180, $81b4963cef37ffda$var$_RAD2DEG = 180 / Math.PI, $81b4963cef37ffda$var$_sin = Math.sin, $81b4963cef37ffda$var$_cos = Math.cos, $81b4963cef37ffda$var$_abs = Math.abs, $81b4963cef37ffda$var$_sqrt = Math.sqrt, $81b4963cef37ffda$var$_atan2 = Math.atan2, $81b4963cef37ffda$var$_largeNum = 1e8, $81b4963cef37ffda$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $81b4963cef37ffda$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $81b4963cef37ffda$var$_isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, $81b4963cef37ffda$var$_temp = {}, $81b4963cef37ffda$var$_temp2 = {}, $81b4963cef37ffda$var$_roundingNum = 1e5, $81b4963cef37ffda$var$_wrapProgress = function _wrapProgress(progress) {
    return Math.round((progress + $81b4963cef37ffda$var$_largeNum) % 1 * $81b4963cef37ffda$var$_roundingNum) / $81b4963cef37ffda$var$_roundingNum || (progress < 0 ? 0 : 1);
}, //if progress lands on 1, the % will make it 0 which is why we || 1, but not if it's negative because it makes more sense for motion to end at 0 in that case.
$81b4963cef37ffda$var$_round = function _round(value) {
    return Math.round(value * $81b4963cef37ffda$var$_roundingNum) / $81b4963cef37ffda$var$_roundingNum || 0;
}, $81b4963cef37ffda$var$_roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 1e10) / 1e10 || 0;
}, $81b4963cef37ffda$var$_splitSegment = function _splitSegment(rawPath, segIndex, i, t) {
    var segment = rawPath[segIndex], shift = t === 1 ? 6 : $81b4963cef37ffda$export$bd9f14de8998b2c6(segment, i, t);
    if ((shift || !t) && shift + i + 2 < segment.length) {
        rawPath.splice(segIndex, 0, segment.slice(0, i + shift + 2));
        segment.splice(0, i + shift);
        return 1;
    }
}, $81b4963cef37ffda$var$_getSampleIndex = function _getSampleIndex(samples, length, progress) {
    // slightly slower way than doing this (when there's no lookup): segment.lookup[progress < 1 ? ~~(length / segment.minLength) : segment.lookup.length - 1] || 0;
    var l = samples.length, i = ~~(progress * l);
    if (samples[i] > length) {
        while(--i && samples[i] > length);
        i < 0 && (i = 0);
    } else {
        while(samples[++i] < length && i < l);
    }
    return i < l ? i : l - 1;
}, $81b4963cef37ffda$var$_reverseRawPath = function _reverseRawPath(rawPath, skipOuter) {
    var i = rawPath.length;
    skipOuter || rawPath.reverse();
    while(i--)rawPath[i].reversed || $81b4963cef37ffda$export$1c1e155a66a9b65a(rawPath[i]);
}, $81b4963cef37ffda$var$_copyMetaData = function _copyMetaData(source, copy) {
    copy.totalLength = source.totalLength;
    if (source.samples) {
        //segment
        copy.samples = source.samples.slice(0);
        copy.lookup = source.lookup.slice(0);
        copy.minLength = source.minLength;
        copy.resolution = source.resolution;
    } else if (source.totalPoints) //rawPath
    copy.totalPoints = source.totalPoints;
    return copy;
}, //pushes a new segment into a rawPath, but if its starting values match the ending values of the last segment, it'll merge it into that same segment (to reduce the number of segments)
$81b4963cef37ffda$var$_appendOrMerge = function _appendOrMerge(rawPath, segment) {
    var index = rawPath.length, prevSeg = rawPath[index - 1] || [], l = prevSeg.length;
    if (index && segment[0] === prevSeg[l - 2] && segment[1] === prevSeg[l - 1]) {
        segment = prevSeg.concat(segment.slice(2));
        index--;
    }
    rawPath[index] = segment;
}, $81b4963cef37ffda$var$_bestDistance;
function $81b4963cef37ffda$export$a7de45090ab95fc7(value) {
    value = $81b4963cef37ffda$var$_isString(value) && $81b4963cef37ffda$var$_selectorExp.test(value) ? document.querySelector(value) || value : value;
    var e = value.getAttribute ? value : 0, rawPath;
    if (e && (value = value.getAttribute("d"))) {
        //implements caching
        if (!e._gsPath) e._gsPath = {};
        rawPath = e._gsPath[value];
        return rawPath && !rawPath._dirty ? rawPath : e._gsPath[value] = $81b4963cef37ffda$export$a9a6ab89eb1c2191(value);
    }
    return !value ? console.warn("Expecting a <path> element or an SVG path data string") : $81b4963cef37ffda$var$_isString(value) ? $81b4963cef37ffda$export$a9a6ab89eb1c2191(value) : $81b4963cef37ffda$var$_isNumber(value[0]) ? [
        value
    ] : value;
} //copies a RawPath WITHOUT the length meta data (for speed)
function $81b4963cef37ffda$export$e358367bf79edde2(rawPath) {
    var a = [], i = 0;
    for(; i < rawPath.length; i++)a[i] = $81b4963cef37ffda$var$_copyMetaData(rawPath[i], rawPath[i].slice(0));
    return $81b4963cef37ffda$var$_copyMetaData(rawPath, a);
}
function $81b4963cef37ffda$export$1c1e155a66a9b65a(segment) {
    var i = 0, y;
    segment.reverse(); //this will invert the order y, x, y, x so we must flip it back.
    for(; i < segment.length; i += 2){
        y = segment[i];
        segment[i] = segment[i + 1];
        segment[i + 1] = y;
    }
    segment.reversed = !segment.reversed;
}
var $81b4963cef37ffda$var$_createPath = function _createPath(e, ignore) {
    var path = document.createElementNS("http://www.w3.org/2000/svg", "path"), attr = [].slice.call(e.attributes), i = attr.length, name;
    ignore = "," + ignore + ",";
    while(--i > -1){
        name = attr[i].nodeName.toLowerCase(); //in Microsoft Edge, if you don't set the attribute with a lowercase name, it doesn't render correctly! Super weird.
        if (ignore.indexOf("," + name + ",") < 0) path.setAttributeNS(null, name, attr[i].nodeValue);
    }
    return path;
}, $81b4963cef37ffda$var$_typeAttrs = {
    rect: "rx,ry,x,y,width,height",
    circle: "r,cx,cy",
    ellipse: "rx,ry,cx,cy",
    line: "x1,x2,y1,y2"
}, $81b4963cef37ffda$var$_attrToObj = function _attrToObj(e, attrs) {
    var props = attrs ? attrs.split(",") : [], obj = {}, i = props.length;
    while(--i > -1)obj[props[i]] = +e.getAttribute(props[i]) || 0;
    return obj;
}; //converts an SVG shape like <circle>, <rect>, <polygon>, <polyline>, <ellipse>, etc. to a <path>, swapping it in and copying the attributes to match.
function $81b4963cef37ffda$export$1a6b6149d6272140(element, swap) {
    var type = element.tagName.toLowerCase(), circ = 0.552284749831, data, x, y, r, ry, path, rcirc, rycirc, points, w, h, x2, x3, x4, x5, x6, y2, y3, y4, y5, y6, attr;
    if (type === "path" || !element.getBBox) return element;
    path = $81b4963cef37ffda$var$_createPath(element, "x,y,width,height,cx,cy,rx,ry,r,x1,x2,y1,y2,points");
    attr = $81b4963cef37ffda$var$_attrToObj(element, $81b4963cef37ffda$var$_typeAttrs[type]);
    if (type === "rect") {
        r = attr.rx;
        ry = attr.ry || r;
        x = attr.x;
        y = attr.y;
        w = attr.width - r * 2;
        h = attr.height - ry * 2;
        if (r || ry) {
            //if there are rounded corners, render cubic beziers
            x2 = x + r * (1 - circ);
            x3 = x + r;
            x4 = x3 + w;
            x5 = x4 + r * circ;
            x6 = x4 + r;
            y2 = y + ry * (1 - circ);
            y3 = y + ry;
            y4 = y3 + h;
            y5 = y4 + ry * circ;
            y6 = y4 + ry;
            data = "M" + x6 + "," + y3 + " V" + y4 + " C" + [
                x6,
                y5,
                x5,
                y6,
                x4,
                y6,
                x4 - (x4 - x3) / 3,
                y6,
                x3 + (x4 - x3) / 3,
                y6,
                x3,
                y6,
                x2,
                y6,
                x,
                y5,
                x,
                y4,
                x,
                y4 - (y4 - y3) / 3,
                x,
                y3 + (y4 - y3) / 3,
                x,
                y3,
                x,
                y2,
                x2,
                y,
                x3,
                y,
                x3 + (x4 - x3) / 3,
                y,
                x4 - (x4 - x3) / 3,
                y,
                x4,
                y,
                x5,
                y,
                x6,
                y2,
                x6,
                y3
            ].join(",") + "z";
        } else data = "M" + (x + w) + "," + y + " v" + h + " h" + -w + " v" + -h + " h" + w + "z";
    } else if (type === "circle" || type === "ellipse") {
        if (type === "circle") {
            r = ry = attr.r;
            rycirc = r * circ;
        } else {
            r = attr.rx;
            ry = attr.ry;
            rycirc = ry * circ;
        }
        x = attr.cx;
        y = attr.cy;
        rcirc = r * circ;
        data = "M" + (x + r) + "," + y + " C" + [
            x + r,
            y + rycirc,
            x + rcirc,
            y + ry,
            x,
            y + ry,
            x - rcirc,
            y + ry,
            x - r,
            y + rycirc,
            x - r,
            y,
            x - r,
            y - rycirc,
            x - rcirc,
            y - ry,
            x,
            y - ry,
            x + rcirc,
            y - ry,
            x + r,
            y - rycirc,
            x + r,
            y
        ].join(",") + "z";
    } else if (type === "line") data = "M" + attr.x1 + "," + attr.y1 + " L" + attr.x2 + "," + attr.y2; //previously, we just converted to "Mx,y Lx,y" but Safari has bugs that cause that not to render properly when using a stroke-dasharray that's not fully visible! Using a cubic bezier fixes that issue.
    else if (type === "polyline" || type === "polygon") {
        points = (element.getAttribute("points") + "").match($81b4963cef37ffda$var$_numbersExp) || [];
        x = points.shift();
        y = points.shift();
        data = "M" + x + "," + y + " L" + points.join(",");
        if (type === "polygon") data += "," + x + "," + y + "z";
    }
    path.setAttribute("d", $81b4963cef37ffda$export$ced9e1d9be30c397(path._gsRawPath = $81b4963cef37ffda$export$a9a6ab89eb1c2191(data)));
    if (swap && element.parentNode) {
        element.parentNode.insertBefore(path, element);
        element.parentNode.removeChild(element);
    }
    return path;
} //returns the rotation (in degrees) at a particular progress on a rawPath (the slope of the tangent)
function $81b4963cef37ffda$export$d03e55696b4d7894(rawPath, progress) {
    var d = $81b4963cef37ffda$var$getProgressData(rawPath, progress >= 1 ? 1 - 1e-9 : progress ? progress : 1e-9);
    return $81b4963cef37ffda$var$getRotationAtBezierT(d.segment, d.i, d.t);
}
function $81b4963cef37ffda$var$getRotationAtBezierT(segment, i, t) {
    var a = segment[i], b = segment[i + 2], c = segment[i + 4], x;
    a += (b - a) * t;
    b += (c - b) * t;
    a += (b - a) * t;
    x = b + (c + (segment[i + 6] - c) * t - b) * t - a;
    a = segment[i + 1];
    b = segment[i + 3];
    c = segment[i + 5];
    a += (b - a) * t;
    b += (c - b) * t;
    a += (b - a) * t;
    return $81b4963cef37ffda$var$_round($81b4963cef37ffda$var$_atan2(b + (c + (segment[i + 7] - c) * t - b) * t - a, x) * $81b4963cef37ffda$var$_RAD2DEG);
}
function $81b4963cef37ffda$export$510a529ffd67482a(rawPath, start, end) {
    end = $81b4963cef37ffda$var$_isUndefined(end) ? 1 : $81b4963cef37ffda$var$_roundPrecise(end) || 0; // we must round to avoid issues like 4.15 / 8 = 0.8300000000000001 instead of 0.83 or 2.8 / 5 = 0.5599999999999999 instead of 0.56 and if someone is doing a loop like start: 2.8 / 0.5, end: 2.8 / 0.5 + 1.
    start = $81b4963cef37ffda$var$_roundPrecise(start) || 0;
    var loops = Math.max(0, ~~($81b4963cef37ffda$var$_abs(end - start) - 1e-8)), path = $81b4963cef37ffda$export$e358367bf79edde2(rawPath);
    if (start > end) {
        start = 1 - start;
        end = 1 - end;
        $81b4963cef37ffda$var$_reverseRawPath(path);
        path.totalLength = 0;
    }
    if (start < 0 || end < 0) {
        var offset = Math.abs(~~Math.min(start, end)) + 1;
        start += offset;
        end += offset;
    }
    path.totalLength || $81b4963cef37ffda$export$cd44c6d3aa5b1098(path);
    var wrap = end > 1, s = $81b4963cef37ffda$var$getProgressData(path, start, $81b4963cef37ffda$var$_temp, true), e = $81b4963cef37ffda$var$getProgressData(path, end, $81b4963cef37ffda$var$_temp2), eSeg = e.segment, sSeg = s.segment, eSegIndex = e.segIndex, sSegIndex = s.segIndex, ei = e.i, si = s.i, sameSegment = sSegIndex === eSegIndex, sameBezier = ei === si && sameSegment, wrapsBehind, sShift, eShift, i, copy, totalSegments, l, j;
    if (wrap || loops) {
        wrapsBehind = eSegIndex < sSegIndex || sameSegment && ei < si || sameBezier && e.t < s.t;
        if ($81b4963cef37ffda$var$_splitSegment(path, sSegIndex, si, s.t)) {
            sSegIndex++;
            if (!wrapsBehind) {
                eSegIndex++;
                if (sameBezier) {
                    e.t = (e.t - s.t) / (1 - s.t);
                    ei = 0;
                } else if (sameSegment) ei -= si;
            }
        }
        if (Math.abs(1 - (end - start)) < 1e-5) eSegIndex = sSegIndex - 1;
        else if (!e.t && eSegIndex) eSegIndex--;
        else if ($81b4963cef37ffda$var$_splitSegment(path, eSegIndex, ei, e.t) && wrapsBehind) sSegIndex++;
        if (s.t === 1) sSegIndex = (sSegIndex + 1) % path.length;
        copy = [];
        totalSegments = path.length;
        l = 1 + totalSegments * loops;
        j = sSegIndex;
        l += (totalSegments - sSegIndex + eSegIndex) % totalSegments;
        for(i = 0; i < l; i++)$81b4963cef37ffda$var$_appendOrMerge(copy, path[j++ % totalSegments]);
        path = copy;
    } else {
        eShift = e.t === 1 ? 6 : $81b4963cef37ffda$export$bd9f14de8998b2c6(eSeg, ei, e.t);
        if (start !== end) {
            sShift = $81b4963cef37ffda$export$bd9f14de8998b2c6(sSeg, si, sameBezier ? s.t / e.t : s.t);
            sameSegment && (eShift += sShift);
            eSeg.splice(ei + eShift + 2);
            (sShift || si) && sSeg.splice(0, si + sShift);
            i = path.length;
            while(i--)//chop off any extra segments
            (i < sSegIndex || i > eSegIndex) && path.splice(i, 1);
        } else {
            eSeg.angle = $81b4963cef37ffda$var$getRotationAtBezierT(eSeg, ei + eShift, 0); //record the value before we chop because it'll be impossible to determine the angle after its length is 0!
            ei += eShift;
            s = eSeg[ei];
            e = eSeg[ei + 1];
            eSeg.length = eSeg.totalLength = 0;
            eSeg.totalPoints = path.totalPoints = 8;
            eSeg.push(s, e, s, e, s, e, s, e);
        }
    }
    path.totalLength = 0;
    return path;
} //measures a Segment according to its resolution (so if segment.resolution is 6, for example, it'll take 6 samples equally across each Bezier) and create/populate a "samples" Array that has the length up to each of those sample points (always increasing from the start) as well as a "lookup" array that's broken up according to the smallest distance between 2 samples. This gives us a very fast way of looking up a progress position rather than looping through all the points/Beziers. You can optionally have it only measure a subset, starting at startIndex and going for a specific number of beziers (remember, there are 3 x/y pairs each, for a total of 6 elements for each Bezier). It will also populate a "totalLength" property, but that's not generally super accurate because by default it'll only take 6 samples per Bezier. But for performance reasons, it's perfectly adequate for measuring progress values along the path. If you need a more accurate totalLength, either increase the resolution or use the more advanced bezierToPoints() method which keeps adding points until they don't deviate by more than a certain precision value.
function $81b4963cef37ffda$var$measureSegment(segment, startIndex, bezierQty) {
    startIndex = startIndex || 0;
    if (!segment.samples) {
        segment.samples = [];
        segment.lookup = [];
    }
    var resolution = ~~segment.resolution || 12, inc = 1 / resolution, endIndex = bezierQty ? startIndex + bezierQty * 6 + 1 : segment.length, x1 = segment[startIndex], y1 = segment[startIndex + 1], samplesIndex = startIndex ? startIndex / 6 * resolution : 0, samples = segment.samples, lookup = segment.lookup, min = (startIndex ? segment.minLength : $81b4963cef37ffda$var$_largeNum) || $81b4963cef37ffda$var$_largeNum, prevLength = samples[samplesIndex + bezierQty * resolution - 1], length = startIndex ? samples[samplesIndex - 1] : 0, i, j, x4, x3, x2, xd, xd1, y4, y3, y2, yd, yd1, inv, t, lengthIndex, l, segLength;
    samples.length = lookup.length = 0;
    for(j = startIndex + 2; j < endIndex; j += 6){
        x4 = segment[j + 4] - x1;
        x3 = segment[j + 2] - x1;
        x2 = segment[j] - x1;
        y4 = segment[j + 5] - y1;
        y3 = segment[j + 3] - y1;
        y2 = segment[j + 1] - y1;
        xd = xd1 = yd = yd1 = 0;
        if ($81b4963cef37ffda$var$_abs(x4) < .01 && $81b4963cef37ffda$var$_abs(y4) < .01 && $81b4963cef37ffda$var$_abs(x2) + $81b4963cef37ffda$var$_abs(y2) < .01) //dump points that are sufficiently close (basically right on top of each other, making a bezier super tiny or 0 length)
        {
            if (segment.length > 8) {
                segment.splice(j, 6);
                j -= 6;
                endIndex -= 6;
            }
        } else for(i = 1; i <= resolution; i++){
            t = inc * i;
            inv = 1 - t;
            xd = xd1 - (xd1 = (t * t * x4 + 3 * inv * (t * x3 + inv * x2)) * t);
            yd = yd1 - (yd1 = (t * t * y4 + 3 * inv * (t * y3 + inv * y2)) * t);
            l = $81b4963cef37ffda$var$_sqrt(yd * yd + xd * xd);
            if (l < min) min = l;
            length += l;
            samples[samplesIndex++] = length;
        }
        x1 += x4;
        y1 += y4;
    }
    if (prevLength) {
        prevLength -= length;
        for(; samplesIndex < samples.length; samplesIndex++)samples[samplesIndex] += prevLength;
    }
    if (samples.length && min) {
        segment.totalLength = segLength = samples[samples.length - 1] || 0;
        segment.minLength = min;
        if (segLength / min < 9999) {
            // if the lookup would require too many values (memory problem), we skip this and instead we use a loop to lookup values directly in the samples Array
            l = lengthIndex = 0;
            for(i = 0; i < segLength; i += min)lookup[l++] = samples[lengthIndex] < i ? ++lengthIndex : lengthIndex;
        }
    } else segment.totalLength = samples[0] = 0;
    return startIndex ? length - samples[startIndex / 2 - 1] : length;
}
function $81b4963cef37ffda$export$cd44c6d3aa5b1098(rawPath, resolution) {
    var pathLength, points, i;
    for(i = pathLength = points = 0; i < rawPath.length; i++){
        rawPath[i].resolution = ~~resolution || 12; //steps per Bezier curve (anchor, 2 control points, to anchor)
        points += rawPath[i].length;
        pathLength += $81b4963cef37ffda$var$measureSegment(rawPath[i]);
    }
    rawPath.totalPoints = points;
    rawPath.totalLength = pathLength;
    return rawPath;
} //divide segment[i] at position t (value between 0 and 1, progress along that particular cubic bezier segment that starts at segment[i]). Returns how many elements were spliced into the segment array (either 0 or 6)
function $81b4963cef37ffda$export$bd9f14de8998b2c6(segment, i, t) {
    if (t <= 0 || t >= 1) return 0;
    var ax = segment[i], ay = segment[i + 1], cp1x = segment[i + 2], cp1y = segment[i + 3], cp2x = segment[i + 4], cp2y = segment[i + 5], bx = segment[i + 6], by = segment[i + 7], x1a = ax + (cp1x - ax) * t, x2 = cp1x + (cp2x - cp1x) * t, y1a = ay + (cp1y - ay) * t, y2 = cp1y + (cp2y - cp1y) * t, x1 = x1a + (x2 - x1a) * t, y1 = y1a + (y2 - y1a) * t, x2a = cp2x + (bx - cp2x) * t, y2a = cp2y + (by - cp2y) * t;
    x2 += (x2a - x2) * t;
    y2 += (y2a - y2) * t;
    segment.splice(i + 2, 4, $81b4963cef37ffda$var$_round(x1a), $81b4963cef37ffda$var$_round(y1a), $81b4963cef37ffda$var$_round(x1), $81b4963cef37ffda$var$_round(y1), $81b4963cef37ffda$var$_round(x1 + (x2 - x1) * t), $81b4963cef37ffda$var$_round(y1 + (y2 - y1) * t), $81b4963cef37ffda$var$_round(x2), $81b4963cef37ffda$var$_round(y2), $81b4963cef37ffda$var$_round(x2a), $81b4963cef37ffda$var$_round(y2a));
    segment.samples && segment.samples.splice(i / 6 * segment.resolution | 0, 0, 0, 0, 0, 0, 0, 0);
    return 6;
} // returns an object {path, segment, segIndex, i, t}
function $81b4963cef37ffda$var$getProgressData(rawPath, progress, decoratee, pushToNextIfAtEnd) {
    decoratee = decoratee || {};
    rawPath.totalLength || $81b4963cef37ffda$export$cd44c6d3aa5b1098(rawPath);
    if (progress < 0 || progress > 1) progress = $81b4963cef37ffda$var$_wrapProgress(progress);
    var segIndex = 0, segment = rawPath[0], samples, resolution, length, min, max, i, t;
    if (!progress) {
        t = i = segIndex = 0;
        segment = rawPath[0];
    } else if (progress === 1) {
        t = 1;
        segIndex = rawPath.length - 1;
        segment = rawPath[segIndex];
        i = segment.length - 8;
    } else {
        if (rawPath.length > 1) {
            //speed optimization: most of the time, there's only one segment so skip the recursion.
            length = rawPath.totalLength * progress;
            max = i = 0;
            while((max += rawPath[i++].totalLength) < length)segIndex = i;
            segment = rawPath[segIndex];
            min = max - segment.totalLength;
            progress = (length - min) / (max - min) || 0;
        }
        samples = segment.samples;
        resolution = segment.resolution; //how many samples per cubic bezier chunk
        length = segment.totalLength * progress;
        i = segment.lookup.length ? segment.lookup[~~(length / segment.minLength)] || 0 : $81b4963cef37ffda$var$_getSampleIndex(samples, length, progress);
        min = i ? samples[i - 1] : 0;
        max = samples[i];
        if (max < length) {
            min = max;
            max = samples[++i];
        }
        t = 1 / resolution * ((length - min) / (max - min) + i % resolution);
        i = ~~(i / resolution) * 6;
        if (pushToNextIfAtEnd && t === 1) {
            if (i + 6 < segment.length) {
                i += 6;
                t = 0;
            } else if (segIndex + 1 < rawPath.length) {
                i = t = 0;
                segment = rawPath[++segIndex];
            }
        }
    }
    decoratee.t = t;
    decoratee.i = i;
    decoratee.path = rawPath;
    decoratee.segment = segment;
    decoratee.segIndex = segIndex;
    return decoratee;
}
function $81b4963cef37ffda$export$5fcb25b7d1608b70(rawPath, progress, includeAngle, point) {
    var segment = rawPath[0], result = point || {}, samples, resolution, length, min, max, i, t, a, inv;
    if (progress < 0 || progress > 1) progress = $81b4963cef37ffda$var$_wrapProgress(progress);
    segment.lookup || $81b4963cef37ffda$export$cd44c6d3aa5b1098(rawPath);
    if (rawPath.length > 1) {
        //speed optimization: most of the time, there's only one segment so skip the recursion.
        length = rawPath.totalLength * progress;
        max = i = 0;
        while((max += rawPath[i++].totalLength) < length)segment = rawPath[i];
        min = max - segment.totalLength;
        progress = (length - min) / (max - min) || 0;
    }
    samples = segment.samples;
    resolution = segment.resolution;
    length = segment.totalLength * progress;
    i = segment.lookup.length ? segment.lookup[progress < 1 ? ~~(length / segment.minLength) : segment.lookup.length - 1] || 0 : $81b4963cef37ffda$var$_getSampleIndex(samples, length, progress);
    min = i ? samples[i - 1] : 0;
    max = samples[i];
    if (max < length) {
        min = max;
        max = samples[++i];
    }
    t = 1 / resolution * ((length - min) / (max - min) + i % resolution) || 0;
    inv = 1 - t;
    i = ~~(i / resolution) * 6;
    a = segment[i];
    result.x = $81b4963cef37ffda$var$_round((t * t * (segment[i + 6] - a) + 3 * inv * (t * (segment[i + 4] - a) + inv * (segment[i + 2] - a))) * t + a);
    result.y = $81b4963cef37ffda$var$_round((t * t * (segment[i + 7] - (a = segment[i + 1])) + 3 * inv * (t * (segment[i + 5] - a) + inv * (segment[i + 3] - a))) * t + a);
    if (includeAngle) result.angle = segment.totalLength ? $81b4963cef37ffda$var$getRotationAtBezierT(segment, i, t >= 1 ? 1 - 1e-9 : t ? t : 1e-9) : segment.angle || 0;
    return result;
} //applies a matrix transform to RawPath (or a segment in a RawPath) and returns whatever was passed in (it transforms the values in the array(s), not a copy).
function $81b4963cef37ffda$export$9210b538875bfe33(rawPath, a, b, c, d, tx, ty) {
    var j = rawPath.length, segment, l, i, x, y;
    while(--j > -1){
        segment = rawPath[j];
        l = segment.length;
        for(i = 0; i < l; i += 2){
            x = segment[i];
            y = segment[i + 1];
            segment[i] = x * a + y * c + tx;
            segment[i + 1] = x * b + y * d + ty;
        }
    }
    rawPath._dirty = 1;
    return rawPath;
} // translates SVG arc data into a segment (cubic beziers). Angle is in degrees.
function $81b4963cef37ffda$var$arcToSegment(lastX, lastY, rx, ry, angle, largeArcFlag, sweepFlag, x, y) {
    if (lastX === x && lastY === y) return;
    rx = $81b4963cef37ffda$var$_abs(rx);
    ry = $81b4963cef37ffda$var$_abs(ry);
    var angleRad = angle % 360 * $81b4963cef37ffda$var$_DEG2RAD, cosAngle = $81b4963cef37ffda$var$_cos(angleRad), sinAngle = $81b4963cef37ffda$var$_sin(angleRad), PI = Math.PI, TWOPI = PI * 2, dx2 = (lastX - x) / 2, dy2 = (lastY - y) / 2, x1 = cosAngle * dx2 + sinAngle * dy2, y1 = -sinAngle * dx2 + cosAngle * dy2, x1_sq = x1 * x1, y1_sq = y1 * y1, radiiCheck = x1_sq / (rx * rx) + y1_sq / (ry * ry);
    if (radiiCheck > 1) {
        rx = $81b4963cef37ffda$var$_sqrt(radiiCheck) * rx;
        ry = $81b4963cef37ffda$var$_sqrt(radiiCheck) * ry;
    }
    var rx_sq = rx * rx, ry_sq = ry * ry, sq = (rx_sq * ry_sq - rx_sq * y1_sq - ry_sq * x1_sq) / (rx_sq * y1_sq + ry_sq * x1_sq);
    if (sq < 0) sq = 0;
    var coef = (largeArcFlag === sweepFlag ? -1 : 1) * $81b4963cef37ffda$var$_sqrt(sq), cx1 = coef * (rx * y1 / ry), cy1 = coef * -(ry * x1 / rx), sx2 = (lastX + x) / 2, sy2 = (lastY + y) / 2, cx = sx2 + (cosAngle * cx1 - sinAngle * cy1), cy = sy2 + (sinAngle * cx1 + cosAngle * cy1), ux = (x1 - cx1) / rx, uy = (y1 - cy1) / ry, vx = (-x1 - cx1) / rx, vy = (-y1 - cy1) / ry, temp = ux * ux + uy * uy, angleStart = (uy < 0 ? -1 : 1) * Math.acos(ux / $81b4963cef37ffda$var$_sqrt(temp)), angleExtent = (ux * vy - uy * vx < 0 ? -1 : 1) * Math.acos((ux * vx + uy * vy) / $81b4963cef37ffda$var$_sqrt(temp * (vx * vx + vy * vy)));
    isNaN(angleExtent) && (angleExtent = PI); //rare edge case. Math.cos(-1) is NaN.
    if (!sweepFlag && angleExtent > 0) angleExtent -= TWOPI;
    else if (sweepFlag && angleExtent < 0) angleExtent += TWOPI;
    angleStart %= TWOPI;
    angleExtent %= TWOPI;
    var segments = Math.ceil($81b4963cef37ffda$var$_abs(angleExtent) / (TWOPI / 4)), rawPath = [], angleIncrement = angleExtent / segments, controlLength = 4 / 3 * $81b4963cef37ffda$var$_sin(angleIncrement / 2) / (1 + $81b4963cef37ffda$var$_cos(angleIncrement / 2)), ma = cosAngle * rx, mb = sinAngle * rx, mc = sinAngle * -ry, md = cosAngle * ry, i;
    for(i = 0; i < segments; i++){
        angle = angleStart + i * angleIncrement;
        x1 = $81b4963cef37ffda$var$_cos(angle);
        y1 = $81b4963cef37ffda$var$_sin(angle);
        ux = $81b4963cef37ffda$var$_cos(angle += angleIncrement);
        uy = $81b4963cef37ffda$var$_sin(angle);
        rawPath.push(x1 - controlLength * y1, y1 + controlLength * x1, ux + controlLength * uy, uy - controlLength * ux, ux, uy);
    } //now transform according to the actual size of the ellipse/arc (the beziers were noramlized, between 0 and 1 on a circle).
    for(i = 0; i < rawPath.length; i += 2){
        x1 = rawPath[i];
        y1 = rawPath[i + 1];
        rawPath[i] = x1 * ma + y1 * mc + cx;
        rawPath[i + 1] = x1 * mb + y1 * md + cy;
    }
    rawPath[i - 2] = x; //always set the end to exactly where it's supposed to be
    rawPath[i - 1] = y;
    return rawPath;
} //Spits back a RawPath with absolute coordinates. Each segment starts with a "moveTo" command (x coordinate, then y) and then 2 control points (x, y, x, y), then anchor. The goal is to minimize memory and maximize speed.
function $81b4963cef37ffda$export$a9a6ab89eb1c2191(d) {
    var a = (d + "").replace($81b4963cef37ffda$var$_scientific, function(m) {
        var n = +m;
        return n < 0.0001 && n > -0.0001 ? 0 : n;
    }).match($81b4963cef37ffda$var$_svgPathExp) || [], //some authoring programs spit out very small numbers in scientific notation like "1e-5", so make sure we round that down to 0 first.
    path = [], relativeX = 0, relativeY = 0, twoThirds = 2 / 3, elements = a.length, points = 0, errorMessage = "ERROR: malformed path: " + d, i, j, x, y, command, isRelative, segment, startX, startY, difX, difY, beziers, prevCommand, flag1, flag2, line = function line(sx, sy, ex, ey) {
        difX = (ex - sx) / 3;
        difY = (ey - sy) / 3;
        segment.push(sx + difX, sy + difY, ex - difX, ey - difY, ex, ey);
    };
    if (!d || !isNaN(a[0]) || isNaN(a[1])) {
        console.log(errorMessage);
        return path;
    }
    for(i = 0; i < elements; i++){
        prevCommand = command;
        if (isNaN(a[i])) {
            command = a[i].toUpperCase();
            isRelative = command !== a[i]; //lower case means relative
        } else //commands like "C" can be strung together without any new command characters between.
        i--;
        x = +a[i + 1];
        y = +a[i + 2];
        if (isRelative) {
            x += relativeX;
            y += relativeY;
        }
        if (!i) {
            startX = x;
            startY = y;
        } // "M" (move)
        if (command === "M") {
            if (segment) {
                if (segment.length < 8) //if the path data was funky and just had a M with no actual drawing anywhere, skip it.
                path.length -= 1;
                else points += segment.length;
            }
            relativeX = startX = x;
            relativeY = startY = y;
            segment = [
                x,
                y
            ];
            path.push(segment);
            i += 2;
            command = "L"; //an "M" with more than 2 values gets interpreted as "lineTo" commands ("L").
        // "C" (cubic bezier)
        } else if (command === "C") {
            if (!segment) segment = [
                0,
                0
            ];
            if (!isRelative) relativeX = relativeY = 0;
             //note: "*1" is just a fast/short way to cast the value as a Number. WAAAY faster in Chrome, slightly slower in Firefox.
            segment.push(x, y, relativeX + a[i + 3] * 1, relativeY + a[i + 4] * 1, relativeX += a[i + 5] * 1, relativeY += a[i + 6] * 1);
            i += 6; // "S" (continuation of cubic bezier)
        } else if (command === "S") {
            difX = relativeX;
            difY = relativeY;
            if (prevCommand === "C" || prevCommand === "S") {
                difX += relativeX - segment[segment.length - 4];
                difY += relativeY - segment[segment.length - 3];
            }
            if (!isRelative) relativeX = relativeY = 0;
            segment.push(difX, difY, x, y, relativeX += a[i + 3] * 1, relativeY += a[i + 4] * 1);
            i += 4; // "Q" (quadratic bezier)
        } else if (command === "Q") {
            difX = relativeX + (x - relativeX) * twoThirds;
            difY = relativeY + (y - relativeY) * twoThirds;
            if (!isRelative) relativeX = relativeY = 0;
            relativeX += a[i + 3] * 1;
            relativeY += a[i + 4] * 1;
            segment.push(difX, difY, relativeX + (x - relativeX) * twoThirds, relativeY + (y - relativeY) * twoThirds, relativeX, relativeY);
            i += 4; // "T" (continuation of quadratic bezier)
        } else if (command === "T") {
            difX = relativeX - segment[segment.length - 4];
            difY = relativeY - segment[segment.length - 3];
            segment.push(relativeX + difX, relativeY + difY, x + (relativeX + difX * 1.5 - x) * twoThirds, y + (relativeY + difY * 1.5 - y) * twoThirds, relativeX = x, relativeY = y);
            i += 2; // "H" (horizontal line)
        } else if (command === "H") {
            line(relativeX, relativeY, relativeX = x, relativeY);
            i += 1; // "V" (vertical line)
        } else if (command === "V") {
            //adjust values because the first (and only one) isn't x in this case, it's y.
            line(relativeX, relativeY, relativeX, relativeY = x + (isRelative ? relativeY - relativeX : 0));
            i += 1; // "L" (line) or "Z" (close)
        } else if (command === "L" || command === "Z") {
            if (command === "Z") {
                x = startX;
                y = startY;
                segment.closed = true;
            }
            if (command === "L" || $81b4963cef37ffda$var$_abs(relativeX - x) > 0.5 || $81b4963cef37ffda$var$_abs(relativeY - y) > 0.5) {
                line(relativeX, relativeY, x, y);
                if (command === "L") i += 2;
            }
            relativeX = x;
            relativeY = y; // "A" (arc)
        } else if (command === "A") {
            flag1 = a[i + 4];
            flag2 = a[i + 5];
            difX = a[i + 6];
            difY = a[i + 7];
            j = 7;
            if (flag1.length > 1) {
                // for cases when the flags are merged, like "a8 8 0 018 8" (the 0 and 1 flags are WITH the x value of 8, but it could also be "a8 8 0 01-8 8" so it may include x or not)
                if (flag1.length < 3) {
                    difY = difX;
                    difX = flag2;
                    j--;
                } else {
                    difY = flag2;
                    difX = flag1.substr(2);
                    j -= 2;
                }
                flag2 = flag1.charAt(1);
                flag1 = flag1.charAt(0);
            }
            beziers = $81b4963cef37ffda$var$arcToSegment(relativeX, relativeY, +a[i + 1], +a[i + 2], +a[i + 3], +flag1, +flag2, (isRelative ? relativeX : 0) + difX * 1, (isRelative ? relativeY : 0) + difY * 1);
            i += j;
            if (beziers) for(j = 0; j < beziers.length; j++)segment.push(beziers[j]);
            relativeX = segment[segment.length - 2];
            relativeY = segment[segment.length - 1];
        } else console.log(errorMessage);
    }
    i = segment.length;
    if (i < 6) {
        //in case there's odd SVG like a M0,0 command at the very end.
        path.pop();
        i = 0;
    } else if (segment[0] === segment[i - 2] && segment[1] === segment[i - 1]) segment.closed = true;
    path.totalPoints = points + i;
    return path;
} //populates the points array in alternating x/y values (like [x, y, x, y...] instead of individual point objects [{x, y}, {x, y}...] to conserve memory and stay in line with how we're handling segment arrays
function $81b4963cef37ffda$export$f86e11e84068dc85(x1, y1, x2, y2, x3, y3, x4, y4, threshold, points, index) {
    var x12 = (x1 + x2) / 2, y12 = (y1 + y2) / 2, x23 = (x2 + x3) / 2, y23 = (y2 + y3) / 2, x34 = (x3 + x4) / 2, y34 = (y3 + y4) / 2, x123 = (x12 + x23) / 2, y123 = (y12 + y23) / 2, x234 = (x23 + x34) / 2, y234 = (y23 + y34) / 2, x1234 = (x123 + x234) / 2, y1234 = (y123 + y234) / 2, dx = x4 - x1, dy = y4 - y1, d2 = $81b4963cef37ffda$var$_abs((x2 - x4) * dy - (y2 - y4) * dx), d3 = $81b4963cef37ffda$var$_abs((x3 - x4) * dy - (y3 - y4) * dx), length;
    if (!points) {
        points = [
            x1,
            y1,
            x4,
            y4
        ];
        index = 2;
    }
    points.splice(index || points.length - 2, 0, x1234, y1234);
    if ((d2 + d3) * (d2 + d3) > threshold * (dx * dx + dy * dy)) {
        length = points.length;
        $81b4963cef37ffda$export$f86e11e84068dc85(x1, y1, x12, y12, x123, y123, x1234, y1234, threshold, points, index);
        $81b4963cef37ffda$export$f86e11e84068dc85(x1234, y1234, x234, y234, x34, y34, x4, y4, threshold, points, index + 2 + (points.length - length));
    }
    return points;
}
function $81b4963cef37ffda$export$e3b964ae0940782f(points, curviness) {
    if (curviness === void 0) curviness = 1;
    var x = points[0], y = 0, segment = [
        x,
        y
    ], i = 2;
    for(; i < points.length; i += 2)segment.push(x, y, points[i], y = (points[i] - x) * curviness / 2, x = points[i], -y);
    return segment;
} //points is an array of x/y points, like [x, y, x, y, x, y]
function $81b4963cef37ffda$export$ae6dd21671b80694(points, curviness) {
    //points = simplifyPoints(points, tolerance);
    $81b4963cef37ffda$var$_abs(points[0] - points[2]) < 1e-4 && $81b4963cef37ffda$var$_abs(points[1] - points[3]) < 1e-4 && (points = points.slice(2)); // if the first two points are super close, dump the first one.
    var l = points.length - 2, x = +points[0], y = +points[1], nextX = +points[2], nextY = +points[3], segment = [
        x,
        y,
        x,
        y
    ], dx2 = nextX - x, dy2 = nextY - y, closed = Math.abs(points[l] - x) < 0.001 && Math.abs(points[l + 1] - y) < 0.001, prevX, prevY, i, dx1, dy1, r1, r2, r3, tl, mx1, mx2, mxm, my1, my2, mym;
    if (closed) {
        // if the start and end points are basically on top of each other, close the segment by adding the 2nd point to the end, and the 2nd-to-last point to the beginning (we'll remove them at the end, but this allows the curvature to look perfect)
        points.push(nextX, nextY);
        nextX = x;
        nextY = y;
        x = points[l - 2];
        y = points[l - 1];
        points.unshift(x, y);
        l += 4;
    }
    curviness = curviness || curviness === 0 ? +curviness : 1;
    for(i = 2; i < l; i += 2){
        prevX = x;
        prevY = y;
        x = nextX;
        y = nextY;
        nextX = +points[i + 2];
        nextY = +points[i + 3];
        if (x === nextX && y === nextY) continue;
        dx1 = dx2;
        dy1 = dy2;
        dx2 = nextX - x;
        dy2 = nextY - y;
        r1 = $81b4963cef37ffda$var$_sqrt(dx1 * dx1 + dy1 * dy1); // r1, r2, and r3 correlate x and y (and z in the future). Basically 2D or 3D hypotenuse
        r2 = $81b4963cef37ffda$var$_sqrt(dx2 * dx2 + dy2 * dy2);
        r3 = $81b4963cef37ffda$var$_sqrt(Math.pow(dx2 / r2 + dx1 / r1, 2) + Math.pow(dy2 / r2 + dy1 / r1, 2));
        tl = (r1 + r2) * curviness * 0.25 / r3;
        mx1 = x - (x - prevX) * (r1 ? tl / r1 : 0);
        mx2 = x + (nextX - x) * (r2 ? tl / r2 : 0);
        mxm = x - (mx1 + ((mx2 - mx1) * (r1 * 3 / (r1 + r2) + 0.5) / 4 || 0));
        my1 = y - (y - prevY) * (r1 ? tl / r1 : 0);
        my2 = y + (nextY - y) * (r2 ? tl / r2 : 0);
        mym = y - (my1 + ((my2 - my1) * (r1 * 3 / (r1 + r2) + 0.5) / 4 || 0));
        if (x !== prevX || y !== prevY) segment.push($81b4963cef37ffda$var$_round(mx1 + mxm), $81b4963cef37ffda$var$_round(my1 + mym), $81b4963cef37ffda$var$_round(x), $81b4963cef37ffda$var$_round(y), $81b4963cef37ffda$var$_round(mx2 + mxm), $81b4963cef37ffda$var$_round(my2 + mym));
    }
    x !== nextX || y !== nextY || segment.length < 4 ? segment.push($81b4963cef37ffda$var$_round(nextX), $81b4963cef37ffda$var$_round(nextY), $81b4963cef37ffda$var$_round(nextX), $81b4963cef37ffda$var$_round(nextY)) : segment.length -= 2;
    if (segment.length === 2) // only one point!
    segment.push(x, y, x, y, x, y);
    else if (closed) {
        segment.splice(0, 6);
        segment.length = segment.length - 6;
    }
    return segment;
} //returns the squared distance between an x/y coordinate and a segment between x1/y1 and x2/y2
function $81b4963cef37ffda$var$pointToSegDist(x, y, x1, y1, x2, y2) {
    var dx = x2 - x1, dy = y2 - y1, t;
    if (dx || dy) {
        t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return Math.pow(x - x1, 2) + Math.pow(y - y1, 2);
}
function $81b4963cef37ffda$var$simplifyStep(points, first, last, tolerance, simplified) {
    var maxSqDist = tolerance, firstX = points[first], firstY = points[first + 1], lastX = points[last], lastY = points[last + 1], index, i, d;
    for(i = first + 2; i < last; i += 2){
        d = $81b4963cef37ffda$var$pointToSegDist(points[i], points[i + 1], firstX, firstY, lastX, lastY);
        if (d > maxSqDist) {
            index = i;
            maxSqDist = d;
        }
    }
    if (maxSqDist > tolerance) {
        index - first > 2 && $81b4963cef37ffda$var$simplifyStep(points, first, index, tolerance, simplified);
        simplified.push(points[index], points[index + 1]);
        last - index > 2 && $81b4963cef37ffda$var$simplifyStep(points, index, last, tolerance, simplified);
    }
} //points is an array of x/y values like [x, y, x, y, x, y]
function $81b4963cef37ffda$export$59627e036caae5e0(points, tolerance) {
    var prevX = parseFloat(points[0]), prevY = parseFloat(points[1]), temp = [
        prevX,
        prevY
    ], l = points.length - 2, i, x, y, dx, dy, result, last;
    tolerance = Math.pow(tolerance || 1, 2);
    for(i = 2; i < l; i += 2){
        x = parseFloat(points[i]);
        y = parseFloat(points[i + 1]);
        dx = prevX - x;
        dy = prevY - y;
        if (dx * dx + dy * dy > tolerance) {
            temp.push(x, y);
            prevX = x;
            prevY = y;
        }
    }
    temp.push(parseFloat(points[l]), parseFloat(points[l + 1]));
    last = temp.length - 2;
    result = [
        temp[0],
        temp[1]
    ];
    $81b4963cef37ffda$var$simplifyStep(temp, 0, last, tolerance, result);
    result.push(temp[last], temp[last + 1]);
    return result;
}
function $81b4963cef37ffda$var$getClosestProgressOnBezier(iterations, px, py, start, end, slices, x0, y0, x1, y1, x2, y2, x3, y3) {
    var inc = (end - start) / slices, best = 0, t = start, x, y, d, dx, dy, inv;
    $81b4963cef37ffda$var$_bestDistance = $81b4963cef37ffda$var$_largeNum;
    while(t <= end){
        inv = 1 - t;
        x = inv * inv * inv * x0 + 3 * inv * inv * t * x1 + 3 * inv * t * t * x2 + t * t * t * x3;
        y = inv * inv * inv * y0 + 3 * inv * inv * t * y1 + 3 * inv * t * t * y2 + t * t * t * y3;
        dx = x - px;
        dy = y - py;
        d = dx * dx + dy * dy;
        if (d < $81b4963cef37ffda$var$_bestDistance) {
            $81b4963cef37ffda$var$_bestDistance = d;
            best = t;
        }
        t += inc;
    }
    return iterations > 1 ? $81b4963cef37ffda$var$getClosestProgressOnBezier(iterations - 1, px, py, Math.max(best - inc, 0), Math.min(best + inc, 1), slices, x0, y0, x1, y1, x2, y2, x3, y3) : best;
}
function $81b4963cef37ffda$export$c7551252c2f97fc2(rawPath, x, y, slices) {
    //returns an object with the closest j, i, and t (j is the segment index, i is the index of the point in that segment, and t is the time/progress along that bezier)
    var closest = {
        j: 0,
        i: 0,
        t: 0
    }, bestDistance = $81b4963cef37ffda$var$_largeNum, i, j, t, segment;
    for(j = 0; j < rawPath.length; j++){
        segment = rawPath[j];
        for(i = 0; i < segment.length; i += 6){
            t = $81b4963cef37ffda$var$getClosestProgressOnBezier(1, x, y, 0, 1, slices || 20, segment[i], segment[i + 1], segment[i + 2], segment[i + 3], segment[i + 4], segment[i + 5], segment[i + 6], segment[i + 7]);
            if (bestDistance > $81b4963cef37ffda$var$_bestDistance) {
                bestDistance = $81b4963cef37ffda$var$_bestDistance;
                closest.j = j;
                closest.i = i;
                closest.t = t;
            }
        }
    }
    return closest;
} //subdivide a Segment closest to a specific x,y coordinate
function $81b4963cef37ffda$export$179b6e586855bec6(x, y, segment, slices, iterations) {
    var l = segment.length, bestDistance = $81b4963cef37ffda$var$_largeNum, bestT = 0, bestSegmentIndex = 0, t, i;
    slices = slices || 20;
    iterations = iterations || 3;
    for(i = 0; i < l; i += 6){
        t = $81b4963cef37ffda$var$getClosestProgressOnBezier(1, x, y, 0, 1, slices, segment[i], segment[i + 1], segment[i + 2], segment[i + 3], segment[i + 4], segment[i + 5], segment[i + 6], segment[i + 7]);
        if (bestDistance > $81b4963cef37ffda$var$_bestDistance) {
            bestDistance = $81b4963cef37ffda$var$_bestDistance;
            bestT = t;
            bestSegmentIndex = i;
        }
    }
    t = $81b4963cef37ffda$var$getClosestProgressOnBezier(iterations, x, y, bestT - 0.05, bestT + 0.05, slices, segment[bestSegmentIndex], segment[bestSegmentIndex + 1], segment[bestSegmentIndex + 2], segment[bestSegmentIndex + 3], segment[bestSegmentIndex + 4], segment[bestSegmentIndex + 5], segment[bestSegmentIndex + 6], segment[bestSegmentIndex + 7]);
    $81b4963cef37ffda$export$bd9f14de8998b2c6(segment, bestSegmentIndex, t);
    return bestSegmentIndex + 6;
}
function $81b4963cef37ffda$export$ced9e1d9be30c397(rawPath) {
    if ($81b4963cef37ffda$var$_isNumber(rawPath[0])) //in case a segment is passed in instead
    rawPath = [
        rawPath
    ];
    var result = "", l = rawPath.length, sl, s, i, segment;
    for(s = 0; s < l; s++){
        segment = rawPath[s];
        result += "M" + $81b4963cef37ffda$var$_round(segment[0]) + "," + $81b4963cef37ffda$var$_round(segment[1]) + " C";
        sl = segment.length;
        for(i = 2; i < sl; i++)result += $81b4963cef37ffda$var$_round(segment[i++]) + "," + $81b4963cef37ffda$var$_round(segment[i++]) + " " + $81b4963cef37ffda$var$_round(segment[i++]) + "," + $81b4963cef37ffda$var$_round(segment[i++]) + " " + $81b4963cef37ffda$var$_round(segment[i++]) + "," + $81b4963cef37ffda$var$_round(segment[i]) + " ";
        if (segment.closed) result += "z";
    }
    return result;
} /*
// takes a segment with coordinates [x, y, x, y, ...] and converts the control points into angles and lengths [x, y, angle, length, angle, length, x, y, angle, length, ...] so that it animates more cleanly and avoids odd breaks/kinks. For example, if you animate from 1 o'clock to 6 o'clock, it'd just go directly/linearly rather than around. So the length would be very short in the middle of the tween.
export function cpCoordsToAngles(segment, copy) {
	var result = copy ? segment.slice(0) : segment,
		x, y, i;
	for (i = 0; i < segment.length; i+=6) {
		x = segment[i+2] - segment[i];
		y = segment[i+3] - segment[i+1];
		result[i+2] = Math.atan2(y, x);
		result[i+3] = Math.sqrt(x * x + y * y);
		x = segment[i+6] - segment[i+4];
		y = segment[i+7] - segment[i+5];
		result[i+4] = Math.atan2(y, x);
		result[i+5] = Math.sqrt(x * x + y * y);
	}
	return result;
}

// takes a segment that was converted with cpCoordsToAngles() to have angles and lengths instead of coordinates for the control points, and converts it BACK into coordinates.
export function cpAnglesToCoords(segment, copy) {
	var result = copy ? segment.slice(0) : segment,
		length = segment.length,
		rnd = 1000,
		angle, l, i, j;
	for (i = 0; i < length; i+=6) {
		angle = segment[i+2];
		l = segment[i+3]; //length
		result[i+2] = (((segment[i] + Math.cos(angle) * l) * rnd) | 0) / rnd;
		result[i+3] = (((segment[i+1] + Math.sin(angle) * l) * rnd) | 0) / rnd;
		angle = segment[i+4];
		l = segment[i+5]; //length
		result[i+4] = (((segment[i+6] - Math.cos(angle) * l) * rnd) | 0) / rnd;
		result[i+5] = (((segment[i+7] - Math.sin(angle) * l) * rnd) | 0) / rnd;
	}
	return result;
}

//adds an "isSmooth" array to each segment and populates it with a boolean value indicating whether or not it's smooth (the control points have basically the same slope). For any smooth control points, it converts the coordinates into angle (x, in radians) and length (y) and puts them into the same index value in a smoothData array.
export function populateSmoothData(rawPath) {
	let j = rawPath.length,
		smooth, segment, x, y, x2, y2, i, l, a, a2, isSmooth, smoothData;
	while (--j > -1) {
		segment = rawPath[j];
		isSmooth = segment.isSmooth = segment.isSmooth || [0, 0, 0, 0];
		smoothData = segment.smoothData = segment.smoothData || [0, 0, 0, 0];
		isSmooth.length = 4;
		l = segment.length - 2;
		for (i = 6; i < l; i += 6) {
			x = segment[i] - segment[i - 2];
			y = segment[i + 1] - segment[i - 1];
			x2 = segment[i + 2] - segment[i];
			y2 = segment[i + 3] - segment[i + 1];
			a = _atan2(y, x);
			a2 = _atan2(y2, x2);
			smooth = (Math.abs(a - a2) < 0.09);
			if (smooth) {
				smoothData[i - 2] = a;
				smoothData[i + 2] = a2;
				smoothData[i - 1] = _sqrt(x * x + y * y);
				smoothData[i + 3] = _sqrt(x2 * x2 + y2 * y2);
			}
			isSmooth.push(smooth, smooth, 0, 0, smooth, smooth);
		}
		//if the first and last points are identical, check to see if there's a smooth transition. We must handle this a bit differently due to their positions in the array.
		if (segment[l] === segment[0] && segment[l+1] === segment[1]) {
			x = segment[0] - segment[l-2];
			y = segment[1] - segment[l-1];
			x2 = segment[2] - segment[0];
			y2 = segment[3] - segment[1];
			a = _atan2(y, x);
			a2 = _atan2(y2, x2);
			if (Math.abs(a - a2) < 0.09) {
				smoothData[l-2] = a;
				smoothData[2] = a2;
				smoothData[l-1] = _sqrt(x * x + y * y);
				smoothData[3] = _sqrt(x2 * x2 + y2 * y2);
				isSmooth[l-2] = isSmooth[l-1] = true; //don't change indexes 2 and 3 because we'll trigger everything from the END, and this will optimize file size a bit.
			}
		}
	}
	return rawPath;
}
export function pointToScreen(svgElement, point) {
	if (arguments.length < 2) { //by default, take the first set of coordinates in the path as the point
		let rawPath = getRawPath(svgElement);
		point = svgElement.ownerSVGElement.createSVGPoint();
		point.x = rawPath[0][0];
		point.y = rawPath[0][1];
	}
	return point.matrixTransform(svgElement.getScreenCTM());
}

*/ 


var $08495e356c406f7c$var$gsap, $08495e356c406f7c$var$_coreInitted, $08495e356c406f7c$var$_getGSAP = function _getGSAP() {
    return $08495e356c406f7c$var$gsap || typeof window !== "undefined" && ($08495e356c406f7c$var$gsap = window.gsap) && $08495e356c406f7c$var$gsap.registerPlugin && $08495e356c406f7c$var$gsap;
}, $08495e356c406f7c$var$_initCore = function _initCore() {
    $08495e356c406f7c$var$gsap = $08495e356c406f7c$var$_getGSAP();
    if ($08495e356c406f7c$var$gsap) {
        $08495e356c406f7c$var$gsap.registerEase("_CE", $08495e356c406f7c$export$94f46869cc67acd8.create);
        $08495e356c406f7c$var$_coreInitted = 1;
    } else console.warn("Please gsap.registerPlugin(CustomEase)");
}, $08495e356c406f7c$var$_bigNum = 1e20, $08495e356c406f7c$var$_round = function _round(value) {
    return ~~(value * 1000 + (value < 0 ? -0.5 : .5)) / 1000;
}, $08495e356c406f7c$var$_bonusValidated = 1, //<name>CustomEase</name>
$08495e356c406f7c$var$_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/gi, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$08495e356c406f7c$var$_needsParsingExp = /[cLlsSaAhHvVtTqQ]/g, $08495e356c406f7c$var$_findMinimum = function _findMinimum(values) {
    var l = values.length, min = $08495e356c406f7c$var$_bigNum, i;
    for(i = 1; i < l; i += 6)+values[i] < min && (min = +values[i]);
    return min;
}, //takes all the points and translates/scales them so that the x starts at 0 and ends at 1.
$08495e356c406f7c$var$_normalize = function _normalize(values, height, originY) {
    if (!originY && originY !== 0) originY = Math.max(+values[values.length - 1], +values[1]);
    var tx = +values[0] * -1, ty = -originY, l = values.length, sx = 1 / (+values[l - 2] + tx), sy = -height || (Math.abs(+values[l - 1] - +values[1]) < 0.01 * (+values[l - 2] - +values[0]) ? $08495e356c406f7c$var$_findMinimum(values) + ty : +values[l - 1] + ty), i;
    if (sy) //typically y ends at 1 (so that the end values are reached)
    sy = 1 / sy;
    else //in case the ease returns to its beginning value, scale everything proportionally
    sy = -sx;
    for(i = 0; i < l; i += 2){
        values[i] = (+values[i] + tx) * sx;
        values[i + 1] = (+values[i + 1] + ty) * sy;
    }
}, //note that this function returns point objects like {x, y} rather than working with segments which are arrays with alternating x, y values as in the similar function in paths.js
$08495e356c406f7c$var$_bezierToPoints = function _bezierToPoints(x1, y1, x2, y2, x3, y3, x4, y4, threshold, points, index) {
    var x12 = (x1 + x2) / 2, y12 = (y1 + y2) / 2, x23 = (x2 + x3) / 2, y23 = (y2 + y3) / 2, x34 = (x3 + x4) / 2, y34 = (y3 + y4) / 2, x123 = (x12 + x23) / 2, y123 = (y12 + y23) / 2, x234 = (x23 + x34) / 2, y234 = (y23 + y34) / 2, x1234 = (x123 + x234) / 2, y1234 = (y123 + y234) / 2, dx = x4 - x1, dy = y4 - y1, d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx), d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx), length;
    if (!points) {
        points = [
            {
                x: x1,
                y: y1
            },
            {
                x: x4,
                y: y4
            }
        ];
        index = 1;
    }
    points.splice(index || points.length - 1, 0, {
        x: x1234,
        y: y1234
    });
    if ((d2 + d3) * (d2 + d3) > threshold * (dx * dx + dy * dy)) {
        length = points.length;
        _bezierToPoints(x1, y1, x12, y12, x123, y123, x1234, y1234, threshold, points, index);
        _bezierToPoints(x1234, y1234, x234, y234, x34, y34, x4, y4, threshold, points, index + 1 + (points.length - length));
    }
    return points;
};
var $08495e356c406f7c$export$94f46869cc67acd8 = /*#__PURE__*/ function() {
    function CustomEase(id, data, config) {
        $08495e356c406f7c$var$_coreInitted || $08495e356c406f7c$var$_initCore();
        this.id = id;
        $08495e356c406f7c$var$_bonusValidated && this.setData(data, config);
    }
    var _proto = CustomEase.prototype;
    _proto.setData = function setData(data, config) {
        config = config || {};
        data = data || "0,0,1,1";
        var values = data.match($08495e356c406f7c$var$_numExp), closest = 1, points = [], lookup = [], precision = config.precision || 1, fast = precision <= 1, l, a1, a2, i, inc, j, point, prevPoint, p;
        this.data = data;
        if ($08495e356c406f7c$var$_needsParsingExp.test(data) || ~data.indexOf("M") && data.indexOf("C") < 0) values = (0, $81b4963cef37ffda$export$a9a6ab89eb1c2191)(data)[0];
        l = values.length;
        if (l === 4) {
            values.unshift(0, 0);
            values.push(1, 1);
            l = 8;
        } else if ((l - 2) % 6) throw "Invalid CustomEase";
        if (+values[0] !== 0 || +values[l - 2] !== 1) $08495e356c406f7c$var$_normalize(values, config.height, config.originY);
        this.segment = values;
        for(i = 2; i < l; i += 6){
            a1 = {
                x: +values[i - 2],
                y: +values[i - 1]
            };
            a2 = {
                x: +values[i + 4],
                y: +values[i + 5]
            };
            points.push(a1, a2);
            $08495e356c406f7c$var$_bezierToPoints(a1.x, a1.y, +values[i], +values[i + 1], +values[i + 2], +values[i + 3], a2.x, a2.y, 1 / (precision * 200000), points, points.length - 1);
        }
        l = points.length;
        for(i = 0; i < l; i++){
            point = points[i];
            prevPoint = points[i - 1] || point;
            if ((point.x > prevPoint.x || prevPoint.y !== point.y && prevPoint.x === point.x || point === prevPoint) && point.x <= 1) {
                //if a point goes BACKWARD in time or is a duplicate, just drop it. Also it shouldn't go past 1 on the x axis, as could happen in a string like "M0,0 C0,0 0.12,0.68 0.18,0.788 0.195,0.845 0.308,1 0.32,1 0.403,1.005 0.398,1 0.5,1 0.602,1 0.816,1.005 0.9,1 0.91,1 0.948,0.69 0.962,0.615 1.003,0.376 1,0 1,0".
                prevPoint.cx = point.x - prevPoint.x; //change in x between this point and the next point (performance optimization)
                prevPoint.cy = point.y - prevPoint.y;
                prevPoint.n = point;
                prevPoint.nx = point.x; //next point's x value (performance optimization, making lookups faster in getRatio()). Remember, the lookup will always land on a spot where it's either this point or the very next one (never beyond that)
                if (fast && i > 1 && Math.abs(prevPoint.cy / prevPoint.cx - points[i - 2].cy / points[i - 2].cx) > 2) //if there's a sudden change in direction, prioritize accuracy over speed. Like a bounce ease - you don't want to risk the sampling chunks landing on each side of the bounce anchor and having it clipped off.
                fast = 0;
                if (prevPoint.cx < closest) {
                    if (!prevPoint.cx) {
                        prevPoint.cx = 0.001; //avoids math problems in getRatio() (dividing by zero)
                        if (i === l - 1) {
                            //in case the final segment goes vertical RIGHT at the end, make sure we end at the end.
                            prevPoint.x -= 0.001;
                            closest = Math.min(closest, 0.001);
                            fast = 0;
                        }
                    } else closest = prevPoint.cx;
                }
            } else {
                points.splice(i--, 1);
                l--;
            }
        }
        l = 1 / closest + 1 | 0;
        inc = 1 / l;
        j = 0;
        point = points[0];
        if (fast) {
            for(i = 0; i < l; i++){
                //for fastest lookups, we just sample along the path at equal x (time) distance. Uses more memory and is slightly less accurate for anchors that don't land on the sampling points, but for the vast majority of eases it's excellent (and fast).
                p = i * inc;
                if (point.nx < p) point = points[++j];
                a1 = point.y + (p - point.x) / point.cx * point.cy;
                lookup[i] = {
                    x: p,
                    cx: inc,
                    y: a1,
                    cy: 0,
                    nx: 9
                };
                if (i) lookup[i - 1].cy = a1 - lookup[i - 1].y;
            }
            lookup[l - 1].cy = points[points.length - 1].y - a1;
        } else {
            //this option is more accurate, ensuring that EVERY anchor is hit perfectly. Clipping across a bounce, for example, would never happen.
            for(i = 0; i < l; i++){
                //build a lookup table based on the smallest distance so that we can instantly find the appropriate point (well, it'll either be that point or the very next one). We'll look up based on the linear progress. So it's it's 0.5 and the lookup table has 100 elements, it'd be like lookup[Math.floor(0.5 * 100)]
                if (point.nx < i * inc) point = points[++j];
                lookup[i] = point;
            }
            if (j < points.length - 1) lookup[i - 1] = points[points.length - 2];
        } //this._calcEnd = (points[points.length-1].y !== 1 || points[0].y !== 0); //ensures that we don't run into floating point errors. As long as we're starting at 0 and ending at 1, tell GSAP to skip the final calculation and use 0/1 as the factor.
        this.ease = function(p) {
            var point = lookup[p * l | 0] || lookup[l - 1];
            if (point.nx < p) point = point.n;
            return point.y + (p - point.x) / point.cx * point.cy;
        };
        this.ease.custom = this;
        this.id && $08495e356c406f7c$var$gsap && $08495e356c406f7c$var$gsap.registerEase(this.id, this.ease);
        return this;
    };
    _proto.getSVGData = function getSVGData(config) {
        return CustomEase.getSVGData(this, config);
    };
    CustomEase.create = function create(id, data, config) {
        return new CustomEase(id, data, config).ease;
    };
    CustomEase.register = function register(core) {
        $08495e356c406f7c$var$gsap = core;
        $08495e356c406f7c$var$_initCore();
    };
    CustomEase.get = function get(id) {
        return $08495e356c406f7c$var$gsap.parseEase(id);
    };
    CustomEase.getSVGData = function getSVGData(ease, config) {
        config = config || {};
        var width = config.width || 100, height = config.height || 100, x = config.x || 0, y = (config.y || 0) + height, e = $08495e356c406f7c$var$gsap.utils.toArray(config.path)[0], a, slope, i, inc, tx, ty, precision, threshold, prevX, prevY;
        if (config.invert) {
            height = -height;
            y = 0;
        }
        if (typeof ease === "string") ease = $08495e356c406f7c$var$gsap.parseEase(ease);
        if (ease.custom) ease = ease.custom;
        if (ease instanceof CustomEase) a = (0, $81b4963cef37ffda$export$ced9e1d9be30c397)((0, $81b4963cef37ffda$export$9210b538875bfe33)([
            ease.segment
        ], width, 0, 0, -height, x, y));
        else {
            a = [
                x,
                y
            ];
            precision = Math.max(5, (config.precision || 1) * 200);
            inc = 1 / precision;
            precision += 2;
            threshold = 5 / precision;
            prevX = $08495e356c406f7c$var$_round(x + inc * width);
            prevY = $08495e356c406f7c$var$_round(y + ease(inc) * -height);
            slope = (prevY - y) / (prevX - x);
            for(i = 2; i < precision; i++){
                tx = $08495e356c406f7c$var$_round(x + i * inc * width);
                ty = $08495e356c406f7c$var$_round(y + ease(i * inc) * -height);
                if (Math.abs((ty - prevY) / (tx - prevX) - slope) > threshold || i === precision - 1) {
                    //only add points when the slope changes beyond the threshold
                    a.push(prevX, prevY);
                    slope = (ty - prevY) / (tx - prevX);
                }
                prevX = tx;
                prevY = ty;
            }
            a = "M" + a.join(",");
        }
        e && e.setAttribute("d", a);
        return a;
    };
    return CustomEase;
}();
$08495e356c406f7c$var$_getGSAP() && $08495e356c406f7c$var$gsap.registerPlugin($08495e356c406f7c$export$94f46869cc67acd8);
$08495e356c406f7c$export$94f46869cc67acd8.version = "3.12.5";


/*!
 * CustomWiggle 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $37c66e5fa2b08312$var$gsap, $37c66e5fa2b08312$var$_coreInitted, $37c66e5fa2b08312$var$createCustomEase, $37c66e5fa2b08312$var$_getGSAP = function _getGSAP() {
    return $37c66e5fa2b08312$var$gsap || typeof window !== "undefined" && ($37c66e5fa2b08312$var$gsap = window.gsap) && $37c66e5fa2b08312$var$gsap.registerPlugin && $37c66e5fa2b08312$var$gsap;
}, $37c66e5fa2b08312$var$_eases = {
    easeOut: "M0,1,C0.7,1,0.6,0,1,0",
    easeInOut: "M0,0,C0.1,0,0.24,1,0.444,1,0.644,1,0.6,0,1,0",
    anticipate: "M0,0,C0,0.222,0.024,0.386,0,0.4,0.18,0.455,0.65,0.646,0.7,0.67,0.9,0.76,1,0.846,1,1",
    uniform: "M0,0,C0,0.95,0,1,0,1,0,1,1,1,1,1,1,1,1,0,1,0"
}, $37c66e5fa2b08312$var$_linearEase = function _linearEase(p) {
    return p;
}, $37c66e5fa2b08312$var$_initCore = function _initCore(required) {
    if (!$37c66e5fa2b08312$var$_coreInitted) {
        $37c66e5fa2b08312$var$gsap = $37c66e5fa2b08312$var$_getGSAP();
        $37c66e5fa2b08312$var$createCustomEase = $37c66e5fa2b08312$var$gsap && $37c66e5fa2b08312$var$gsap.parseEase("_CE");
        if ($37c66e5fa2b08312$var$createCustomEase) {
            for(var p in $37c66e5fa2b08312$var$_eases)$37c66e5fa2b08312$var$_eases[p] = $37c66e5fa2b08312$var$createCustomEase("", $37c66e5fa2b08312$var$_eases[p]);
            $37c66e5fa2b08312$var$_coreInitted = 1;
            $37c66e5fa2b08312$var$_create("wiggle").config = function(vars) {
                return typeof vars === "object" ? $37c66e5fa2b08312$var$_create("", vars) : $37c66e5fa2b08312$var$_create("wiggle(" + vars + ")", {
                    wiggles: +vars
                });
            };
        } else required && console.warn("Please gsap.registerPlugin(CustomEase, CustomWiggle)");
    }
}, $37c66e5fa2b08312$var$_parseEase = function _parseEase(ease, invertNonCustomEases) {
    if (typeof ease !== "function") ease = $37c66e5fa2b08312$var$gsap.parseEase(ease) || $37c66e5fa2b08312$var$createCustomEase("", ease);
    return ease.custom || !invertNonCustomEases ? ease : function(p) {
        return 1 - ease(p);
    };
}, $37c66e5fa2b08312$var$_bonusValidated = 1, //<name>CustomWiggle</name>
$37c66e5fa2b08312$var$_create = function _create(id, vars) {
    if (!$37c66e5fa2b08312$var$_coreInitted) $37c66e5fa2b08312$var$_initCore(1);
    vars = vars || {};
    var wiggles = (vars.wiggles || 10) | 0, inc = 1 / wiggles, x = inc / 2, anticipate = vars.type === "anticipate", yEase = $37c66e5fa2b08312$var$_eases[vars.type] || $37c66e5fa2b08312$var$_eases.easeOut, xEase = $37c66e5fa2b08312$var$_linearEase, rnd = 1000, nextX, nextY, angle, handleX, handleY, easedX, y, path, i;
    if ($37c66e5fa2b08312$var$_bonusValidated) {
        if (anticipate) {
            //the anticipate ease is actually applied on the x-axis (timing) and uses easeOut for amplitude.
            xEase = yEase;
            yEase = $37c66e5fa2b08312$var$_eases.easeOut;
        }
        if (vars.timingEase) xEase = $37c66e5fa2b08312$var$_parseEase(vars.timingEase);
        if (vars.amplitudeEase) yEase = $37c66e5fa2b08312$var$_parseEase(vars.amplitudeEase, true);
        easedX = xEase(x);
        y = anticipate ? -yEase(x) : yEase(x);
        path = [
            0,
            0,
            easedX / 4,
            0,
            easedX / 2,
            y,
            easedX,
            y
        ];
        if (vars.type === "random") {
            //if we just select random values on the y-axis and plug them into the "normal" algorithm, since the control points are always straight horizontal, it creates a bit of a slowdown at each anchor which just didn't seem as desirable, so we switched to an algorithm that bends the control points to be more in line with their context.
            path.length = 4;
            nextX = xEase(inc);
            nextY = Math.random() * 2 - 1;
            for(i = 2; i < wiggles; i++){
                x = nextX;
                y = nextY;
                nextX = xEase(inc * i);
                nextY = Math.random() * 2 - 1;
                angle = Math.atan2(nextY - path[path.length - 3], nextX - path[path.length - 4]);
                handleX = Math.cos(angle) * inc;
                handleY = Math.sin(angle) * inc;
                path.push(x - handleX, y - handleY, x, y, x + handleX, y + handleY);
            }
            path.push(nextX, 0, 1, 0);
        } else {
            for(i = 1; i < wiggles; i++){
                path.push(xEase(x + inc / 2), y);
                x += inc;
                y = (y > 0 ? -1 : 1) * yEase(i * inc);
                easedX = xEase(x);
                path.push(xEase(x - inc / 2), y, easedX, y);
            }
            path.push(xEase(x + inc / 4), y, xEase(x + inc / 4), 0, 1, 0);
        }
        i = path.length;
        while(--i > -1)path[i] = ~~(path[i] * rnd) / rnd; //round values to avoid odd strings for super tiny values
        path[2] = "C" + path[2];
        return $37c66e5fa2b08312$var$createCustomEase(id, "M" + path.join(","));
    }
};
var $37c66e5fa2b08312$export$2b4e60312e59e027 = /*#__PURE__*/ function() {
    function CustomWiggle(id, vars) {
        this.ease = $37c66e5fa2b08312$var$_create(id, vars);
    }
    CustomWiggle.create = function create(id, vars) {
        return $37c66e5fa2b08312$var$_create(id, vars);
    };
    CustomWiggle.register = function register(core) {
        $37c66e5fa2b08312$var$gsap = core;
        $37c66e5fa2b08312$var$_initCore();
    };
    return CustomWiggle;
}();
$37c66e5fa2b08312$var$_getGSAP() && $37c66e5fa2b08312$var$gsap.registerPlugin($37c66e5fa2b08312$export$2b4e60312e59e027);
$37c66e5fa2b08312$export$2b4e60312e59e027.version = "3.12.5";


(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930), (0, $015e296242376acd$export$4129f9ba90e1264a), (0, $08495e356c406f7c$export$94f46869cc67acd8), (0, $37c66e5fa2b08312$export$2b4e60312e59e027));
function $e6673c56130650ed$var$AnimBowl() {
    const animationIsOk = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
    const bowl = document.querySelector("#SVGBowl");
    if (!bowl) return;
    (0, $37c66e5fa2b08312$export$2b4e60312e59e027).create("bottleShake", {
        wiggles: 5,
        type: "easeInOut"
    });
    let q = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.selector("#SVGBowl");
    let previous;
    window.addEventListener("accordianClick", (e)=>{
        (0, $4dab17958b7cdb31$export$99ee26438460406a).set(q(`.item`), {
            opacity: 1
        });
        const { open: open, food: food } = e.detail;
        if (previous === food && open === "true") return;
        previous = food;
        (0, $4dab17958b7cdb31$export$99ee26438460406a).to(q(`#${food}`), {
            opacity: 0,
            duration: 0.2
        });
        if (animationIsOk) switch(food){
            case "bottle":
                bottleTween.restart();
                break;
            case "beetroot":
                beetrootTween.restart();
                break;
            case "leaf":
                leafTween.restart();
                break;
            case "ravioli":
                ravioliTween.restart();
                break;
            case "fishcake":
                fishcakeTween.restart();
                break;
        }
    });
    let bottleTween = (0, $4dab17958b7cdb31$export$99ee26438460406a).to(q(".bottle"), {
        transformOrigin: "center bottom",
        rotation: 10,
        duration: 0.6,
        ease: "bottleShake",
        paused: true
    });
    let beetrootTween = (0, $4dab17958b7cdb31$export$99ee26438460406a).to(q(".beetroot"), {
        transformOrigin: "center",
        rotate: 360,
        duration: 0.6,
        paused: true
    });
    let leafTween = (0, $4dab17958b7cdb31$export$99ee26438460406a).to(q(".leaf"), {
        transformOrigin: "center bottom",
        yPercent: -10,
        yoyo: true,
        repeat: 1,
        duration: 0.4,
        ease: "back.in(1.2)",
        paused: true
    });
    let ravioliTween = (0, $4dab17958b7cdb31$export$99ee26438460406a).to(q(".ravioli"), {
        transformOrigin: "center",
        rotate: -20,
        scale: 1.03,
        yoyo: true,
        repeat: 1,
        duration: 0.6,
        ease: "back.in(1.3)",
        paused: true
    });
    let fishcakeTween = (0, $4dab17958b7cdb31$export$99ee26438460406a).to(q(".fishcake"), {
        transformOrigin: "center",
        rotate: 360,
        duration: 1,
        ease: "sine",
        paused: true
    });
    let mm = (0, $4dab17958b7cdb31$export$99ee26438460406a).matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", ()=>{
        let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            scrollTrigger: {
                trigger: "#SVGBowl",
                start: "top 60%",
                end: "bottom top"
            },
            timeScale: 1.5
        });
        tl.to(q(".white"), {
            duration: 1,
            opacity: 0
        }).fromTo(q("#ray-mask"), {
            drawSVG: "100% 100%"
        }, {
            drawSVG: "0% 100%",
            duration: 2
        }, 0).from(q("#sparks > *"), {
            opacity: 0,
            scale: 0.5,
            transformOrigin: "center",
            stagger: 0.1
        }, 0).from(q("#bubbles > *"), {
            opacity: 0,
            scale: 0.5,
            transformOrigin: "center",
            stagger: 0.05
        }, 0).from(".bowl-cta", {
            duration: 0.5,
            opacity: 0,
            transformOrigin: "center",
            ease: "back.out(1.7)"
        }, 1.5);
    });
    mm.add("(prefers-reduced-motion: reduce)", ()=>{
        let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            scrollTrigger: {
                trigger: "#SVGBowl",
                start: "top 60%",
                end: "bottom center"
            }
        });
        tl.to(q(".white"), {
            duration: 1,
            opacity: 0
        });
    });
}
var $e6673c56130650ed$export$2e2bcd8739ae039 = $e6673c56130650ed$var$AnimBowl;







(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930), (0, $015e296242376acd$export$4129f9ba90e1264a), (0, $08495e356c406f7c$export$94f46869cc67acd8), (0, $37c66e5fa2b08312$export$2b4e60312e59e027));
function $e2219852f6853050$var$AnimHero() {
    const svg = document.querySelector(".hero-anim");
    if (!svg) return;
    const animationIsOk = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
    (0, $37c66e5fa2b08312$export$2b4e60312e59e027).create("bottleShake", {
        wiggles: 12,
        type: "easeInOut"
    });
    (0, $37c66e5fa2b08312$export$2b4e60312e59e027).create("prawnWiggle", {
        wiggles: 4,
        type: "easeInOut"
    });
    const dt = document.querySelector(".hero-anim--desktop");
    const mob = document.querySelector(".hero-anim--mobile");
    let q;
    if (window.matchMedia("(min-width: 1000px)").matches) q = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.selector(dt);
    else q = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.selector(mob);
    if (animationIsOk) {
        let desktopTl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            defaults: {
                ease: "sine.out"
            }
        });
        let mobileTl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            defaults: {
                ease: "sine.out"
            },
            delay: 0.4
        });
        function createDesktopTl() {
            (0, $4dab17958b7cdb31$export$99ee26438460406a).to(".hero-anim-decorations > *", {
                y: "random([-70, -150, -50])",
                ease: "none",
                opacity: 0,
                scrollTrigger: {
                    trigger: ".c-hero",
                    start: 0,
                    end: "bottom top",
                    scrub: 1
                }
            });
            desktopTl.to(q(".hero-anim-white, .hero-anim-fade"), {
                duration: 1,
                opacity: 0,
                ease: "none"
            }, 0.3).to(q(".hero-anim-color"), {
                duration: 2,
                opacity: 1,
                ease: "none"
            }, 0.3).fromTo(q(".hero-anim-draw-center"), {
                drawSVG: "50% 50%"
            }, {
                drawSVG: "0% 100% ",
                duration: 2.5
            }, 1).fromTo(q(".hero-anim-draw-right"), {
                drawSVG: "0% 0%"
            }, {
                drawSVG: "0% 100% ",
                duration: 2.5
            }, 1).from(q(".hero-anim-draw-left"), {
                drawSVG: "0% 0%",
                duration: 2.5
            }, 1).to(q(".hero-anim-video"), {
                opacity: 1
            }, 1).fromTo(q(".hero-anim-draw-plant"), {
                drawSVG: "0% 0%"
            }, {
                drawSVG: "0% 100% ",
                duration: 2
            }, 1.5).from(q(".hero-anim-draw-plant-2"), {
                drawSVG: "100% 100%",
                ease: "none"
            }, 2).from(q(".hero-anim-leaf-2"), {
                scale: 0.3,
                opacity: 0,
                transformOrigin: "right bottom",
                rotate: 50
            }, 2).from(q(".hero-anim-leaf"), {
                scale: 0.3,
                opacity: 0,
                transformOrigin: "left bottom",
                rotate: 50
            }, 3).from(q(".hero-anim-leaf-3"), {
                scale: 0.3,
                opacity: 0,
                transformOrigin: "right bottom",
                rotate: -50
            }, 3.2).to(q(".hero-anim-with"), {
                opacity: 1,
                duration: 1
            }, 2).to(q(".hero-anim-vitaly"), {
                opacity: 1,
                duration: 1
            }, 2.5).to(q(".hero-anim-munch"), {
                opacity: 0,
                duration: 0.1,
                stagger: {
                    from: "end",
                    each: 0.3
                }
            }, 3).from(q(".hero-anim-sparkles > *"), {
                opacity: 0,
                scale: 0.5,
                duration: 0.3,
                stagger: 0.2
            }, 3.5).from(q(".hero-anim-draw-fish"), {
                drawSVG: "100% 100%",
                duration: 2,
                ease: "sine.out"
            }, 2).from(q(".hero-anim-fish"), {
                scale: 0.3,
                opacity: 0,
                transformOrigin: "center"
            }, 2).to(q(".hero-anim-fishcake"), {
                transformOrigin: "center",
                rotate: 360,
                duration: 1.5
            }, 3).to(q(".hero-anim-pepper, .hero-anim-salt"), {
                transformOrigin: "center",
                ease: "bottleShake",
                rotate: 30,
                yPercent: -5,
                xPercent: -8,
                stagger: 0.2,
                duration: 1
            }, 3.8).fromTo(q(".hero-anim-salts > *"), {
                y: -2
            }, {
                opacity: 1,
                y: 0,
                duration: 0.2,
                stagger: 0.04
            }, 4).to(q(".hero-anim-feeler"), {
                transformOrigin: "left top",
                ease: "prawnWiggle",
                rotate: 20,
                stagger: 0.5,
                duration: 4
            }, 3.3);
        }
        function createMobileTl() {
            mobileTl.to(q(".hero-anim-white, .hero-anim-fade"), {
                duration: 1,
                opacity: 0,
                ease: "none"
            }, 0.3).to(q(".hero-anim-color"), {
                duration: 0.5,
                opacity: 1,
                ease: "none"
            }, 0.3).to(q(".hero-anim-video"), {
                opacity: 1,
                duration: 1
            }, 0.5).fromTo(q(".hero-anim-draw-plant"), {
                drawSVG: "0% 0%"
            }, {
                drawSVG: "0% 100% ",
                duration: 2
            }, 0.5).from(q(".hero-anim-leaf-2"), {
                scale: 0.3,
                opacity: 0,
                transformOrigin: "right bottom",
                rotate: 50
            }, 1).from(q(".hero-anim-leaf"), {
                scale: 0.3,
                opacity: 0,
                transformOrigin: "left bottom",
                rotate: 50
            }, 1).to(q(".hero-anim-with"), {
                opacity: 1,
                duration: 1
            }, 2.5).to(q(".hero-anim-vitaly"), {
                opacity: 1,
                duration: 1
            }, 3).from(q(".hero-anim-sparkles > *"), {
                opacity: 0,
                duration: 0.3,
                stagger: 0.1
            }, 2).from(q(".hero-anim-draw-fish"), {
                drawSVG: "100% 100%",
                duration: 1,
                ease: "none"
            }, 1.5).from(q(".hero-anim-fish"), {
                scale: 0.3,
                opacity: 0,
                transformOrigin: "center"
            }, 1.5).to(q(".hero-anim-fishcake"), {
                transformOrigin: "center",
                rotate: 360,
                duration: 1.5
            }, 2).to(q(".hero-anim-pepper, .hero-anim-salt"), {
                transformOrigin: "center",
                ease: "bottleShake",
                rotate: 30,
                duration: 0.4
            }, 1.5).to(q(".hero-anim-salts > *"), {
                opacity: 1,
                stagger: 0.1,
                duration: 0.1
            }, 1.7).to(q(".hero-anim-feeler"), {
                transformOrigin: "left top",
                ease: "prawnWiggle",
                rotate: 20,
                stagger: 0.5,
                duration: 4
            }, 2);
        }
        function addMQListener(mq, callback) {
            if (mq.addEventListener) mq.addEventListener("change", callback);
            else mq.addListener(callback);
        }
        addMQListener(window.matchMedia("(min-width: 1000px)"), (event)=>{
            if (event.matches) {
                if (desktopTl.totalDuration() === 0) {
                    q = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.selector(dt);
                    createDesktopTl();
                    desktopTl.totalProgress(1).pause();
                }
            } else if (mobileTl.totalDuration() === 0) {
                q = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.selector(mob);
                createMobileTl();
                mobileTl.totalProgress(1).pause();
            }
        });
        if (window.matchMedia("(min-width: 1000px)").matches) createDesktopTl();
        else createMobileTl();
    } else {
        (0, $4dab17958b7cdb31$export$99ee26438460406a).set(".hero-anim-color", {
            opacity: 1
        });
        let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            defaults: {
                ease: "sine.out"
            }
        });
        tl.to(q(".hero-anim-video"), {
            opacity: 1
        }, 0.3).to(q(".hero-anim-with"), {
            opacity: 1,
            duration: 1
        }, 0.8).to(q(".hero-anim-vitaly"), {
            opacity: 1,
            duration: 1
        }, 1.5);
    }
}
var $e2219852f6853050$export$2e2bcd8739ae039 = $e2219852f6853050$var$AnimHero;





(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930), (0, $015e296242376acd$export$4129f9ba90e1264a));
function $39ff439fa6c3dbaf$var$AnimHeroUX() {
    let svg = document.querySelector(".hero-anim--ux");
    let q = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.selector(svg);
    let main = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline();
    (0, $4dab17958b7cdb31$export$99ee26438460406a).set(".hero-anim", {
        autoAlpha: 1
    });
    let mm = (0, $4dab17958b7cdb31$export$99ee26438460406a).matchMedia(), breakPoint = 800;
    mm.add({
        isDesktop: `(min-width: ${breakPoint}px) and (prefers-reduced-motion: no-preference)`,
        isMobile: `(max-width: ${breakPoint - 1}px) and (prefers-reduced-motion: no-preference)`
    }, (context)=>{
        let { isDesktop: isDesktop, isMobile: isMobile } = context.conditions;
        main.add(dropper(), 0).add(intro(), 0.3).add(helix(), 1.5).add(dna(), 2).add(wave().timeScale(1.5), 2).add(snowflakes(), 2.5).add(time(), 1).from(q("#sparkles g"), {
            transformOrigin: "center center",
            rotation: "random([-660, 660])",
            scale: 0,
            ease: "back.out",
            stagger: 0.1,
            duration: 3
        }, 3);
        function intro() {
            let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
                defaults: {
                    duration: 4,
                    ease: "sine.out"
                }
            });
            tl.from(q("#drawsvg-intro-top, #drawsvg-intro-underline, #drawsvg-intro-heart"), {
                opacity: 0,
                duration: 0.01
            }, 0).from(q("#drawsvg-intro-top"), {
                drawSVG: "50% 50%"
            }, 0).from(q("#drawsvg-intro-topleft"), {
                drawSVG: "0% 0%"
            }, 0).from(q("#drawsvg-intro-topright"), {
                drawSVG: "0% 0%"
            }, 0).from(q("#drawsvg-intro-underline"), {
                drawSVG: "50% 50%"
            }, 0).fromTo(q(".drawsvg-intro-heart"), {
                drawSVG: "91% 91%"
            }, {
                drawSVG: "91% -91%"
            }, 0);
            return tl;
        }
        function snowflakes() {
            let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
                defaults: {
                    duration: 4,
                    ease: "sine.out"
                }
            });
            tl.from(q(".snowflake1"), {
                opacity: 0,
                scale: 0.3,
                rotation: -100,
                duration: 4,
                ease: "back.out",
                transformOrigin: "50% 50%"
            }, 0).from(q(".snowflake2"), {
                opacity: 0,
                scale: 0.3,
                rotation: 100,
                duration: 4,
                ease: "back.out",
                transformOrigin: "50% 50%"
            }, 0).from(q("#snowflakes .dot"), {
                opacity: 0,
                duration: 1,
                ease: "sine.out",
                transformOrigin: "50% 50%",
                stagger: 0.2
            }, 0);
            return tl;
        }
        function dna() {
            let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
                defaults: {
                    duration: 3,
                    ease: "expo.out"
                }
            });
            tl.from(q("#dna-graph"), {
                duration: 0.7,
                opacity: 0
            }, 0).from(q("#dna-graph .one rect"), {
                scaleY: 0,
                transformOrigin: "50% 50%"
            }, 0.4).from(q("#dna-graph .one .dot"), {
                yPercent: 310
            }, 0.4).from(q("#dna-graph .one .dot-top"), {
                yPercent: -310
            }, 0.4).from(q("#dna-graph .two rect"), {
                scaleY: 0,
                transformOrigin: "50% 50%"
            }, 0.3).from(q("#dna-graph .two .dot"), {
                yPercent: 250
            }, 0.3).from(q("#dna-graph .two .dot-top"), {
                yPercent: -250
            }, 0.3).from(q("#dna-graph .three rect"), {
                scaleY: 0,
                transformOrigin: "50% 50%"
            }, 0.2).from(q("#dna-graph .three .dot"), {
                yPercent: 180
            }, 0.2).from(q("#dna-graph .three .dot-top"), {
                yPercent: -180
            }, 0.2).from(q("#dna-graph .four rect"), {
                scaleY: 0,
                transformOrigin: "50% 50%"
            }, 0.1).from(q("#dna-graph .four .dot"), {
                yPercent: 100
            }, 0.1).from(q("#dna-graph .four .dot-top"), {
                yPercent: -100
            }, 0.1).from(q("#dna-graph .five rect"), {
                scaleY: 0,
                transformOrigin: "50% 50%"
            }, 0).from(q("#dna-graph .five .dot"), {
                yPercent: 180
            }, 0).from(q("#dna-graph .five .dot-top"), {
                yPercent: -180
            }, 0);
            return tl;
        }
        function helix() {
            let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
                defaults: {
                    duration: 1,
                    ease: "sine.out"
                }
            });
            tl.from(q("#double-helix > *"), {
                opacity: 0,
                duration: 0.01
            }, 0).from(q("#double-helix > *"), {
                drawSVG: "50% 50%"
            }, 0).from(q("#with-lettering"), {
                opacity: 0
            }, 0).from(q("#vitaly-lettering"), {
                opacity: 0
            }, 0.2);
            return tl;
        }
        function wave() {
            let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
                defaults: {
                    duration: 1,
                    ease: "none"
                },
                paused: true
            });
            tl.from(q("#wave-one"), {
                drawSVG: "0% 0%"
            }, 0).from(q("#wave-two"), {
                drawSVG: "10% 10%"
            }).from(q("#wave-two"), {
                opacity: 0,
                duration: 0.01
            }, "<").from(q("#wave-three"), {
                drawSVG: "0% 0%"
            }, "<+=30%");
            let main = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
                defaults: {
                    duration: 1
                }
            });
            main.to(tl, {
                progress: 1,
                ease: "sine.inOut",
                duration: 4
            }).from(q("#drops > g"), {
                yPercent: -50,
                opacity: 0,
                stagger: {
                    from: "end",
                    each: "0.3"
                },
                scale: 0,
                transformOrigin: "top center"
            }, "<50%").from(q("#flower-one .stem"), {
                scaleY: 0,
                transformOrigin: "bottom center"
            }, 1.1).from(q("#flower-one .flower"), {
                scale: 0,
                transformOrigin: "center center",
                rotation: 360
            }, 1.5).from(q("#flower-two .stem"), {
                scaleY: 0,
                transformOrigin: "bottom center"
            }, 0.5).from(q("#flower-two .flower"), {
                scale: 0,
                transformOrigin: "center center",
                rotation: 360
            }, 0.9).from(q("#cog-flowers .dots, #wave #circles"), {
                opacity: 0,
                stagger: 0.4
            }, 2).from(q("#fingerprint g > *"), {
                drawSVG: "0% 0%",
                stagger: {
                    from: "end",
                    each: 0.1
                }
            }, "<").from(q("#fingerprint > path"), {
                opacity: 0
            }, "<30%");
            return main;
        }
        function time() {
            let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
                defaults: {
                    duration: 2,
                    ease: "back.out"
                }
            });
            tl.from(q("#plant"), {
                scale: 0,
                yPercent: 100,
                transformOrigin: "bottom center",
                ease: "sine.out"
            }).from(q("#left-leaf"), {
                scale: 0,
                transformOrigin: "bottom right"
            }, 0.5).from(q("#right-leaf"), {
                scale: 0,
                transformOrigin: "bottom left"
            }, "<50%").from(q("#hourglass"), {
                rotation: 180,
                yPercent: -5,
                transformOrigin: "center center",
                ease: "back.inOut"
            }, 0).from(q("#topsand"), {
                yPercent: -40,
                scale: 1.1,
                transformOrigin: "center center",
                duration: 1,
                ease: "expo.out"
            }, "<50%").fromTo(q("#sand"), {
                y: -14
            }, {
                y: 20,
                ease: "sine.out",
                stagger: 1,
                duration: 1
            }, 2).from(q("#bottomsand"), {
                yPercent: 100,
                duration: 3,
                ease: "sine.out"
            }, "<20%").fromTo(q("#finalsand"), {
                y: -14
            }, {
                y: 0,
                ease: "sine.out",
                stagger: 1,
                duration: 1
            }, 4.5);
            return tl;
        }
        function dropper() {
            let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
                defaults: {
                    duration: 1,
                    ease: "back.out"
                }
            });
            tl.to(q(".squeeze"), {
                keyframes: {
                    scale: [
                        1,
                        0.7,
                        1
                    ],
                    easeEach: "none"
                },
                transformOrigin: "20% 90%",
                duration: 2,
                ease: "back.out"
            }).to(q("#pipette-filling"), {
                yPercent: 30,
                xPercent: -30,
                ease: "sine.out",
                duration: 0.5
            }, 0).to(q("#pipette-filling"), {
                yPercent: 10,
                xPercent: -10,
                ease: "sine.out",
                duration: 0.5
            }, 0.5).fromTo(q("#droplet"), {
                scale: 0.4,
                yPercent: -50,
                xPercent: 60,
                rotation: 50
            }, {
                yPercent: 500,
                xPercent: 0,
                scale: 1,
                rotation: 0,
                transformOrigin: "top left",
                ease: "sine.out"
            }, 0.2).from(q("#droplet"), {
                opacity: 0,
                duration: 0.001
            }, "<").from(q("#liquid"), {
                yPercent: 100,
                rotation: 20,
                ease: "sine.out"
            }, "<15%").set(q("#droplet"), {
                scale: 0.3,
                yPercent: -50,
                xPercent: 60
            }).to(q("#droplet"), {
                scale: 1,
                yPercent: 0,
                xPercent: 0
            }).from(q("#glass-pipette"), {
                rotation: 20,
                yPercent: -50,
                xPercent: -20,
                transformOrigin: "bottom left",
                ease: "elastic.out",
                duration: 3
            }, 0);
            return tl;
        }
        function textIntro() {
            let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
                defaults: {
                    duration: 1,
                    ease: "sine.out"
                }
            });
            let tween = (0, $4dab17958b7cdb31$export$99ee26438460406a).from(q(".intro-text"), {
                opacity: 0,
                yPercent: -10,
                ease: "sine.out"
            });
            return tl;
        }
        if (isDesktop) {
            //TODO once I have access to the figma to grab the surrounding decor.
            //Whap in some animations on scroll for the decor
            // Forgive me for my sins, cassie
            // https://images.squarespace-cdn.com/content/v1/5a05ececd55b4165f250f032/1542045347481-ET7TCLLBH4WGSY2J7QK6/fa5.jpg
            (0, $4dab17958b7cdb31$export$99ee26438460406a).to(q(".hero-decorations"), {
                duration: 1,
                opacity: 1,
                ease: "none"
            }, 0.3);
            (0, $4dab17958b7cdb31$export$99ee26438460406a).to(".hero-decorations > *", {
                y: "random([-70, -150, -50])",
                ease: "none",
                opacity: 0,
                scrollTrigger: {
                    trigger: ".c-hero",
                    start: 0,
                    end: "bottom top",
                    scrub: 1
                }
            });
        }
    });
}
var $39ff439fa6c3dbaf$export$2e2bcd8739ae039 = $39ff439fa6c3dbaf$var$AnimHeroUX;




(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930));
function $1033b6f6513d4b8c$var$AnimNewsletter() {
    const svg = document.querySelector("#newsletter-svg");
    if (!svg) return;
    let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
        scrollTrigger: {
            trigger: "#newsletter-svg",
            start: "top 80%",
            end: "bottom top",
            toggleActions: "play reset pause reverse"
        }
    });
    tl.from(".newsletter-letter", {
        yPercent: 100,
        duration: 1,
        ease: "back.out(3)"
    }, 0.5).from(".newsletter-open", {
        scaleY: 0,
        transformOrigin: "center",
        duration: 0.2,
        ease: "none"
    }, 0).from(".newsletter-line", {
        opacity: 0,
        scale: 0,
        duration: 0.2,
        ease: "back.out(3)",
        transformOrigin: "bottom center"
    }, 1).from(".newsletter-sparkles", {
        opacity: 0,
        duration: 0.2,
        transformOrigin: "center"
    }, "<");
}
var $1033b6f6513d4b8c$export$2e2bcd8739ae039 = $1033b6f6513d4b8c$var$AnimNewsletter;




(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930));
function $578af777c0f2e999$var$AnimHand() {
    const hand = document.querySelector(".anim-hand");
    if (hand) {
        const q = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.selector(".anim-hand");
        let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            scrollTrigger: {
                trigger: ".anim-hand",
                start: "top 70%",
                end: "top 40%",
                scrub: 1
            }
        });
        tl.from(q(".lines > *"), {
            opacity: 0,
            scale: 0.2,
            transformOrigin: "bottom center"
        }).from(q(".sparks > *"), {
            opacity: 0,
            scale: 0.2,
            transformOrigin: "center"
        }).from(q(".hand"), {
            yPercent: 50
        }, 0);
    }
    const handCta = document.querySelector(".anim-hand-cta");
    if (handCta) {
        const q = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.selector(".anim-hand-cta");
        let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            paused: true
        });
        tl.from(q(".lines > *"), {
            opacity: 0,
            scale: 0.2,
            duration: 0.2,
            transformOrigin: "bottom center"
        }).from(q(".sparks > *"), {
            opacity: 0,
            duration: 0.05,
            scale: 0.2,
            transformOrigin: "center",
            stagger: 0.03,
            ease: "sine.out(1.7)"
        }, 0).from(q(".hand"), {
            yPercent: 50,
            duration: 0.8,
            ease: "back.out(2)"
        }, 0);
        const button = document.querySelector(".anim-hand-btn");
        button.addEventListener("mouseover", (e)=>{
            tl.play();
        });
        button.addEventListener("mouseleave", (e)=>{
            tl.reverse();
        });
    }
}
var $578af777c0f2e999$export$2e2bcd8739ae039 = $578af777c0f2e999$var$AnimHand;




(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930));
function $377db753c00f7aba$var$AnimTea() {
    const svg = document.querySelector("#svg-tea");
    if (!svg) return;
    let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
        scrollTrigger: {
            trigger: svg,
            start: "top 80%",
            end: "top top",
            scrub: 2
        }
    });
    tl.from(".biscuit", {
        rotate: 360,
        transformOrigin: "center",
        xPercent: 150,
        onStart: ()=>{
            (0, $4dab17958b7cdb31$export$99ee26438460406a).to(".teabag", {
                rotate: -30,
                duration: 0.2,
                ease: "none",
                transformOrigin: "top center"
            });
            (0, $4dab17958b7cdb31$export$99ee26438460406a).to(".teabag", {
                rotate: 0,
                duration: 20,
                delay: 0.2,
                ease: "elastic.out( 1.5, 0.1)",
                transformOrigin: "top center"
            });
        }
    });
}
var $377db753c00f7aba$export$2e2bcd8739ae039 = $377db753c00f7aba$var$AnimTea;




(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930));
function $02286b7c028989c7$var$AnimCards() {
    const cards = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.toArray(".anim-card");
    if (!cards.length > 0) return;
    cards.forEach((card)=>{
        const q = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.selector(card);
        let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            scrollTrigger: {
                trigger: card,
                start: "center 80%",
                end: "bottom top"
            }
        });
        tl.from(q(".color"), {
            opacity: 0,
            duration: 4,
            ease: "circ.out"
        });
    });
}
var $02286b7c028989c7$export$2e2bcd8739ae039 = $02286b7c028989c7$var$AnimCards;




(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930));
function $d8fadea08eb01699$var$AnimTestimonials() {
    const svg = document.querySelector(".testimonials__svg");
    if (!svg) return;
    const q = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.selector(".testimonials__svg");
    let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
        scrollTrigger: {
            trigger: ".testimonials__svg",
            start: "top 70%",
            end: "top 30%",
            scrub: 2
        }
    });
    tl.from(q(".leaf"), {
        duration: 4,
        rotate: -50,
        svgOrigin: "60 60",
        ease: "circ.out"
    });
    tl.from(q(".sparks > *"), {
        opacity: 0,
        scale: 0,
        transformOrigin: "center"
    }, 0);
}
var $d8fadea08eb01699$export$2e2bcd8739ae039 = $d8fadea08eb01699$var$AnimTestimonials;






(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930), (0, $37c66e5fa2b08312$export$2b4e60312e59e027), (0, $08495e356c406f7c$export$94f46869cc67acd8));
function $cbc1160894bda1ba$var$AnimBits() {
    const sparks = document.querySelectorAll(".c-icon--spark");
    if (sparks.length) (0, $4dab17958b7cdb31$export$99ee26438460406a).from(sparks, {
        opacity: 0,
        scale: 0,
        transformOrigin: "center",
        stagger: 0.1,
        scrollTrigger: {
            trigger: ".anim-slat",
            start: "top 60%"
        }
    });
    const bits = document.querySelectorAll(".anim-decoration");
    if (bits.length) {
        (0, $4dab17958b7cdb31$export$99ee26438460406a).set(bits, {
            yPercent: 400
        });
        (0, $4dab17958b7cdb31$export$99ee26438460406a).to(bits, {
            yPercent: "random([-200, -500, -800])",
            ease: "none",
            opacity: 0,
            scrollTrigger: {
                trigger: ".anim-packages",
                start: "top bottom",
                end: "bottom top",
                scrub: 1
            }
        });
    }
    const slide = document.querySelector(".glide__slide--active");
    if (slide) (0, $4dab17958b7cdb31$export$99ee26438460406a).from(slide, {
        yPercent: 40,
        duration: 1,
        ease: "sine.out",
        scrollTrigger: {
            trigger: slide,
            start: "top 90%"
        }
    });
    const bottleSVG = document.querySelector("#anim-bottle");
    if (bottleSVG) {
        (0, $37c66e5fa2b08312$export$2b4e60312e59e027).create("bottleShake", {
            wiggles: 8,
            type: "easeInOut"
        });
        let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            scrollTrigger: {
                trigger: bottleSVG,
                start: "top 90%"
            }
        });
        tl.from("#dotted-line", {
            opacity: 0
        }).from("#bottle-spark > *", {
            opacity: 0,
            stagger: 0.1
        }).to("#bottle-jar", {
            transformOrigin: "center bottom",
            rotation: 10,
            duration: 1.2,
            ease: "bottleShake"
        }, 0);
    }
}
var $cbc1160894bda1ba$export$2e2bcd8739ae039 = $cbc1160894bda1ba$var$AnimBits;




(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930));
function $216392f52529a08e$var$AnimCreator() {
    const section = document.querySelector(".anim-creator");
    if (!section) return;
    let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
        scrollTrigger: {
            trigger: ".anim-creator",
            start: "top 60%",
            end: "top 30%"
        }
    });
    tl.from(".anim-creator-image", {
        opacity: 0,
        y: 80,
        duration: 6,
        ease: "circ.out"
    }, 0);
}
var $216392f52529a08e$export$2e2bcd8739ae039 = $216392f52529a08e$var$AnimCreator;



function $6aeba538135d8ccc$var$AnimCTA() {
    const ctas = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.toArray(".c-hero__cta");
    const tongue = document.querySelector(".anim-tongue");
    if (!tongue) return;
    if (!ctas.length > 0) return;
    ctas.forEach((cta)=>{
        const q = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.selector(cta);
        let lick = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            paused: true
        });
        lick.to(q(".anim-tongue"), {
            xPercent: -140,
            yPercent: 4,
            rotate: 35,
            duration: 0.4,
            transformOrigin: "bottom center",
            ease: "back.inOut(1.3)"
        });
        cta.addEventListener("mouseenter", (e)=>{
            lick.play(0);
        });
        cta.addEventListener("mouseleave", (e)=>{
            lick.reverse();
        });
    });
}
var $6aeba538135d8ccc$export$2e2bcd8739ae039 = $6aeba538135d8ccc$var$AnimCTA;


var $74cf6679aa998d5b$exports = {};


/*!
 * MorphSVGPlugin 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $cc16220f4ef12af5$var$gsap, $cc16220f4ef12af5$var$_toArray, $cc16220f4ef12af5$var$_lastLinkedAnchor, $cc16220f4ef12af5$var$_doc, $cc16220f4ef12af5$var$_coreInitted, $cc16220f4ef12af5$var$PluginClass, $cc16220f4ef12af5$var$_getGSAP = function _getGSAP() {
    return $cc16220f4ef12af5$var$gsap || typeof window !== "undefined" && ($cc16220f4ef12af5$var$gsap = window.gsap) && $cc16220f4ef12af5$var$gsap.registerPlugin && $cc16220f4ef12af5$var$gsap;
}, $cc16220f4ef12af5$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $cc16220f4ef12af5$var$_atan2 = Math.atan2, $cc16220f4ef12af5$var$_cos = Math.cos, $cc16220f4ef12af5$var$_sin = Math.sin, $cc16220f4ef12af5$var$_sqrt = Math.sqrt, $cc16220f4ef12af5$var$_PI = Math.PI, $cc16220f4ef12af5$var$_2PI = $cc16220f4ef12af5$var$_PI * 2, $cc16220f4ef12af5$var$_angleMin = $cc16220f4ef12af5$var$_PI * 0.3, $cc16220f4ef12af5$var$_angleMax = $cc16220f4ef12af5$var$_PI * 0.7, $cc16220f4ef12af5$var$_bigNum = 1e20, $cc16220f4ef12af5$var$_numExp = /[-+=\.]*\d+[\.e\-\+]*\d*[e\-\+]*\d*/gi, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$cc16220f4ef12af5$var$_selectorExp = /(^[#\.][a-z]|[a-y][a-z])/i, $cc16220f4ef12af5$var$_commands = /[achlmqstvz]/i, $cc16220f4ef12af5$var$_log = function _log(message) {
    return console && console.warn(message);
}, $cc16220f4ef12af5$var$_bonusValidated = 1, //<name>MorphSVGPlugin</name>
$cc16220f4ef12af5$var$_getAverageXY = function _getAverageXY(segment) {
    var l = segment.length, x = 0, y = 0, i;
    for(i = 0; i < l; i++){
        x += segment[i++];
        y += segment[i];
    }
    return [
        x / (l / 2),
        y / (l / 2)
    ];
}, $cc16220f4ef12af5$var$_getSize = function _getSize(segment) {
    //rough estimate of the bounding box (based solely on the anchors) of a single segment. sets "size", "centerX", and "centerY" properties on the bezier array itself, and returns the size (width * height)
    var l = segment.length, xMax = segment[0], xMin = xMax, yMax = segment[1], yMin = yMax, x, y, i;
    for(i = 6; i < l; i += 6){
        x = segment[i];
        y = segment[i + 1];
        if (x > xMax) xMax = x;
        else if (x < xMin) xMin = x;
        if (y > yMax) yMax = y;
        else if (y < yMin) yMin = y;
    }
    segment.centerX = (xMax + xMin) / 2;
    segment.centerY = (yMax + yMin) / 2;
    return segment.size = (xMax - xMin) * (yMax - yMin);
}, $cc16220f4ef12af5$var$_getTotalSize = function _getTotalSize(rawPath, samplesPerBezier) {
    if (samplesPerBezier === void 0) samplesPerBezier = 3;
    //rough estimate of the bounding box of the entire list of Bezier segments (based solely on the anchors). sets "size", "centerX", and "centerY" properties on the bezier array itself, and returns the size (width * height)
    var j = rawPath.length, xMax = rawPath[0][0], xMin = xMax, yMax = rawPath[0][1], yMin = yMax, inc = 1 / samplesPerBezier, l, x, y, i, segment, k, t, inv, x1, y1, x2, x3, x4, y2, y3, y4;
    while(--j > -1){
        segment = rawPath[j];
        l = segment.length;
        for(i = 6; i < l; i += 6){
            x1 = segment[i];
            y1 = segment[i + 1];
            x2 = segment[i + 2] - x1;
            y2 = segment[i + 3] - y1;
            x3 = segment[i + 4] - x1;
            y3 = segment[i + 5] - y1;
            x4 = segment[i + 6] - x1;
            y4 = segment[i + 7] - y1;
            k = samplesPerBezier;
            while(--k > -1){
                t = inc * k;
                inv = 1 - t;
                x = (t * t * x4 + 3 * inv * (t * x3 + inv * x2)) * t + x1;
                y = (t * t * y4 + 3 * inv * (t * y3 + inv * y2)) * t + y1;
                if (x > xMax) xMax = x;
                else if (x < xMin) xMin = x;
                if (y > yMax) yMax = y;
                else if (y < yMin) yMin = y;
            }
        }
    }
    rawPath.centerX = (xMax + xMin) / 2;
    rawPath.centerY = (yMax + yMin) / 2;
    rawPath.left = xMin;
    rawPath.width = xMax - xMin;
    rawPath.top = yMin;
    rawPath.height = yMax - yMin;
    return rawPath.size = (xMax - xMin) * (yMax - yMin);
}, $cc16220f4ef12af5$var$_sortByComplexity = function _sortByComplexity(a, b) {
    return b.length - a.length;
}, $cc16220f4ef12af5$var$_sortBySize = function _sortBySize(a, b) {
    var sizeA = a.size || $cc16220f4ef12af5$var$_getSize(a), sizeB = b.size || $cc16220f4ef12af5$var$_getSize(b);
    return Math.abs(sizeB - sizeA) < (sizeA + sizeB) / 20 ? b.centerX - a.centerX || b.centerY - a.centerY : sizeB - sizeA; //if the size is within 10% of each other, prioritize position from left to right, then top to bottom.
}, $cc16220f4ef12af5$var$_offsetSegment = function _offsetSegment(segment, shapeIndex) {
    var a = segment.slice(0), l = segment.length, wrap = l - 2, i, index;
    shapeIndex = shapeIndex | 0;
    for(i = 0; i < l; i++){
        index = (i + shapeIndex) % wrap;
        segment[i++] = a[index];
        segment[i] = a[index + 1];
    }
}, $cc16220f4ef12af5$var$_getTotalMovement = function _getTotalMovement(sb, eb, shapeIndex, offsetX, offsetY) {
    var l = sb.length, d = 0, wrap = l - 2, index, i, x, y;
    shapeIndex *= 6;
    for(i = 0; i < l; i += 6){
        index = (i + shapeIndex) % wrap;
        y = sb[index] - (eb[i] - offsetX);
        x = sb[index + 1] - (eb[i + 1] - offsetY);
        d += $cc16220f4ef12af5$var$_sqrt(x * x + y * y);
    }
    return d;
}, $cc16220f4ef12af5$var$_getClosestShapeIndex = function _getClosestShapeIndex(sb, eb, checkReverse) {
    //finds the index in a closed cubic bezier array that's closest to the angle provided (angle measured from the center or average x/y).
    var l = sb.length, sCenter = $cc16220f4ef12af5$var$_getAverageXY(sb), //when comparing distances, adjust the coordinates as if the shapes are centered with each other.
    eCenter = $cc16220f4ef12af5$var$_getAverageXY(eb), offsetX = eCenter[0] - sCenter[0], offsetY = eCenter[1] - sCenter[1], min = $cc16220f4ef12af5$var$_getTotalMovement(sb, eb, 0, offsetX, offsetY), minIndex = 0, copy, d, i;
    for(i = 6; i < l; i += 6){
        d = $cc16220f4ef12af5$var$_getTotalMovement(sb, eb, i / 6, offsetX, offsetY);
        if (d < min) {
            min = d;
            minIndex = i;
        }
    }
    if (checkReverse) {
        copy = sb.slice(0);
        (0, $81b4963cef37ffda$export$1c1e155a66a9b65a)(copy);
        for(i = 6; i < l; i += 6){
            d = $cc16220f4ef12af5$var$_getTotalMovement(copy, eb, i / 6, offsetX, offsetY);
            if (d < min) {
                min = d;
                minIndex = -i;
            }
        }
    }
    return minIndex / 6;
}, $cc16220f4ef12af5$var$_getClosestAnchor = function _getClosestAnchor(rawPath, x, y) {
    //finds the x/y of the anchor that's closest to the provided x/y coordinate (returns an array, like [x, y]). The bezier should be the top-level type that contains an array for each segment.
    var j = rawPath.length, closestDistance = $cc16220f4ef12af5$var$_bigNum, closestX = 0, closestY = 0, segment, dx, dy, d, i, l;
    while(--j > -1){
        segment = rawPath[j];
        l = segment.length;
        for(i = 0; i < l; i += 6){
            dx = segment[i] - x;
            dy = segment[i + 1] - y;
            d = $cc16220f4ef12af5$var$_sqrt(dx * dx + dy * dy);
            if (d < closestDistance) {
                closestDistance = d;
                closestX = segment[i];
                closestY = segment[i + 1];
            }
        }
    }
    return [
        closestX,
        closestY
    ];
}, $cc16220f4ef12af5$var$_getClosestSegment = function _getClosestSegment(bezier, pool, startIndex, sortRatio, offsetX, offsetY) {
    //matches the bezier to the closest one in a pool (array) of beziers, assuming they are in order of size and we shouldn't drop more than 20% of the size, otherwise prioritizing location (total distance to the center). Extracts the segment out of the pool array and returns it.
    var l = pool.length, index = 0, minSize = Math.min(bezier.size || $cc16220f4ef12af5$var$_getSize(bezier), pool[startIndex].size || $cc16220f4ef12af5$var$_getSize(pool[startIndex])) * sortRatio, //limit things based on a percentage of the size of either the bezier or the next element in the array, whichever is smaller.
    min = $cc16220f4ef12af5$var$_bigNum, cx = bezier.centerX + offsetX, cy = bezier.centerY + offsetY, size, i, dx, dy, d;
    for(i = startIndex; i < l; i++){
        size = pool[i].size || $cc16220f4ef12af5$var$_getSize(pool[i]);
        if (size < minSize) break;
        dx = pool[i].centerX - cx;
        dy = pool[i].centerY - cy;
        d = $cc16220f4ef12af5$var$_sqrt(dx * dx + dy * dy);
        if (d < min) {
            index = i;
            min = d;
        }
    }
    d = pool[index];
    pool.splice(index, 1);
    return d;
}, $cc16220f4ef12af5$var$_subdivideSegmentQty = function _subdivideSegmentQty(segment, quantity) {
    var tally = 0, max = 0.999999, l = segment.length, newPointsPerSegment = quantity / ((l - 2) / 6), ax, ay, cp1x, cp1y, cp2x, cp2y, bx, by, x1, y1, x2, y2, i, t;
    for(i = 2; i < l; i += 6){
        tally += newPointsPerSegment;
        while(tally > max){
            //compare with 0.99999 instead of 1 in order to prevent rounding errors
            ax = segment[i - 2];
            ay = segment[i - 1];
            cp1x = segment[i];
            cp1y = segment[i + 1];
            cp2x = segment[i + 2];
            cp2y = segment[i + 3];
            bx = segment[i + 4];
            by = segment[i + 5];
            t = 1 / ((Math.floor(tally) || 1) + 1); //progress along the bezier (value between 0 and 1)
            x1 = ax + (cp1x - ax) * t;
            x2 = cp1x + (cp2x - cp1x) * t;
            x1 += (x2 - x1) * t;
            x2 += (cp2x + (bx - cp2x) * t - x2) * t;
            y1 = ay + (cp1y - ay) * t;
            y2 = cp1y + (cp2y - cp1y) * t;
            y1 += (y2 - y1) * t;
            y2 += (cp2y + (by - cp2y) * t - y2) * t;
            segment.splice(i, 4, ax + (cp1x - ax) * t, ay + (cp1y - ay) * t, x1, y1, x1 + (x2 - x1) * t, y1 + (y2 - y1) * t, x2, y2, cp2x + (bx - cp2x) * t, cp2y + (by - cp2y) * t);
            i += 6;
            l += 6;
            tally--;
        }
    }
    return segment;
}, $cc16220f4ef12af5$var$_equalizeSegmentQuantity = function _equalizeSegmentQuantity(start, end, shapeIndex, map, fillSafe) {
    //returns an array of shape indexes, 1 for each segment.
    var dif = end.length - start.length, longer = dif > 0 ? end : start, shorter = dif > 0 ? start : end, added = 0, sortMethod = map === "complexity" ? $cc16220f4ef12af5$var$_sortByComplexity : $cc16220f4ef12af5$var$_sortBySize, sortRatio = map === "position" ? 0 : typeof map === "number" ? map : 0.8, i = shorter.length, shapeIndices = typeof shapeIndex === "object" && shapeIndex.push ? shapeIndex.slice(0) : [
        shapeIndex
    ], reverse = shapeIndices[0] === "reverse" || shapeIndices[0] < 0, log = shapeIndex === "log", eb, sb, b, x, y, offsetX, offsetY;
    if (!shorter[0]) return;
    if (longer.length > 1) {
        start.sort(sortMethod);
        end.sort(sortMethod);
        offsetX = longer.size || $cc16220f4ef12af5$var$_getTotalSize(longer); //ensures centerX and centerY are defined (used below).
        offsetX = shorter.size || $cc16220f4ef12af5$var$_getTotalSize(shorter);
        offsetX = longer.centerX - shorter.centerX;
        offsetY = longer.centerY - shorter.centerY;
        if (sortMethod === $cc16220f4ef12af5$var$_sortBySize) for(i = 0; i < shorter.length; i++)longer.splice(i, 0, $cc16220f4ef12af5$var$_getClosestSegment(shorter[i], longer, i, sortRatio, offsetX, offsetY));
    }
    if (dif) {
        if (dif < 0) dif = -dif;
        if (longer[0].length > shorter[0].length) //since we use shorter[0] as the one to map the origination point of any brand new fabricated segments, do any subdividing first so that there are more points to choose from (if necessary)
        $cc16220f4ef12af5$var$_subdivideSegmentQty(shorter[0], (longer[0].length - shorter[0].length) / 6 | 0);
        i = shorter.length;
        while(added < dif){
            x = longer[i].size || $cc16220f4ef12af5$var$_getSize(longer[i]); //just to ensure centerX and centerY are calculated which we use on the next line.
            b = $cc16220f4ef12af5$var$_getClosestAnchor(shorter, longer[i].centerX, longer[i].centerY);
            x = b[0];
            y = b[1];
            shorter[i++] = [
                x,
                y,
                x,
                y,
                x,
                y,
                x,
                y
            ];
            shorter.totalPoints += 8;
            added++;
        }
    }
    for(i = 0; i < start.length; i++){
        eb = end[i];
        sb = start[i];
        dif = eb.length - sb.length;
        if (dif < 0) $cc16220f4ef12af5$var$_subdivideSegmentQty(eb, -dif / 6 | 0);
        else if (dif > 0) $cc16220f4ef12af5$var$_subdivideSegmentQty(sb, dif / 6 | 0);
        if (reverse && fillSafe !== false && !sb.reversed) (0, $81b4963cef37ffda$export$1c1e155a66a9b65a)(sb);
        shapeIndex = shapeIndices[i] || shapeIndices[i] === 0 ? shapeIndices[i] : "auto";
        if (shapeIndex) {
            //if start shape is closed, find the closest point to the start/end, and re-organize the bezier points accordingly so that the shape morphs in a more intuitive way.
            if (sb.closed || Math.abs(sb[0] - sb[sb.length - 2]) < 0.5 && Math.abs(sb[1] - sb[sb.length - 1]) < 0.5) {
                if (shapeIndex === "auto" || shapeIndex === "log") {
                    shapeIndices[i] = shapeIndex = $cc16220f4ef12af5$var$_getClosestShapeIndex(sb, eb, !i || fillSafe === false);
                    if (shapeIndex < 0) {
                        reverse = true;
                        (0, $81b4963cef37ffda$export$1c1e155a66a9b65a)(sb);
                        shapeIndex = -shapeIndex;
                    }
                    $cc16220f4ef12af5$var$_offsetSegment(sb, shapeIndex * 6);
                } else if (shapeIndex !== "reverse") {
                    if (i && shapeIndex < 0) //only happens if an array is passed as shapeIndex and a negative value is defined for an index beyond 0. Very rare, but helpful sometimes.
                    (0, $81b4963cef37ffda$export$1c1e155a66a9b65a)(sb);
                    $cc16220f4ef12af5$var$_offsetSegment(sb, (shapeIndex < 0 ? -shapeIndex : shapeIndex) * 6);
                } //otherwise, if it's not a closed shape, consider reversing it if that would make the overall travel less
            } else if (!reverse && (shapeIndex === "auto" && Math.abs(eb[0] - sb[0]) + Math.abs(eb[1] - sb[1]) + Math.abs(eb[eb.length - 2] - sb[sb.length - 2]) + Math.abs(eb[eb.length - 1] - sb[sb.length - 1]) > Math.abs(eb[0] - sb[sb.length - 2]) + Math.abs(eb[1] - sb[sb.length - 1]) + Math.abs(eb[eb.length - 2] - sb[0]) + Math.abs(eb[eb.length - 1] - sb[1]) || shapeIndex % 2)) {
                (0, $81b4963cef37ffda$export$1c1e155a66a9b65a)(sb);
                shapeIndices[i] = -1;
                reverse = true;
            } else if (shapeIndex === "auto") shapeIndices[i] = 0;
            else if (shapeIndex === "reverse") shapeIndices[i] = -1;
            if (sb.closed !== eb.closed) //if one is closed and one isn't, don't close either one otherwise the tweening will look weird (but remember, the beginning and final states will honor the actual values, so this only affects the inbetween state)
            sb.closed = eb.closed = false;
        }
    }
    log && $cc16220f4ef12af5$var$_log("shapeIndex:[" + shapeIndices.join(",") + "]");
    start.shapeIndex = shapeIndices;
    return shapeIndices;
}, $cc16220f4ef12af5$var$_pathFilter = function _pathFilter(a, shapeIndex, map, precompile, fillSafe) {
    var start = (0, $81b4963cef37ffda$export$a9a6ab89eb1c2191)(a[0]), end = (0, $81b4963cef37ffda$export$a9a6ab89eb1c2191)(a[1]);
    if (!$cc16220f4ef12af5$var$_equalizeSegmentQuantity(start, end, shapeIndex || shapeIndex === 0 ? shapeIndex : "auto", map, fillSafe)) return; //malformed path data or null target
    a[0] = (0, $81b4963cef37ffda$export$ced9e1d9be30c397)(start);
    a[1] = (0, $81b4963cef37ffda$export$ced9e1d9be30c397)(end);
    if (precompile === "log" || precompile === true) $cc16220f4ef12af5$var$_log('precompile:["' + a[0] + '","' + a[1] + '"]');
}, $cc16220f4ef12af5$var$_offsetPoints = function _offsetPoints(text, offset) {
    if (!offset) return text;
    var a = text.match($cc16220f4ef12af5$var$_numExp) || [], l = a.length, s = "", inc, i, j;
    if (offset === "reverse") {
        i = l - 1;
        inc = -2;
    } else {
        i = ((parseInt(offset, 10) || 0) * 2 + 1 + l * 100) % l;
        inc = 2;
    }
    for(j = 0; j < l; j += 2){
        s += a[i - 1] + "," + a[i] + " ";
        i = (i + inc) % l;
    }
    return s;
}, //adds a certain number of points while maintaining the polygon/polyline shape (so that the start/end values can have a matching quantity of points to animate). Returns the revised string.
$cc16220f4ef12af5$var$_equalizePointQuantity = function _equalizePointQuantity(a, quantity) {
    var tally = 0, x = parseFloat(a[0]), y = parseFloat(a[1]), s = x + "," + y + " ", max = 0.999999, newPointsPerSegment, i, l, j, factor, nextX, nextY;
    l = a.length;
    newPointsPerSegment = quantity * 0.5 / (l * 0.5 - 1);
    for(i = 0; i < l - 2; i += 2){
        tally += newPointsPerSegment;
        nextX = parseFloat(a[i + 2]);
        nextY = parseFloat(a[i + 3]);
        if (tally > max) {
            //compare with 0.99999 instead of 1 in order to prevent rounding errors
            factor = 1 / (Math.floor(tally) + 1);
            j = 1;
            while(tally > max){
                s += (x + (nextX - x) * factor * j).toFixed(2) + "," + (y + (nextY - y) * factor * j).toFixed(2) + " ";
                tally--;
                j++;
            }
        }
        s += nextX + "," + nextY + " ";
        x = nextX;
        y = nextY;
    }
    return s;
}, $cc16220f4ef12af5$var$_pointsFilter = function _pointsFilter(a) {
    var startNums = a[0].match($cc16220f4ef12af5$var$_numExp) || [], endNums = a[1].match($cc16220f4ef12af5$var$_numExp) || [], dif = endNums.length - startNums.length;
    if (dif > 0) a[0] = $cc16220f4ef12af5$var$_equalizePointQuantity(startNums, dif);
    else a[1] = $cc16220f4ef12af5$var$_equalizePointQuantity(endNums, -dif);
}, $cc16220f4ef12af5$var$_buildPointsFilter = function _buildPointsFilter(shapeIndex) {
    return !isNaN(shapeIndex) ? function(a) {
        $cc16220f4ef12af5$var$_pointsFilter(a);
        a[1] = $cc16220f4ef12af5$var$_offsetPoints(a[1], parseInt(shapeIndex, 10));
    } : $cc16220f4ef12af5$var$_pointsFilter;
}, $cc16220f4ef12af5$var$_parseShape = function _parseShape(shape, forcePath, target) {
    var isString = typeof shape === "string", e, type;
    if (!isString || $cc16220f4ef12af5$var$_selectorExp.test(shape) || (shape.match($cc16220f4ef12af5$var$_numExp) || []).length < 3) {
        e = $cc16220f4ef12af5$var$_toArray(shape)[0];
        if (e) {
            type = (e.nodeName + "").toUpperCase();
            if (forcePath && type !== "PATH") {
                //if we were passed an element (or selector text for an element) that isn't a path, convert it.
                e = (0, $81b4963cef37ffda$export$1a6b6149d6272140)(e, false);
                type = "PATH";
            }
            shape = e.getAttribute(type === "PATH" ? "d" : "points") || "";
            if (e === target) //if the shape matches the target element, the user wants to revert to the original which should have been stored in the data-original attribute
            shape = e.getAttributeNS(null, "data-original") || shape;
        } else {
            $cc16220f4ef12af5$var$_log("WARNING: invalid morph to: " + shape);
            shape = false;
        }
    }
    return shape;
}, //adds an "isSmooth" array to each segment and populates it with a boolean value indicating whether or not it's smooth (the control points have basically the same slope). For any smooth control points, it converts the coordinates into angle (x, in radians) and length (y) and puts them into the same index value in a smoothData array.
$cc16220f4ef12af5$var$_populateSmoothData = function _populateSmoothData(rawPath, tolerance) {
    var j = rawPath.length, limit = 0.2 * (tolerance || 1), smooth, segment, x, y, x2, y2, i, l, a, a2, isSmooth, smoothData;
    while(--j > -1){
        segment = rawPath[j];
        isSmooth = segment.isSmooth = segment.isSmooth || [
            0,
            0,
            0,
            0
        ];
        smoothData = segment.smoothData = segment.smoothData || [
            0,
            0,
            0,
            0
        ];
        isSmooth.length = 4;
        l = segment.length - 2;
        for(i = 6; i < l; i += 6){
            x = segment[i] - segment[i - 2];
            y = segment[i + 1] - segment[i - 1];
            x2 = segment[i + 2] - segment[i];
            y2 = segment[i + 3] - segment[i + 1];
            a = $cc16220f4ef12af5$var$_atan2(y, x);
            a2 = $cc16220f4ef12af5$var$_atan2(y2, x2);
            smooth = Math.abs(a - a2) < limit;
            if (smooth) {
                smoothData[i - 2] = a;
                smoothData[i + 2] = a2;
                smoothData[i - 1] = $cc16220f4ef12af5$var$_sqrt(x * x + y * y);
                smoothData[i + 3] = $cc16220f4ef12af5$var$_sqrt(x2 * x2 + y2 * y2);
            }
            isSmooth.push(smooth, smooth, 0, 0, smooth, smooth);
        } //if the first and last points are identical, check to see if there's a smooth transition. We must handle this a bit differently due to their positions in the array.
        if (segment[l] === segment[0] && segment[l + 1] === segment[1]) {
            x = segment[0] - segment[l - 2];
            y = segment[1] - segment[l - 1];
            x2 = segment[2] - segment[0];
            y2 = segment[3] - segment[1];
            a = $cc16220f4ef12af5$var$_atan2(y, x);
            a2 = $cc16220f4ef12af5$var$_atan2(y2, x2);
            if (Math.abs(a - a2) < limit) {
                smoothData[l - 2] = a;
                smoothData[2] = a2;
                smoothData[l - 1] = $cc16220f4ef12af5$var$_sqrt(x * x + y * y);
                smoothData[3] = $cc16220f4ef12af5$var$_sqrt(x2 * x2 + y2 * y2);
                isSmooth[l - 2] = isSmooth[l - 1] = true; //don't change indexes 2 and 3 because we'll trigger everything from the END, and this will optimize file size a bit.
            }
        }
    }
    return rawPath;
}, $cc16220f4ef12af5$var$_parseOriginFactors = function _parseOriginFactors(v) {
    var a = v.trim().split(" "), x = ~v.indexOf("left") ? 0 : ~v.indexOf("right") ? 100 : isNaN(parseFloat(a[0])) ? 50 : parseFloat(a[0]), y = ~v.indexOf("top") ? 0 : ~v.indexOf("bottom") ? 100 : isNaN(parseFloat(a[1])) ? 50 : parseFloat(a[1]);
    return {
        x: x / 100,
        y: y / 100
    };
}, $cc16220f4ef12af5$var$_shortAngle = function _shortAngle(dif) {
    return dif !== dif % $cc16220f4ef12af5$var$_PI ? dif + (dif < 0 ? $cc16220f4ef12af5$var$_2PI : -$cc16220f4ef12af5$var$_2PI) : dif;
}, $cc16220f4ef12af5$var$_morphMessage = "Use MorphSVGPlugin.convertToPath() to convert to a path before morphing.", $cc16220f4ef12af5$var$_tweenRotation = function _tweenRotation(start, end, i, linkedPT) {
    var so = this._origin, //starting origin
    eo = this._eOrigin, //ending origin
    dx = start[i] - so.x, dy = start[i + 1] - so.y, d = $cc16220f4ef12af5$var$_sqrt(dx * dx + dy * dy), //length from starting origin to starting point
    sa = $cc16220f4ef12af5$var$_atan2(dy, dx), angleDif, _short;
    dx = end[i] - eo.x;
    dy = end[i + 1] - eo.y;
    angleDif = $cc16220f4ef12af5$var$_atan2(dy, dx) - sa;
    _short = $cc16220f4ef12af5$var$_shortAngle(angleDif); //in the case of control points, we ALWAYS link them to their anchor so that they don't get torn apart and rotate the opposite direction. If it's not a control point, we look at the most recently linked point as long as they're within a certain rotational range of each other.
    if (!linkedPT && $cc16220f4ef12af5$var$_lastLinkedAnchor && Math.abs(_short + $cc16220f4ef12af5$var$_lastLinkedAnchor.ca) < $cc16220f4ef12af5$var$_angleMin) linkedPT = $cc16220f4ef12af5$var$_lastLinkedAnchor;
    return this._anchorPT = $cc16220f4ef12af5$var$_lastLinkedAnchor = {
        _next: this._anchorPT,
        t: start,
        sa: sa,
        //starting angle
        ca: linkedPT && _short * linkedPT.ca < 0 && Math.abs(_short) > $cc16220f4ef12af5$var$_angleMax ? angleDif : _short,
        //change in angle
        sl: d,
        //starting length
        cl: $cc16220f4ef12af5$var$_sqrt(dx * dx + dy * dy) - d,
        //change in length
        i: i
    };
}, $cc16220f4ef12af5$var$_initCore = function _initCore(required) {
    $cc16220f4ef12af5$var$gsap = $cc16220f4ef12af5$var$_getGSAP();
    $cc16220f4ef12af5$var$PluginClass = $cc16220f4ef12af5$var$PluginClass || $cc16220f4ef12af5$var$gsap && $cc16220f4ef12af5$var$gsap.plugins.morphSVG;
    if ($cc16220f4ef12af5$var$gsap && $cc16220f4ef12af5$var$PluginClass) {
        $cc16220f4ef12af5$var$_toArray = $cc16220f4ef12af5$var$gsap.utils.toArray;
        $cc16220f4ef12af5$var$_doc = document;
        $cc16220f4ef12af5$var$PluginClass.prototype._tweenRotation = $cc16220f4ef12af5$var$_tweenRotation;
        $cc16220f4ef12af5$var$_coreInitted = 1;
    } else if (required) $cc16220f4ef12af5$var$_log("Please gsap.registerPlugin(MorphSVGPlugin)");
};
var $cc16220f4ef12af5$export$7063f9e613eaa131 = {
    version: "3.12.5",
    name: "morphSVG",
    rawVars: 1,
    // otherwise "render" would be interpreted as a function-based value.
    register: function register(core, Plugin) {
        $cc16220f4ef12af5$var$gsap = core;
        $cc16220f4ef12af5$var$PluginClass = Plugin;
        $cc16220f4ef12af5$var$_initCore();
    },
    init: function init(target, value, tween, index, targets) {
        $cc16220f4ef12af5$var$_coreInitted || $cc16220f4ef12af5$var$_initCore(1);
        if (!value) {
            $cc16220f4ef12af5$var$_log("invalid shape");
            return false;
        }
        $cc16220f4ef12af5$var$_isFunction(value) && (value = value.call(tween, index, target, targets));
        var type, p, pt, shape, isPoly, shapeIndex, map, startSmooth, endSmooth, start, end, i, j, l, startSeg, endSeg, precompiled, sData, eData, originFactors, useRotation, offset;
        if (typeof value === "string" || value.getBBox || value[0]) value = {
            shape: value
        };
        else if (typeof value === "object") {
            // if there are any function-based values, parse them here (and make a copy of the object so we're not modifying the original)
            type = {};
            for(p in value)type[p] = $cc16220f4ef12af5$var$_isFunction(value[p]) && p !== "render" ? value[p].call(tween, index, target, targets) : value[p];
            value = type;
        }
        var cs = target.nodeType ? window.getComputedStyle(target) : {}, fill = cs.fill + "", fillSafe = !(fill === "none" || (fill.match($cc16220f4ef12af5$var$_numExp) || [])[3] === "0" || cs.fillRule === "evenodd"), origins = (value.origin || "50 50").split(",");
        type = (target.nodeName + "").toUpperCase();
        isPoly = type === "POLYLINE" || type === "POLYGON";
        if (type !== "PATH" && !isPoly && !value.prop) {
            $cc16220f4ef12af5$var$_log("Cannot morph a <" + type + "> element. " + $cc16220f4ef12af5$var$_morphMessage);
            return false;
        }
        p = type === "PATH" ? "d" : "points";
        if (!value.prop && !$cc16220f4ef12af5$var$_isFunction(target.setAttribute)) return false;
        shape = $cc16220f4ef12af5$var$_parseShape(value.shape || value.d || value.points || "", p === "d", target);
        if (isPoly && $cc16220f4ef12af5$var$_commands.test(shape)) {
            $cc16220f4ef12af5$var$_log("A <" + type + "> cannot accept path data. " + $cc16220f4ef12af5$var$_morphMessage);
            return false;
        }
        shapeIndex = value.shapeIndex || value.shapeIndex === 0 ? value.shapeIndex : "auto";
        map = value.map || $cc16220f4ef12af5$export$7063f9e613eaa131.defaultMap;
        this._prop = value.prop;
        this._render = value.render || $cc16220f4ef12af5$export$7063f9e613eaa131.defaultRender;
        this._apply = "updateTarget" in value ? value.updateTarget : $cc16220f4ef12af5$export$7063f9e613eaa131.defaultUpdateTarget;
        this._rnd = Math.pow(10, isNaN(value.precision) ? 2 : +value.precision);
        this._tween = tween;
        if (shape) {
            this._target = target;
            precompiled = typeof value.precompile === "object";
            start = this._prop ? target[this._prop] : target.getAttribute(p);
            if (!this._prop && !target.getAttributeNS(null, "data-original")) target.setAttributeNS(null, "data-original", start); //record the original state in a data-original attribute so that we can revert to it later.
            if (p === "d" || this._prop) {
                start = (0, $81b4963cef37ffda$export$a9a6ab89eb1c2191)(precompiled ? value.precompile[0] : start);
                end = (0, $81b4963cef37ffda$export$a9a6ab89eb1c2191)(precompiled ? value.precompile[1] : shape);
                if (!precompiled && !$cc16220f4ef12af5$var$_equalizeSegmentQuantity(start, end, shapeIndex, map, fillSafe)) return false; //malformed path data or null target
                if (value.precompile === "log" || value.precompile === true) $cc16220f4ef12af5$var$_log('precompile:["' + (0, $81b4963cef37ffda$export$ced9e1d9be30c397)(start) + '","' + (0, $81b4963cef37ffda$export$ced9e1d9be30c397)(end) + '"]');
                useRotation = (value.type || $cc16220f4ef12af5$export$7063f9e613eaa131.defaultType) !== "linear";
                if (useRotation) {
                    start = $cc16220f4ef12af5$var$_populateSmoothData(start, value.smoothTolerance);
                    end = $cc16220f4ef12af5$var$_populateSmoothData(end, value.smoothTolerance);
                    if (!start.size) $cc16220f4ef12af5$var$_getTotalSize(start); //adds top/left/width/height values
                    if (!end.size) $cc16220f4ef12af5$var$_getTotalSize(end);
                    originFactors = $cc16220f4ef12af5$var$_parseOriginFactors(origins[0]);
                    this._origin = start.origin = {
                        x: start.left + originFactors.x * start.width,
                        y: start.top + originFactors.y * start.height
                    };
                    if (origins[1]) originFactors = $cc16220f4ef12af5$var$_parseOriginFactors(origins[1]);
                    this._eOrigin = {
                        x: end.left + originFactors.x * end.width,
                        y: end.top + originFactors.y * end.height
                    };
                }
                this._rawPath = target._gsRawPath = start;
                j = start.length;
                while(--j > -1){
                    startSeg = start[j];
                    endSeg = end[j];
                    startSmooth = startSeg.isSmooth || [];
                    endSmooth = endSeg.isSmooth || [];
                    l = startSeg.length;
                    $cc16220f4ef12af5$var$_lastLinkedAnchor = 0; //reset; we use _lastLinkedAnchor in the _tweenRotation() method to help make sure that close points don't get ripped apart and rotate opposite directions. Typically we want to go the shortest direction, but if the previous anchor is going a different direction, we override this logic (within certain thresholds)
                    for(i = 0; i < l; i += 2)if (endSeg[i] !== startSeg[i] || endSeg[i + 1] !== startSeg[i + 1]) {
                        if (useRotation) {
                            if (startSmooth[i] && endSmooth[i]) {
                                //if BOTH starting and ending values are smooth (meaning control points have basically the same slope), interpolate the rotation and length instead of the coordinates (this is what makes things smooth).
                                sData = startSeg.smoothData;
                                eData = endSeg.smoothData;
                                offset = i + (i === l - 4 ? 7 - l : 5); //helps us accommodate wrapping (like if the end and start anchors are identical and the control points are smooth).
                                this._controlPT = {
                                    _next: this._controlPT,
                                    i: i,
                                    j: j,
                                    l1s: sData[i + 1],
                                    l1c: eData[i + 1] - sData[i + 1],
                                    l2s: sData[offset],
                                    l2c: eData[offset] - sData[offset]
                                };
                                pt = this._tweenRotation(startSeg, endSeg, i + 2);
                                this._tweenRotation(startSeg, endSeg, i, pt);
                                this._tweenRotation(startSeg, endSeg, offset - 1, pt);
                                i += 4;
                            } else this._tweenRotation(startSeg, endSeg, i);
                        } else {
                            pt = this.add(startSeg, i, startSeg[i], endSeg[i], 0, 0, 0, 0, 0, 1);
                            pt = this.add(startSeg, i + 1, startSeg[i + 1], endSeg[i + 1], 0, 0, 0, 0, 0, 1) || pt;
                        }
                    }
                }
            } else pt = this.add(target, "setAttribute", target.getAttribute(p) + "", shape + "", index, targets, 0, $cc16220f4ef12af5$var$_buildPointsFilter(shapeIndex), p);
            if (useRotation) {
                this.add(this._origin, "x", this._origin.x, this._eOrigin.x, 0, 0, 0, 0, 0, 1);
                pt = this.add(this._origin, "y", this._origin.y, this._eOrigin.y, 0, 0, 0, 0, 0, 1);
            }
            if (pt) {
                this._props.push("morphSVG");
                pt.end = shape;
                pt.endProp = p;
            }
        }
        return $cc16220f4ef12af5$var$_bonusValidated;
    },
    render: function render(ratio, data) {
        var rawPath = data._rawPath, controlPT = data._controlPT, anchorPT = data._anchorPT, rnd = data._rnd, target = data._target, pt = data._pt, s, space, easeInOut, segment, l, angle, i, j, x, y, sin, cos, offset;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        if (ratio === 1 && data._apply) {
            pt = data._pt;
            while(pt){
                if (pt.end) {
                    if (data._prop) target[data._prop] = pt.end;
                    else target.setAttribute(pt.endProp, pt.end); //make sure the end value is exactly as specified (in case we had to add fabricated points during the tween)
                }
                pt = pt._next;
            }
        } else if (rawPath) {
            //rotationally position the anchors
            while(anchorPT){
                angle = anchorPT.sa + ratio * anchorPT.ca;
                l = anchorPT.sl + ratio * anchorPT.cl; //length
                anchorPT.t[anchorPT.i] = data._origin.x + $cc16220f4ef12af5$var$_cos(angle) * l;
                anchorPT.t[anchorPT.i + 1] = data._origin.y + $cc16220f4ef12af5$var$_sin(angle) * l;
                anchorPT = anchorPT._next;
            } //smooth out the control points
            easeInOut = ratio < 0.5 ? 2 * ratio * ratio : (4 - 2 * ratio) * ratio - 1;
            while(controlPT){
                i = controlPT.i;
                segment = rawPath[controlPT.j];
                offset = i + (i === segment.length - 4 ? 7 - segment.length : 5); //accommodates wrapping around of smooth points, like if the start and end anchors are on top of each other and their handles are smooth.
                angle = $cc16220f4ef12af5$var$_atan2(segment[offset] - segment[i + 1], segment[offset - 1] - segment[i]); //average the angles
                sin = $cc16220f4ef12af5$var$_sin(angle);
                cos = $cc16220f4ef12af5$var$_cos(angle);
                x = segment[i + 2];
                y = segment[i + 3];
                l = controlPT.l1s + easeInOut * controlPT.l1c; //length
                segment[i] = x - cos * l;
                segment[i + 1] = y - sin * l;
                l = controlPT.l2s + easeInOut * controlPT.l2c;
                segment[offset - 1] = x + cos * l;
                segment[offset] = y + sin * l;
                controlPT = controlPT._next;
            }
            target._gsRawPath = rawPath;
            if (data._apply) {
                s = "";
                space = " ";
                for(j = 0; j < rawPath.length; j++){
                    segment = rawPath[j];
                    l = segment.length;
                    s += "M" + (segment[0] * rnd | 0) / rnd + space + (segment[1] * rnd | 0) / rnd + " C";
                    for(i = 2; i < l; i++)//this is actually faster than just doing a join() on the array, possibly because the numbers have so many decimal places
                    s += (segment[i] * rnd | 0) / rnd + space;
                }
                if (data._prop) target[data._prop] = s;
                else target.setAttribute("d", s);
            }
        }
        data._render && rawPath && data._render.call(data._tween, rawPath, target);
    },
    kill: function kill(property) {
        this._pt = this._rawPath = 0;
    },
    getRawPath: (0, $81b4963cef37ffda$export$a7de45090ab95fc7),
    stringToRawPath: (0, $81b4963cef37ffda$export$a9a6ab89eb1c2191),
    rawPathToString: (0, $81b4963cef37ffda$export$ced9e1d9be30c397),
    normalizeStrings: function normalizeStrings(shape1, shape2, _ref) {
        var shapeIndex = _ref.shapeIndex, map = _ref.map;
        var result = [
            shape1,
            shape2
        ];
        $cc16220f4ef12af5$var$_pathFilter(result, shapeIndex, map);
        return result;
    },
    pathFilter: $cc16220f4ef12af5$var$_pathFilter,
    pointsFilter: $cc16220f4ef12af5$var$_pointsFilter,
    getTotalSize: $cc16220f4ef12af5$var$_getTotalSize,
    equalizeSegmentQuantity: $cc16220f4ef12af5$var$_equalizeSegmentQuantity,
    convertToPath: function convertToPath(targets, swap) {
        return $cc16220f4ef12af5$var$_toArray(targets).map(function(target) {
            return (0, $81b4963cef37ffda$export$1a6b6149d6272140)(target, swap !== false);
        });
    },
    defaultType: "linear",
    defaultUpdateTarget: true,
    defaultMap: "size"
};
$cc16220f4ef12af5$var$_getGSAP() && $cc16220f4ef12af5$var$gsap.registerPlugin($cc16220f4ef12af5$export$7063f9e613eaa131);


(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930), (0, $cc16220f4ef12af5$export$7063f9e613eaa131));
function $74cf6679aa998d5b$var$InjectMeal() {
    const container = document.querySelector(".anim-inject");
    if (!container) return;
    const today = new Date();
    const currentTime = today.getHours();
    // forgive me
    let breakfastMarkup = `
<svg class="anim-meals" width="100%" xml:space="preserve" fill-rule="evenodd" stroke-miterlimit="10" clip-rule="evenodd" viewBox="0 0 2384 2584">
 <g class="meals-all">
 <g class="meal breakfast">
   <g class="spoon" fill-rule="nonzero" stroke-width="5.25px">
    <path fill="#d9dacb" stroke="#9da2a7" d="M1358.08,939.375c154.75,-351.292 335.667,-428.958 335.667,-428.958c0,-0 66.667,-32.834 47.792,45.416c-15.292,62.959 -227.167,294.292 -309.625,382.5c-19.914,21.286 -31.285,49.192 -31.917,78.334c-1.875,83.333 -6.917,273.583 -160.375,227.25c-220.875,-66.834 111.5,-288.709 118.458,-304.542Z" />
    <path fill="#9da2a7" stroke="#d9dacb" d="M1197.92,1185.42c-4.167,-0 29.166,62.5 100,33.333c47.666,-19.625 83.333,-129.167 75,-150c-15.542,-38.875 -58.334,120.833 -175,116.667Z" />
   </g>
   <g class="bowl">
    <g class="yoghurt" fill-rule="nonzero" stroke-width="8.33px">
     <path fill="#fff8ec" stroke="#e6e6e6" d="M1672.04,1177.54c-23.819,-15.106 -51.462,-23.101 -79.667,-23.042l-2.75,0c-3.472,-64.357 -57.373,-115.428 -121.823,-115.428c-30.782,-0 -60.452,11.65 -83.01,32.595c-8.14,-28.123 -26.112,-52.41 -50.625,-68.417l-0,-4.542c-0.14,-81.688 -67.395,-148.827 -149.083,-148.827c-69.155,-0 -129.67,48.117 -145.251,115.494c-20.552,-10.171 -43.176,-15.463 -66.108,-15.463c-78.106,-0 -143.64,61.398 -148.725,139.338c-35.704,15.581 -61.895,47.321 -70.417,85.333" />
     <g fill="none" stroke="#f4b67f" stroke-linecap="round">
      <path d="M1097.46,1065.5l0,46.75" />
      <path d="M1120.83,1088.88l-46.708,0" />
     </g>
     <g fill="none" stroke="#f4b67f" stroke-linecap="round">
      <path d="M980.792,1019.67l-0,46.75" />
      <path d="M1004.17,1043.04l-46.709,-0" />
     </g>
    </g>
    <g class="granola" fill="#ffa18f">
     <circle cx="1133.33" cy="950" r="12.5" />
     <circle cx="1220.83" cy="891.667" r="12.5" />
     <circle cx="1320.83" cy="1062.5" r="12.5" />
     <circle cx="1162.5" cy="1029.17" r="8.333" />
     <circle cx="1304.17" cy="979.167" r="8.333" />
     <circle cx="1208.33" cy="966.667" r="8.333" />
     <circle cx="1383.33" cy="1120.83" r="8.333" />
     <circle cx="1068.75" cy="981.25" r="6.25" />
     <circle cx="1322.92" cy="1118.75" r="6.25" />
     <circle cx="1243.75" cy="1031.25" r="6.25" />
     <circle cx="1272.92" cy="925" r="6.25" />
     <circle cx="1143.75" cy="897.917" r="6.25" />
    </g>
    <g class="orange-slices" fill-rule="nonzero" stroke="#c29c87">
     <g>
      <path fill="#ffca6c" stroke-width="5.25px" d="M1038.54,1343.12c30.772,-7.453 57.471,-26.588 74.416,-53.333c1.151,-0.443 1.87,-1.607 1.75,-2.834c16.283,-26.876 21.612,-59.015 14.875,-89.708c0.589,-1.177 0.255,-2.619 -0.791,-3.417c-2.576,-10.566 -6.556,-20.74 -11.834,-30.25c-9.882,-17.765 -23.995,-32.822 -41.083,-43.833c-0.463,-1.072 -1.542,-1.752 -2.708,-1.708c-2.917,-1.75 -5.917,-3.417 -8.959,-4.917c-22.789,-11.351 -48.536,-15.397 -73.708,-11.583c-2.583,0.375 -5.167,0.875 -7.75,1.458c-0.813,-0.197 -1.673,-0.013 -2.333,0.5c-31.302,7.416 -58.447,26.891 -75.5,54.167c-0.256,0.262 -0.454,0.574 -0.584,0.916c-7.787,12.52 -13.263,26.337 -16.166,40.792c-9.988,50.16 12.215,101.557 55.583,128.667c0.249,0.177 0.514,0.33 0.792,0.458c0.583,0.375 1.125,0.75 1.75,1.083c21.655,12.83 46.73,18.721 71.833,16.875c6.068,-0.471 12.097,-1.362 18.042,-2.666c0.851,0.146 1.724,-0.1 2.375,-0.667Z" />
      <g fill="#ffe895" stroke-width="4.17px">
       <path d="M1107.54,1269.25c-1.507,3.369 -4.868,5.549 -8.559,5.549c-1.729,-0 -3.425,-0.479 -4.9,-1.382l-7.791,-4.834l-45.042,-28.166l-6.625,-4.167c-2.741,-1.711 -4.412,-4.722 -4.412,-7.953c0,-4.343 3.017,-8.144 7.245,-9.13l54.167,-12.5c4.708,-1.125 9.417,-2.125 14.167,-3.209c0.655,-0.142 1.324,-0.214 1.995,-0.214c4.831,-0 8.912,3.735 9.338,8.548c0.333,2.944 0.542,5.902 0.625,8.875c0.395,16.764 -3.1,33.395 -10.208,48.583Z" />
       <path d="M1107.38,1177.12c1.032,2.241 1.567,4.68 1.567,7.148c0,7.924 -5.513,14.858 -13.234,16.644l-51.708,12l-7.833,1.833c-0.695,0.164 -1.407,0.246 -2.121,0.246c-5.075,0 -9.25,-4.175 -9.25,-9.25c-0,-1.737 0.489,-3.44 1.412,-4.913l0,-0.208l29.375,-47.167l2.959,-4.666c3.131,-4.931 8.581,-7.926 14.421,-7.926c4.388,-0 8.611,1.69 11.787,4.717c3.781,3.671 7.29,7.612 10.5,11.792c4.758,6.116 8.824,12.739 12.125,19.75Z" />
       <path d="M1046.29,1121.38c6.6,2.478 10.997,8.826 10.997,15.876c-0,3.233 -0.925,6.399 -2.664,9.124l-28.083,45.292l-4.167,6.625c-1.698,2.75 -4.709,4.429 -7.941,4.429c-4.341,-0 -8.137,-3.029 -9.101,-7.263l-12.5,-54.166l-1.25,-5.584c-0.291,-1.258 -0.439,-2.546 -0.439,-3.838c0,-9.177 7.431,-16.782 16.606,-16.995c11.92,-0.181 23.788,1.607 35.125,5.292l3.417,1.208Z" />
       <path d="M963.583,1127.04c2.199,-0.997 4.586,-1.513 7.001,-1.513c7.897,0 14.8,5.517 16.541,13.221l12,51.708l1.792,7.625c0.161,0.696 0.243,1.409 0.243,2.123c0,5.143 -4.232,9.375 -9.375,9.375c-1.75,0 -3.466,-0.49 -4.952,-1.414l-47.083,-29l-4.875,-3.084c-4.927,-3.111 -7.923,-8.547 -7.923,-14.374c-0,-4.376 1.69,-8.588 4.715,-11.751c8.285,-8.554 17.929,-15.678 28.541,-21.083l3.375,-1.833Z" />
       <path d="M1056.54,1323.71c-2.199,0.997 -4.586,1.513 -7.001,1.513c-7.897,-0 -14.8,-5.517 -16.541,-13.221l0,-0.208l-12.167,-51.667l-1.791,-7.625c-0.162,-0.696 -0.244,-1.408 -0.244,-2.123c0,-5.143 4.232,-9.375 9.375,-9.375c1.75,0 3.466,0.49 4.952,1.415l47.125,29.375l4.875,3.083c4.927,3.111 7.923,8.547 7.923,14.374c0,4.377 -1.69,8.588 -4.715,11.751c-8.285,8.554 -17.929,15.679 -28.541,21.083l-3.25,1.625Z" />
       <path d="M906.875,1187c2.462,-6.902 9.037,-11.538 16.365,-11.538c3.243,0 6.423,0.908 9.177,2.621l45.041,28.084l6.667,4.166c2.741,1.711 4.412,4.723 4.412,7.954c-0,4.342 -3.017,8.143 -7.245,9.13l-54.167,12.5l-5.667,1.291c-1.218,0.266 -2.461,0.4 -3.708,0.4c-9.517,-0 -17.362,-7.8 -17.417,-17.316l0,-6.167c0.627,-10.642 2.831,-21.131 6.542,-31.125Z" />
       <path d="M911.167,1270.17c-1.067,-2.305 -1.62,-4.814 -1.62,-7.353c0,-8.141 5.681,-15.259 13.62,-17.064l51.833,-12l7.833,-1.833c0.695,-0.164 1.407,-0.247 2.121,-0.247c5.075,0 9.25,4.176 9.25,9.25c0,1.738 -0.489,3.441 -1.412,4.913l-0,0.209l-29.375,47.166c-0.959,1.542 -1.917,3.084 -2.917,4.625c-3.225,5.064 -8.828,8.139 -14.832,8.139c-4.553,0 -8.933,-1.768 -12.21,-4.93c-5.67,-5.5 -10.702,-11.622 -15,-18.25c-2.714,-4.038 -5.151,-8.256 -7.291,-12.625Z" />
       <path d="M967.875,1323.83c-4.986,-2.038 -8.261,-6.916 -8.261,-12.303c-0,-2.485 0.697,-4.921 2.011,-7.03l2.667,-4.167l28.083,-45.083l4.167,-6.625c1.698,-2.75 4.708,-4.429 7.941,-4.429c4.341,-0 8.137,3.029 9.1,7.262l12.5,54.167c0.792,3.333 1.5,6.667 2.25,10c0.214,0.956 0.321,1.933 0.321,2.913c0,6.956 -5.426,12.811 -12.362,13.337c-16.542,1.107 -33.119,-1.587 -48.459,-7.875l0.042,-0.167Z" />
      </g>
     </g>
     <g>
      <path fill="#ffca6c" stroke-width="5.25px" d="M880.208,1268.12c30.773,-7.453 57.472,-26.588 74.417,-53.333c1.15,-0.443 1.869,-1.607 1.75,-2.834c16.283,-26.876 21.612,-59.015 14.875,-89.708c0.588,-1.177 0.254,-2.619 -0.792,-3.417c-2.575,-10.566 -6.555,-20.74 -11.833,-30.25c-9.883,-17.765 -23.995,-32.822 -41.083,-43.833c-0.463,-1.072 -1.542,-1.752 -2.709,-1.708c-2.916,-1.75 -5.916,-3.417 -8.958,-4.917c-22.789,-11.351 -48.536,-15.397 -73.708,-11.583c-2.584,0.375 -5.167,0.875 -7.75,1.458c-0.813,-0.197 -1.673,-0.013 -2.334,0.5c-31.301,7.416 -58.446,26.891 -75.5,54.167c-0.255,0.262 -0.454,0.574 -0.583,0.916c-7.788,12.52 -13.264,26.337 -16.167,40.792c-9.988,50.16 12.216,101.557 55.584,128.667c0.249,0.177 0.514,0.33 0.791,0.458c0.584,0.375 1.125,0.75 1.75,1.083c21.656,12.83 46.731,18.721 71.834,16.875c6.068,-0.471 12.096,-1.362 18.041,-2.666c0.851,0.146 1.724,-0.1 2.375,-0.667Z" />
      <g fill="#ffe895" stroke-width="4.17px">
       <path d="M949.208,1194.25c-1.506,3.369 -4.868,5.549 -8.558,5.549c-1.73,-0 -3.426,-0.479 -4.9,-1.382l-7.792,-4.834l-45.041,-28.166l-6.625,-4.167c-2.742,-1.711 -4.412,-4.722 -4.412,-7.953c-0,-4.343 3.016,-8.144 7.245,-9.13l54.167,-12.5c4.708,-1.125 9.416,-2.125 14.166,-3.209c0.656,-0.142 1.324,-0.214 1.995,-0.214c4.832,-0 8.912,3.735 9.339,8.548c0.333,2.944 0.541,5.902 0.625,8.875c0.394,16.764 -3.1,33.395 -10.209,48.583Z" />
       <path d="M949.042,1102.12c1.032,2.241 1.567,4.68 1.567,7.148c-0,7.924 -5.514,14.858 -13.234,16.644l-51.708,12l-7.834,1.833c-0.695,0.164 -1.407,0.246 -2.121,0.246c-5.074,0 -9.25,-4.175 -9.25,-9.25c0,-1.737 0.49,-3.44 1.413,-4.913l0,-0.208l29.375,-47.167l2.958,-4.666c3.131,-4.931 8.581,-7.926 14.422,-7.926c4.387,-0 8.611,1.69 11.787,4.717c3.781,3.671 7.29,7.612 10.5,11.792c4.758,6.116 8.824,12.739 12.125,19.75Z" />
       <path d="M887.958,1046.38c6.601,2.478 10.997,8.826 10.997,15.876c0,3.233 -0.924,6.399 -2.663,9.124l-28.084,45.292l-4.166,6.625c-1.699,2.75 -4.709,4.429 -7.941,4.429c-4.342,-0 -8.138,-3.029 -9.101,-7.263l-12.5,-54.166l-1.25,-5.584c-0.292,-1.258 -0.439,-2.546 -0.439,-3.838c0,-9.177 7.431,-16.782 16.606,-16.995c11.919,-0.181 23.787,1.607 35.125,5.292l3.416,1.208Z" />
       <path d="M805.25,1052.04c2.199,-0.997 4.586,-1.513 7,-1.513c7.898,0 14.801,5.517 16.542,13.221l12,51.708l1.791,7.625c0.162,0.696 0.244,1.409 0.244,2.123c-0,5.143 -4.232,9.375 -9.375,9.375c-1.75,0 -3.466,-0.49 -4.952,-1.414l-47.083,-29l-4.875,-3.084c-4.928,-3.111 -7.924,-8.547 -7.924,-14.374c0,-4.376 1.69,-8.588 4.715,-11.751c8.286,-8.554 17.93,-15.678 28.542,-21.083l3.375,-1.833Z" />
       <path d="M898.208,1248.71c-2.199,0.997 -4.586,1.513 -7,1.513c-7.898,-0 -14.801,-5.517 -16.541,-13.221l-0,-0.208l-12.167,-51.667l-1.792,-7.625c-0.161,-0.696 -0.243,-1.408 -0.243,-2.123c-0,-5.143 4.232,-9.375 9.375,-9.375c1.75,0 3.466,0.49 4.952,1.415l47.125,29.375l4.875,3.083c4.927,3.111 7.923,8.547 7.923,14.374c0,4.377 -1.69,8.588 -4.715,11.751c-8.285,8.554 -17.93,15.679 -28.542,21.083l-3.25,1.625Z" />
       <path d="M748.542,1112c2.462,-6.902 9.037,-11.538 16.365,-11.538c3.243,0 6.422,0.908 9.176,2.621l45.042,28.084l6.667,4.166c2.741,1.711 4.412,4.723 4.412,7.954c-0,4.342 -3.017,8.143 -7.246,9.13l-54.166,12.5l-5.667,1.291c-1.218,0.266 -2.462,0.4 -3.709,0.4c-9.516,-0 -17.361,-7.8 -17.416,-17.316l-0,-6.167c0.626,-10.642 2.831,-21.131 6.542,-31.125Z" />
       <path d="M752.833,1195.17c-1.066,-2.305 -1.619,-4.814 -1.619,-7.353c-0,-8.141 5.681,-15.259 13.619,-17.064l51.834,-12l7.833,-1.833c0.695,-0.164 1.407,-0.247 2.121,-0.247c5.074,0 9.25,4.176 9.25,9.25c0,1.738 -0.49,3.441 -1.413,4.913l0,0.209l-29.375,47.166c-0.958,1.542 -1.916,3.084 -2.916,4.625c-3.225,5.064 -8.828,8.139 -14.832,8.139c-4.553,0 -8.933,-1.768 -12.21,-4.93c-5.67,-5.5 -10.702,-11.622 -15,-18.25c-2.715,-4.038 -5.151,-8.256 -7.292,-12.625Z" />
       <path d="M809.542,1248.83c-4.987,-2.038 -8.262,-6.916 -8.262,-12.303c0,-2.485 0.697,-4.921 2.012,-7.03l2.666,-4.167l28.084,-45.083l4.166,-6.625c1.699,-2.75 4.709,-4.429 7.941,-4.429c4.342,-0 8.138,3.029 9.101,7.262l12.5,54.167c0.792,3.333 1.5,6.667 2.25,10c0.213,0.956 0.321,1.933 0.321,2.913c0,6.956 -5.426,12.811 -12.363,13.337c-16.541,1.107 -33.119,-1.587 -48.458,-7.875l0.042,-0.167Z" />
      </g>
     </g>
    </g>
    <g class="berries">
     <g class="leaves" fill-rule="nonzero" stroke="#82cdb2">
      <g>
       <path fill="#bfe6c7" stroke-width="8.33px" d="M1533.19,879.143l28.863,-34.741l34.741,28.863c32.45,27.048 36.984,75.965 10.058,108.518l-28.969,34.869l-34.645,-28.783c-32.579,-27.067 -37.115,-76.148 -10.048,-108.726Z" />
       <path fill="none" stroke-linecap="round" stroke-width="4.17px" d="M1560.58,849.667c0,-0 54.584,63.666 15.917,163.208c0,0 -1.708,-55.875 -33.792,-91.667" />
      </g>
      <g>
       <path fill="#bfe6c7" stroke-width="8.32px" d="M1461.81,1063.81l-24.39,-37.94l37.94,-24.39c35.578,-22.872 83.676,-12.416 106.547,23.162l24.39,37.94l-37.94,24.39c-35.578,22.872 -83.675,12.416 -106.547,-23.162Z" />
       <path fill="none" stroke-linecap="round" stroke-width="4.17px" d="M1435.04,1026.38c-0,0 77.041,-33.333 160.541,33.333c0,0 -53.833,-15.041 -97.666,4.917" />
      </g>
      <g>
       <path fill="#bfe6c7" stroke-width="8.33px" d="M1780.7,1127.48l30.281,33.512l-33.513,30.281c-0.01,0.01 -0.02,0.019 -0.031,0.028c-31.426,28.396 -80.653,25.903 -109.049,-5.524c-0.019,-0.02 -0.037,-0.041 -0.056,-0.062l-30.225,-33.45l33.544,-30.309c31.426,-28.396 80.653,-25.903 109.049,5.524Z" />
       <path fill="none" stroke-linecap="round" stroke-width="4.17px" d="M1805.88,1158.79c0,-0 -70.833,44.958 -163.833,-7.5c-0,-0 55.541,6.291 95.833,-20.375" />
      </g>
     </g>
     <g stroke="#ee7868" stroke-width="8.33px">
      <circle cx="1644.12" cy="1073" r="87.167" fill="#ffa18f" />
      <path fill="none" fill-rule="nonzero" stroke-linecap="round" d="M1654.46,1055.67c10.822,-1.195 21.747,-1.083 32.542,0.333" />
      <path fill="none" fill-rule="nonzero" stroke-linecap="round" d="M1670.54,1072.12c-1.167,-10.838 -1.041,-21.776 0.375,-32.583" />
     </g>
     <g stroke="#ee7868" stroke-width="8.33px">
      <circle cx="1545.71" cy="1133.25" r="87.167" fill="#ffa18f" />
      <path fill="none" fill-rule="nonzero" stroke-linecap="round" d="M1565.96,1137.71c10.728,1.863 21.192,5.011 31.167,9.375" />
      <path fill="none" fill-rule="nonzero" stroke-linecap="round" d="M1576.83,1158c1.866,-10.74 5.014,-21.218 9.375,-31.208" />
     </g>
    </g>
    <g stroke="#82cdb2" stroke-width="8.33px">
     <path fill="#0d242f" fill-rule="nonzero" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M710.875,1163.96c67.99,248.677 295.634,422.436 553.438,422.436c257.803,0 485.447,-173.759 553.437,-422.436l-1106.88,0Z" />
     <path fill="none" fill-rule="nonzero" d="M1817.75,1163.96c-6.042,0.459 -738.292,16.667 -843.292,342.042" />
     <rect width="405" height="57.833" x="1060.54" y="1550.92" fill="#0d242f" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" />
     <path fill="none" fill-rule="nonzero" d="M1088.12,1551.88l0,56.042" />
     <path fill="none" fill-rule="nonzero" d="M1113.83,1551.88l0,56.042" />
     <path fill="none" fill-rule="nonzero" d="M1128.42,1551.88l-0,56.042" />
     <path fill="none" fill-rule="nonzero" d="M1143.58,1551.88l0,56.042" />
     <g class="symbol">
      <ellipse cx="1263.42" cy="1358.58" fill="#0d242f" rx="118.292" ry="118.25" />
      <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1198.67,1314.27c20.235,-17.063 56.919,-6.895 81.87,22.692c24.95,29.588 28.778,67.462 8.543,84.526c-20.234,17.063 -56.919,6.895 -81.869,-22.692c-24.95,-29.588 -28.779,-67.462 -8.544,-84.526Z" />
      <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1247.44,1336.94c24.95,-29.587 61.634,-39.755 81.869,-22.692c20.235,17.064 16.406,54.938 -8.544,84.526c-24.95,29.587 -61.634,39.755 -81.869,22.692c-20.235,-17.064 -16.407,-54.938 8.544,-84.526Z" />
     </g>
    </g>
   </g>
   <g class="cereal" fill="#ffe895" fill-rule="nonzero" stroke="#f4cd7f" stroke-width="8.33px">
    <path class="a-sr" d="M1172.58,615.75c-24.183,-0 -44.083,19.9 -44.083,44.083c0,24.184 19.9,44.084 44.083,44.084c24.184,-0 44.084,-19.9 44.084,-44.084c-0,-24.183 -19.9,-44.083 -44.084,-44.083Zm0,60.958c-9.063,-0.113 -16.458,-7.601 -16.458,-16.665c0,-9.143 7.524,-16.667 16.667,-16.667c9.142,0 16.666,7.523 16.666,16.666c0,0 0,0.001 0,0.001c0,9.143 -7.523,16.667 -16.666,16.667c-0.07,-0 -0.139,-0.001 -0.209,-0.002Z" />
    <path class="a-sr" d="M1001.62,774.083c-28.686,0 -52.292,23.606 -52.292,52.292c0,28.686 23.606,52.292 52.292,52.292c28.686,-0 52.292,-23.606 52.292,-52.292c-0,-28.686 -23.606,-52.292 -52.292,-52.292Zm0,72.334c-10.995,-0 -20.042,-9.047 -20.042,-20.042c0,-10.995 9.047,-20.042 20.042,-20.042c10.995,0 20.042,9.047 20.042,20.042c-0,10.995 -9.047,20.042 -20.042,20.042Z" />
    <path class="a-sr" d="M1305.92,786.583c-19.612,0 -35.75,16.138 -35.75,35.75c-0,19.612 16.138,35.75 35.75,35.75c19.612,0 35.75,-16.138 35.75,-35.75c-0,-19.612 -16.138,-35.75 -35.75,-35.75Zm-0,49.417c-7.52,-0 -13.709,-6.188 -13.709,-13.708c0,-7.521 6.189,-13.709 13.709,-13.709c7.52,0 13.708,6.188 13.708,13.709l0,0.041c0,7.498 -6.169,13.667 -13.667,13.667c-0.014,0 -0.027,0 -0.041,-0Z" />
   </g>
   <g class="sparks" fill="none" fill-rule="nonzero" stroke="#ffe895" stroke-linecap="round" stroke-width="8.33px">
    <g class="a-sr">
     <path d="M1825.25,728.25l0,14.75" />
     <path d="M1825.25,774.083l0,14.75" />
     <path d="M1855.58,758.542l-14.791,-0" />
     <path d="M1809.75,758.542l-14.792,-0" />
    </g>
    <g class="a-sr">
     <path d="M1341.92,615.75l-0,14.75" />
     <path d="M1341.92,661.583l-0,14.75" />
     <path d="M1372.25,646.042l-14.792,-0" />
     <path d="M1326.42,646.042l-14.792,-0" />
    </g>
    <g class="a-sr">
     <path d="M921.083,611.583l0,14.75" />
     <path d="M921.083,657.417l0,14.75" />
     <path d="M951.417,641.875l-14.792,0" />
     <path d="M905.583,641.875l-14.791,0" />
    </g>
    <g class="a-sr">
     <path d="M720.417,740.75l-0,12.375" />
     <path d="M720.417,779.208l-0,12.375" />
     <path d="M745.833,766.167l-12.375,-0" />
     <path d="M707.375,766.167l-12.417,-0" />
    </g>
    <g class="a-sr">
     <path d="M1937.08,928.25l0,12.375" />
     <path d="M1937.08,966.708l0,12.375" />
     <path d="M1962.5,953.667l-12.375,-0" />
     <path d="M1924.04,953.667l-12.417,-0" />
    </g>
   </g>
   <g class="white-dots" fill="#fff8ec">
    <circle cx="870.833" cy="841.667" r="12.5" />
    <circle cx="1087.5" cy="566.667" r="12.5" />
    <circle cx="1779.17" cy="975" r="12.5" />
    <circle cx="1770.83" cy="883.333" r="8.333" />
    <circle cx="1687.5" cy="958.333" r="8.333" />
    <circle cx="862.5" cy="925" r="8.333" />
    <circle cx="895.833" cy="779.167" r="4.167" />
    <circle cx="1854.17" cy="895.833" r="4.167" />
    <circle cx="1858.33" cy="1025" r="4.167" />
    <circle cx="825" cy="720.833" r="4.167" />
    <circle cx="820.833" cy="812.5" r="4.167" />
    <circle cx="983.333" cy="533.333" r="4.167" />
    <circle cx="1162.5" cy="508.333" r="8.333" />
    <circle cx="766.667" cy="862.5" r="8.333" />
    <circle cx="1050" cy="479.167" r="4.167" />
   </g>

   <g class="avocado">
    <g class="inner-avo">
     <path fill="#bfe6c7" fill-rule="nonzero" stroke="#82cdb2" stroke-width="8.33px" d="M1785.12,1411.08c2.108,-2.669 4.069,-5.451 5.875,-8.333c8.911,-14.183 13.639,-30.597 13.639,-47.347c-0,-48.824 -40.176,-89 -89,-89c-29.573,0 -57.279,14.74 -73.806,39.264c-1.416,2.083 -2.708,4.166 -4.166,6.291c-19.434,32.775 -48.636,58.669 -83.5,74.042c-48.254,22.3 -79.286,70.827 -79.286,123.984c0,74.927 61.656,136.583 136.584,136.583c74.433,0 135.864,-60.845 136.577,-135.275c0.901,-36.585 13.951,-71.851 37.083,-100.209Z" />
     <path fill="#f4b67f" fill-rule="nonzero" stroke="#f4cd7f" stroke-width="8.33px" d="M1671.25,1563.96c-14.866,21.682 -39.524,34.672 -65.813,34.672c-43.775,0 -79.796,-36.021 -79.796,-79.797c-0,-16.106 4.876,-31.841 13.984,-45.125c25,-36.333 90.208,-68.375 126.542,-43.458c36.333,24.917 30,97.375 5.083,133.708Z" />
     <circle cx="1783.17" cy="1369.04" r="6.917" fill="#82cdb2" />
     <circle cx="1753" cy="1376.88" r="4.625" fill="#82cdb2" />
     <circle cx="1774.46" cy="1399.04" r="3.625" fill="#82cdb2" />
     <circle cx="1747.96" cy="1405.04" r="3.625" fill="#82cdb2" />
     <circle cx="1790.67" cy="1345" r="2.833" fill="#82cdb2" />
     <circle cx="1768.75" cy="1343.04" r="2.833" fill="#82cdb2" />
     <circle cx="1736.75" cy="1436.75" r="2.833" fill="#82cdb2" />
     <circle cx="1757.62" cy="1430.29" r="2.833" fill="#82cdb2" />
     <circle cx="1776.42" cy="1322.83" r="3.625" fill="#82cdb2" />
     <path class="stone" fill="#c29c87" fill-rule="nonzero" stroke="#f4cd7f" stroke-width="8.33px" d="M1627.29,1502.08c-0.405,1.024 -0.612,2.115 -0.612,3.216c-0,4.669 3.737,8.558 8.403,8.743c4.579,0.295 8.187,4.144 8.187,8.732c0,3.398 -1.98,6.502 -5.062,7.934c-3.208,1.364 -5.302,4.529 -5.302,8.015c0,2.206 0.838,4.331 2.344,5.944c1.472,1.611 2.288,3.717 2.288,5.899c0,4.8 -3.95,8.75 -8.75,8.75c-1.097,0 -2.184,-0.206 -3.205,-0.608c-1.013,-0.392 -2.089,-0.593 -3.176,-0.593c-4.67,-0 -8.566,3.72 -8.782,8.385c-0.208,4.625 -4.07,8.318 -8.7,8.318c-3.443,-0 -6.577,-2.043 -7.967,-5.193c-1.383,-3.195 -4.548,-5.273 -8.029,-5.273c-2.196,-0 -4.314,0.827 -5.929,2.315c-1.616,1.527 -3.757,2.378 -5.981,2.378c-4.777,0 -8.708,-3.931 -8.708,-8.708c-0,-1.13 0.22,-2.249 0.647,-3.295c0.393,-1.013 0.594,-2.09 0.594,-3.176c0,-4.67 -3.721,-8.567 -8.385,-8.783c-4.626,-0.207 -8.318,-4.069 -8.318,-8.699c0,-3.444 2.042,-6.577 5.193,-7.967c3.195,-1.384 5.273,-4.548 5.273,-8.03c-0,-2.196 -0.827,-4.314 -2.315,-5.929c-1.494,-1.616 -2.324,-3.738 -2.324,-5.939c-0,-4.8 3.949,-8.75 8.75,-8.75c1.095,0 2.18,0.206 3.199,0.606c1.034,0.417 2.139,0.631 3.255,0.631c4.669,0 8.55,-3.756 8.703,-8.423c0.296,-4.578 4.144,-8.187 8.732,-8.187c3.399,0 6.503,1.98 7.935,5.062c1.364,3.209 4.528,5.303 8.015,5.303c2.206,-0 4.331,-0.839 5.943,-2.344c1.62,-1.509 3.752,-2.349 5.966,-2.349c4.8,-0 8.75,3.95 8.75,8.75c-0,1.119 -0.215,2.227 -0.632,3.265Z" />
    </g>
   </g>
   <g class="mug" stroke="#9683ba">
    <rect width="406.208" height="529.375" x="191.333" y="1076.75" fill="#c9bde0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" />
    <path fill="none" fill-rule="nonzero" stroke-width="20.83px" d="M190.542,1170.83l-73.542,0c-43.958,0 -79.5,34.584 -79.5,77.084l0,156.75c0,42.5 35.667,76.958 79.625,76.958l74.542,0" />
    <g class="teabag" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px">
     <path fill="none" fill-rule="nonzero" d="M327.333,1078.17l0,173.208" />
     <rect width="91.917" height="121.333" x="279.542" y="1255.04" fill="#ffe895" />
    </g>
   </g>
   <g class="cookie">
    <g>
     <circle cx="622.25" cy="1472.17" r="136.292" fill="#ffca6c" stroke="#c29c87" stroke-width="8.33px" />
     <circle cx="675.875" cy="1407.71" r="18.583" fill="#c29c87" />
     <circle cx="613.583" cy="1373.08" r="5.917" fill="#c29c87" />
     <circle cx="648.833" cy="1473.46" r="5.917" fill="#c29c87" />
     <circle cx="706.292" cy="1475.29" r="12" fill="#c29c87" />
     <circle cx="595.917" cy="1425.71" r="10.75" fill="#c29c87" />
    </g>
   </g>
  </g>
   <g class="arm" stroke-width="8.33px">
   <path fill="#9683ba" fill-rule="nonzero" stroke="#c9bde0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1788.21,2335.38c0,0 875.794,451.96 1492.84,147.565c-0,0 135.867,-300.25 58.67,-422.565c-228.349,-361.81 -1470.97,-52.458 -1470.97,-52.458l-80.542,327.458Z" />
   <path fill="none" fill-rule="nonzero" stroke="#c9bde0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1811.58,2260.88c0,0 53.709,103.958 289.334,154.167" />
   <path fill="none" fill-rule="nonzero" stroke="#c9bde0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1806.38,2219.29c0,-0 73.875,78 218.333,81.458" />
   <g class="hand" fill-rule="nonzero">
    <path fill="#d9dacb" stroke="#9da2a7" d="M832.083,1718.96c5.209,-7.5 16.667,-12.5 31.917,-15.291c-3.789,-1.104 -7.644,-1.966 -11.542,-2.584c-80.625,-12.5 -119.833,13.542 -115.75,41.125c3.667,25 165.25,63.334 196.459,70.5c-73.834,-36.541 -125.792,-66.5 -101.084,-93.75Z" />
    <path fill="#d9dacb" stroke="#9da2a7" d="M1120.83,1745.83c47.167,19.834 116.667,55.25 168.625,82.584c-28.666,-39.875 -74.291,-88.459 -138.375,-114.459c-78,-31.625 -91.666,-9 -91.666,11c20.882,5.688 41.393,12.659 61.416,20.875Z" />
    <path class="tray" fill="#0d242f" stroke="#fff8ec" stroke-linecap="round" d="M1882.46,1698.71l-1759.88,0c-51.001,-0.01 -96.209,-33.887 -110.541,-82.833l-2,-6.875l1984.96,0l-2,6.875c-14.332,48.946 -59.54,82.823 -110.542,82.833Z" />

    <path fill="#fff8ec" stroke="#9da2a7" d="M1360.79,1866.67c-0,-0 29.583,-133.334 81.125,-170.834c51.541,-37.5 108.666,-44.083 104.541,-2.083c-4.125,42 -20.583,157.833 -20.583,157.833c0,0 57.583,131.667 46.333,170.834l173.834,29.166l-85.334,228.25c0,0 -253.166,-38.666 -380.75,-209.708c0,0 -89.083,-119.375 -204.708,-184.833c-128.167,-72.792 -282.458,-123.042 -243.167,-166.334c25.334,-36.458 193.792,-13.125 288.834,26.792c84.416,35.458 239.875,120.917 239.875,120.917Z" />
   </g>
   <path fill="#ffa18f" fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1566.33,2286.71l244.125,76.125l80.834,-360.083l-247.792,20.792l-77.167,263.166Z" />
   <g class="symbol-4" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4">
    <path fill="#ffa18f" d="M1660.28,2240.39c5.088,-28.221 32.131,-47.003 60.352,-41.915c28.222,5.088 47.003,32.132 41.915,60.353c-5.088,28.222 -32.131,47.003 -60.352,41.915c-28.222,-5.088 -47.003,-32.131 -41.915,-60.353Z" />
    <path fill="#ffa18f" d="M1686.86,2225.33c10.085,-5.804 25.155,1.443 33.632,16.172c8.477,14.73 7.17,31.4 -2.915,37.204c-10.085,5.804 -25.155,-1.442 -33.632,-16.172c-8.477,-14.729 -7.17,-31.4 2.915,-37.204Z" />
    <path fill="none" d="M1706.18,2238.62c13.085,-10.844 29.737,-12.374 37.162,-3.414c7.425,8.959 2.829,25.037 -10.255,35.881c-13.085,10.844 -29.737,12.374 -37.162,3.415c-7.425,-8.96 -2.83,-25.038 10.255,-35.882Z" />
   </g>
  </g>
  </g>
</svg>
`;
    let lunchMarkup = `
<svg class="anim-meals" width="100%" xml:space="preserve" fill-rule="evenodd" stroke-miterlimit="10" clip-rule="evenodd" viewBox="0 0 2384 2584">
 <g class="meals-all">
 <g class="meal lunch">
   <g class="asparagus" fill-rule="nonzero" stroke="#548f9c">
    <path fill="#82cdb2" stroke-width="8.33px" d="M1615.68,620.14l24.627,6.286l-124.782,488.825c-1.696,6.644 -8.559,10.716 -15.203,9.02c-6.645,-1.696 -10.716,-8.559 -9.02,-15.203l124.781,-488.825l-0.403,-0.103Z" />
    <path fill="#bfe6c7" stroke-width="8.33px" d="M1669.5,461.167c0,-0 -94.833,85.875 -57.875,158.333l32.708,8.333c67.167,-45.875 25.167,-166.666 25.167,-166.666Z" />
    <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="4.17px" d="M1677.33,580.708l-45.25,26.834l-26.791,-45.209" />
    <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="4.17px" d="M1683.38,552.958l-43.708,24.875l-25.375,-43" />
    <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="4.17px" d="M1681.83,526.208l-36.25,21.459l-18.958,-31.959" />
   </g>
   <g class="pencil" fill-rule="nonzero" stroke="#fff8ec" stroke-width="8.33px">
    <path fill="#9683ba" d="M1813.42,623.208l-304.542,545.042c-3.988,7.139 -11.552,11.578 -19.729,11.578c-12.397,-0 -22.599,-10.202 -22.599,-22.599c0,-3.858 0.988,-7.652 2.87,-11.021l304.166,-544.666l50.5,-44l-10.666,65.666Z" />
    <path fill="#9683ba" d="M1791.08,616.667c3.167,-5.667 8.084,-5.459 13.75,-2.292c3.7,2.066 6.001,5.985 6.001,10.223c0,2.009 -0.517,3.984 -1.501,5.735" />
    <path fill="#9683ba" d="M1791.08,616.667c3.167,-5.667 0.417,-9.709 -5.25,-12.875c-5.613,-3.128 -12.805,-1.1 -15.958,4.5" />
    <path fill="none" d="M1523.67,1142.17l-39.375,-22.834" />
    <path fill="none" d="M1504.33,1130.54l286.75,-513.75" />
   </g>
   <g class="bowl">
    <g fill="#0d242f" fill-rule="nonzero" stroke="#fff8ec" stroke-width="8.33px">
     <path d="M924.167,1323.5c-16.353,11.47 -38.436,10.893 -54.167,-1.417c-16.522,-13.098 -35.987,-21.98 -56.708,-25.875c-19.563,-3.822 -34.493,-19.987 -36.75,-39.791c-2.525,-20.524 -9.879,-40.16 -21.459,-57.292c-11.314,-16.423 -10.671,-38.433 1.584,-54.167c7.165,-9.108 13.091,-19.126 17.625,-29.791c3.757,-8.654 6.552,-17.694 8.333,-26.959c3.816,-19.505 19.991,-34.358 39.75,-36.5c20.524,-2.524 40.159,-9.879 57.292,-21.458c16.309,-11.368 38.268,-10.791 53.958,1.417c16.57,13.045 36.035,21.919 56.75,25.875c19.547,3.838 34.456,19.999 36.708,39.791c2.525,20.524 9.879,40.16 21.459,57.292c11.326,16.414 10.7,38.423 -1.542,54.167c-7.171,9.104 -13.098,19.123 -17.625,29.791c-3.732,8.678 -6.526,17.729 -8.333,27c-3.804,19.513 -19.985,34.371 -39.75,36.5c-20.524,2.525 -40.16,9.879 -57.292,21.459l0.167,-0.042Z" />
     <path d="M917.708,1280.83c-11.56,8.061 -27.127,7.654 -38.25,-1c-11.733,-9.279 -25.547,-15.572 -40.25,-18.333c-13.875,-2.691 -24.465,-14.162 -26.041,-28.208c-0.891,-7.265 -2.639,-14.398 -5.209,-21.25c-2.576,-6.835 -5.932,-13.35 -10,-19.417c-8.031,-11.625 -7.591,-27.221 1.084,-38.375c5.09,-6.453 9.294,-13.557 12.5,-21.125c2.612,-6.145 4.54,-12.558 5.75,-19.125c2.706,-13.838 14.189,-24.37 28.208,-25.875c7.232,-0.919 14.334,-2.666 21.167,-5.208c6.838,-2.568 13.355,-5.924 19.416,-10c11.556,-8.075 27.132,-7.668 38.25,1c11.724,9.269 25.522,15.56 40.209,18.333c13.889,2.667 24.491,14.151 26.041,28.208c0.92,7.25 2.682,14.367 5.25,21.209c2.557,6.851 5.928,13.37 10.042,19.416c8.046,11.626 7.588,27.241 -1.125,38.375c-5.068,6.483 -9.271,13.598 -12.5,21.167c-2.607,6.15 -4.548,12.562 -5.792,19.125c-2.702,13.824 -14.163,24.353 -28.166,25.875c-7.252,0.885 -14.372,2.633 -21.209,5.208c-6.828,2.562 -13.331,5.919 -19.375,10Z" />
     <path d="M911.833,1242.12c-7.25,5.067 -17.023,4.813 -24,-0.625c-3.291,-2.598 -6.854,-4.833 -10.625,-6.667c-4.662,-2.267 -9.61,-3.893 -14.708,-4.833c-8.711,-1.699 -15.362,-8.892 -16.375,-17.708c-0.544,-4.559 -1.635,-9.036 -3.25,-13.334c-1.618,-4.299 -3.729,-8.396 -6.292,-12.208c-5.066,-7.379 -4.691,-17.275 0.917,-24.25c3.172,-4.06 5.805,-8.514 7.833,-13.25c1.654,-3.852 2.87,-7.877 3.625,-12c1.673,-8.702 8.895,-15.329 17.709,-16.25c9.121,-1.171 17.85,-4.437 25.5,-9.542c7.25,-5.067 17.023,-4.812 24,0.625c7.363,5.817 16.028,9.763 25.25,11.5c8.714,1.678 15.363,8.887 16.333,17.709c0.583,4.555 1.688,9.029 3.292,13.333c1.609,4.29 3.721,8.374 6.291,12.167c5.044,7.298 4.756,17.094 -0.708,24.083c-3.196,4.059 -5.831,8.529 -7.833,13.292c-1.654,3.852 -2.87,7.877 -3.625,12c-1.723,8.675 -8.918,15.277 -17.709,16.25c-4.558,0.549 -9.034,1.64 -13.333,3.25c-4.337,1.661 -8.463,3.829 -12.292,6.458Z" />
    </g>
    <g fill="#0d242f" fill-rule="nonzero" stroke="#fff8ec" stroke-width="8.33px">
     <path d="M1075.33,1276.58c-30.994,-4.859 -55.379,-29.498 -59.916,-60.541c-4.508,-33.053 -16.994,-64.517 -36.375,-91.667c-18.171,-25.716 -17.51,-60.493 1.625,-85.5c19.574,-26.144 32.67,-56.563 38.208,-88.75c4.945,-31.104 29.741,-55.527 60.917,-60c18.139,-2.542 35.863,-7.474 52.708,-14.667c13.651,-5.889 26.641,-13.207 38.75,-21.833c25.653,-18.067 60.315,-17.321 85.167,1.833c26.16,19.539 56.573,32.619 88.75,38.167c31.004,4.885 55.394,29.53 59.958,60.583c2.023,14.738 5.641,29.212 10.792,43.167c6.404,17.22 15.063,33.514 25.75,48.458c18.197,25.708 17.536,60.503 -1.625,85.5c-19.539,26.16 -32.619,56.574 -38.167,88.75c-4.992,31.089 -29.791,55.482 -60.958,59.959c-18.128,2.557 -35.838,7.502 -52.667,14.708c-13.677,5.838 -26.671,13.16 -38.75,21.833c-25.674,18.048 -60.334,17.302 -85.208,-1.833c-26.16,-19.548 -56.572,-32.641 -88.75,-38.208l-0.209,0.041Z" />
     <path d="M1114.58,1220.83c-21.984,-3.459 -39.276,-20.938 -42.5,-42.958c-1.421,-10.442 -3.978,-20.697 -7.625,-30.583c-4.511,-12.184 -10.62,-23.716 -18.166,-34.292c-12.868,-18.241 -12.394,-42.892 1.166,-60.625c6.921,-9.242 12.725,-19.27 17.292,-29.875c4.539,-10.595 7.825,-21.684 9.792,-33.042c3.522,-22.052 21.104,-39.363 43.208,-42.541c23.381,-3.267 45.628,-12.146 64.833,-25.875c18.195,-12.824 42.787,-12.298 60.417,1.291c9.244,6.908 19.272,12.698 29.875,17.25c10.594,4.552 21.683,7.852 33.042,9.834c21.983,3.429 39.285,20.9 42.5,42.916c3.217,23.393 12.069,45.659 25.791,64.875c12.908,18.229 12.434,42.907 -1.166,60.625c-13.851,18.565 -23.131,40.136 -27.084,62.959c-3.522,22.052 -21.104,39.363 -43.208,42.541c-12.904,1.785 -25.514,5.274 -37.5,10.375c-9.688,4.183 -18.906,9.378 -27.5,15.5c-18.186,12.803 -42.753,12.278 -60.375,-1.291c-18.516,-13.827 -40.028,-23.106 -62.792,-27.084Z" />
     <path d="M1150.21,1170.38c-13.803,-2.154 -24.663,-13.132 -26.666,-26.958c-1.999,-14.689 -7.564,-28.667 -16.209,-40.709c-8.072,-11.449 -7.767,-26.919 0.75,-38.041c4.338,-5.802 7.974,-12.095 10.834,-18.75c2.852,-6.684 4.921,-13.675 6.166,-20.834c2.194,-13.852 13.241,-24.729 27.125,-26.708c8.06,-1.14 15.934,-3.339 23.417,-6.542c6.086,-2.598 11.871,-5.853 17.25,-9.708c11.415,-8.052 26.848,-7.73 37.917,0.792c5.797,4.343 12.091,7.98 18.75,10.833c6.67,2.887 13.665,4.958 20.833,6.167c13.779,2.204 24.613,13.156 26.667,26.958c0.891,6.558 2.498,13 4.791,19.208c2.835,7.647 6.66,14.889 11.375,21.542c8.098,11.436 7.809,26.915 -0.708,38.042c-8.696,11.644 -14.521,25.179 -17,39.5c-2.219,13.84 -13.252,24.703 -27.125,26.708c-14.68,2.056 -28.648,7.632 -40.708,16.25c-11.433,8.013 -26.848,7.675 -37.917,-0.833c-5.801,-4.338 -12.095,-7.974 -18.75,-10.834c-6.673,-2.821 -13.65,-4.862 -20.792,-6.083Z" />
     <path d="M1179.17,1129.17c-7.108,-1.159 -12.698,-6.799 -13.792,-13.917c-0.458,-3.389 -1.297,-6.715 -2.5,-9.917c-1.455,-3.953 -3.43,-7.694 -5.875,-11.125c-4.158,-5.922 -4.006,-13.907 0.375,-19.666c2.244,-2.986 4.119,-6.232 5.583,-9.667c1.491,-3.444 2.568,-7.053 3.209,-10.75c1.168,-7.133 6.85,-12.73 14,-13.792c4.174,-0.579 8.251,-1.714 12.125,-3.375c3.142,-1.344 6.131,-3.02 8.916,-5c5.914,-4.105 13.85,-3.936 19.584,0.417c3.004,2.238 6.263,4.112 9.708,5.583c3.429,1.483 7.025,2.546 10.708,3.167c7.121,1.164 12.714,6.825 13.792,13.958c0.464,3.384 1.288,6.708 2.458,9.917c1.482,3.941 3.456,7.679 5.875,11.125c4.158,5.922 4.006,13.907 -0.375,19.667c-2.229,2.995 -4.102,6.239 -5.583,9.666c-1.482,3.444 -2.546,7.053 -3.167,10.75c-1.173,7.146 -6.876,12.747 -14.041,13.792c-4.16,0.585 -8.223,1.72 -12.084,3.375c-3.146,1.335 -6.136,3.012 -8.916,5c-5.923,4.126 -13.883,3.957 -19.625,-0.417c-2.986,-2.244 -6.232,-4.118 -9.667,-5.583c-3.43,-1.49 -7.024,-2.567 -10.708,-3.208Z" />
    </g>
    <g class="egg">
     <path fill="#ffe895" fill-rule="nonzero" stroke="#f4cd7f" stroke-width="8.33px" d="M877.625,1126.33c-35.917,-79.166 -31.583,-204.916 31.417,-233.583c63,-28.667 160.75,50.833 196.666,129.833c35.917,79 14,166.292 -49,194.917c-63,28.625 -143.166,-12.167 -179.083,-91.167Z" />
     <circle cx="1008.92" cy="1110.21" r="72.208" fill="#ffca6c" stroke="#c29c87" stroke-width="8.33px" />
     <g class="Tools" fill-rule="nonzero">
      <path fill="#ffca6c" d="M1077.75,1096.25c-0.262,-1.184 -1.001,-2.21 -2.042,-2.833c-1.071,-0.586 -2.337,-0.707 -3.5,-0.334c-1.234,0.41 -2.527,0.618 -3.827,0.618c-6.675,0 -12.167,-5.492 -12.167,-12.167c-0,-4.114 2.087,-7.959 5.536,-10.201c1.018,-0.653 1.704,-1.719 1.875,-2.916c0.193,-1.211 -0.158,-2.447 -0.958,-3.375c-4.312,-5.148 -9.351,-9.64 -14.959,-13.334c-0.702,-0.494 -1.54,-0.76 -2.4,-0.76c-1.608,-0 -3.079,0.931 -3.766,2.385c-2.803,5.382 -9.141,7.985 -14.917,6.125c-5.745,-2.033 -9.122,-8.085 -7.833,-14.041c0.081,-0.329 0.123,-0.667 0.123,-1.006c-0,-2.206 -1.753,-4.05 -3.957,-4.161c-6.688,-0.569 -13.423,-0.176 -20,1.167c-1.197,0.232 -2.233,0.979 -2.833,2.041c-0.609,1.049 -0.731,2.313 -0.333,3.459c0.428,1.26 0.647,2.583 0.647,3.914c-0,6.674 -5.493,12.167 -12.167,12.167c-4.133,-0 -7.993,-2.106 -10.23,-5.581c-0.663,-1.029 -1.746,-1.715 -2.959,-1.875c-1.197,-0.18 -2.414,0.17 -3.333,0.958c-5.15,4.306 -9.655,9.329 -13.375,14.917c-0.679,1.016 -0.877,2.282 -0.542,3.458c0.304,1.182 1.112,2.173 2.209,2.708c5.526,2.668 8.237,9.097 6.291,14.917c-2.135,5.685 -8.121,9.032 -14.083,7.875c-0.317,-0.076 -0.641,-0.114 -0.967,-0.114c-2.187,0 -4.021,1.723 -4.158,3.906c-0.594,6.687 -0.201,13.426 1.167,20c0.221,1.212 0.969,2.266 2.041,2.875c1.049,0.609 2.313,0.731 3.459,0.333c1.26,-0.428 2.583,-0.647 3.914,-0.647c6.674,0 12.167,5.492 12.167,12.167c-0,4.133 -2.106,7.993 -5.581,10.23c-1.035,0.645 -1.736,1.712 -1.917,2.917c-0.193,1.21 0.158,2.446 0.958,3.375c4.333,5.127 9.369,9.616 14.959,13.333c1.022,0.663 2.275,0.874 3.458,0.583c1.182,-0.303 2.173,-1.111 2.708,-2.208c2.803,-5.382 9.141,-7.984 14.917,-6.125c5.75,2.032 9.139,8.076 7.875,14.042c-0.263,1.193 0.011,2.443 0.75,3.416c0.715,0.987 1.827,1.612 3.042,1.709c6.686,0.584 13.421,0.205 20,-1.125c0.348,-0.061 0.685,-0.173 1,-0.334c1.971,-0.889 2.94,-3.173 2.208,-5.208c-0.45,-1.286 -0.679,-2.639 -0.679,-4.001c-0,-6.652 5.473,-12.125 12.125,-12.125c4.163,0 8.045,2.144 10.262,5.668c0.663,1.028 1.746,1.715 2.959,1.875c1.21,0.192 2.446,-0.159 3.375,-0.959c5.127,-4.316 9.617,-9.338 13.333,-14.916c0.679,-1.017 0.877,-2.283 0.542,-3.459c-0.304,-1.182 -1.112,-2.173 -2.209,-2.708c-5.446,-2.74 -8.06,-9.149 -6.083,-14.917c2.133,-5.667 8.093,-9.01 14.042,-7.875c1.193,0.263 2.443,-0.011 3.416,-0.75c0.987,-0.714 1.612,-1.827 1.709,-3.041c0.531,-6.708 0.096,-13.458 -1.292,-20.042Z" />
      <path fill="none" stroke="#c29c87" stroke-width="4.17px" d="M1077.75,1096.25c-0.262,-1.184 -1.001,-2.21 -2.042,-2.833c-1.071,-0.586 -2.337,-0.707 -3.5,-0.334c-1.234,0.41 -2.527,0.618 -3.827,0.618c-6.675,0 -12.167,-5.492 -12.167,-12.167c-0,-4.114 2.087,-7.959 5.536,-10.201c1.018,-0.653 1.704,-1.719 1.875,-2.916c0.193,-1.211 -0.158,-2.447 -0.958,-3.375c-4.312,-5.148 -9.351,-9.64 -14.959,-13.334c-0.702,-0.494 -1.54,-0.76 -2.4,-0.76c-1.608,-0 -3.079,0.931 -3.766,2.385c-2.803,5.382 -9.141,7.985 -14.917,6.125c-5.745,-2.033 -9.122,-8.085 -7.833,-14.041c0.081,-0.329 0.123,-0.667 0.123,-1.006c-0,-2.206 -1.753,-4.05 -3.957,-4.161c-6.688,-0.569 -13.423,-0.176 -20,1.167c-1.197,0.232 -2.233,0.979 -2.833,2.041c-0.609,1.049 -0.731,2.313 -0.333,3.459c0.428,1.26 0.647,2.583 0.647,3.914c-0,6.674 -5.493,12.167 -12.167,12.167c-4.133,-0 -7.993,-2.106 -10.23,-5.581c-0.663,-1.029 -1.746,-1.715 -2.959,-1.875c-1.197,-0.18 -2.414,0.17 -3.333,0.958c-5.15,4.306 -9.655,9.329 -13.375,14.917c-0.679,1.016 -0.877,2.282 -0.542,3.458c0.304,1.182 1.112,2.173 2.209,2.708c5.526,2.668 8.237,9.097 6.291,14.917c-2.135,5.685 -8.121,9.032 -14.083,7.875c-0.317,-0.076 -0.641,-0.114 -0.967,-0.114c-2.187,0 -4.021,1.723 -4.158,3.906c-0.594,6.687 -0.201,13.426 1.167,20c0.221,1.212 0.969,2.266 2.041,2.875c1.049,0.609 2.313,0.731 3.459,0.333c1.26,-0.428 2.583,-0.647 3.914,-0.647c6.674,0 12.167,5.492 12.167,12.167c-0,4.133 -2.106,7.993 -5.581,10.23c-1.035,0.645 -1.736,1.712 -1.917,2.917c-0.193,1.21 0.158,2.446 0.958,3.375c4.333,5.127 9.369,9.616 14.959,13.333c1.022,0.663 2.275,0.874 3.458,0.583c1.182,-0.303 2.173,-1.111 2.708,-2.208c2.803,-5.382 9.141,-7.984 14.917,-6.125c5.75,2.032 9.139,8.076 7.875,14.042c-0.263,1.193 0.011,2.443 0.75,3.416c0.715,0.987 1.827,1.612 3.042,1.709c6.686,0.584 13.421,0.205 20,-1.125c0.348,-0.061 0.685,-0.173 1,-0.334c1.971,-0.889 2.94,-3.173 2.208,-5.208c-0.45,-1.286 -0.679,-2.639 -0.679,-4.001c-0,-6.652 5.473,-12.125 12.125,-12.125c4.163,0 8.045,2.144 10.262,5.668c0.663,1.028 1.746,1.715 2.959,1.875c1.21,0.192 2.446,-0.159 3.375,-0.959c5.127,-4.316 9.617,-9.338 13.333,-14.916c0.679,-1.017 0.877,-2.283 0.542,-3.459c-0.304,-1.182 -1.112,-2.173 -2.209,-2.708c-5.446,-2.74 -8.06,-9.149 -6.083,-14.917c2.133,-5.667 8.093,-9.01 14.042,-7.875c1.193,0.263 2.443,-0.011 3.416,-0.75c0.987,-0.714 1.612,-1.827 1.709,-3.041c0.531,-6.708 0.096,-13.458 -1.292,-20.042Z" />
     </g>
     <circle cx="1008.92" cy="1110.21" r="18.833" fill="#ffe895" stroke="#c29c87" stroke-width="8.33px" />
    </g>
    <g class="leaf" fill-rule="nonzero" stroke="#548f9c" stroke-linecap="round">
     <path fill="#bfe6c7" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M710.333,1073.17c0,-0 -45.5,10.208 -18.541,33.333c17.791,15.167 45.041,17.958 34.958,21.125c-34.833,10.875 -29.167,44.792 -0.458,45.833c28.708,1.042 50.541,-9 49.166,-3.083c0,0 -33.333,3.875 -27.375,24.125c7.875,26.708 108.834,19.083 113.167,20.833c-14.375,-13.333 -15.458,-27.708 -7.667,-63.708c7.792,-36 0.834,-47 -14.083,-49.125c-12.5,-1.75 -20.125,11.833 -24.167,23c-0.408,0.974 -1.365,1.611 -2.421,1.611c-1.44,-0 -2.625,-1.185 -2.625,-2.625c0,-0.051 0.002,-0.102 0.005,-0.153c1.884,-14.141 2.289,-28.441 1.208,-42.666c-3.167,-28.709 -37.5,-31.709 -45.833,3.833c-2.417,10.292 -7.167,-16.667 -23.625,-33.333c-24.834,-25.125 -31.709,21 -31.709,21Z" />
     <path fill="none" stroke-width="4.17px" d="M724.667,1086.88c17.041,30 58.333,83 134.5,126.667" />
    </g>
    <g fill="#0d242f" fill-rule="nonzero" stroke="#fff8ec" stroke-width="8.33px">
     <path d="M1220.83,1439.08c-26.556,9.748 -56.568,1.015 -73.75,-21.458c-18.044,-23.987 -41.636,-43.247 -68.75,-56.125c-25.578,-12.286 -40.292,-39.967 -36.166,-68.042c3.93,-29.166 0.903,-58.852 -8.834,-86.625c-9.697,-26.674 -0.867,-56.757 21.709,-73.958c23.938,-18.097 43.152,-41.714 56,-68.833c12.325,-25.556 40.079,-40.171 68.125,-35.875c29.179,3.932 58.88,0.905 86.666,-8.834c26.544,-9.741 56.541,-1.008 73.709,21.459c18.058,23.963 41.648,43.206 68.75,56.083c25.575,12.293 40.299,39.961 36.208,68.042c-3.932,29.179 -0.905,58.88 8.833,86.666c9.698,26.674 0.868,56.758 -21.708,73.959c-13.175,9.938 -24.972,21.582 -35.083,34.625c-8.138,10.631 -15.122,22.099 -20.834,34.208c-12.287,25.468 -39.91,40.068 -67.875,35.875c-29.288,-3.99 -59.111,-0.962 -87,8.833Z" />
     <path d="M1227.38,1378.04c-18.85,6.979 -40.195,0.782 -52.375,-15.209c-5.698,-7.641 -12.223,-14.628 -19.458,-20.833c-8.838,-7.609 -18.646,-14.012 -29.167,-19.042c-18.023,-8.687 -28.451,-28.139 -25.708,-47.958c2.837,-20.691 0.694,-41.763 -6.25,-61.458c-6.885,-18.911 -0.61,-40.245 15.416,-52.417c9.369,-7.07 17.774,-15.334 25,-24.583c5.818,-7.524 10.805,-15.655 14.875,-24.25c8.707,-18.061 28.3,-28.409 48.125,-25.417c20.681,2.793 41.732,0.637 61.417,-6.292c18.827,-6.938 40.123,-0.745 52.292,15.209c12.798,17.005 29.526,30.659 48.75,39.791c18.138,8.714 28.578,28.339 25.666,48.25c-2.777,20.692 -0.635,41.75 6.25,61.459c6.866,18.903 0.614,40.217 -15.375,52.416c-17.003,12.812 -30.633,29.575 -39.708,48.834c-8.711,18.076 -28.328,28.427 -48.167,25.416c-20.68,-2.793 -41.732,-0.637 -61.416,6.292l-0.167,-0.208Z" />
     <path d="M1233.33,1322.62c-11.82,4.34 -25.179,0.457 -32.833,-9.542c-3.595,-4.768 -7.687,-9.14 -12.208,-13.041c-5.586,-4.76 -11.762,-8.779 -18.375,-11.959c-11.402,-5.457 -17.965,-17.786 -16.125,-30.291c0.882,-6.464 0.994,-13.01 0.333,-19.5c-0.646,-6.488 -2.044,-12.878 -4.167,-19.042c-4.325,-11.872 -0.391,-25.268 9.667,-32.917c10.68,-8.043 19.258,-18.551 25,-30.625c5.456,-11.349 17.754,-17.863 30.208,-16c6.478,0.883 13.038,0.995 19.542,0.334c6.487,-0.646 12.877,-2.045 19.042,-4.167c11.808,-4.333 25.152,-0.451 32.791,9.542c8.009,10.712 18.526,19.298 30.625,25c11.329,5.531 17.848,17.809 16.084,30.291c-0.848,6.481 -0.946,13.039 -0.292,19.542c0.626,6.49 2.025,12.883 4.167,19.042c4.242,11.876 0.323,25.22 -9.667,32.916c-5.859,4.435 -11.112,9.618 -15.625,15.417c-3.65,4.718 -6.779,9.817 -9.333,15.208c-5.467,11.34 -17.757,17.849 -30.209,16c-6.464,-0.882 -13.009,-0.994 -19.5,-0.333c-6.517,0.601 -12.939,1.986 -19.125,4.125Z" />
    </g>
    <g class="prawn-2">
     <g fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px">
      <path fill="#ffa18f" d="M1679.42,942.542c48.821,26.877 79.254,78.373 79.254,134.103c-0,83.979 -69.104,153.084 -153.083,153.084c-52.824,-0 -102.048,-27.342 -129.963,-72.187c-34.75,-55.834 -22.375,-124.709 -15.208,-170.834l22.833,-0.666c54.458,4.916 72.542,47.416 79.583,84.083c9.417,48.917 61.875,78.583 106.209,55.917c2,-1.042 3.958,-2.167 5.916,-3.334c23.04,-13.951 37.157,-39.002 37.157,-65.937c-0,-19.522 -7.417,-38.334 -20.74,-52.604l-53.292,-60.125c12.509,-7.827 28.291,-8.4 41.334,-1.5Z" />
      <path fill="none" d="M1562.83,1070.12l-109.75,12.292" />
      <path fill="none" d="M1594.92,1089.12l-113.667,77.5" />
      <path fill="none" d="M1559.67,1222.54l39.958,-94.667l10.958,-21.375" />
      <path fill="none" d="M1658,1218.54l-16.417,-80.917" />
      <path fill="none" d="M1725.46,1164.92l-38.041,-47.084" />
      <path fill="none" d="M1710.29,1073.71l45.291,25.917" />
      <path fill="none" d="M1710.17,1032.88l36.75,-6.375" />
      <g fill="none">
       <path class="antennae" d="M1458.67,997.958c-0,0 12.708,-144.833 -126.75,-200.958" />
       <path class="antennae" d="M1485.96,985.792c9.323,-22.199 12.085,-46.613 7.959,-70.334" />
      </g>
     </g>
     <circle cx="1487.71" cy="1041.46" r="9.042" fill="#ee7868" />
    </g>
    <g class="prawn-1">
     <g fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px">
      <path fill="#ffa18f" d="M1190.33,1167.04c-0.003,-0.401 -0.004,-0.801 -0.004,-1.202c-0,-84.002 69.123,-153.125 153.125,-153.125c84.002,0 153.125,69.123 153.125,153.125c-0,25.829 -6.536,51.243 -18.996,73.868c-31.75,57.625 -97.875,80.5 -141.666,96.792l-11.75,-19.625c-22.334,-50 5.875,-86.417 34.416,-110.5c38.084,-32.125 38.334,-92.417 -3.125,-120c-1.875,-1.208 -3.791,-2.417 -5.791,-3.5c-11.607,-6.595 -24.731,-10.063 -38.081,-10.063c-33.485,-0 -63.316,21.818 -73.461,53.73l-26.375,75.875c-12.884,-7.159 -21.046,-20.641 -21.417,-35.375Z" />
      <path fill="none" d="M1358.62,1206.38l64.375,89.75" />
      <path fill="none" d="M1359.54,1169.08l123.166,61.25" />
      <path fill="none" d="M1493.17,1134.62l-102.125,11.417l-24,0.875" />
      <path fill="none" d="M1441.58,1050.79l-62.541,53.875" />
      <path fill="none" d="M1361.83,1018.17l-22.458,56.208" />
      <path fill="none" d="M1289.71,1076l0.459,-52.208" />
      <path fill="none" d="M1254.12,1096.04l-23.5,-28.959" />
      <path fill="none" d="M1346.62,1332.5c0,0 -132.583,59.708 -113.292,208.833" />
      <path fill="none" d="M1322.67,1314.67c-23.924,2.705 -46.575,12.223 -65.25,27.416" />
     </g>
     <circle cx="1370.38" cy="1285.92" r="9.042" fill="#ee7868" />
    </g>
    <g class="leaf-2" fill-rule="nonzero" stroke="#82cdb2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4">
     <path fill="#bfe6c7" stroke-width="8.33px" d="M1755.76,1062.85l59.667,-0.218l0.218,59.583c0.205,55.932 -45.652,102.126 -101.584,102.331l-59.541,0.218l-0.219,-59.583c-0.205,-55.932 45.652,-102.126 101.584,-102.331l-0.125,0Z" />
     <path fill="none" stroke-width="4.17px" d="M1813.96,1064.92c0,-0 -26.875,115.291 -160.5,160.458c0,0 58.709,-54.167 67.875,-117.292" />
    </g>
    <g class="leaf-3" fill-rule="nonzero" stroke="#82cdb2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4">
     <path fill="#bfe6c7" stroke-width="8.33px" d="M1546.49,1147.85l16.077,-52.162l52.242,16.102c48.952,15.087 76.818,67.783 61.73,116.735l-16.089,52.202l-52.202,-16.089c-0.013,-0.004 -0.027,-0.009 -0.04,-0.013c-48.951,-15.087 -76.817,-67.783 -61.73,-116.735c0.004,-0.013 0.008,-0.027 0.012,-0.04Z" />
     <path fill="none" stroke-width="4.17px" d="M1563.38,1102.29c0,-0 92.792,48.583 95.833,177.666c0,0 -30.083,-64.5 -82.583,-89.666" />
    </g>
    <g stroke="#82cdb2" stroke-width="8.33px">
     <path fill="#0d242f" fill-rule="nonzero" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M706.542,1167.67c67.99,248.676 295.633,422.435 553.437,422.435c257.804,0 485.447,-173.759 553.438,-422.435l-1106.88,-0Z" />
     <path fill="none" fill-rule="nonzero" d="M1813.42,1167.67c-6.042,0.5 -738.292,16.666 -843.292,342.083" />
     <rect width="405" height="57.833" x="1056.21" y="1554.62" fill="#0d242f" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" />
     <path fill="none" fill-rule="nonzero" d="M1083.79,1555.62l-0,56.042" />
     <path fill="none" fill-rule="nonzero" d="M1109.5,1555.62l0,56.042" />
     <path fill="none" fill-rule="nonzero" d="M1124.08,1555.62l0,56.042" />
     <path fill="none" fill-rule="nonzero" d="M1139.25,1555.62l0,56.042" />
     <g class="symbol-2">
      <ellipse cx="1259.08" cy="1362.33" fill="#0d242f" rx="118.292" ry="118.25" />
      <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1194.34,1318.03c20.235,-17.063 56.92,-6.896 81.87,22.692c24.95,29.587 28.778,67.462 8.544,84.525c-20.235,17.063 -56.92,6.896 -81.87,-22.692c-24.95,-29.587 -28.778,-67.462 -8.544,-84.525Z" />
      <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1243.09,1340.72c24.95,-29.587 61.635,-39.755 81.87,-22.692c20.234,17.064 16.406,54.938 -8.544,84.526c-24.95,29.587 -61.635,39.755 -81.87,22.691c-20.234,-17.063 -16.406,-54.937 8.544,-84.525Z" />
     </g>
    </g>
   </g>
   <g class="chicken" fill-rule="nonzero" stroke-width="8.33px">
    <path fill="#ffa18f" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1438.46,1421.92c-7.072,12.039 -21.455,17.875 -34.916,14.166c-17,-4.5 -42.875,-13.708 -45.834,-28.708c-4.166,-22.5 20.834,-21.125 20.834,-21.125c-0,0 -7.25,-21.292 8.625,-28.917c15.875,-7.625 54.166,30.542 54.75,51.084c0.095,4.73 -1.101,9.398 -3.459,13.5Z" />
    <path fill="#ffca6c" stroke="#c29c87" d="M1663.58,1518.92c-2.073,-33.053 -29.841,-59.134 -62.959,-59.134c-12.73,0 -25.166,3.853 -35.666,11.05c-3.648,-18.103 -20.045,-31.022 -38.5,-30.333c-7.07,0.26 -13.922,2.53 -19.75,6.542c0.521,-2.838 0.521,-5.746 0,-8.584c-2.378,-12.799 -14.563,-21.582 -27.458,-19.791c1.667,-4.601 2.07,-9.566 1.167,-14.375c-2.431,-13.124 -13.987,-22.736 -27.334,-22.736c-15.249,-0 -27.798,12.549 -27.798,27.798c0,1.698 0.156,3.393 0.465,5.063c0,0.416 0,0.833 0.292,1.25c-8.877,7.112 -14.052,17.89 -14.052,29.264c0,16.939 11.476,31.874 27.843,36.236l0,2.125c0.631,16.37 11.814,30.56 27.584,35c-0.526,3.221 -0.736,6.487 -0.625,9.75c0.932,23.797 19.718,43.357 43.458,45.25c-1.323,4.229 -1.915,8.654 -1.75,13.083c0.961,20.896 18.415,37.566 39.333,37.566c10.394,-0 20.377,-4.116 27.75,-11.441c6.049,9.194 16.504,14.564 27.5,14.125c5.966,-0.168 11.757,-2.064 16.667,-5.458c9.411,6.399 20.532,9.822 31.912,9.822c31.132,0 56.75,-25.617 56.75,-56.75c0,-26.587 -18.684,-49.784 -44.662,-55.447l-0.167,0.125Z" />
    <path fill="none" stroke="#c29c87" stroke-linecap="round" d="M1500.25,1505.42c4.888,-6.183 12.35,-9.796 20.232,-9.796c12.365,0 23.076,8.892 25.351,21.046" />
    <path fill="none" stroke="#c29c87" stroke-linecap="round" d="M1594.33,1570.08c-0.288,-1.55 -0.433,-3.125 -0.433,-4.702c0,-14.126 11.624,-25.75 25.75,-25.75c7.341,0 14.342,3.139 19.225,8.619" />
    <path fill="none" stroke="#c29c87" stroke-linecap="round" d="M1596.96,1511.46c2.412,-5.773 8.085,-9.552 14.342,-9.552c2.072,-0 4.124,0.414 6.033,1.219c3.037,1.311 5.587,3.541 7.292,6.375" />
    <path fill="none" stroke="#c29c87" stroke-linecap="round" d="M1462.75,1453.71c6.068,2.261 10.116,8.088 10.116,14.564c-0,5.221 -2.631,10.105 -6.991,12.978" />
   </g>
   <g class="chicken" fill-rule="nonzero" stroke-width="8.33px">
    <path fill="#ffa18f" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1580.12,1409.42c-7.072,12.039 -21.455,17.875 -34.917,14.166c-17,-4.5 -42.875,-13.708 -45.833,-28.708c-4.167,-22.5 20.833,-21.125 20.833,-21.125c0,0 -7.25,-21.292 8.625,-28.917c15.875,-7.625 54.167,30.542 54.75,51.084c0.095,4.73 -1.1,9.398 -3.458,13.5Z" />
    <path fill="#ffca6c" stroke="#c29c87" d="M1805.25,1506.42c-2.074,-33.053 -29.841,-59.134 -62.96,-59.134c-12.729,0 -25.165,3.853 -35.665,11.05c-3.648,-18.103 -20.045,-31.022 -38.5,-30.333c-7.07,0.26 -13.922,2.53 -19.75,6.542c0.52,-2.838 0.52,-5.746 0,-8.584c-2.378,-12.799 -14.564,-21.582 -27.458,-19.791c1.666,-4.601 2.069,-9.566 1.166,-14.375c-2.43,-13.124 -13.986,-22.736 -27.333,-22.736c-15.25,-0 -27.798,12.549 -27.798,27.798c-0,1.698 0.155,3.393 0.465,5.063c-0,0.416 -0,0.833 0.291,1.25c-8.876,7.112 -14.051,17.89 -14.051,29.264c-0,16.939 11.476,31.874 27.843,36.236l0,2.125c0.631,16.37 11.814,30.56 27.583,35c-0.526,3.221 -0.735,6.487 -0.625,9.75c0.933,23.797 19.719,43.357 43.459,45.25c-1.324,4.229 -1.915,8.654 -1.75,13.083c0.961,20.896 18.415,37.566 39.333,37.566c10.394,-0 20.376,-4.116 27.75,-11.441c6.049,9.194 16.503,14.564 27.5,14.125c5.966,-0.168 11.757,-2.064 16.667,-5.458c9.41,6.399 20.532,9.822 31.912,9.822c31.132,0 56.75,-25.617 56.75,-56.75c-0,-26.587 -18.685,-49.784 -44.662,-55.447l-0.167,0.125Z" />
    <path fill="none" stroke="#c29c87" stroke-linecap="round" d="M1641.92,1492.92c4.888,-6.183 12.35,-9.796 20.232,-9.796c12.365,0 23.076,8.892 25.351,21.046" />
    <path fill="none" stroke="#c29c87" stroke-linecap="round" d="M1736,1557.58c-0.288,-1.55 -0.433,-3.125 -0.433,-4.702c0,-14.126 11.624,-25.75 25.75,-25.75c7.34,0 14.341,3.139 19.225,8.619" />
    <path fill="none" stroke="#c29c87" stroke-linecap="round" d="M1738.62,1498.96c2.411,-5.773 8.084,-9.552 14.341,-9.552c2.073,-0 4.124,0.414 6.034,1.219c3.036,1.311 5.587,3.541 7.292,6.375" />
    <path fill="none" stroke="#c29c87" stroke-linecap="round" d="M1604.42,1441.21c6.068,2.261 10.115,8.088 10.115,14.564c0,5.221 -2.631,10.105 -6.99,12.978" />
   </g>
   <g class="bottle">
    <path fill="#d9dacb" fill-rule="nonzero" stroke="#9da2a7" stroke-width="8.33px" d="M470.833,1170.83l0,93.625l-33.333,0c-0.042,0 -0.083,0 -0.125,0c-29.509,0 -53.792,24.283 -53.792,53.792c0,0.028 0,0.056 0,0.083l0,291.667l275.792,0l0,-291.667c0,-29.509 -24.282,-53.791 -53.792,-53.791c-0.014,-0 -0.027,-0 -0.041,-0l-33.334,-0l0,-95.834" />
    <path fill="#ffe895" fill-rule="nonzero" stroke="#f4b67f" stroke-width="8.33px" d="M572.292,1139.38l-0,-36.667l-101.459,0l0,38.417" />
    <rect width="164.75" height="28.042" x="439.083" y="1140.54" fill="#d9dacb" stroke="#9da2a7" stroke-width="8.33px" />
    <path fill="#92cac4" fill-rule="nonzero" stroke="#548f9c" stroke-width="8.33px" d="M576.958,1478.38c11.61,-13.356 18.008,-30.468 18.008,-48.164c-0,-40.276 -33.142,-73.417 -73.417,-73.417c-40.275,-0 -73.417,33.141 -73.417,73.417c0,40.275 33.142,73.416 73.417,73.416c9.15,0 18.221,-1.711 26.743,-5.044l37.875,14.667l-9.209,-34.875Z" />
    <g fill="#548f9c">
     <circle cx="488.167" cy="1430.04" r="8.75" />
     <circle cx="521.458" cy="1430.04" r="8.75" />
     <circle cx="554.792" cy="1430.04" r="8.75" />
    </g>
   </g>
   <g class="salt">
    <path fill="#9da2a7" fill-rule="nonzero" stroke="#d9dacb" stroke-width="8.33px" d="M308.083,1486.08c-1.31,-5.669 -3.563,-11.078 -6.666,-16c-9.13,-13.849 -24.241,-22.647 -40.792,-23.75l-2.583,0c-23.523,-0.041 -44.31,15.807 -50.5,38.5l-14.459,51.375l-4.416,17.167c-0.943,3.718 -1.42,7.539 -1.42,11.375c0,25.318 20.769,46.179 46.086,46.292l45.839,-0c25.372,-0 46.25,-20.878 46.25,-46.25c-0,-3.664 -0.436,-7.314 -1.297,-10.875l-16.042,-67.834Z" />
    <path fill="#d9dacb" fill-rule="nonzero" d="M258.042,1446.25c-49.542,2.458 -52.834,53.208 -52.834,53.208l106.209,0c-0,0 -3.334,-50.75 -52.875,-53.208" />
    <g fill="#0d242f">
     <circle cx="248.125" cy="1458" r="3.333" />
     <circle cx="264.875" cy="1458" r="3.333" />
    </g>
   </g>
   <g class="dots" fill="#fff8ec">
    <circle cx="785.25" cy="918.333" r="10.417" />
    <circle cx="1093.58" cy="843.333" r="10.417" />
    <circle cx="1460.25" cy="739.167" r="10.417" />
    <circle cx="1235.25" cy="514.167" r="10.417" />
    <circle cx="531.083" cy="397.5" r="10.417" />
    <circle cx="1016.5" cy="853.75" r="8.333" />
    <circle cx="1474.83" cy="816.25" r="8.333" />
    <circle cx="1158.17" cy="591.25" r="8.333" />
    <circle cx="1249.83" cy="603.75" r="8.333" />
    <circle cx="774.833" cy="978.75" r="8.333" />
    <circle cx="662.333" cy="462.083" r="8.333" />
    <circle cx="668.583" cy="947.5" r="6.25" />
    <circle cx="735.25" cy="889.167" r="6.25" />
    <circle cx="839.417" cy="976.667" r="6.25" />
    <circle cx="639.417" cy="360" r="6.25" />
    <circle cx="741.5" cy="795.417" r="4.167" />
    <circle cx="1037.33" cy="791.25" r="4.167" />
    <circle cx="1320.67" cy="528.75" r="4.167" />
    <circle cx="1329" cy="657.917" r="4.167" />
    <circle cx="549.833" cy="320.417" r="4.167" />
    <circle cx="1354" cy="774.583" r="4.167" />
   </g>
   <g class="sparkles" fill="none" fill-rule="nonzero" stroke="#ffe895" stroke-linecap="round" stroke-width="8.33px">
    <g>
     <path d="M1999.29,550.792l-0,14.791" />
     <path d="M1999.29,596.625l-0,14.792" />
     <path d="M2029.58,581.125l-14.791,0" />
     <path d="M1983.75,581.125l-14.792,0" />
    </g>
    <g>
     <path d="M1945.12,859.125l0,14.792" />
     <path d="M1945.12,904.958l0,14.792" />
     <path d="M1975.42,889.458l-14.792,0" />
     <path d="M1929.58,889.458l-14.791,0" />
    </g>
    <g>
     <path d="M1840.96,246.625l0,14.792" />
     <path d="M1840.96,292.458l0,14.792" />
     <path d="M1871.25,276.958l-14.792,0" />
     <path d="M1825.42,276.958l-14.792,0" />
    </g>
    <g>
     <path d="M765.958,579.958l0,14.792" />
     <path d="M765.958,625.792l0,14.791" />
     <path d="M796.25,610.292l-14.792,-0" />
     <path d="M750.417,610.292l-14.792,-0" />
    </g>
    <g>
     <path d="M1515.96,400.792l0,14.791" />
     <path d="M1515.96,446.625l0,14.792" />
     <path d="M1546.25,431.125l-14.792,0" />
     <path d="M1500.42,431.125l-14.792,0" />
    </g>
    <g>
     <path d="M1886.79,675.875l-0,8.625" />
     <path d="M1886.79,702.708l-0,8.625" />
     <path d="M1904.5,693.625l-8.625,0" />
     <path d="M1877.67,693.625l-8.625,0" />
    </g>
    <g>
     <path d="M2020.12,700.875l0,8.625" />
     <path d="M2020.12,727.708l0,8.625" />
     <path d="M2037.83,718.625l-8.625,0" />
     <path d="M2011,718.625l-8.625,0" />
    </g>
    <g>
     <path d="M1699.29,300.875l-0,8.625" />
     <path d="M1699.29,327.708l-0,8.625" />
     <path d="M1717,318.625l-8.625,0" />
     <path d="M1690.17,318.625l-8.625,0" />
    </g>
    <g>
     <path d="M1803.46,413.375l0,8.625" />
     <path d="M1803.46,440.208l0,8.625" />
     <path d="M1821.17,431.125l-8.625,0" />
     <path d="M1794.33,431.125l-8.625,0" />
    </g>
    <g>
     <path d="M632.625,788.375l0,8.625" />
     <path d="M632.625,815.208l0,8.625" />
     <path d="M650.333,806.125l-8.625,0" />
     <path d="M623.5,806.125l-8.625,0" />
    </g>
    <g>
     <path d="M582.625,984.208l0,8.625" />
     <path d="M582.625,1011.04l0,8.625" />
     <path d="M600.333,1001.96l-8.625,0" />
     <path d="M573.5,1001.96l-8.625,0" />
    </g>
    <g>
     <path d="M395.125,892.542l0,8.625" />
     <path d="M395.125,919.375l0,8.625" />
     <path d="M412.833,910.292l-8.625,-0" />
     <path d="M386,910.292l-8.625,-0" />
    </g>
    <g>
     <path d="M574.292,500.875l-0,8.625" />
     <path d="M574.292,527.708l-0,8.625" />
     <path d="M592,518.625l-8.625,0" />
     <path d="M565.167,518.625l-8.625,0" />
    </g>
   </g>
   <g class="mushrooms" fill-rule="nonzero" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4">
    <g stroke="#9683ba">
     <path fill="#c9bde0" stroke-width="8.33px" d="M954.167,585.292c-12.521,15.582 -12.151,38.087 0.875,53.25c9.583,11.416 12.708,1.125 20.208,-10.834c0.913,-1.459 2.518,-2.349 4.239,-2.349c1.825,0 3.51,0.999 4.386,2.599l5.833,10.875c1.409,3.128 3.716,5.767 6.625,7.584c2.301,1.271 4.888,1.938 7.517,1.938c8.526,0 15.542,-7.015 15.542,-15.541c-0,-4.324 -1.805,-8.458 -4.975,-11.397l-9.459,-8.584c-0.96,-0.947 -1.501,-2.24 -1.501,-3.589c0,-2.121 1.339,-4.026 3.335,-4.744c13.291,-4.375 23.5,-6.417 13.833,-18.792c-7.997,-10.316 -20.34,-16.366 -33.393,-16.366c-12.868,0 -25.055,5.879 -33.065,15.95Z" />
     <path fill="none" stroke-width="4.17px" d="M1009.25,575.208c-18.197,-10.926 -41.937,-6.58 -55.083,10.084c-12.521,15.582 -12.151,38.087 0.875,53.25c9.583,11.416 12.708,1.125 20.208,-10.834c0.913,-1.459 2.518,-2.349 4.239,-2.349c1.825,0 3.51,0.999 4.386,2.599l0.542,1.042c-0,0 -17.334,-43.083 24.458,-53.583" />
    </g>
    <g stroke="#c9bde0">
     <path fill="#9683ba" stroke-width="8.33px" d="M1452.38,599.292c-22.168,-5.54 -45.361,5.555 -54.958,26.291c-7.375,15.459 4.875,13.792 20.833,15.959c2.844,0.354 5.002,2.798 5.002,5.664c-0,1.25 -0.411,2.466 -1.169,3.461l-9.5,12.5c-2.512,3.112 -3.883,6.993 -3.883,10.992c-0,6.636 3.774,12.723 9.717,15.674c6.403,3.341 14.224,2.518 19.791,-2.083c2.554,-2.204 4.42,-5.098 5.375,-8.333l4.459,-13.917c0.79,-2.353 3.008,-3.948 5.49,-3.948c1.596,0 3.124,0.66 4.218,1.823c10.917,11.792 17.875,21.5 26.208,5.5c3.617,-6.928 5.506,-14.629 5.506,-22.445c0,-22.315 -15.4,-41.888 -37.089,-47.138Z" />
     <path fill="none" stroke-width="4.17px" d="M1417.33,658.333c0,0 41,-45.833 71.875,-7.083" />
    </g>
   </g>
   <g class="leaves">
    <g class="prawn-smol">
     <g fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="4.17px">
      <path fill="#ffa18f" d="M1162.12,427.375c-11.668,17.484 -31.348,28.01 -52.368,28.01c-34.538,0 -62.958,-28.42 -62.958,-62.958c0,-23.703 13.385,-45.476 34.534,-56.177c24.125,-12.25 51.875,-4.708 70.5,0l-0.541,9.375c-3.959,22.125 -22,28 -37.25,29.583c-20.375,2.125 -34.417,22.542 -26.709,41.667c0.334,0.875 0.75,1.708 1.167,2.542c5.327,10.821 16.386,17.704 28.448,17.704c7.087,-0 13.973,-2.376 19.552,-6.746l26.5,-19.667c2.64,5.321 2.308,11.653 -0.875,16.667Z" />
      <path fill="none" d="M1114.04,375.083l-1.125,-45.375" />
      <path fill="none" d="M1105.08,387.542l-27.666,-49.292" />
      <path fill="none" d="M1051.71,368.333l37.375,19.75l8.334,5.25" />
      <path fill="none" d="M1049.83,408.75l33.75,-3.833" />
      <path fill="none" d="M1069.38,438.292l20.667,-13.875" />
      <path fill="none" d="M1107.29,435.333l-12.25,17.625" />
      <path fill="none" d="M1124,436.75l1.292,15.292" />
      <path fill="none" d="M1147.29,335.042c-0,-0 58.875,10.375 86.833,-44.75" />
      <path fill="none" d="M1151.33,346.625c8.744,4.633 18.642,6.644 28.5,5.792" />
     </g>
     <circle cx="1128.46" cy="345.333" r="3.708" fill="#ee7868" />
    </g>

    <g fill-rule="nonzero" stroke="#548f9c" stroke-linecap="round">
     <path fill="#92cac4" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M875.75,748c-9.667,15.083 16,29.417 16,29.417c0,5.166 -15.958,-7.375 -39.958,-12.125c-24,-4.75 -35.167,22.25 -8.584,38c7.75,4.541 -15.25,1.583 -32.875,10.625c-26.75,13.75 8.792,31.041 8.792,31.041c0,0 -3.292,39.375 22.167,23.417c16.666,-10.542 25.958,-31.833 25.958,-22.875c0,30.917 28.792,35.083 37,12.042c8.208,-23.042 6.75,-50 11.167,-47.584c-0,0 -1.875,34.209 15.958,35.792c12.708,1.167 20.542,-6.542 21.125,-37.792c0.583,-31.25 4.167,-42.875 18.75,-51.083c-0,0 -79.083,-34.583 -95.5,-8.875Z" />
     <path fill="none" stroke-width="4.17px" d="M833.625,836.417c36.944,-40.279 85.393,-68.243 138.75,-80.084" />
    </g>
    <g fill-rule="nonzero" stroke="#548f9c" stroke-linecap="round">
     <path fill="#92cac4" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M846.333,336.792c-17.916,0.958 -14.541,30.166 -14.541,30.166c-4.167,3 -3.334,-17.291 -13.542,-39.5c-10.208,-22.208 -38.583,-15.541 -35.792,15.25c0.792,8.917 -10.25,-11.5 -27.875,-20.5c-26.791,-13.666 -20.041,25.292 -20.041,25.292c-0,-0 -33.917,20.333 -6.042,31.667c18.333,7.458 41,2.458 33.708,7.708c-25,18 -11.666,43.875 11.875,37.042c23.542,-6.834 44.667,-23.917 45.125,-18.709c0,0 -28.833,18.417 -19.75,33.834c6.5,11 17.334,12.833 43.042,-4.917c25.708,-17.75 37.5,-21.583 52.417,-14.667c-0,0 -18.125,-84.375 -48.584,-82.666Z" />
     <path fill="none" stroke-width="4.17px" d="M750,354.167c54.187,6.475 105.102,29.43 145.833,65.75" />
    </g>
    <g fill-rule="nonzero" stroke="#548f9c" stroke-linecap="round">
     <path fill="#bfe6c7" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1247.54,765.083c-0,0 27.375,-13.958 6.375,-24.25c-13.834,-6.75 -31.625,-4.166 -25.709,-7.75c20.417,-12.5 11.334,-33.333 -7.208,-29.166c-18.542,4.166 -30.792,14.041 -30.875,10.041c0,0 20.625,-7.958 13.5,-19.875c-9.375,-15.75 -72.5,5.625 -75.583,5.167c11.375,6.167 14.375,15.125 15.333,39.375c0.958,24.25 7.125,30.125 17,29.167c8.333,-0.917 10.917,-10.834 11.667,-18.584c-0,-0.937 0.771,-1.708 1.708,-1.708c0.937,0 1.708,0.771 1.708,1.708c1.071,9.347 3.139,18.552 6.167,27.459c6.75,17.75 29.167,14.083 28.583,-9.959c0,-6.958 7.292,9.459 20.5,17.375c20.042,11.75 16.834,-19 16.834,-19Z" />
     <path fill="none" stroke-width="4.17px" d="M1236.17,758.667c-15.792,-16.334 -50.667,-43.375 -106.5,-58.75" />
    </g>
    <g fill-rule="nonzero" stroke="#548f9c" stroke-linecap="round">
     <path fill="#bfe6c7" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M358.333,640.542c0,-0 -29.875,7.208 -11.833,22.083c11.875,9.792 29.833,11.333 23.208,13.5c-22.791,7.542 -18.791,29.833 0,30.208c18.792,0.375 33.334,-6.458 32.334,-2.583c-0,0 -21.917,2.958 -17.75,16.208c5.458,17.5 71.833,11.375 74.708,12.5c-9.625,-8.625 -10.458,-18.083 -5.75,-41.875c4.708,-23.791 0,-30.916 -9.792,-32.166c-8.333,-1.042 -13.125,8 -15.666,15.416c-0.211,0.729 -0.883,1.234 -1.641,1.234c-0.938,-0 -1.709,-0.771 -1.709,-1.708c0,-0.079 0.006,-0.157 0.016,-0.234c1.091,-9.338 1.202,-18.764 0.334,-28.125c-2.375,-18.833 -25,-20.458 -30.042,3.042c-1.5,6.791 -4.917,-10.917 -15.958,-21.667c-16.292,-16.292 -20.459,14.167 -20.459,14.167Z" />
     <path fill="none" stroke-width="4.17px" d="M368.083,649.417c11.542,19.541 39.167,54.166 89.917,81.875" />
    </g>
   </g>
  </g>
   <g class="arm" stroke-width="8.33px">
   <path fill="#9683ba" fill-rule="nonzero" stroke="#c9bde0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1788.21,2335.38c0,0 875.794,451.96 1492.84,147.565c-0,0 135.867,-300.25 58.67,-422.565c-228.349,-361.81 -1470.97,-52.458 -1470.97,-52.458l-80.542,327.458Z" />
   <path fill="none" fill-rule="nonzero" stroke="#c9bde0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1811.58,2260.88c0,0 53.709,103.958 289.334,154.167" />
   <path fill="none" fill-rule="nonzero" stroke="#c9bde0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1806.38,2219.29c0,-0 73.875,78 218.333,81.458" />
   <g class="hand" fill-rule="nonzero">
    <path fill="#d9dacb" stroke="#9da2a7" d="M832.083,1718.96c5.209,-7.5 16.667,-12.5 31.917,-15.291c-3.789,-1.104 -7.644,-1.966 -11.542,-2.584c-80.625,-12.5 -119.833,13.542 -115.75,41.125c3.667,25 165.25,63.334 196.459,70.5c-73.834,-36.541 -125.792,-66.5 -101.084,-93.75Z" />
    <path fill="#d9dacb" stroke="#9da2a7" d="M1120.83,1745.83c47.167,19.834 116.667,55.25 168.625,82.584c-28.666,-39.875 -74.291,-88.459 -138.375,-114.459c-78,-31.625 -91.666,-9 -91.666,11c20.882,5.688 41.393,12.659 61.416,20.875Z" />
    <path class="tray" fill="#0d242f" stroke="#fff8ec" stroke-linecap="round" d="M1882.46,1698.71l-1759.88,0c-51.001,-0.01 -96.209,-33.887 -110.541,-82.833l-2,-6.875l1984.96,0l-2,6.875c-14.332,48.946 -59.54,82.823 -110.542,82.833Z" />

    <path fill="#fff8ec" stroke="#9da2a7" d="M1360.79,1866.67c-0,-0 29.583,-133.334 81.125,-170.834c51.541,-37.5 108.666,-44.083 104.541,-2.083c-4.125,42 -20.583,157.833 -20.583,157.833c0,0 57.583,131.667 46.333,170.834l173.834,29.166l-85.334,228.25c0,0 -253.166,-38.666 -380.75,-209.708c0,0 -89.083,-119.375 -204.708,-184.833c-128.167,-72.792 -282.458,-123.042 -243.167,-166.334c25.334,-36.458 193.792,-13.125 288.834,26.792c84.416,35.458 239.875,120.917 239.875,120.917Z" />
   </g>
   <path fill="#ffa18f" fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1566.33,2286.71l244.125,76.125l80.834,-360.083l-247.792,20.792l-77.167,263.166Z" />
   <g class="symbol-4" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4">
    <path fill="#ffa18f" d="M1660.28,2240.39c5.088,-28.221 32.131,-47.003 60.352,-41.915c28.222,5.088 47.003,32.132 41.915,60.353c-5.088,28.222 -32.131,47.003 -60.352,41.915c-28.222,-5.088 -47.003,-32.131 -41.915,-60.353Z" />
    <path fill="#ffa18f" d="M1686.86,2225.33c10.085,-5.804 25.155,1.443 33.632,16.172c8.477,14.73 7.17,31.4 -2.915,37.204c-10.085,5.804 -25.155,-1.442 -33.632,-16.172c-8.477,-14.729 -7.17,-31.4 2.915,-37.204Z" />
    <path fill="none" d="M1706.18,2238.62c13.085,-10.844 29.737,-12.374 37.162,-3.414c7.425,8.959 2.829,25.037 -10.255,35.881c-13.085,10.844 -29.737,12.374 -37.162,3.415c-7.425,-8.96 -2.83,-25.038 10.255,-35.882Z" />
   </g>
  </g>
  </g>
</svg>
  `;
    let dinnerMarkup = `
<svg class="anim-meals" width="100%" xml:space="preserve" fill-rule="evenodd" stroke-miterlimit="10" clip-rule="evenodd" viewBox="0 0 2384 2584">
 <g class="meals-all">
 <g class="meal dinner">
   <g class="bowl">
    <g class="chips-back">
     <path fill="#ffca6c" stroke="#ffe895" stroke-width="8.33px" d="M1262.83,818.588c1.015,-4.368 -1.708,-8.738 -6.076,-9.753l-17.086,-3.97c-4.368,-1.015 -8.738,1.707 -9.753,6.075l-70.76,304.555c-1.015,4.368 1.707,8.738 6.075,9.753l17.087,3.97c4.368,1.014 8.738,-1.708 9.753,-6.076l70.76,-304.554Z" />
     <path fill="#ffe895" stroke="#f4cd7f" stroke-width="8.33px" d="M1207.19,835.981c-0.144,-4.482 -3.9,-8.004 -8.382,-7.86l-17.532,0.563c-4.482,0.144 -8.004,3.9 -7.86,8.382l10.039,312.506c0.144,4.482 3.9,8.003 8.382,7.86l17.532,-0.564c4.482,-0.144 8.004,-3.899 7.86,-8.381l-10.039,-312.506Z" />
     <path fill="#ffe895" stroke="#f4cd7f" stroke-width="8.33px" d="M1311.89,864.087c2.242,-3.884 0.909,-8.857 -2.974,-11.099l-15.192,-8.771c-3.883,-2.242 -8.857,-0.909 -11.099,2.974l-156.333,270.777c-2.242,3.884 -0.91,8.857 2.974,11.099l15.191,8.771c3.884,2.242 8.857,0.91 11.099,-2.974l156.334,-270.777Z" />
     <path fill="#ffca6c" stroke="#ffe895" stroke-width="8.33px" d="M829.596,916.76c-1.212,-4.318 -5.701,-6.839 -10.019,-5.627l-16.889,4.741c-4.317,1.212 -6.838,5.701 -5.626,10.018l84.502,301.032c1.212,4.317 5.701,6.838 10.019,5.626l16.889,-4.741c4.317,-1.212 6.838,-5.701 5.626,-10.018l-84.502,-301.031Z" />
     <path fill="#ffca6c" stroke="#ffe895" stroke-width="8.33px" d="M897.25,878.333c0,-4.484 -3.641,-8.125 -8.125,-8.125l-17.542,0c-4.484,0 -8.125,3.641 -8.125,8.125l0,312.667c0,4.484 3.641,8.125 8.125,8.125l17.542,0c4.484,0 8.125,-3.641 8.125,-8.125l0,-312.667Z" />
     <path fill="#ffca6c" stroke="#ffe895" stroke-width="8.32px" d="M852.779,848.177c-0.584,-4.446 -4.668,-7.582 -9.114,-6.998l-17.342,2.277c-4.446,0.584 -7.582,4.667 -6.998,9.114l40.643,309.515c0.584,4.447 4.668,7.582 9.114,6.998l17.342,-2.277c4.446,-0.584 7.582,-4.667 6.998,-9.114l-40.643,-309.515Z" />
    </g>
    <g class="salad-leaf-04">
     <g fill-rule="nonzero" stroke="#548f9c" stroke-linecap="round">
      <path fill="#92cac4" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1424.04,985.625c-0,0 63.666,6.25 30.833,42.083c-21.667,23.625 -58.333,32.042 -43.958,34.625c49.208,8.917 47.416,56.042 8.333,62.5c-39.083,6.459 -70.333,-3.75 -67.458,4.167c-0,0 43.458,6.833 40.791,35.667c-1.875,20.583 -16.375,30.75 -66.25,22.583c-49.875,-8.167 -66.291,-3.042 -83.583,17.5c17.292,-20.542 16.292,-40.292 -0.333,-87.958c-16.625,-47.667 -9.084,-63.792 10.875,-69.167c16.666,-4.542 29.375,12.5 36.75,27.208c0.623,1.161 1.839,1.888 3.156,1.888c1.966,-0 3.584,-1.618 3.584,-3.584c-0,-0.242 -0.025,-0.483 -0.074,-0.72c-4.969,-18.929 -7.944,-38.327 -8.875,-57.875c-0.5,-39.542 45.584,-49.417 62.875,-2.5c5.042,13.625 7,-23.875 26.542,-49.25c29.708,-38.75 46.792,22.833 46.792,22.833Z" />
      <path fill="none" stroke-width="4.17px" d="M1406.88,1006.71c-18.125,43.667 -65.083,122.667 -161.583,194.959" />
     </g>
    </g>
    <g class="salad-leaf-02">
     <g fill-rule="nonzero" stroke="#82cdb2" stroke-linecap="round">
      <path fill="#bfe6c7" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1126.25,932.708c0,0 21.833,-65.833 51.917,-22.5c19.833,28.584 19.958,69.334 26.125,54.834c21.25,-50 70.833,-36.709 68.041,6.125c-2.791,42.833 -20.833,73.5 -11.875,72.333c0,0 17.625,-44.292 47.542,-34.583c21.333,6.916 28.625,24.708 8.042,75.541c-20.584,50.834 -19.167,69.417 -1.542,92.667c-17.625,-23.25 -38.75,-26.958 -93.25,-20.833c-54.5,6.125 -69.708,-5.667 -70.833,-28.084c-1.292,-31.416 58.625,-36 58.625,-36c3.541,-8.333 -43.334,0.459 -85.334,-8.333c-42,-8.792 -41.416,-60.125 12.5,-67.167c15.625,-2 -23.583,-13.083 -45.833,-39.875c-33.458,-40.833 35.875,-44.125 35.875,-44.125Z" />
      <path fill="none" stroke-width="4.17px" d="M1144.42,955.958c41.666,29.667 111.291,92.875 164.666,212.5" />
     </g>
    </g>
    <g class="tentacle">
     <path fill="#ffa18f" fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M782.5,936.208c90.833,-45.291 69,226.417 146.792,320.834c120.833,146.75 262.75,-10.834 162.833,-99.5c-34.583,-30.709 -53.25,3.541 -95.083,-84.167c-34.792,-72.875 -80.167,-269.958 -262.5,-209.083c-26.542,8.875 -61.542,26.125 -86.667,3.666c-40.458,-36.125 14.292,-90.458 8.333,-110.083c-8.75,-29.167 -40.583,10.708 -40.583,10.708c-93.458,121.334 33.833,233.959 166.875,167.625Z" />
     <g>
      <circle cx="1037.21" cy="1227.67" r="88.167" fill="#fff8ec" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" />
      <circle cx="940.875" cy="1102.21" r="39.25" fill="#ee7868" />
      <circle cx="906.583" cy="994.042" r="28.208" fill="#ee7868" />
      <circle cx="851.125" cy="913.583" r="20.958" fill="#ee7868" />
      <circle cx="772.667" cy="896.125" r="17.875" fill="#ee7868" />
      <circle cx="696.875" cy="909.25" r="15.333" fill="#ee7868" />
      <circle cx="631.542" cy="890.208" r="10.708" fill="#ee7868" />
      <g>
       <g class="Tools-2" fill-rule="nonzero">
        <path fill="#fff8ec" d="M1104.62,1211.71c-0.263,-1.197 -1.041,-2.219 -2.125,-2.791c-1.072,-0.594 -2.354,-0.686 -3.5,-0.25c-5.767,2.053 -12.236,-0.418 -15.167,-5.792c-2.731,-5.475 -1.061,-12.192 3.917,-15.75c1.185,-0.767 1.903,-2.086 1.903,-3.498c-0,-1.071 -0.413,-2.102 -1.153,-2.877c-4.508,-5.035 -9.714,-9.398 -15.458,-12.958c-1.054,-0.628 -2.321,-0.794 -3.5,-0.459c-1.176,0.353 -2.137,1.208 -2.625,2.334c-2.025,4.267 -6.345,6.998 -11.068,6.998c-6.72,0 -12.25,-5.53 -12.25,-12.25c0,-0.641 0.051,-1.281 0.151,-1.915c0.195,-1.21 -0.122,-2.449 -0.875,-3.417c-0.758,-0.96 -1.902,-1.54 -3.125,-1.583c-6.744,-0.399 -13.51,0.191 -20.083,1.75c-1.198,0.263 -2.22,1.041 -2.792,2.125c-0.58,1.092 -0.671,2.379 -0.25,3.542c2.03,5.755 -0.437,12.197 -5.792,15.125c-5.475,2.731 -12.192,1.061 -15.75,-3.917c-0.698,-1.018 -1.813,-1.675 -3.041,-1.792c-1.21,-0.157 -2.429,0.224 -3.334,1.042c-5.044,4.498 -9.409,9.706 -12.958,15.458c-0.663,1.041 -0.831,2.324 -0.458,3.5c0.333,1.183 1.172,2.16 2.291,2.667c4.371,1.969 7.194,6.337 7.194,11.131c0,6.697 -5.511,12.208 -12.208,12.208c-0.764,0 -1.527,-0.071 -2.277,-0.214c-0.288,-0.062 -0.582,-0.093 -0.876,-0.093c-2.286,-0 -4.167,1.881 -4.167,4.167c-0,0.031 0,0.062 0.001,0.093c-0.382,6.743 0.208,13.507 1.75,20.083c0.272,1.205 1.067,2.229 2.167,2.792c1.072,0.594 2.354,0.685 3.5,0.25c5.777,-2.047 12.249,0.443 15.166,5.833c2.708,5.465 1.041,12.154 -3.916,15.708c-1.034,0.69 -1.707,1.806 -1.834,3.042c-0.146,1.216 0.251,2.436 1.084,3.333c4.487,5.057 9.696,9.423 15.458,12.959c0.681,0.45 1.48,0.689 2.296,0.689c1.663,0 3.173,-0.995 3.829,-2.523c2.01,-4.304 6.349,-7.067 11.1,-7.067c6.72,0 12.25,5.53 12.25,12.25c-0,0.707 -0.062,1.413 -0.183,2.109c-0.229,1.212 0.092,2.464 0.875,3.417c0.749,0.976 1.895,1.572 3.125,1.625c6.743,0.377 13.506,-0.212 20.083,-1.75c1.942,-0.387 3.353,-2.107 3.353,-4.087c-0,-0.542 -0.106,-1.079 -0.311,-1.58c-2.053,-5.767 0.417,-12.236 5.791,-15.167c5.534,-2.681 12.266,-0.9 15.75,4.167c0.689,1.007 1.787,1.663 3,1.792c1.22,0.132 2.442,-0.245 3.375,-1.042c5.035,-4.508 9.399,-9.714 12.959,-15.458c0.17,-0.326 0.323,-0.659 0.458,-1c0.256,-0.814 0.256,-1.687 -0,-2.5c-0.362,-1.168 -1.192,-2.134 -2.292,-2.667c-4.304,-2.01 -7.067,-6.349 -7.067,-11.1c0,-6.72 5.53,-12.25 12.25,-12.25c0.707,0 1.413,0.062 2.109,0.183c1.212,0.229 2.464,-0.092 3.417,-0.875c0.976,-0.749 1.572,-1.895 1.625,-3.125c0.416,-6.925 -0.188,-13.875 -1.792,-20.625Z" />
        <path fill="none" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="5.71px" d="M1104.62,1211.71c-0.263,-1.197 -1.041,-2.219 -2.125,-2.791c-1.072,-0.594 -2.354,-0.686 -3.5,-0.25c-5.767,2.053 -12.236,-0.418 -15.167,-5.792c-2.731,-5.475 -1.061,-12.192 3.917,-15.75c1.185,-0.767 1.903,-2.086 1.903,-3.498c-0,-1.071 -0.413,-2.102 -1.153,-2.877c-4.508,-5.035 -9.714,-9.398 -15.458,-12.958c-1.054,-0.628 -2.321,-0.794 -3.5,-0.459c-1.176,0.353 -2.137,1.208 -2.625,2.334c-2.025,4.267 -6.345,6.998 -11.068,6.998c-6.72,0 -12.25,-5.53 -12.25,-12.25c0,-0.641 0.051,-1.281 0.151,-1.915c0.195,-1.21 -0.122,-2.449 -0.875,-3.417c-0.758,-0.96 -1.902,-1.54 -3.125,-1.583c-6.744,-0.399 -13.51,0.191 -20.083,1.75c-1.198,0.263 -2.22,1.041 -2.792,2.125c-0.58,1.092 -0.671,2.379 -0.25,3.542c2.03,5.755 -0.437,12.197 -5.792,15.125c-5.475,2.731 -12.192,1.061 -15.75,-3.917c-0.698,-1.018 -1.813,-1.675 -3.041,-1.792c-1.21,-0.157 -2.429,0.224 -3.334,1.042c-5.044,4.498 -9.409,9.706 -12.958,15.458c-0.663,1.041 -0.831,2.324 -0.458,3.5c0.333,1.183 1.172,2.16 2.291,2.667c4.371,1.969 7.194,6.337 7.194,11.131c0,6.697 -5.511,12.208 -12.208,12.208c-0.764,0 -1.527,-0.071 -2.277,-0.214c-0.288,-0.062 -0.582,-0.093 -0.876,-0.093c-2.286,-0 -4.167,1.881 -4.167,4.167c-0,0.031 0,0.062 0.001,0.093c-0.382,6.743 0.208,13.507 1.75,20.083c0.272,1.205 1.067,2.229 2.167,2.792c1.072,0.594 2.354,0.685 3.5,0.25c5.777,-2.047 12.249,0.443 15.166,5.833c2.708,5.465 1.041,12.154 -3.916,15.708c-1.034,0.69 -1.707,1.806 -1.834,3.042c-0.146,1.216 0.251,2.436 1.084,3.333c4.487,5.057 9.696,9.423 15.458,12.959c0.681,0.45 1.48,0.689 2.296,0.689c1.663,0 3.173,-0.995 3.829,-2.523c2.01,-4.304 6.349,-7.067 11.1,-7.067c6.72,0 12.25,5.53 12.25,12.25c-0,0.707 -0.062,1.413 -0.183,2.109c-0.229,1.212 0.092,2.464 0.875,3.417c0.749,0.976 1.895,1.572 3.125,1.625c6.743,0.377 13.506,-0.212 20.083,-1.75c1.942,-0.387 3.353,-2.107 3.353,-4.087c-0,-0.542 -0.106,-1.079 -0.311,-1.58c-2.053,-5.767 0.417,-12.236 5.791,-15.167c5.534,-2.681 12.266,-0.9 15.75,4.167c0.689,1.007 1.787,1.663 3,1.792c1.22,0.132 2.442,-0.245 3.375,-1.042c5.035,-4.508 9.399,-9.714 12.959,-15.458c0.17,-0.326 0.323,-0.659 0.458,-1c0.256,-0.814 0.256,-1.687 -0,-2.5c-0.362,-1.168 -1.192,-2.134 -2.292,-2.667c-4.304,-2.01 -7.067,-6.349 -7.067,-11.1c0,-6.72 5.53,-12.25 12.25,-12.25c0.707,0 1.413,0.062 2.109,0.183c1.212,0.229 2.464,-0.092 3.417,-0.875c0.976,-0.749 1.572,-1.895 1.625,-3.125c0.416,-6.925 -0.188,-13.875 -1.792,-20.625Z" />
       </g>
       <circle cx="1035.83" cy="1227.88" r="18.958" fill="#fff8ec" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="5.71px" />
      </g>
     </g>
    </g>
    <g class="salad-leaf-03">
     <g fill-rule="nonzero" stroke="#82cdb2" stroke-linecap="round">
      <path fill="#bfe6c7" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1043.42,995.833c-0,0 69.208,-4.791 40.541,39.5c-18.916,29.167 -56.541,44.75 -40.791,44.959c54.166,0.708 60.833,51.458 20.166,65.291c-40.666,13.834 -75.875,8.625 -71.375,16.667c0,0 47.667,-0.542 50,30.792c1.709,22.416 -12,35.916 -66.666,36.166c-54.667,0.25 -71.459,8.667 -86.25,33.792c14.791,-25 10.166,-46.042 -16.209,-94.167c-26.375,-48.125 -21.208,-66.666 -0.833,-76c28.542,-13.125 55.542,40.542 55.542,40.542c9.041,0 -16.875,-39.875 -24.542,-82.167c-7.667,-42.291 39.875,-61.125 66.667,-14c7.833,13.667 3.166,-26.791 19.5,-57.5c24.875,-46.375 54.25,16.125 54.25,16.125Z" />
      <path fill="none" stroke-width="4.17px" d="M1028.83,1021.62c-11.541,50 -43.625,138.25 -133.875,233" />
     </g>
    </g>
    <g class="salad-leaf-01">
     <g fill-rule="nonzero" stroke="#82cdb2" stroke-linecap="round">
      <path fill="#bfe6c7" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1783.33,1027.75c0,0 68.917,7.917 32.667,46.25c-23.917,25.25 -63.75,33.708 -48.333,36.792c53.208,10.583 50.458,61.666 7.958,67.833c-42.5,6.167 -76.208,-5.333 -73.25,3.208c0,0 47,8.334 43.625,39.417c-2.417,22.333 -18.375,33.125 -72.292,23.375c-53.916,-9.75 -71.875,-4.542 -91,17.5c19.125,-22.042 18.417,-43.458 1.25,-95.542c-17.166,-52.083 -8.708,-69.416 13.042,-75c30.458,-7.708 47.208,50 47.208,50c8.875,1.792 -9.291,-42.291 -9.125,-85.25c0.167,-42.958 50.334,-52.833 68.25,-1.583c5.209,14.875 8,-25.792 29.667,-53c32.833,-41.167 50.333,26 50.333,26Z" />
      <path fill="none" stroke-width="4.17px" d="M1764.21,1050.29c-20.458,47.083 -68.125,127.958 -174.125,204.708" />
     </g>
    </g>
    <g class="octopus">
     <g>
      <g stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4">
       <path fill="#ee7868" fill-rule="nonzero" stroke="#ffa18f" stroke-width="8.33px" d="M1023.46,949.042c59.292,-85.459 23.959,-142.792 -23.208,-138.084c-36.458,3.625 46.167,-32.25 84,10.834c23.5,26.75 43.208,74.25 0.625,152.291c-42.583,78.042 -15.917,169.5 43.25,184.459c29.917,7.541 65.208,23 56.958,69.875c-4.166,22.666 -30.416,34.583 -30.416,34.583c-85.417,29.417 -273.875,-108.458 -131.209,-313.958Z" />
       <circle cx="1026.62" cy="1137.29" r="24.833" fill="#ffa18f" stroke="#ee7868" stroke-width="5.71px" />
       <circle cx="1017.12" cy="1060.79" r="18.792" fill="#ffa18f" stroke="#ee7868" stroke-width="4.29px" />
       <circle cx="1035.58" cy="996.625" r="15.125" fill="#ffa18f" stroke="#ee7868" stroke-width="3.46px" />
       <circle cx="1062.17" cy="938.583" r="11.708" fill="#ffa18f" stroke="#ee7868" stroke-width="2.67px" />
       <circle cx="1077.46" cy="887.583" r="8.625" fill="#ffa18f" stroke="#ee7868" stroke-width="1.96px" />
      </g>
      <circle cx="1135.62" cy="1215.21" r="50.833" fill="#fff8ec" stroke="#ffa18f" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" />
      <g>
       <g class="Tools-3" fill-rule="nonzero">
        <path fill="#fff8ec" d="M1172.08,1205.71c-0.149,-0.682 -0.613,-1.254 -1.25,-1.541c-0.595,-0.273 -1.28,-0.273 -1.875,-0c-3.048,1.12 -6.492,-0.207 -8,-3.084c-1.446,-2.89 -0.577,-6.439 2.042,-8.333c0.551,-0.367 0.904,-0.966 0.958,-1.625c0.082,-0.634 -0.116,-1.273 -0.541,-1.75c-2.428,-2.686 -5.236,-5.002 -8.334,-6.875c-0.542,-0.353 -1.216,-0.445 -1.833,-0.25c-0.624,0.179 -1.141,0.62 -1.417,1.208c-1.071,2.272 -3.367,3.727 -5.878,3.727c-3.566,0 -6.5,-2.934 -6.5,-6.5c-0,-0.355 0.029,-0.71 0.087,-1.06c0.124,-0.642 -0.027,-1.308 -0.417,-1.833c-0.417,-0.501 -1.017,-0.816 -1.667,-0.875c-3.583,-0.182 -7.173,0.14 -10.666,0.958c-0.627,0.145 -1.16,0.556 -1.459,1.125c-0.29,0.591 -0.29,1.284 0,1.875c1.047,3.049 -0.261,6.442 -3.083,8c-2.88,1.522 -6.483,0.639 -8.333,-2.042c-0.367,-0.55 -0.966,-0.904 -1.625,-0.958c-0.646,-0.072 -1.294,0.124 -1.792,0.542c-2.683,2.419 -4.987,5.228 -6.833,8.333c-0.371,0.536 -0.464,1.218 -0.25,1.833c0.179,0.625 0.62,1.142 1.208,1.417c2.284,1.066 3.751,3.369 3.751,5.89c-0,3.566 -2.935,6.5 -6.5,6.5c-0.378,-0 -0.754,-0.033 -1.126,-0.098c-0.629,-0.118 -1.279,0.034 -1.792,0.416c-0.501,0.418 -0.816,1.018 -0.875,1.667c-0.202,3.583 0.121,7.177 0.959,10.667c0.238,1.012 1.149,1.734 2.19,1.734c0.277,-0 0.551,-0.051 0.81,-0.151c3.048,-1.121 6.492,0.207 8,3.083c1.438,2.901 0.55,6.451 -2.084,8.334c-0.526,0.389 -0.872,0.976 -0.958,1.625c-0.077,0.653 0.136,1.308 0.583,1.791c2.427,2.676 5.235,4.978 8.334,6.834c0.553,0.366 1.245,0.458 1.875,0.25c0.624,-0.18 1.141,-0.621 1.416,-1.209c1.022,-2.356 3.357,-3.888 5.925,-3.888c3.543,0 6.458,2.916 6.458,6.459c0,0.438 -0.044,0.875 -0.133,1.304c-0.105,0.635 0.061,1.286 0.459,1.792c0.411,0.509 1.014,0.825 1.666,0.875c3.57,0.204 7.15,-0.118 10.625,-0.958c0.65,-0.116 1.207,-0.534 1.5,-1.125c0.273,-0.595 0.273,-1.28 0,-1.875c-1.046,-3.049 0.262,-6.442 3.084,-8c2.892,-1.495 6.484,-0.597 8.333,2.083c0.42,0.607 1.112,0.97 1.851,0.97c0.564,0 1.109,-0.212 1.524,-0.595c2.688,-2.426 5.004,-5.233 6.875,-8.333c0.1,-0.173 0.184,-0.354 0.25,-0.542c0.318,-1.084 -0.195,-2.251 -1.208,-2.75c-2.338,-1.031 -3.853,-3.355 -3.853,-5.909c-0,-3.543 2.915,-6.459 6.458,-6.459c0.412,0 0.823,0.04 1.228,0.118c0.647,0.088 1.304,-0.076 1.833,-0.458c0.509,-0.411 0.826,-1.015 0.875,-1.667c0.209,-3.579 -0.085,-7.17 -0.875,-10.667Z" />
        <path fill="none" stroke="#ffa18f" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="4.17px" d="M1172.08,1205.71c-0.149,-0.682 -0.613,-1.254 -1.25,-1.541c-0.595,-0.273 -1.28,-0.273 -1.875,-0c-3.048,1.12 -6.492,-0.207 -8,-3.084c-1.446,-2.89 -0.577,-6.439 2.042,-8.333c0.551,-0.367 0.904,-0.966 0.958,-1.625c0.082,-0.634 -0.116,-1.273 -0.541,-1.75c-2.428,-2.686 -5.236,-5.002 -8.334,-6.875c-0.542,-0.353 -1.216,-0.445 -1.833,-0.25c-0.624,0.179 -1.141,0.62 -1.417,1.208c-1.071,2.272 -3.367,3.727 -5.878,3.727c-3.566,0 -6.5,-2.934 -6.5,-6.5c-0,-0.355 0.029,-0.71 0.087,-1.06c0.124,-0.642 -0.027,-1.308 -0.417,-1.833c-0.417,-0.501 -1.017,-0.816 -1.667,-0.875c-3.583,-0.182 -7.173,0.14 -10.666,0.958c-0.627,0.145 -1.16,0.556 -1.459,1.125c-0.29,0.591 -0.29,1.284 0,1.875c1.047,3.049 -0.261,6.442 -3.083,8c-2.88,1.522 -6.483,0.639 -8.333,-2.042c-0.367,-0.55 -0.966,-0.904 -1.625,-0.958c-0.646,-0.072 -1.294,0.124 -1.792,0.542c-2.683,2.419 -4.987,5.228 -6.833,8.333c-0.371,0.536 -0.464,1.218 -0.25,1.833c0.179,0.625 0.62,1.142 1.208,1.417c2.284,1.066 3.751,3.369 3.751,5.89c-0,3.566 -2.935,6.5 -6.5,6.5c-0.378,-0 -0.754,-0.033 -1.126,-0.098c-0.629,-0.118 -1.279,0.034 -1.792,0.416c-0.501,0.418 -0.816,1.018 -0.875,1.667c-0.202,3.583 0.121,7.177 0.959,10.667c0.238,1.012 1.149,1.734 2.19,1.734c0.277,-0 0.551,-0.051 0.81,-0.151c3.048,-1.121 6.492,0.207 8,3.083c1.438,2.901 0.55,6.451 -2.084,8.334c-0.526,0.389 -0.872,0.976 -0.958,1.625c-0.077,0.653 0.136,1.308 0.583,1.791c2.427,2.676 5.235,4.978 8.334,6.834c0.553,0.366 1.245,0.458 1.875,0.25c0.624,-0.18 1.141,-0.621 1.416,-1.209c1.022,-2.356 3.357,-3.888 5.925,-3.888c3.543,0 6.458,2.916 6.458,6.459c0,0.438 -0.044,0.875 -0.133,1.304c-0.105,0.635 0.061,1.286 0.459,1.792c0.411,0.509 1.014,0.825 1.666,0.875c3.57,0.204 7.15,-0.118 10.625,-0.958c0.65,-0.116 1.207,-0.534 1.5,-1.125c0.273,-0.595 0.273,-1.28 0,-1.875c-1.046,-3.049 0.262,-6.442 3.084,-8c2.892,-1.495 6.484,-0.597 8.333,2.083c0.42,0.607 1.112,0.97 1.851,0.97c0.564,0 1.109,-0.212 1.524,-0.595c2.688,-2.426 5.004,-5.233 6.875,-8.333c0.1,-0.173 0.184,-0.354 0.25,-0.542c0.318,-1.084 -0.195,-2.251 -1.208,-2.75c-2.338,-1.031 -3.853,-3.355 -3.853,-5.909c-0,-3.543 2.915,-6.459 6.458,-6.459c0.412,0 0.823,0.04 1.228,0.118c0.647,0.088 1.304,-0.076 1.833,-0.458c0.509,-0.411 0.826,-1.015 0.875,-1.667c0.209,-3.579 -0.085,-7.17 -0.875,-10.667Z" />
       </g>
       <circle cx="1135.62" cy="1214.29" r="10.042" fill="#fff8ec" stroke="#ffa18f" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="4.17px" />
      </g>
     </g>
    </g>
    <g class="lobster">
     <g>
      <g fill="#ee7868" fill-rule="nonzero" stroke="#ffa18f" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px">
       <path d="M1429.17,1140.21c-0,0 -83.334,-4.875 -118.209,29.167c-34.875,34.042 18.709,103.375 44.375,99.708c18.959,-2.666 69.042,-47.958 94.084,-71.625c12.885,-11.968 14.694,-31.955 4.166,-46.041c-5.707,-7.626 -14.913,-11.852 -24.416,-11.209Z" />
       <path d="M1443.25,1169.12c0,0 -76.042,34.667 -90.875,81c-14.833,46.333 64.792,82.625 85.833,67.417c15.459,-11.209 38.584,-74.667 49.709,-107.334c5.839,-16.585 -1.87,-35.117 -17.75,-42.666c-8.647,-4.092 -18.81,-3.494 -26.917,1.583Z" />
       <path d="M1520.83,1207.29c0,-0 30.042,78 8.334,121.458c-21.709,43.458 -104.167,13.667 -108.334,-11.917c-3.208,-18.833 24.709,-80.333 39.625,-111.416c7.48,-15.822 25.86,-23.586 42.417,-17.917c8.938,3.134 15.705,10.592 17.958,19.792Z" />
      </g>
      <path fill="#ffa18f" fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1508.58,894.208c65.5,-89.666 239.042,-140.375 261.959,-123.666c18.333,13.375 27.416,197.5 -38.084,287.166c-65.5,89.667 -222.208,199.042 -284,153.917c-61.791,-45.125 -5.333,-227.75 60.125,-317.417Z" />
      <g fill="#ee7868">
       <circle cx="1676.71" cy="847.917" r="12.125" />
       <circle cx="1725.38" cy="883.458" r="12.125" />
      </g>
      <path fill="none" fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1736.38,1049.33c-46.532,-16.261 -90.324,-39.499 -129.875,-68.916c-35.044,-25.309 -66.643,-55.073 -94,-88.542" />
      <path fill="none" fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1693.29,1102.79c-45.31,-16.253 -87.978,-39.096 -126.625,-67.792c-34.021,-24.542 -64.819,-53.268 -91.667,-85.5" />
      <path fill="none" fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1636.04,1150.83c-38.851,-15.751 -75.559,-36.344 -109.25,-61.291c-29.322,-21.189 -56.282,-45.468 -80.417,-72.417" />
      <path fill="none" fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1572,1194.92c-29.923,-14.166 -58.415,-31.175 -85.083,-50.792c-21.317,-15.478 -41.366,-32.629 -59.959,-51.292" />
      <path fill="none" fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1487.71,923.708c0,0 -82.75,-37.5 -68.583,-145" />
      <path fill="none" fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1431.33,1050c0,0 -95.041,-22.583 -91.666,-113.208" />
      <g class="left-arm" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px">
       <path class="arm" fill="none" fill-rule="nonzero" d="M1569.75,834.875c0,0 -73.458,-126.583 26.458,-243.833" />
       <path class="pincher-1" fill="#ffa18f" d="M1640.77,526.372c2.271,-7.637 -2.086,-15.682 -9.724,-17.953c-7.637,-2.271 -15.682,2.086 -17.953,9.723l-18.277,61.466c-2.271,7.637 2.086,15.682 9.724,17.953c7.637,2.271 15.682,-2.086 17.953,-9.723l18.277,-61.466Z" />
       <path class="pincher-2" fill="#ffa18f" d="M1609.95,569.457c-7.923,-0.852 -15.047,4.888 -15.899,12.811c-0.852,7.922 4.888,15.046 12.81,15.899l63.757,6.858c7.923,0.853 15.047,-4.887 15.899,-12.81c0.853,-7.923 -4.888,-15.047 -12.81,-15.899l-63.757,-6.859Z" />
      </g>
      <path fill="none" fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1710.71,1086.58c0,0 60.959,67.375 159.042,21.209" />
      <path fill="none" fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1607.71,1178.71c0,0 50.625,83.792 135.792,53" />
      <g class="right-arm" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px">
       <path fill="none" fill-rule="nonzero" d="M1770.38,981.375c0,0 142.958,31.458 224.208,-99.417" />
       <path class="pincher-3" fill="#ffa18f" d="M1989.79,855.921c-6.584,4.488 -8.286,13.477 -3.798,20.061c4.488,6.584 13.478,8.286 20.062,3.798l52.986,-36.118c6.584,-4.488 8.286,-13.477 3.798,-20.061c-4.488,-6.584 -13.478,-8.286 -20.062,-3.798l-52.986,36.118Z" />
       <path class="pincher-4" fill="#ffa18f" d="M1985,803.757c-3.223,-7.288 -11.756,-10.587 -19.044,-7.364c-7.287,3.223 -10.586,11.756 -7.363,19.044l25.939,58.644c3.223,7.288 11.756,10.587 19.043,7.364c7.288,-3.223 10.587,-11.756 7.364,-19.044l-25.939,-58.644Z" />
      </g>
     </g>
    </g>
    <g class="tomato-video">
     <g stroke="#fff8ec">
      <g>
       <ellipse cx="1431.29" cy="1088.58" fill="#9683ba" stroke-width="8.33px" rx="115.25" ry="115.167" />
       <circle cx="1431.29" cy="1088.58" r="49.583" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" />
       <ellipse cx="1431.29" cy="1088.58" fill="none" stroke-dasharray="0,9.13" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="4.17px" rx="66.708" ry="66.667" />
      </g>
      <path fill="none" fill-rule="nonzero" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="4.17px" d="M1420.62,1068.04l0,41.041l30.208,-20.5l-30.208,-20.541Z" />
     </g>
    </g>
    <g class="beetroot-cog">
     <g stroke-width="8.33px">
      <circle cx="1306.29" cy="1121.92" r="86.625" fill="#fff8ec" stroke="#9da2a7" />
      <path fill="#ffa18f" fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1312.79,1087.04c0.8,3.538 3.971,6.072 7.599,6.072c1.469,0 2.908,-0.415 4.151,-1.197c1.249,-0.802 2.702,-1.228 4.186,-1.228c4.251,-0 7.75,3.498 7.75,7.75c-0,1.484 -0.426,2.937 -1.228,4.186c-0.787,1.241 -1.205,2.68 -1.205,4.15c0,3.608 2.52,6.761 6.038,7.558c3.505,0.828 6.002,3.982 6.002,7.584c0,3.601 -2.497,6.756 -6.002,7.583c-3.518,0.797 -6.038,3.951 -6.038,7.559c0,1.469 0.418,2.908 1.205,4.149c0.802,1.249 1.228,2.703 1.228,4.187c-0,4.251 -3.499,7.75 -7.75,7.75c-1.484,-0 -2.937,-0.427 -4.186,-1.228c-1.245,-0.786 -2.687,-1.203 -4.159,-1.203c-3.614,0 -6.777,2.515 -7.591,6.036c-0.791,3.527 -3.948,6.056 -7.563,6.056c-3.614,-0 -6.772,-2.529 -7.562,-6.056c-0.797,-3.519 -3.951,-6.038 -7.559,-6.038c-1.469,0 -2.909,0.418 -4.15,1.205c-1.236,0.771 -2.665,1.179 -4.122,1.179c-4.274,0 -7.791,-3.517 -7.791,-7.791c-0,-1.447 0.403,-2.866 1.163,-4.097c0.803,-1.245 1.231,-2.696 1.231,-4.177c-0,-3.61 -2.537,-6.761 -6.064,-7.531c-3.505,-0.827 -6.002,-3.982 -6.002,-7.583c0,-3.602 2.497,-6.756 6.002,-7.584c3.519,-0.797 6.038,-3.95 6.038,-7.558c-0,-1.47 -0.418,-2.909 -1.205,-4.15c-0.76,-1.231 -1.163,-2.649 -1.163,-4.096c-0,-4.275 3.517,-7.792 7.791,-7.792c1.457,0 2.886,0.409 4.122,1.18c1.235,0.767 2.66,1.174 4.114,1.174c3.62,0 6.785,-2.522 7.595,-6.049c0.79,-3.527 3.948,-6.056 7.562,-6.056c3.615,0 6.772,2.529 7.563,6.056Z" />
     </g>
    </g>
    <g class="salad-leaf-05">
     <g fill-rule="nonzero" stroke="#548f9c" stroke-linecap="round">
      <path fill="#92cac4" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1069.75,1068.62c0,0 6.208,-63.667 42.083,-30.833c23.625,21.666 32,58.333 34.584,43.958c8.958,-49.208 56.041,-47.417 62.5,-8.333c6.458,39.083 -3.75,70.291 4.166,67.416c0,0 6.792,-43.416 35.625,-40.791c20.584,1.875 30.75,16.375 22.625,66.25c-8.125,49.875 -3.083,66.291 17.5,83.583c-20.583,-17.292 -40.291,-16.292 -88,0.333c-47.708,16.625 -63.75,9.084 -69.166,-10.875c-4.5,-16.666 12.708,-29.375 27.208,-36.75c1.161,-0.623 1.887,-1.839 1.887,-3.156c0,-1.966 -1.617,-3.584 -3.583,-3.584c-0.242,0 -0.484,0.025 -0.721,0.074c-18.91,4.99 -38.296,7.965 -57.833,8.875c-39.583,0.5 -49.417,-45.584 -2.542,-62.875c13.625,-5 -23.833,-6.959 -49.208,-26.542c-38.542,-29.667 22.875,-46.75 22.875,-46.75Z" />
      <path fill="none" stroke-width="4.17px" d="M1090.79,1085.79c43.666,18.125 122.708,65.083 194.958,161.625" />
     </g>
    </g>
    <g class="chips-front" stroke-width="8.33px">
     <path fill="#ffe895" stroke="#f4cd7f" d="M727.435,891.238c-1.74,-4.133 -6.508,-6.076 -10.641,-4.336l-16.168,6.806c-4.133,1.74 -6.076,6.508 -4.336,10.641l121.314,288.173c1.74,4.133 6.508,6.076 10.641,4.336l16.168,-6.806c4.133,-1.74 6.076,-6.508 4.336,-10.641l-121.314,-288.173Z" />
     <path fill="#ffca6c" stroke="#ffe895" d="M723.777,997.22c-2.242,-3.884 -7.215,-5.216 -11.099,-2.974l-15.191,8.771c-3.884,2.242 -5.216,7.215 -2.974,11.099l156.333,270.777c2.242,3.884 7.216,5.216 11.099,2.974l15.192,-8.771c3.883,-2.242 5.216,-7.215 2.974,-11.099l-156.334,-270.777Z" />
     <path fill="#ffe895" stroke="#f4cd7f" d="M615.745,1006.61c-3.311,-3.024 -8.454,-2.79 -11.478,0.521l-11.829,12.954c-3.023,3.312 -2.79,8.455 0.522,11.479l230.89,210.832c3.312,3.023 8.455,2.79 11.479,-0.522l11.828,-12.953c3.024,-3.312 2.79,-8.455 -0.521,-11.479l-230.891,-210.832Z" />
     <path fill="#ffe895" stroke="#f4cd7f" d="M943.907,952.539c0.502,-4.456 -2.708,-8.482 -7.164,-8.984l-17.431,-1.964c-4.456,-0.502 -8.482,2.708 -8.984,7.164l-35.015,310.7c-0.503,4.456 2.708,8.481 7.164,8.983l17.431,1.965c4.456,0.502 8.482,-2.708 8.984,-7.164l35.015,-310.7Z" />
     <path fill="#ffe895" stroke="#f4cd7f" d="M805.071,934.174c-1.182,-4.326 -5.654,-6.878 -9.979,-5.697l-16.922,4.623c-4.326,1.182 -6.878,5.654 -5.696,9.979l82.399,301.614c1.181,4.326 5.653,6.878 9.979,5.697l16.921,-4.623c4.326,-1.182 6.878,-5.653 5.697,-9.979l-82.399,-301.614Z" />
     <path fill="#ffca6c" stroke="#ffe895" d="M700.002,1049.49c-2.963,-3.366 -8.102,-3.693 -11.467,-0.73l-13.167,11.592c-3.365,2.963 -3.692,8.101 -0.729,11.467l206.606,234.679c2.963,3.366 8.102,3.693 11.468,0.73l13.166,-11.592c3.366,-2.963 3.693,-8.101 0.729,-11.467l-206.606,-234.679Z" />
     <path fill="#ffe895" stroke="#f4cd7f" d="M630.864,1063.28c-3.517,-2.783 -8.631,-2.188 -11.414,1.329l-10.886,13.755c-2.783,3.516 -2.188,8.63 1.329,11.413l245.17,194.041c3.516,2.783 8.63,2.188 11.413,-1.329l10.887,-13.755c2.783,-3.516 2.187,-8.63 -1.329,-11.413l-245.17,-194.041Z" />
    </g>
    <g stroke="#82cdb2" stroke-width="8.33px">
     <path fill="#0d242f" fill-rule="nonzero" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M707.667,1167.79c67.99,248.676 295.633,422.435 553.437,422.435c257.804,0 485.447,-173.759 553.438,-422.435l-1106.88,-0Z" />
     <path fill="none" fill-rule="nonzero" d="M1814.54,1167.79c-6.042,0.5 -738.292,16.666 -843.292,342.083" />
     <rect width="405" height="57.833" x="1057.33" y="1554.75" fill="#0d242f" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" />
     <path fill="none" fill-rule="nonzero" d="M1084.92,1555.71l-0,56.084" />
     <path fill="none" fill-rule="nonzero" d="M1110.62,1555.71l0,56.084" />
     <path fill="none" fill-rule="nonzero" d="M1125.21,1555.71l0,56.084" />
     <path fill="none" fill-rule="nonzero" d="M1140.38,1555.71l0,56.084" />
     <g class="symbol-3">
      <ellipse cx="1260.21" cy="1362.42" fill="#0d242f" rx="118.292" ry="118.25" />
      <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1195.44,1318.11c20.234,-17.064 56.919,-6.896 81.869,22.691c24.95,29.588 28.779,67.462 8.544,84.526c-20.235,17.063 -56.919,6.895 -81.869,-22.692c-24.951,-29.588 -28.779,-67.462 -8.544,-84.525Z" />
      <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1244.21,1340.79c24.951,-29.588 61.635,-39.755 81.87,-22.692c20.235,17.063 16.406,54.938 -8.544,84.525c-24.95,29.588 -61.635,39.755 -81.869,22.692c-20.235,-17.063 -16.407,-54.938 8.543,-84.525Z" />
     </g>
    </g>
    <g class="peppers" fill-rule="nonzero" stroke-width="8.33px">
     <path fill="#c9bde0" stroke="#9683ba" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1087.96,258.708c-18.706,-12.313 -43.358,-11.234 -60.916,2.667c-8.304,-5.129 -17.873,-7.846 -27.633,-7.846c-28.846,0 -52.583,23.737 -52.583,52.584c-0,6.054 1.045,12.063 3.091,17.762c-11.918,9.977 -18.814,24.745 -18.814,40.287c-0,28.824 23.718,52.542 52.541,52.542c0.661,0 1.321,-0.012 1.981,-0.037c6.162,15.384 19.32,26.931 35.375,31.041c16.244,4.106 33.507,0.319 46.542,-10.208c8.319,-6.785 14.357,-15.965 17.291,-26.292c10.667,-0.734 20.853,-4.736 29.167,-11.458c12.886,-10.596 20.056,-26.666 19.333,-43.333c-0.697,-16.58 -9.285,-31.864 -23.083,-41.084c5.542,-21.651 -3.478,-44.562 -22.292,-56.625Zm-3.041,50.375c-2.58,10.686 1.79,21.913 10.916,28.042c7.211,4.897 11.539,13.068 11.539,21.785c0,13.691 -10.678,25.215 -24.33,26.257c-11.017,0.752 -20.434,8.379 -23.459,19c-3.223,11.242 -13.578,19.046 -25.273,19.046c-10.671,-0 -20.329,-6.497 -24.352,-16.38c-4.155,-10.172 -14.268,-16.714 -25.25,-16.333c-0.294,0.01 -0.588,0.015 -0.883,0.015c-14.423,-0 -26.291,-11.869 -26.291,-26.292c-0,-7.744 3.421,-15.105 9.341,-20.098c8.42,-7.121 11.525,-18.805 7.75,-29.167c-1.052,-2.885 -1.59,-5.933 -1.59,-9.005c-0,-14.423 11.868,-26.292 26.291,-26.292c4.906,0 9.716,1.374 13.882,3.964c9.325,5.787 21.336,5.153 30,-1.583c4.622,-3.612 10.323,-5.576 16.189,-5.576c14.423,0 26.292,11.869 26.292,26.292c-0,2.132 -0.259,4.256 -0.772,6.325Z" />
     <path fill="#ffe895" stroke="#f4cd7f" d="M1412.96,483.708c-18.706,-12.313 -43.358,-11.234 -60.916,2.667c-8.304,-5.129 -17.873,-7.846 -27.633,-7.846c-28.846,0 -52.583,23.737 -52.583,52.584c-0,6.054 1.045,12.063 3.091,17.762c-11.918,9.977 -18.814,24.745 -18.814,40.287c-0,28.824 23.718,52.542 52.541,52.542c0.661,0 1.321,-0.012 1.981,-0.037c6.162,15.384 19.32,26.931 35.375,31.041c16.244,4.106 33.507,0.319 46.542,-10.208c8.319,-6.785 14.357,-15.965 17.291,-26.292c10.667,-0.734 20.853,-4.736 29.167,-11.458c12.886,-10.596 20.056,-26.666 19.333,-43.333c-0.697,-16.58 -9.285,-31.864 -23.083,-41.084c5.542,-21.651 -3.478,-44.562 -22.292,-56.625Zm-3.041,50.375c-2.606,10.66 1.712,21.88 10.791,28.042c7.211,4.897 11.539,13.068 11.539,21.785c0,13.691 -10.678,25.215 -24.33,26.257c-10.948,0.791 -20.296,8.369 -23.334,18.916c-3.223,11.243 -13.578,19.046 -25.273,19.046c-10.671,0 -20.329,-6.496 -24.352,-16.379c-4.155,-10.172 -14.268,-16.714 -25.25,-16.333c-0.294,0.01 -0.588,0.014 -0.883,0.014c-14.423,0 -26.291,-11.868 -26.291,-26.291c-0,-7.744 3.421,-15.106 9.341,-20.098c8.42,-7.122 11.525,-18.805 7.75,-29.167c-1.052,-2.886 -1.59,-5.934 -1.59,-9.005c-0,-14.423 11.868,-26.292 26.291,-26.292c4.906,0 9.716,1.373 13.882,3.964c9.325,5.786 21.336,5.152 30,-1.584c4.627,-3.624 10.338,-5.595 16.215,-5.595c14.423,-0 26.292,11.868 26.292,26.292c-0,2.167 -0.268,4.327 -0.798,6.428Z" />
     <path fill="#bfe6c7" stroke="#82cdb2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1899.54,582.792c-13.378,-8.814 -31.012,-8.056 -43.584,1.875c-5.996,-3.793 -12.948,-5.807 -20.044,-5.807c-20.572,0 -37.5,16.928 -37.5,37.5c0,4.487 0.806,8.938 2.378,13.14c-8.588,7.12 -13.565,17.713 -13.565,28.868c0,20.572 16.928,37.5 37.5,37.5c0.536,-0 1.071,-0.012 1.606,-0.035c4.414,11.004 13.841,19.253 25.334,22.167c19.69,5.302 40.281,-6.379 45.833,-26c7.631,-0.586 14.903,-3.495 20.833,-8.333c9.254,-7.593 14.402,-19.125 13.875,-31.084c-0.607,-11.808 -6.801,-22.648 -16.666,-29.166c3.997,-15.536 -2.483,-31.988 -16,-40.625Zm-2.167,36.041c-1.859,7.617 1.224,15.634 7.708,20.042c5.169,3.501 8.272,9.351 8.272,15.593c0,9.807 -7.659,18.056 -17.438,18.782c-7.828,0.569 -14.507,5.996 -16.667,13.542c-2.339,8.009 -9.734,13.554 -18.078,13.554c-7.623,-0 -14.526,-4.628 -17.422,-11.679c-3.001,-7.242 -10.206,-11.902 -18.042,-11.667c-0.264,0.011 -0.528,0.017 -0.793,0.017c-10.332,-0 -18.833,-8.502 -18.833,-18.834c-0,-5.612 2.509,-10.941 6.835,-14.516c6.007,-5.091 8.225,-13.431 5.541,-20.834c-0.755,-2.066 -1.141,-4.249 -1.141,-6.449c0,-10.309 8.483,-18.791 18.792,-18.791c3.527,-0 6.985,0.993 9.974,2.865c6.68,4.122 15.266,3.655 21.459,-1.166c3.311,-2.588 7.394,-3.994 11.596,-3.994c10.332,0 18.833,8.502 18.833,18.833c0,1.587 -0.2,3.166 -0.596,4.702Z" />
     <path fill="#ffa18f" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M930.833,603.042c-13.617,-8.988 -31.583,-8.212 -44.375,1.916c-6.059,-3.757 -13.049,-5.748 -20.179,-5.748c-21.006,-0 -38.291,17.285 -38.291,38.292c-0,4.461 0.779,8.888 2.304,13.081c-8.579,7.28 -13.532,17.978 -13.532,29.229c0,21.029 17.305,38.333 38.334,38.333c0.413,0 0.826,-0.007 1.239,-0.02c4.469,11.207 14.056,19.615 25.75,22.583c11.807,3.041 24.383,0.319 33.875,-7.333c6.026,-4.961 10.39,-11.652 12.5,-19.167c7.784,-0.526 15.219,-3.436 21.292,-8.333c9.451,-7.72 14.71,-19.476 14.167,-31.667c-0.486,-12.044 -6.681,-23.165 -16.667,-29.916c4.008,-15.812 -2.64,-32.517 -16.417,-41.25Zm-2.208,36.708c-1.883,7.764 1.266,15.928 7.875,20.417c5.272,3.56 8.44,9.522 8.44,15.884c0,9.989 -7.81,18.39 -17.773,19.116c-7.979,0.577 -14.79,6.103 -17,13.791c-2.36,8.181 -9.902,13.854 -18.416,13.854c-7.778,0 -14.817,-4.734 -17.751,-11.937c-3.012,-7.416 -10.375,-12.191 -18.375,-11.917c-0.23,0.009 -0.461,0.013 -0.691,0.013c-10.492,-0 -19.125,-8.634 -19.125,-19.125c-0,-5.643 2.497,-11.006 6.816,-14.638c6.098,-5.175 8.363,-13.636 5.667,-21.166c-0.756,-2.09 -1.143,-4.296 -1.143,-6.519c0,-10.514 8.652,-19.166 19.167,-19.166c3.552,-0 7.035,0.987 10.059,2.851c6.798,4.23 15.565,3.762 21.875,-1.166c3.363,-2.614 7.503,-4.034 11.762,-4.034c10.515,-0 19.167,8.652 19.167,19.167c0,1.541 -0.186,3.078 -0.554,4.575Z" />
    </g>
   </g>
   <g class="carrot">
    <g>
     <g fill-rule="nonzero">
      <g>
       <path fill="#ffca6c" stroke="#c29c87" stroke-width="8.33px" d="M1553.58,1509.88c66.959,-31.625 119.834,-4.917 129.875,20c10.459,25.875 -9.041,76.083 -62,97.458c-52.958,21.375 -193.708,51.334 -209.541,12.084c-15.834,-39.25 90,-105.125 141.666,-129.542Z" />
       <path fill="none" stroke="#c29c87" stroke-width="8.33px" d="M1553.58,1509.88c0,0 -39.416,106.417 67.875,117.458" />
       <path fill="none" stroke="#c29c87" stroke-width="8.33px" d="M1503.62,1537.5c-6.167,22.083 -20.833,93.542 55.917,108.667" />
       <path fill="none" stroke="#c29c87" stroke-width="8.33px" d="M1452.38,1573.5c-4.167,24.792 -3.75,64.667 33.333,84.625" />
       <g stroke="#548f9c" stroke-linecap="round">
        <path fill="#92cac4" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1834.08,1489c0,0 32.292,26.25 1.625,33.917c-20.25,5.041 -43.083,-3.542 -36.291,3c23.5,22.5 5.625,47.416 -17.834,36.833c-23.458,-10.583 -36.791,-27.292 -38.041,-22.042c-0,0 21.083,19.292 9.333,34c-8.333,10.5 -19.958,10.792 -44.083,-11.5c-24.125,-22.291 -34.875,-25.5 -51.625,-20.541c16.666,-4.959 23.291,-16 31.416,-47.834c8.125,-31.833 17.959,-37.875 30.709,-33.625c10.75,3.542 11.375,17.417 10.208,27.959c-0.043,0.177 -0.065,0.359 -0.065,0.541c0,1.259 1.036,2.294 2.294,2.294c1.055,0 1.98,-0.727 2.229,-1.752c4.087,-12.058 9.436,-23.65 15.959,-34.583c13.916,-21.667 42.5,-10.459 35,21.208c-2.167,9.208 12.5,-10.417 32.083,-17.167c29.958,-10.25 17.083,29.292 17.083,29.292Z" />
        <path fill="none" stroke-width="4.17px" d="M1817.21,1494.25c-25.5,17.208 -71.083,39.917 -149.416,44.458" />
       </g>
      </g>
      <path fill="none" stroke="#c29c87" stroke-linecap="round" stroke-width="8.33px" d="M1664.5,1553.29c-3.667,0.958 -8,-3.292 -9.708,-9.584c-1.709,-6.291 -0,-12.125 3.625,-13.125" />
     </g>
    </g>
    <g>
     <g fill-rule="nonzero">
      <g>
       <path fill="#ffca6c" stroke="#c29c87" stroke-width="8.33px" d="M1514.96,1448.54c56.584,-47.75 114.542,-35.542 130.667,-14c16.667,22.291 10.792,75.791 -34.958,110.083c-45.75,34.292 -173.959,99.375 -199.334,65.5c-25.375,-33.875 59.959,-124.708 103.625,-161.583Z" />
       <path fill="none" stroke="#c29c87" stroke-width="8.33px" d="M1514.96,1448.54c0,-0 -10.75,112.958 95.834,96.083" />
       <path fill="none" stroke="#c29c87" stroke-width="8.33px" d="M1473.75,1487.96c-0.292,22.959 3.792,95.834 81.917,90.709" />
       <path fill="none" stroke="#c29c87" stroke-width="8.33px" d="M1433.33,1536c2.459,25 13,63.5 53.834,73.292" />
       <g stroke="#548f9c" stroke-linecap="round">
        <path fill="#92cac4" stroke-linejoin="round" stroke-miterlimit="4" stroke-width="8.33px" d="M1780.67,1356.33c-0,0 37.958,17.042 10.291,32.334c-18.291,10.083 -42.583,7.666 -34.291,12.208c28.458,15.75 17.583,44.417 -7.792,40.167c-25.375,-4.25 -42.583,-16.875 -42.458,-11.459c-0,0 25.375,13.209 17.791,30.417c-5.458,12.5 -16.666,15.583 -45.583,0.208c-28.917,-15.375 -40.25,-15.666 -55.167,-6.583c14.917,-9.083 18.417,-21.458 18.084,-54.167c-0.334,-32.708 7.625,-41.208 20.833,-40.416c11.292,0.708 15.5,13.958 17.042,24.416c-0,1.258 1.034,2.292 2.291,2.292c1.258,-0 2.292,-1.034 2.292,-2.292c0.878,-12.692 3.07,-25.259 6.542,-37.5c7.916,-24.5 38.375,-20.833 39.291,11.5c0.292,9.459 9.25,-13.25 26.584,-25c26.5,-17.666 24.25,23.875 24.25,23.875Z" />
        <path fill="none" stroke-width="4.17px" d="M1765.71,1365.75c-20.25,23.167 -58.333,56.792 -133,81.333" />
       </g>
      </g>
      <path fill="none" stroke="#c29c87" stroke-linecap="round" stroke-width="8.33px" d="M1633.33,1462c-3.291,1.875 -8.583,-1.125 -11.833,-6.75c-3.25,-5.625 -3.167,-11.708 0,-13.625" />
     </g>
    </g>
   </g>
   <g class="wine">
    <g>
     <clipPath id="wineClip">
      <path d="M378.167,1392c22.257,0.162 44.316,-4.205 64.833,-12.833c72.805,-31.269 120.243,-103.223 120.292,-182.459c-0,-99.041 -61.709,-199.416 -64.334,-203.625l-4.166,-6.458l-260.25,0l-4.167,6.458c-2.625,4.167 -64.333,104.584 -64.333,203.625c0.083,79.078 47.334,150.906 119.916,182.292c20.742,8.843 43.078,13.338 65.625,13.208l26.584,-0.208Z" />
     </clipPath>
     <g fill="#ffe895" fill-rule="nonzero" stroke="#f4cd7f" stroke-width="8.33px" clip-path="url(#wineClip)">
      <g class="wine-clip">
       <path opacity="0" class="wine-morph-5" d="M400.24,1185.12c-104.47-63.48-232.39,9-232.39,9a195.2,195.2,0,0,0,117.44,178.69,161.57,161.57,0,0,0,64.34,12.92h25.94a161.27,161.27,0,0,0,63.58-12.77,195.13,195.13,0,0,0,117.94-178.84C557.14,1116.57,504.71,1248.85,400.24,1185.12Z" fill="#ffe895" fill-opacity="0" fill-rule="evenodd" />
       <path opacity="0" class="wine-morph-4" d="M344.36,1200c-117.34-65.46-173.88-9.47-173.88-9.47A195.15,195.15,0,0,0,288,1369.17a161.13,161.13,0,0,0,64.34,12.92H378.3a160.81,160.81,0,0,0,63.53-12.76,195.12,195.12,0,0,0,118-178.84C559.83,1112.82,461.69,1265.37,344.36,1200Z" fill="#ffe895" fill-opacity="0" fill-rule="evenodd" />
       <path opacity="0" class="wine-morph-3" d="M365.84,1217.89c-82.53,34.35-198.24-22.79-198.24-22.79a195.1,195.1,0,0,0,117.53,178.63,162.05,162.05,0,0,0,64.35,13h26.09a160,160,0,0,0,63.53-12.81A195,195,0,0,0,557,1195.1C556.94,1117.23,448.32,1183.39,365.84,1217.89Z" fill="#ffe895" fill-opacity="0" fill-rule="evenodd" />
       <path opacity="0" class="wine-morph-2" d="M292.89,1172.3c-135.17-143.53-122.51,19.5-122.51,19.5A195.2,195.2,0,0,0,288,1370.49a161,161,0,0,0,64.29,12.92H378.2a159.42,159.42,0,0,0,63.58-12.77,195.27,195.27,0,0,0,118-178.84C559.78,1114.14,428.26,1315.47,292.89,1172.3Z" fill="#ffe895" fill-opacity="0" fill-rule="evenodd" />
       <path class="wine-path" d="M428.21,1182.89c-131.73,132.38-261.88,8.91-261.88,8.91a195.16,195.16,0,0,0,117.54,178.69,161.23,161.23,0,0,0,64.34,12.92h25.94a159,159,0,0,0,63.53-12.77A195.09,195.09,0,0,0,555.62,1191.8C555.67,1114.14,559.78,1050.71,428.21,1182.89Z" fill="#ffe895" stroke="#f4cd7f" stroke-miterlimit="1.93" stroke-width="8.16" fill-rule="evenodd" />
      </g>
     </g>
    </g>
    <path fill="#0d242f" fill-rule="nonzero" stroke="#fff8ec" stroke-linecap="round" stroke-width="8.33px" d="M472.542,1588.21l-100,0l-0,-202.541l-20.834,-0l0,202.541l-100,0c-5.714,0 -10.416,4.703 -10.416,10.417c-0,5.714 4.702,10.417 10.416,10.417l220.834,-0c5.714,-0 10.416,-4.703 10.416,-10.417c0,-5.714 -4.702,-10.417 -10.416,-10.417Z" />
    <path fill="none" fill-rule="nonzero" stroke="#fff8ec" stroke-linecap="round" stroke-width="8.33px" d="M375.5,1385.67c22.271,0.095 44.331,-4.342 64.833,-13.042c72.801,-31.259 120.25,-103.189 120.334,-182.417c-0,-99.083 -61.709,-199.458 -64.375,-203.666l-4.167,-6.459l-260.25,0l-4.167,6.459c-2.625,4.166 -64.333,104.583 -64.333,203.666c0.096,79.076 47.366,150.892 119.958,182.25c20.743,8.838 43.078,13.334 65.625,13.209l26.542,-0Z" />
   </g>
   <g class="dots" fill="#fff8ec">
    <circle cx="282.833" cy="1200.96" r="12.125" fill="#ffca6c" />
    <circle cx="253.667" cy="1042.62" r="12.125" fill="#ffca6c" />
    <circle cx="352.125" cy="1247.75" r="7.208" fill="#ffca6c" />
    <circle cx="255.083" cy="1107.42" r="7.208" fill="#ffca6c" />
    <circle cx="258.583" cy="1246.04" r="8.458" fill="#ffca6c" />
    <circle cx="310.542" cy="1060.83" r="8.458" fill="#ffca6c" />
    <circle cx="223.917" cy="1204.62" r="8.458" fill="#ffca6c" />
    <circle cx="753.042" cy="643.458" r="10.417" />
    <circle cx="1082.21" cy="610.125" r="10.417" />
    <circle cx="1953.04" cy="1076.79" r="10.417" />
    <circle cx="1761.38" cy="285.125" r="10.417" />
    <circle cx="1915.54" cy="1189.29" r="10.417" />
    <circle cx="740.542" cy="764.292" r="10.417" />
    <circle cx="1263.46" cy="687.208" r="8.333" />
    <circle cx="1534.29" cy="258.042" r="8.333" />
    <circle cx="1650.96" cy="328.875" r="8.333" />
    <circle cx="1942.62" cy="987.208" r="8.333" />
    <circle cx="1859.29" cy="1062.21" r="8.333" />
    <circle cx="619.708" cy="680.958" r="6.25" />
    <circle cx="686.375" cy="618.458" r="6.25" />
    <circle cx="2028.04" cy="1001.79" r="6.25" />
    <circle cx="2032.21" cy="1130.96" r="6.25" />
    <circle cx="1182.21" cy="618.458" r="6.25" />
    <circle cx="690.542" cy="526.792" r="6.25" />
    <circle cx="848.875" cy="789.292" r="6.25" />
    <circle cx="1211.38" cy="464.292" r="6.25" />
    <circle cx="1703.04" cy="422.625" r="6.25" />
    <circle cx="1890.54" cy="310.125" r="6.25" />
   </g>
   <g class="sparkles" fill="none" fill-rule="nonzero" stroke="#ffe895" stroke-linecap="round" stroke-width="8.33px">
    <g>
     <path d="M786.5,416.417l0,14.75" />
     <path d="M786.5,462.25l0,14.792" />
     <path d="M816.833,446.708l-14.791,0" />
     <path d="M771,446.708l-14.792,0" />
    </g>
    <g>
     <path d="M1165.67,699.75l-0,14.75" />
     <path d="M1165.67,745.583l-0,14.792" />
     <path d="M1196,730.042l-14.792,-0" />
     <path d="M1150.17,730.042l-14.792,-0" />
    </g>
    <g>
     <path d="M1528.17,349.75l-0,14.75" />
     <path d="M1528.17,395.583l-0,14.792" />
     <path d="M1558.5,380.042l-14.792,-0" />
     <path d="M1512.67,380.042l-14.792,-0" />
    </g>
    <g>
     <path d="M1847.33,395.583l0,7.875" />
     <path d="M1847.33,419.958l0,7.875" />
     <path d="M1863.46,411.708l-7.875,0" />
     <path d="M1839.08,411.708l-7.875,0" />
    </g>
    <g>
     <path d="M580.667,520.583l-0,7.875" />
     <path d="M580.667,544.958l-0,7.875" />
     <path d="M596.792,536.708l-7.875,0" />
     <path d="M572.417,536.708l-7.875,0" />
    </g>
   </g>
  </g>
  
   <g class="arm" stroke-width="8.33px">
   <path fill="#9683ba" fill-rule="nonzero" stroke="#c9bde0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1788.21,2335.38c0,0 875.794,451.96 1492.84,147.565c-0,0 135.867,-300.25 58.67,-422.565c-228.349,-361.81 -1470.97,-52.458 -1470.97,-52.458l-80.542,327.458Z" />
   <path fill="none" fill-rule="nonzero" stroke="#c9bde0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1811.58,2260.88c0,0 53.709,103.958 289.334,154.167" />
   <path fill="none" fill-rule="nonzero" stroke="#c9bde0" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1806.38,2219.29c0,-0 73.875,78 218.333,81.458" />
   <g class="hand" fill-rule="nonzero">
    <path fill="#d9dacb" stroke="#9da2a7" d="M832.083,1718.96c5.209,-7.5 16.667,-12.5 31.917,-15.291c-3.789,-1.104 -7.644,-1.966 -11.542,-2.584c-80.625,-12.5 -119.833,13.542 -115.75,41.125c3.667,25 165.25,63.334 196.459,70.5c-73.834,-36.541 -125.792,-66.5 -101.084,-93.75Z" />
    <path fill="#d9dacb" stroke="#9da2a7" d="M1120.83,1745.83c47.167,19.834 116.667,55.25 168.625,82.584c-28.666,-39.875 -74.291,-88.459 -138.375,-114.459c-78,-31.625 -91.666,-9 -91.666,11c20.882,5.688 41.393,12.659 61.416,20.875Z" />
    <path class="tray" fill="#0d242f" stroke="#fff8ec" stroke-linecap="round" d="M1882.46,1698.71l-1759.88,0c-51.001,-0.01 -96.209,-33.887 -110.541,-82.833l-2,-6.875l1984.96,0l-2,6.875c-14.332,48.946 -59.54,82.823 -110.542,82.833Z" />

    <path fill="#fff8ec" stroke="#9da2a7" d="M1360.79,1866.67c-0,-0 29.583,-133.334 81.125,-170.834c51.541,-37.5 108.666,-44.083 104.541,-2.083c-4.125,42 -20.583,157.833 -20.583,157.833c0,0 57.583,131.667 46.333,170.834l173.834,29.166l-85.334,228.25c0,0 -253.166,-38.666 -380.75,-209.708c0,0 -89.083,-119.375 -204.708,-184.833c-128.167,-72.792 -282.458,-123.042 -243.167,-166.334c25.334,-36.458 193.792,-13.125 288.834,26.792c84.416,35.458 239.875,120.917 239.875,120.917Z" />
   </g>
   <path fill="#ffa18f" fill-rule="nonzero" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="M1566.33,2286.71l244.125,76.125l80.834,-360.083l-247.792,20.792l-77.167,263.166Z" />
   <g class="symbol-4" stroke="#ee7868" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4">
    <path fill="#ffa18f" d="M1660.28,2240.39c5.088,-28.221 32.131,-47.003 60.352,-41.915c28.222,5.088 47.003,32.132 41.915,60.353c-5.088,28.222 -32.131,47.003 -60.352,41.915c-28.222,-5.088 -47.003,-32.131 -41.915,-60.353Z" />
    <path fill="#ffa18f" d="M1686.86,2225.33c10.085,-5.804 25.155,1.443 33.632,16.172c8.477,14.73 7.17,31.4 -2.915,37.204c-10.085,5.804 -25.155,-1.442 -33.632,-16.172c-8.477,-14.729 -7.17,-31.4 2.915,-37.204Z" />
    <path fill="none" d="M1706.18,2238.62c13.085,-10.844 29.737,-12.374 37.162,-3.414c7.425,8.959 2.829,25.037 -10.255,35.881c-13.085,10.844 -29.737,12.374 -37.162,3.415c-7.425,-8.96 -2.83,-25.038 10.255,-35.882Z" />
   </g>
  </g>
  </g>
</svg>
`;
    // </cursed soup>
    if (currentTime < 12) container.innerHTML = breakfastMarkup;
    else if (currentTime < 18) container.innerHTML = lunchMarkup;
    else container.innerHTML = dinnerMarkup;
}
function $74cf6679aa998d5b$var$AnimMeal(toggle) {
    const animContainer = document.querySelector(".anim-inject");
    const header = document.querySelector("#header");
    if (!animContainer) return;
    const today = new Date();
    const currentTime = today.getHours();
    let mm = (0, $4dab17958b7cdb31$export$99ee26438460406a).matchMedia();
    mm.add({
        animIsOk: "(prefers-reduced-motion: no-preference)",
        animReduced: "(prefers-reduced-motion: reduce)"
    }, ()=>{
        if (toggle.checked === false) return;
        let master = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            delay: 0.5,
            onStart: ()=>{
                (0, $4dab17958b7cdb31$export$99ee26438460406a).to(header, {
                    zIndex: 0
                });
            }
        });
        function entranceTl() {
            let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline();
            tl.from(".meals-all", {
                xPercent: 100,
                duration: 2,
                rotation: 10,
                transformOrigin: "bottom right",
                ease: "back.out"
            }).from(".hand", {
                duration: 2,
                rotation: 30,
                transformOrigin: "bottom right",
                ease: "back.out"
            }, 0).from(".tray", {
                duration: 1.5,
                rotation: 5,
                transformOrigin: "15% bottom",
                ease: "back.out"
            }, 0).from(".meal", {
                duration: 2,
                rotation: 30,
                xPercent: 35,
                transformOrigin: "bottom right",
                ease: "back.out"
            }, 0);
            return tl;
        }
        function breakfastTl() {
            let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline();
            tl.from(".mug, .avocado, .bowl", {
                rotation: 15,
                xPercent: 30,
                transformOrigin: "bottom right",
                ease: "back.out(2)",
                duration: 1.5
            }).from(".cookie", {
                rotation: 500,
                xPercent: 400,
                yPercent: 10,
                transformOrigin: "center",
                ease: "elastic.out(0.7, 0.3)",
                duration: 6
            }, "<").from(".teabag", {
                rotation: -45,
                transformOrigin: "top center",
                ease: "elastic.out(2.5, 0.2)",
                duration: 8
            }, "<").from(".inner-avo", {
                rotation: 45,
                transformOrigin: "center 80%",
                ease: "elastic.out(1, 0.2)",
                duration: 8
            }, "<").from(".spoon", {
                opacity: 0,
                y: -3500,
                rotation: -300,
                duration: 1.5,
                ease: "back.out(1)",
                transformOrigin: "center 80%"
            }, 1).from(".granola > *", {
                duration: 1,
                stagger: 0.1,
                opacity: 0
            }, 1.5).from(".a-sr", {
                y: "random([-1000, -700, -500])",
                duration: 1,
                stagger: 0.1,
                opacity: 0,
                transformOrigin: "center center"
            }, 1.5).from(".berries > *", {
                rotation: "random([-360, -360])",
                y: -3000,
                duration: 3,
                stagger: 0.1,
                ease: "back.out(1)",
                transformOrigin: "center center"
            }, 0).from(".white-dots > * ", {
                stagger: {
                    from: "random",
                    each: 0.1
                },
                opacity: 0,
                y: -300,
                duration: 1
            }, "<");
            return tl;
        }
        function lunchTl() {
            let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline();
            tl.from(".bowl, .bottle", {
                rotation: 15,
                xPercent: 30,
                transformOrigin: "bottom right",
                ease: "back.out(2)",
                duration: 1.5
            }).from(".chicken", {
                rotation: 20,
                transformOrigin: "center bottom",
                ease: "elastic.out(1, 0.2)",
                duration: 6,
                stagger: 0.2
            }, "<").from(".salt, .egg", {
                rotation: 50,
                transformOrigin: "center bottom",
                ease: "elastic.out(1, 0.2)",
                duration: 6
            }, "<").from(".prawn-1, .prawn-2", {
                rotation: 20,
                transformOrigin: "center bottom",
                ease: "elastic.out(1, 0.2)",
                duration: 8,
                stagger: 0.3
            }, "<").from(".asparagus, .pencil", {
                opacity: 0,
                y: -3500,
                rotation: "random([-100, 100, -200, 200])",
                duration: 1.5,
                ease: "back.out(1)",
                stagger: 0.2,
                transformOrigin: "center 80%"
            }, 1).from(".dots > *", {
                duration: 1,
                stagger: 0.1,
                opacity: 0
            }, 1.5).from(".mushrooms > *", {
                rotation: "random([-360, -360, -200, 200])",
                y: "random([-1000, -700, -500])",
                duration: 1,
                stagger: 0.1,
                opacity: 0,
                transformOrigin: "center center"
            }, 1.5).from(".leaves > *", {
                rotation: "random([-360, -360])",
                y: -3000,
                duration: 3,
                stagger: 0.1,
                ease: "back.out(1)",
                transformOrigin: "center center"
            }, 0).from(".sparkles > * ", {
                stagger: {
                    from: "random",
                    each: 0.1
                },
                opacity: 0,
                y: -300,
                duration: 1
            }, "<").to(".antennae", {
                rotation: 10,
                transformOrigin: "bottom bottom",
                ease: "wiggle(6)",
                duration: 6,
                stagger: 0.2
            }, 2);
            return tl;
        }
        function dinnerTl() {
            (0, $4dab17958b7cdb31$export$99ee26438460406a).set(".wine-clip", {
                scale: 1.3,
                transformOrigin: "center center"
            });
            let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline().timeScale(0.8);
            tl.from(".wine", {
                rotation: 5,
                transformOrigin: "bottom right",
                ease: "elastic.out(1, 0.2)",
                duration: 6
            }).to(".wine-path", {
                keyframes: {
                    morphSVG: [
                        ".wine-path",
                        ".wine-morph-2",
                        ".wine-morph-3",
                        ".wine-morph-4",
                        ".wine-morph-5"
                    ],
                    easeEach: "none",
                    ease: "none"
                },
                duration: 2,
                ease: "power2.out"
            }, "<").from(".peppers > *", {
                rotation: "random([-360, -360])",
                y: -3000,
                x: 300,
                duration: 2,
                stagger: 0.3,
                ease: "back.out(0.2)",
                transformOrigin: "center center"
            }, 0).to(".left-arm", {
                rotation: 15,
                transformOrigin: "bottom 10%",
                duration: 0.5,
                repeat: 1,
                ease: "expo.inOut",
                yoyo: true
            }, 1.5).to(".right-arm", {
                rotation: -15,
                transformOrigin: "bottom left",
                duration: 0.5,
                repeat: 1,
                ease: "expo.inOut",
                yoyo: true
            }, "<").to(".pincher-1", {
                rotation: 30,
                transformOrigin: "50% 90%",
                duration: 0.15,
                repeat: 7,
                ease: "expo.inOut",
                yoyo: true
            }, "<").to(".pincher-2", {
                rotation: -35,
                transformOrigin: "10% 60%",
                duration: 0.15,
                repeat: 7,
                ease: "expo.inOut",
                yoyo: true
            }, "<").to(".pincher-3", {
                rotation: -35,
                transformOrigin: "10% 60%",
                duration: 0.2,
                repeat: 5,
                ease: "expo.inOut",
                yoyo: true
            }, "<").to(".pincher-4", {
                rotation: 30,
                transformOrigin: "50% 90%",
                duration: 0.2,
                repeat: 5,
                ease: "expo.inOut",
                yoyo: true
            }, "<").from(".sparkles > * ", {
                stagger: {
                    from: "random",
                    each: 0.1
                },
                opacity: 0,
                y: -300,
                duration: 1
            }, "<").from(".dots > * ", {
                duration: 0.5,
                stagger: {
                    from: "random",
                    each: 0.05
                },
                opacity: 0
            }, 1).from(".tentacle", {
                yPercent: 10,
                xPercent: 10,
                rotation: 5,
                transformOrigin: "bottom center",
                scale: 0.7,
                duration: 1
            }, 0.2).from(".octopus", {
                yPercent: 10,
                xPercent: -10,
                rotation: -5,
                transformOrigin: "bottom center",
                scale: 0.7,
                duration: 1
            }, 0.5);
            return tl;
        }
        master.add(entranceTl(), 0).timeScale(1.4).add(()=>{
            (0, $4dab17958b7cdb31$export$99ee26438460406a).to(header, {
                zIndex: 50
            });
        }, 3);
        if (currentTime < 12) master.add(breakfastTl(), 0.5);
        else if (currentTime < 18) master.add(lunchTl(), 0.5);
        else master.add(dinnerTl(), 0.5);
    }, ".anim-meals");
}
$74cf6679aa998d5b$exports = {
    InjectMeal: $74cf6679aa998d5b$var$InjectMeal,
    AnimMeal: $74cf6679aa998d5b$var$AnimMeal
};




(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930));
function $0667e1704423b6ac$var$AnimPasta(toggle) {
    const animContainer = document.querySelector(".anim-pasta");
    if (!animContainer) return;
    let mm = (0, $4dab17958b7cdb31$export$99ee26438460406a).matchMedia();
    mm.add({
        animIsOk: "(prefers-reduced-motion: no-preference)",
        animReduced: "(prefers-reduced-motion: reduce)"
    }, ()=>{
        if (toggle.checked === false) return;
        let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            defaults: {
                duration: 1
            },
            scrollTrigger: {
                trigger: animContainer,
                start: "80% bottom"
            }
        });
        tl.from(".arm", {
            xPercent: 100,
            ease: "back.out",
            rotation: -10,
            transformOrigin: "center right"
        }).from(".hand", {
            ease: "back.out",
            rotation: -10,
            transformOrigin: "center right"
        }, 0.2).from(".falling > *", {
            rotation: "random([-360, -360])",
            y: -700,
            opacity: 0,
            duration: 1,
            stagger: {
                from: "random",
                amount: 1
            },
            ease: "back.out(0.7)",
            transformOrigin: "center center"
        }, 0).from(".peas-dots > *", {
            y: -100,
            opacity: 0,
            duration: 1,
            stagger: {
                from: "random",
                amount: 1
            }
        }, 0).from(".pasta", {
            y: -700,
            opacity: 0,
            duration: 0.2
        }, 1).to(".hand, .arm", {
            ease: "back.out",
            keyframes: {
                rotation: [
                    0,
                    -5,
                    0
                ]
            },
            duration: 1.2,
            ease: "back.out",
            transformOrigin: "center right"
        }, 1.17);
        tl.timeScale(0.9);
    }, animContainer);
}
var $0667e1704423b6ac$export$2e2bcd8739ae039 = $0667e1704423b6ac$var$AnimPasta;




(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930));
function $483355d9ef926385$var$AnimBite() {
    const animContainer = document.querySelector(".anim-bite");
    if (!animContainer) return;
    let mm = (0, $4dab17958b7cdb31$export$99ee26438460406a).matchMedia();
    mm.add({
        animIsOk: "(prefers-reduced-motion: no-preference)"
    }, ()=>{
        (0, $4dab17958b7cdb31$export$99ee26438460406a).set(".fooditem", {
            opacity: 0
        });
        let buffet = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.toArray(".fooditem");
        let snack = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.random(buffet);
        let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            scrollTrigger: {
                trigger: animContainer,
                start: "center 80%"
            }
        });
        tl.from(".sparks > *", {
            opacity: 0,
            duration: 0.3,
            scale: 0.2,
            transformOrigin: "center",
            stagger: 0.2
        }).to(snack, {
            opacity: 1,
            duration: 0.6
        }, "<").from(".munch", {
            opacity: 0,
            duration: 0.01,
            stagger: 0.4
        }, "-=0.2");
    }, animContainer);
}
var $483355d9ef926385$export$2e2bcd8739ae039 = $483355d9ef926385$var$AnimBite;




(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930));
function $cda0215900937868$var$AnimNoodles(toggle) {
    const animContainer = document.querySelector(".anim-noodles");
    if (!animContainer) return;
    let mm = (0, $4dab17958b7cdb31$export$99ee26438460406a).matchMedia();
    mm.add({
        animIsOk: "(prefers-reduced-motion: no-preference)",
        animReduced: "(prefers-reduced-motion: reduce)"
    }, ()=>{
        if (toggle.checked === false) return;
        let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            defaults: {
                duration: 1
            },
            scrollTrigger: {
                trigger: animContainer,
                start: "top 80%"
            }
        });
        (0, $4dab17958b7cdb31$export$99ee26438460406a).set(".chopstick", {
            rotation: 30,
            y: -300,
            x: 600,
            transformOrigin: "center left"
        });
        (0, $4dab17958b7cdb31$export$99ee26438460406a).set(".noodle", {
            x: 300,
            y: 300
        });
        tl.add(noodleTl().timeScale(0.7)).from(".peas-dots > *", {
            opacity: 0,
            duration: 1.2,
            stagger: {
                from: "random",
                amount: 1
            }
        }, 1.5).from(".falling > *", {
            rotation: "random([-360, -360])",
            y: -700,
            opacity: 0,
            duration: 1,
            stagger: {
                from: "random",
                amount: 1
            },
            ease: "back.out(0.7)",
            transformOrigin: "center center"
        }, 2).from(".sparks > *", {
            y: -100,
            opacity: 0,
            duration: 1.2,
            stagger: {
                from: "random",
                amount: 1
            }
        }, 0.5);
        function noodleTl() {
            let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
                defaults: {
                    ease: "sine.out",
                    duration: 0.33
                }
            });
            tl.to(".chopstick", {
                rotation: 0,
                x: 100,
                y: 100
            }).to(".noodle, .chopstick", {
                x: "-=100",
                y: "-=100"
            }).to(".chopstick", {
                rotation: 15,
                transformOrigin: "center left"
            }, "<").to(".chopstick", {
                rotation: 0,
                y: 80,
                ease: "sine.inOut"
            }).to(".chopstick", {
                x: 80,
                ease: "circ.out"
            }, "<").to(".noodle, .chopstick", {
                x: "-=100",
                y: "-=100"
            }).to(".chopstick", {
                rotation: 15,
                transformOrigin: "center left"
            }, "<").to(".chopstick", {
                y: 40,
                rotation: 0,
                ease: "sine.inOut"
            }).to(".chopstick", {
                x: 40,
                ease: "circ.out"
            }, "<").to(".chopstick", {
                x: "-=100",
                y: "-=100",
                duration: 1
            }).to(".chopstick", {
                rotation: 15,
                transformOrigin: "center left"
            }, "<").to(".noodle", {
                x: 0,
                y: 0,
                duration: 1
            }, "<").to(".chopstick", {
                rotation: 0,
                x: 0,
                y: 0,
                ease: "back.out",
                duration: 1
            });
            return tl;
        }
    }, animContainer);
}
var $cda0215900937868$export$2e2bcd8739ae039 = $cda0215900937868$var$AnimNoodles;




(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $ab59d772409cf5f3$export$875bcbe48555930));
function $13a03c8cafd868ec$var$AnimCatch() {
    const animContainer = document.querySelector(".anim-chopsticks");
    if (!animContainer) return;
    let mm = (0, $4dab17958b7cdb31$export$99ee26438460406a).matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", ()=>{
        let tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            defaults: {
                duration: 1
            },
            scrollTrigger: {
                trigger: animContainer,
                // markers: true,
                start: "top 80%"
            }
        });
        tl.from(".chopstick", {
            xPercent: 100,
            yPercent: -100,
            ease: "back.out",
            rotation: -30,
            transformOrigin: "center right"
        }).from(".falling > *", {
            rotation: "random([-360, -360])",
            y: -700,
            opacity: 0,
            duration: 1,
            stagger: {
                from: "random",
                amount: 1
            },
            ease: "back.out(0.7)",
            transformOrigin: "center center"
        }, 0).from(".fishcake", {
            rotation: 700,
            y: -700,
            opacity: 0,
            duration: 1,
            ease: "power2.in",
            transformOrigin: "center center"
        }, 0.5).from(".sparks > *", {
            y: -100,
            opacity: 0,
            duration: 1,
            stagger: {
                from: "random",
                amount: 1
            }
        }, 0.5).from(".peas-dots > *", {
            opacity: 0,
            duration: 1,
            stagger: {
                from: "random",
                amount: 1
            }
        }, 0.5).to(".food", {
            keyframes: {
                yPercent: [
                    0,
                    10,
                    0
                ],
                rotation: [
                    0,
                    -10,
                    0
                ]
            },
            ease: "back.out",
            transformOrigin: "center right"
        }, 1.45);
    }, animContainer);
}
var $13a03c8cafd868ec$export$2e2bcd8739ae039 = $13a03c8cafd868ec$var$AnimCatch;



/*!
 * EasePack 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $b2de71adcaeab72e$var$gsap, $b2de71adcaeab72e$var$_coreInitted, $b2de71adcaeab72e$var$_registerEase, $b2de71adcaeab72e$var$_getGSAP = function _getGSAP() {
    return $b2de71adcaeab72e$var$gsap || typeof window !== "undefined" && ($b2de71adcaeab72e$var$gsap = window.gsap) && $b2de71adcaeab72e$var$gsap.registerPlugin && $b2de71adcaeab72e$var$gsap;
}, $b2de71adcaeab72e$var$_boolean = function _boolean(value, defaultValue) {
    return !!(typeof value === "undefined" ? defaultValue : value && !~(value + "").indexOf("false"));
}, $b2de71adcaeab72e$var$_initCore = function _initCore(core) {
    $b2de71adcaeab72e$var$gsap = core || $b2de71adcaeab72e$var$_getGSAP();
    if ($b2de71adcaeab72e$var$gsap) {
        $b2de71adcaeab72e$var$_registerEase = $b2de71adcaeab72e$var$gsap.registerEase; //add weighted ease capabilities to standard eases so users can do "power2.inOut(0.8)" for example to push everything toward the "out", or (-0.8) to push it toward the "in" (0 is neutral)
        var eases = $b2de71adcaeab72e$var$gsap.parseEase(), createConfig = function createConfig(ease) {
            return function(ratio) {
                var y = 0.5 + ratio / 2;
                ease.config = function(p) {
                    return ease(2 * (1 - p) * p * y + p * p);
                };
            };
        }, p;
        for(p in eases)if (!eases[p].config) createConfig(eases[p]);
        $b2de71adcaeab72e$var$_registerEase("slow", $b2de71adcaeab72e$export$5b8ec41d2880926f);
        $b2de71adcaeab72e$var$_registerEase("expoScale", $b2de71adcaeab72e$export$f95db16282c8d7a4);
        $b2de71adcaeab72e$var$_registerEase("rough", $b2de71adcaeab72e$export$116b12203755670f);
        for(p in $b2de71adcaeab72e$export$eb3280d9b6c5fe6f)p !== "version" && $b2de71adcaeab72e$var$gsap.core.globals(p, $b2de71adcaeab72e$export$eb3280d9b6c5fe6f[p]);
        $b2de71adcaeab72e$var$_coreInitted = 1;
    }
}, $b2de71adcaeab72e$var$_createSlowMo = function _createSlowMo(linearRatio, power, yoyoMode) {
    linearRatio = Math.min(1, linearRatio || 0.7);
    var pow = linearRatio < 1 ? power || power === 0 ? power : 0.7 : 0, p1 = (1 - linearRatio) / 2, p3 = p1 + linearRatio, calcEnd = $b2de71adcaeab72e$var$_boolean(yoyoMode);
    return function(p) {
        var r = p + (0.5 - p) * pow;
        return p < p1 ? calcEnd ? 1 - (p = 1 - p / p1) * p : r - (p = 1 - p / p1) * p * p * p * r : p > p3 ? calcEnd ? p === 1 ? 0 : 1 - (p = (p - p3) / p1) * p : r + (p - r) * (p = (p - p3) / p1) * p * p * p : calcEnd ? 1 : r;
    };
}, $b2de71adcaeab72e$var$_createExpoScale = function _createExpoScale(start, end, ease) {
    var p1 = Math.log(end / start), p2 = end - start;
    ease && (ease = $b2de71adcaeab72e$var$gsap.parseEase(ease));
    return function(p) {
        return (start * Math.exp(p1 * (ease ? ease(p) : p)) - start) / p2;
    };
}, $b2de71adcaeab72e$var$EasePoint = function EasePoint(time, value, next) {
    this.t = time;
    this.v = value;
    if (next) {
        this.next = next;
        next.prev = this;
        this.c = next.v - value;
        this.gap = next.t - time;
    }
}, $b2de71adcaeab72e$var$_createRoughEase = function _createRoughEase(vars) {
    if (typeof vars !== "object") //users may pass in via a string, like "rough(30)"
    vars = {
        points: +vars || 20
    };
    var taper = vars.taper || "none", a = [], cnt = 0, points = (+vars.points || 20) | 0, i = points, randomize = $b2de71adcaeab72e$var$_boolean(vars.randomize, true), clamp = $b2de71adcaeab72e$var$_boolean(vars.clamp), template = $b2de71adcaeab72e$var$gsap ? $b2de71adcaeab72e$var$gsap.parseEase(vars.template) : 0, strength = (+vars.strength || 1) * 0.4, x, y, bump, invX, obj, pnt, recent;
    while(--i > -1){
        x = randomize ? Math.random() : 1 / points * i;
        y = template ? template(x) : x;
        if (taper === "none") bump = strength;
        else if (taper === "out") {
            invX = 1 - x;
            bump = invX * invX * strength;
        } else if (taper === "in") bump = x * x * strength;
        else if (x < 0.5) {
            //"both" (start)
            invX = x * 2;
            bump = invX * invX * 0.5 * strength;
        } else {
            //"both" (end)
            invX = (1 - x) * 2;
            bump = invX * invX * 0.5 * strength;
        }
        if (randomize) y += Math.random() * bump - bump * 0.5;
        else if (i % 2) y += bump * 0.5;
        else y -= bump * 0.5;
        if (clamp) {
            if (y > 1) y = 1;
            else if (y < 0) y = 0;
        }
        a[cnt++] = {
            x: x,
            y: y
        };
    }
    a.sort(function(a, b) {
        return a.x - b.x;
    });
    pnt = new $b2de71adcaeab72e$var$EasePoint(1, 1, null);
    i = points;
    while(i--){
        obj = a[i];
        pnt = new $b2de71adcaeab72e$var$EasePoint(obj.x, obj.y, pnt);
    }
    recent = new $b2de71adcaeab72e$var$EasePoint(0, 0, pnt.t ? pnt : pnt.next);
    return function(p) {
        var pnt = recent;
        if (p > pnt.t) {
            while(pnt.next && p >= pnt.t)pnt = pnt.next;
            pnt = pnt.prev;
        } else while(pnt.prev && p <= pnt.t)pnt = pnt.prev;
        recent = pnt;
        return pnt.v + (p - pnt.t) / pnt.gap * pnt.c;
    };
};
var $b2de71adcaeab72e$export$5b8ec41d2880926f = $b2de71adcaeab72e$var$_createSlowMo(0.7);
$b2de71adcaeab72e$export$5b8ec41d2880926f.ease = $b2de71adcaeab72e$export$5b8ec41d2880926f; //for backward compatibility
$b2de71adcaeab72e$export$5b8ec41d2880926f.config = $b2de71adcaeab72e$var$_createSlowMo;
var $b2de71adcaeab72e$export$f95db16282c8d7a4 = $b2de71adcaeab72e$var$_createExpoScale(1, 2);
$b2de71adcaeab72e$export$f95db16282c8d7a4.config = $b2de71adcaeab72e$var$_createExpoScale;
var $b2de71adcaeab72e$export$116b12203755670f = $b2de71adcaeab72e$var$_createRoughEase();
$b2de71adcaeab72e$export$116b12203755670f.ease = $b2de71adcaeab72e$export$116b12203755670f; //for backward compatibility
$b2de71adcaeab72e$export$116b12203755670f.config = $b2de71adcaeab72e$var$_createRoughEase;
var $b2de71adcaeab72e$export$eb3280d9b6c5fe6f = {
    SlowMo: $b2de71adcaeab72e$export$5b8ec41d2880926f,
    RoughEase: $b2de71adcaeab72e$export$116b12203755670f,
    ExpoScaleEase: $b2de71adcaeab72e$export$f95db16282c8d7a4
};
for(var $b2de71adcaeab72e$var$p in $b2de71adcaeab72e$export$eb3280d9b6c5fe6f){
    $b2de71adcaeab72e$export$eb3280d9b6c5fe6f[$b2de71adcaeab72e$var$p].register = $b2de71adcaeab72e$var$_initCore;
    $b2de71adcaeab72e$export$eb3280d9b6c5fe6f[$b2de71adcaeab72e$var$p].version = "3.12.5";
}
$b2de71adcaeab72e$var$_getGSAP() && $b2de71adcaeab72e$var$gsap.registerPlugin($b2de71adcaeab72e$export$5b8ec41d2880926f);


(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $b2de71adcaeab72e$export$116b12203755670f));
function $32ea292db4cad46f$var$AnimMunch() {
    const munchings = `<svg class="anim-munch" fill="#0d242f" viewBox="0 0 500 700" preserveAspectRatio="xMaxYMax slice">
  <g class="munches" opacity="0">
  <circle cx="445.25" cy="451.18" r="85.09" fill="#0d242f" fill-opacity="0"/>
  <circle cx="329.67" cy="719.83" r="85.09" fill="#0d242f"/>
  <circle cx="355.92" cy="626.35" r="85.09" fill="#0d242f"/>
  <circle cx="448.64" cy="545.15" r="85.09" fill="#0d242f"/>
  <circle cx="216.16" cy="662.62" r="85.09" fill="#0d242f"/>
  <circle cx="324.25" cy="577.53" r="85.09" fill="#0d242f"/>
  <circle cx="530.33" cy="480.12" r="85.09" fill="#0d242f"/>
  <circle cx="389.34" cy="480.12" r="85.09" fill="#0d242f"/>
  <g>
    <circle cx="117.05" cy="658" r="85.09" fill="#0d242f"/>
    <circle cx="216.16" cy="615.18" r="85.09" fill="#0d242f"/>
  </g>
  <circle cx="282.7" cy="511.08" r="85.09" fill="#0d242f"/>
  <circle cx="484.68" cy="431.84" r="85.09" fill="#0d242f"/>
  <circle cx="45.99" cy="694.42" r="85.09" fill="#0d242f"/>
  <circle cx="26.88" cy="621.58" r="85.09" fill="#0d242f"/>
  <circle cx="161.1" cy="587.69" r="85.09" fill="#0d242f"/>
  <circle cx="363.55" cy="425.99" r="85.09" fill="#0d242f"/>
  <circle cx="211.92" cy="502.61" r="85.09" fill="#0d242f"/>
  <circle cx="476.59" cy="353.06" r="85.09" fill="#0d242f"/>
  <circle cx="76.01" cy="541.27" r="85.09" fill="#0d242f"/>
  <circle cx="276.3" cy="403.04" r="85.09" fill="#0d242f"/>
  <g>
    <circle cx="367.78" cy="310.79" r="85.09" fill="#0d242f"/>
    <circle cx="465.66" cy="255.82" r="85.09" fill="#0d242f"/>
  </g>
  <circle cx="42.98" cy="466.56" r="85.09" fill="#0d242f"/>
  <circle cx="155.17" cy="438.15" r="85.09" fill="#0d242f"/>
  <circle cx="224.63" cy="324.26" r="85.09" fill="#0d242f"/>
  <circle cx="336.82" cy="250.57" r="85.09" fill="#0d242f"/>
  <circle cx="70.08" cy="359.92" r="85.09" fill="#0d242f"/>
  <circle cx="219.17" cy="246.33" r="85.09" fill="#0d242f"/>
  <g>
    <circle cx="111.97" cy="279.37" r="85.09" fill="#0d242f"/>
    <circle cx="22.27" cy="264.12" r="85.09" fill="#0d242f"/>
  </g>
  <circle cx="453.45" cy="132.53" r="85.09" fill="#0d242f"/>
  <circle cx="337.87" cy="189.74" r="85.09" fill="#0d242f"/>
  <circle cx="364.12" cy="96.26" r="85.09" fill="#0d242f"/>
  <circle cx="453.45" r="85.09" fill="#0d242f"/>
  <circle cx="224.36" cy="132.53" r="85.09" fill="#0d242f"/>
  <circle cx="344.63" cy="36.52" r="85.09" fill="#0d242f"/>
  <circle cx="244.58" cy="-1.47" r="85.09" fill="#0d242f"/>
  <circle cx="111.97" cy="165.48" r="85.09" fill="#0d242f"/>
  <g>
    <circle cx="42.98" cy="143.02" r="85.09" fill="#0d242f"/>
    <circle cx="142.09" cy="100.2" r="85.09" fill="#0d242f"/>
  </g>
  <circle cx="134.08" cy="22.17" r="85.09" fill="#0d242f"/>
  <circle cx="35.72" cy="15.11" r="85.09" fill="#0d242f"/>
</g>
<g class="munch" fill="#0d242f">
  <g>
    <circle cx="463.69" cy="665.57" r="50.71"/>
    <circle cx="422.09" cy="694.53" r="21.75" transform="rotate(-85.27 422.079024 694.529572)"/>
  </g>
  <circle cx="485.53" cy="617.63" r="21.83" transform="rotate(-85.27 485.512819 617.630704)"/>
</g>
<g class="arrow">
  <path fill="none" stroke="#fb6955" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.08" d="M442.59,653.63h19.55m0,0-9.51-9.25m9.51,9.25-9.51,9.25"/>
</g>
</svg>


`;
    const animMunches = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.toArray(".anim-munch");
    if (!animMunches.length) return;
    animMunches.forEach((card)=>{
        let q = (0, $4dab17958b7cdb31$export$99ee26438460406a).utils.selector(card);
        card.insertAdjacentHTML("beforeend", munchings);
        card.munches = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
            paused: true
        });
        card.munches.from(q(".munches > *"), {
            duration: 0.01,
            opacity: 0,
            stagger: {
                amount: 30
            },
            ease: "power3.in"
        }, 3);
        card.imageTween = (0, $4dab17958b7cdb31$export$99ee26438460406a).to(q("img"), {
            duration: 0.25,
            rotation: 3,
            paused: true,
            transformOrigin: "center",
            y: "-0.5rem"
        });
        card.addEventListener("mouseenter", (e)=>{
            (0, $4dab17958b7cdb31$export$99ee26438460406a).set(q(".munches"), {
                opacity: 1
            });
            card.munches.timeScale(1).play();
            card.imageTween.play();
        });
        card.addEventListener("mouseleave", (e)=>{
            card.munches.seek(0).pause();
            card.imageTween.reverse();
        });
    });
}
var $32ea292db4cad46f$export$2e2bcd8739ae039 = $32ea292db4cad46f$var$AnimMunch;




(0, $4dab17958b7cdb31$export$99ee26438460406a).registerPlugin((0, $015e296242376acd$export$4129f9ba90e1264a));
function $1265c75500225319$var$AnimBeats() {
    const animBeats = document.querySelector(".anim-beats");
    if (!animBeats) return;
    animBeats.hasBeenLiked = false;
    animBeats.parentElement.addEventListener("mouseenter", ()=>{
        (0, $4dab17958b7cdb31$export$99ee26438460406a).to(".anim-beats .anim-heart", {
            fill: "#ee7868",
            duration: 0.5
        });
    });
    animBeats.parentElement.addEventListener("mouseleave", ()=>{
        if (animBeats.hasBeenLiked) return;
        (0, $4dab17958b7cdb31$export$99ee26438460406a).to(".anim-beats .anim-heart", {
            fill: "#00000000",
            duration: 0.5
        });
    });
    animBeats.tl = (0, $4dab17958b7cdb31$export$99ee26438460406a).timeline({
        paused: true,
        defaults: {
            duration: 1
        }
    });
    animBeats.tl.to(".anim-beats .anim-heart", {
        fill: "#ee7868",
        duration: 0.5,
        onStart: ()=>animBeats.hasBeenLiked = true
    }, 0).to(".anim-beats .pretzel-heart", {
        scale: 1.6,
        transformOrigin: "52% 55%",
        duration: 1,
        ease: "elastic.out(1, 0.3)"
    }, 0).to(".circle-pretzel", {
        opacity: 0,
        transformOrigin: "center",
        duration: 1,
        ease: "back.out"
    }, 0).from(".anim-beats .dots", {
        opacity: 0,
        duration: 0.5
    }, 0).from(".anim-beats .sparks > *", {
        opacity: 0,
        scale: 0,
        transformOrigin: "center center",
        duration: 0.5
    }, 0).from(".anim-beats .lines > *", {
        drawSVG: "0%",
        duration: 0.5
    }, 0).to(".anim-beats .lines > *", {
        drawSVG: "100% 100%",
        opacity: 0,
        duration: 0.5
    }, 0.5).to(".anim-beats .dots", {
        opacity: 0,
        duration: 0.5
    }, 0.5).to(".anim-beats .sparks > *", {
        opacity: 0,
        scale: 0,
        transformOrigin: "center center",
        duration: 0.5
    }, 0.5);
    animBeats.tl.progress(animBeats.dataset.animState);
}
var $1265c75500225319$export$2e2bcd8739ae039 = $1265c75500225319$var$AnimBeats;


const $3e452ceb90b7e871$var$HEIGHT_CUTOFF = 330;
const $3e452ceb90b7e871$var$CLOSED_TOGGLE = "Show more \u2193";
const $3e452ceb90b7e871$var$OPEN_TOGGLE = "Show less \u2191";
const $3e452ceb90b7e871$var$CLOSED_HEIGHT = `${$3e452ceb90b7e871$var$HEIGHT_CUTOFF}px`;
const $3e452ceb90b7e871$var$MAX_TESTIMONIALS_VISIBLE = 12;
function $3e452ceb90b7e871$var$Testimonials() {
    const control = document.querySelector(".c-testimonials .c-testimonial__toggle");
    if (!control) return;
    control.classList.add("c-testimonial__toggle--active");
    $3e452ceb90b7e871$var$toggleTestimonials();
    control.addEventListener("click", $3e452ceb90b7e871$var$toggleTestimonials);
}
function $3e452ceb90b7e871$var$toggleTestimonials(event) {
    const ul = document.querySelector(".c-testimonials__quotes");
    const control = document.querySelector(".c-testimonials .c-testimonial__toggle");
    const lis = ul.querySelectorAll(".c-testimonials__quotes li");
    if (ul.classList.contains(".c-testimonials__quotes--collapsed")) ul.classList.add(".c-testimonials__quotes--expanded");
    ul.classList.add(".c-testimonials__quotes--collapsed");
    const isClosed = control.textContent === $3e452ceb90b7e871$var$CLOSED_TOGGLE;
    lis && Array.from(lis).forEach((el, i)=>{
        if (i >= $3e452ceb90b7e871$var$MAX_TESTIMONIALS_VISIBLE) el.classList.toggle("c-testimonials__quote--hidden");
    });
    control.textContent = isClosed ? $3e452ceb90b7e871$var$OPEN_TOGGLE : $3e452ceb90b7e871$var$CLOSED_TOGGLE;
    if (event && !isClosed) setTimeout(()=>{
        control.scrollIntoView({
            block: "center",
            behavior: "auto"
        });
    }, 100);
    if (event && isClosed && lis.length) lis[$3e452ceb90b7e871$var$MAX_TESTIMONIALS_VISIBLE].querySelector("a").focus();
}
var $3e452ceb90b7e871$export$2e2bcd8739ae039 = $3e452ceb90b7e871$var$Testimonials;


function $e54e7972c2e3d52e$var$Beats() {
    if (!_beats) return;
    const localBeats = $e54e7972c2e3d52e$var$getLocalBeats();
    _beats.forEach(({ slug: slug, count: count })=>{
        let localBeat = localBeats.find((x)=>x.slug === slug);
        if (!localBeat) {
            localBeat = {
                slug: slug,
                count: count
            };
            localBeats.push(localBeat);
        }
        if (localBeat.count < count) localBeat.count = count;
        $e54e7972c2e3d52e$var$updateLocalBeatElements(localBeat);
    });
    $e54e7972c2e3d52e$var$setLocalBeats(localBeats);
    document.querySelectorAll("[data-add-beat]").forEach((el)=>{
        el.addEventListener("click", $e54e7972c2e3d52e$var$AddBeat);
    });
}
function $e54e7972c2e3d52e$var$getLocalBeats() {
    return JSON.parse(localStorage.getItem("_beats") || "[]");
}
function $e54e7972c2e3d52e$var$setLocalBeats(beats) {
    localStorage.setItem("_beats", JSON.stringify(beats));
}
function $e54e7972c2e3d52e$var$updateLocalBeatElements(localBeat) {
    document.querySelectorAll(`[data-beat-id="/articles/${localBeat.slug}/"]`).forEach((el)=>{
        el.textContent = `${localBeat.count} Beat${localBeat.count === 1 ? "" : "s"}`;
    });
}
function $e54e7972c2e3d52e$var$AddBeat(event) {
    const url = event.currentTarget.dataset.addBeat;
    const localBeats = $e54e7972c2e3d52e$var$getLocalBeats();
    const localBeat = localBeats.find((x)=>`/articles/${x.slug}/` === url);
    if (!localBeat) return;
    localBeat.count++;
    //anim-beats.js
    event.target.querySelector(".anim-beats").tl.restart();
    try {
        if (_beatsAPI) fetch(`${_beatsAPI}/beats/${localBeat.slug}`, {
            method: "POST"
        });
    } catch (error) {}
    $e54e7972c2e3d52e$var$updateLocalBeatElements(localBeat);
    $e54e7972c2e3d52e$var$setLocalBeats(localBeats);
}
var $e54e7972c2e3d52e$export$2e2bcd8739ae039 = $e54e7972c2e3d52e$var$Beats;


const $120156388535672d$var$inView = new Set();
const $120156388535672d$var$notInView = new Set();
let $120156388535672d$var$selectedElement = null;
function $120156388535672d$var$Toc() {
    const toc = document.querySelector(".toc ol");
    if (!toc) return;
    $120156388535672d$var$SetupToc(toc);
}
function $120156388535672d$var$SetupToc(toc) {
    let observer = new IntersectionObserver($120156388535672d$var$tocCallback);
    toc.children.forEach((child)=>{
        const heading = document.getElementById(child.children[0].getAttribute("href").replace("#", ""));
        if (heading) observer.observe(heading);
    });
}
function $120156388535672d$var$tocCallback(entries, observer) {
    entries.forEach((entry)=>{
        const link = document.querySelector(`.toc a[href="#${entry.target.id}"]`);
        if (!link) return;
        if (entry.isIntersecting) {
            $120156388535672d$var$inView.add(link);
            $120156388535672d$var$notInView.delete(link);
        } else {
            $120156388535672d$var$inView.delete(link);
            $120156388535672d$var$notInView.add(link);
        }
    });
    const inViewArray = [
        ...$120156388535672d$var$inView
    ];
    if (inViewArray.length === 0) {
        if (!$120156388535672d$var$selectedElement) // Make the first link active
        [
            ...$120156388535672d$var$notInView
        ][0].setAttribute("aria-current", "step");
    // Leave it be
    } else if (inViewArray.length === 1) {
        // Make it active
        inViewArray[0].setAttribute("aria-current", "step");
        $120156388535672d$var$selectedElement = inViewArray[0];
        // Deactivate the rest
        [
            ...$120156388535672d$var$notInView
        ].forEach((el)=>el.removeAttribute("aria-current"));
    } else {
        // Make the last active
        inViewArray.forEach((el, index, array)=>{
            if (index === array.length - 1) {
                el.setAttribute("aria-current", "step");
                $120156388535672d$var$selectedElement = el;
            } else el.removeAttribute("aria-current");
        });
        // Deactivate the rest
        [
            ...$120156388535672d$var$notInView
        ].forEach((el)=>el.removeAttribute("aria-current"));
    }
}
var $120156388535672d$export$2e2bcd8739ae039 = $120156388535672d$var$Toc;



let $4a30e784c9d74ed3$var$articleTagsParent;
let $4a30e784c9d74ed3$var$articleTagsToggle;
function $4a30e784c9d74ed3$var$ArticleTags() {
    $4a30e784c9d74ed3$var$articleTagsParent = document.querySelector(".c-article-tags ul");
    $4a30e784c9d74ed3$var$articleTagsToggle = document.querySelector(".c-article-tags button");
    if (!$4a30e784c9d74ed3$var$articleTagsParent || !$4a30e784c9d74ed3$var$articleTagsToggle) return;
    $4a30e784c9d74ed3$var$articleTagsToggle.addEventListener("click", $4a30e784c9d74ed3$var$ToggleTags);
    $4a30e784c9d74ed3$var$articleTagsParent.classList.remove("c-article-tags--loading");
    $4a30e784c9d74ed3$var$SetupArticleTags();
    window.addEventListener("resize", (0, $f2234d90ae84d9bf$export$de363e709c412c8a)($4a30e784c9d74ed3$var$SetupArticleTags, 300));
    window.addEventListener("resize", (0, $f2234d90ae84d9bf$export$61fc7d43ac8f84b0)($4a30e784c9d74ed3$var$SetupArticleTags, 300));
}
function $4a30e784c9d74ed3$var$SetupArticleTags() {
    // Reset the parent width
    $4a30e784c9d74ed3$var$articleTagsParent.style.width = "auto";
    // Remove child classes
    document.querySelectorAll(".c-article-tags__final").forEach((child)=>{
        child.classList.remove("c-article-tags__final");
    });
    // Force a layout recalc
    const parentSize = $4a30e784c9d74ed3$var$articleTagsParent.getBoundingClientRect();
    let cutoff = parentSize.width - 85;
    const children = $4a30e784c9d74ed3$var$articleTagsParent.children;
    const firstLineHeight = children[0].offsetTop;
    // Get all items on the first line and not passed the button cutoff
    const firstLineItems = [
        ...children
    ].filter((child)=>{
        if (firstLineHeight !== child.offsetTop) return false;
        return child.getBoundingClientRect().right - parentSize.left <= cutoff;
    });
    // If there's only one line of tags, hide the toggle
    $4a30e784c9d74ed3$var$articleTagsToggle.classList.toggle("c-article-tags-trigger--hidden", firstLineItems.length === children.length);
    // Find the final item
    const finalItem = firstLineItems[firstLineItems.length - 1];
    const finalItemSizes = finalItem.getBoundingClientRect();
    // Mark the final item to add a push away margin
    finalItem.classList.add("c-article-tags__final");
    // Position the button
    $4a30e784c9d74ed3$var$articleTagsToggle.style.left = `calc(${finalItemSizes.right - parentSize.left}px - 15px + var(--space-xs))`;
/* Adding -15px due to a hacky trick/workaround */ }
function $4a30e784c9d74ed3$var$ToggleTags() {
    const openClass = "c-article-tags--open";
    $4a30e784c9d74ed3$var$articleTagsParent.classList.toggle(openClass);
    $4a30e784c9d74ed3$var$articleTagsToggle.textContent = $4a30e784c9d74ed3$var$articleTagsParent.classList.contains(openClass) ? "Less..." : "More...";
}
var $4a30e784c9d74ed3$export$2e2bcd8739ae039 = $4a30e784c9d74ed3$var$ArticleTags;


function $7ac61b94ed063090$var$LessonAccordion() {
    const accordion = Array.from(document.querySelectorAll("[data-lesson-accordions]"));
    accordion.forEach($7ac61b94ed063090$var$setupLessonAccordion);
}
function $7ac61b94ed063090$var$setupLessonAccordion(accordion) {
    const controls = accordion.querySelectorAll("[data-lesson-accordion] [aria-controls]");
    const children = accordion.querySelectorAll("[data-lesson-accordion] [aria-labelledby]");
    controls.forEach((control)=>{
        control.addEventListener("click", $7ac61b94ed063090$var$accordionClick);
    });
    if (controls.length && children.length) $7ac61b94ed063090$var$toggleAccordion(controls[0], children[0]);
}
function $7ac61b94ed063090$var$accordionClick(event) {
    $7ac61b94ed063090$var$toggleAccordion(event.currentTarget, event.currentTarget.nextElementSibling);
}
function $7ac61b94ed063090$var$toggleAccordion(trigger, child) {
    const isOpen = trigger.getAttribute("aria-expanded") === "true";
    trigger.setAttribute("aria-expanded", isOpen ? "false" : "true");
    if (isOpen) child.setAttribute("hidden", "hidden");
    else child.removeAttribute("hidden");
}
var $7ac61b94ed063090$export$2e2bcd8739ae039 = $7ac61b94ed063090$var$LessonAccordion;


(()=>{
    if (window.NodeList && !NodeList.prototype.forEach) NodeList.prototype.forEach = Array.prototype.forEach;
    if (window.HTMLCollection && !HTMLCollection.prototype.forEach) HTMLCollection.prototype.forEach = Array.prototype.forEach;
    (0, $74cf6679aa998d5b$exports.InjectMeal)();
    (0, $4ce6618e88acaea1$export$2e2bcd8739ae039)();
    (0, $3122b6012636c8e9$export$2e2bcd8739ae039)();
    (0, $3c6137e97da716c6$export$2e2bcd8739ae039)();
    (0, $255ff5105c45b82c$export$2e2bcd8739ae039)();
    (0, $6581ed4055677626$export$2e2bcd8739ae039)();
    (0, $743652607225910f$export$2e2bcd8739ae039)();
    (0, $f479ac1331318768$export$2e2bcd8739ae039)();
    (0, $3e452ceb90b7e871$export$2e2bcd8739ae039)();
    (0, $e54e7972c2e3d52e$export$2e2bcd8739ae039)();
    (0, $120156388535672d$export$2e2bcd8739ae039)();
    (0, $4a30e784c9d74ed3$export$2e2bcd8739ae039)();
    (0, $7ac61b94ed063090$export$2e2bcd8739ae039)();
    // animation check handled in file.
    const uxHero = document.querySelector(".hero-anim--ux");
    uxHero ? (0, $39ff439fa6c3dbaf$export$2e2bcd8739ae039)() : (0, $e2219852f6853050$export$2e2bcd8739ae039)();
    (0, $e6673c56130650ed$export$2e2bcd8739ae039)();
    (0, $1265c75500225319$export$2e2bcd8739ae039)();
    let motionQuery = window.matchMedia("(prefers-reduced-motion: no-preference)");
    let animationToggle = document.querySelector(".c-animation-toggle-input");
    let url = window.location.href;
    if (animationToggle) {
        // check if the user's visited and used the motion toggle before
        let localMotionPreference = localStorage.getItem("motionPreference");
        // if the users specified no motion on the toggle then use that, otherwise use the OS setting
        localMotionPreference === "false" ? animationToggle.checked = false : animationToggle.checked = motionQuery.matches;
        // adjust when OS setting changes
        motionQuery.addEventListener("change", ()=>{
            animationToggle.checked = motionQuery.matches;
        });
        // update local storage & GSAP if the toggle is used
        animationToggle.addEventListener("change", ()=>{
            localStorage.setItem("motionPreference", animationToggle.checked);
            (0, $4dab17958b7cdb31$export$99ee26438460406a).matchMediaRefresh();
        });
        // hard nope on the subpages
        if (url.slice(url.length - 9) !== "articles/") animationToggle.checked = false;
        (0, $cda0215900937868$export$2e2bcd8739ae039)(animationToggle);
        (0, $74cf6679aa998d5b$exports.AnimMeal)(animationToggle);
        (0, $0667e1704423b6ac$export$2e2bcd8739ae039)(animationToggle);
    }
    (0, $13a03c8cafd868ec$export$2e2bcd8739ae039)();
    (0, $483355d9ef926385$export$2e2bcd8739ae039)();
    // rest of the animation doodahs
    if (motionQuery.matches) {
        (0, $1033b6f6513d4b8c$export$2e2bcd8739ae039)();
        (0, $578af777c0f2e999$export$2e2bcd8739ae039)();
        (0, $377db753c00f7aba$export$2e2bcd8739ae039)();
        (0, $02286b7c028989c7$export$2e2bcd8739ae039)();
        (0, $d8fadea08eb01699$export$2e2bcd8739ae039)();
        (0, $cbc1160894bda1ba$export$2e2bcd8739ae039)();
        (0, $216392f52529a08e$export$2e2bcd8739ae039)();
        (0, $6aeba538135d8ccc$export$2e2bcd8739ae039)();
        (0, $32ea292db4cad46f$export$2e2bcd8739ae039)();
    }
})();

})();
//# sourceMappingURL=app.js.map
